export const countiesGeoData = {
    "type": "FeatureCollection",
    "features": [{
        "geometry": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        23.486761599407465,
                        47.971112648008436
                    ],
                    [
                        23.501956002848072,
                        47.93423204712428
                    ],
                    [
                        23.549446668894593,
                        47.889015336978204
                    ],
                    [
                        23.559678582246164,
                        47.88141877102989
                    ],
                    [
                        23.573476168052615,
                        47.87387386384669
                    ],
                    [
                        23.607014195981318,
                        47.85940462414132
                    ],
                    [
                        23.620346732059904,
                        47.85046470432047
                    ],
                    [
                        23.630010221544907,
                        47.83808817346999
                    ],
                    [
                        23.62918336881717,
                        47.826951708882234
                    ],
                    [
                        23.620656795620967,
                        47.81620325802242
                    ],
                    [
                        23.47916668858411,
                        47.743029200043296
                    ],
                    [
                        23.454465356038217,
                        47.73507104684029
                    ],
                    [
                        23.431831087751014,
                        47.73197051690637
                    ],
                    [
                        23.41446779559377,
                        47.732590558722556
                    ],
                    [
                        23.39767295787463,
                        47.735742842822724
                    ],
                    [
                        23.38185998346394,
                        47.74091057829693
                    ],
                    [
                        23.342895938420327,
                        47.74892032871901
                    ],
                    [
                        23.27184086447165,
                        47.749230521035095
                    ],
                    [
                        23.255562757935344,
                        47.74452776896834
                    ],
                    [
                        23.24409059376101,
                        47.73615620909574
                    ],
                    [
                        23.23954309975118,
                        47.72225546386971
                    ],
                    [
                        23.24099000432414,
                        47.71367693418337
                    ],
                    [
                        23.247346246470567,
                        47.7067525652517
                    ],
                    [
                        23.25881837263266,
                        47.701946379553846
                    ],
                    [
                        23.32677289757584,
                        47.689182410463964
                    ],
                    [
                        23.342585883856678,
                        47.68334296125979
                    ],
                    [
                        23.353334608665183,
                        47.67574670371518
                    ],
                    [
                        23.360931046131338,
                        47.66784022123179
                    ],
                    [
                        23.363256485086755,
                        47.65450770195108
                    ],
                    [
                        23.359535770674423,
                        47.64257036967624
                    ],
                    [
                        23.346926730032724,
                        47.6233467932837
                    ],
                    [
                        23.340570519550006,
                        47.61078935927655
                    ],
                    [
                        23.32367230231634,
                        47.58526104479613
                    ],
                    [
                        23.301813189901196,
                        47.56751031627591
                    ],
                    [
                        23.28393314118084,
                        47.55001781804498
                    ],
                    [
                        23.2679651282083,
                        47.53808059512527
                    ],
                    [
                        23.249671673624412,
                        47.53076839574074
                    ],
                    [
                        23.232721803877507,
                        47.53076839574074
                    ],
                    [
                        23.217218875668166,
                        47.53534177038477
                    ],
                    [
                        23.17174360636849,
                        47.555392168256496
                    ],
                    [
                        23.160426477929615,
                        47.562833638137626
                    ],
                    [
                        23.143528292379955,
                        47.57699303569305
                    ],
                    [
                        23.135311714312458,
                        47.580739410952766
                    ],
                    [
                        23.126578393882685,
                        47.58071355036861
                    ],
                    [
                        23.116811557790406,
                        47.576476138665036
                    ],
                    [
                        23.057848736874497,
                        47.52614322382594
                    ],
                    [
                        23.049787229310088,
                        47.51642815922754
                    ],
                    [
                        23.04420616336569,
                        47.50567938691496
                    ],
                    [
                        23.040330428301466,
                        47.49516321052987
                    ],
                    [
                        23.03614465187736,
                        47.486714212728806
                    ],
                    [
                        23.030873645490868,
                        47.47953111664182
                    ],
                    [
                        23.022967149587743,
                        47.47273565240311
                    ],
                    [
                        23.013303671886874,
                        47.46681880773792
                    ],
                    [
                        22.976716754189543,
                        47.450230646363345
                    ],
                    [
                        22.968810260164354,
                        47.44449456306452
                    ],
                    [
                        22.966019722127545,
                        47.437931587160755
                    ],
                    [
                        22.96757002192539,
                        47.43049022956144
                    ],
                    [
                        22.981677680322253,
                        47.42268703645449
                    ],
                    [
                        22.998420840900753,
                        47.416253297100255
                    ],
                    [
                        23.090456566963425,
                        47.404290203385465
                    ],
                    [
                        23.10208377431522,
                        47.390079247337674
                    ],
                    [
                        23.110300325058986,
                        47.37685006900477
                    ],
                    [
                        23.111850627159473,
                        47.3689953148457
                    ],
                    [
                        23.110300318871708,
                        47.36176050904806
                    ],
                    [
                        23.10502932620185,
                        47.355430173276915
                    ],
                    [
                        23.066375359922816,
                        47.333131819744146
                    ],
                    [
                        23.05986413097779,
                        47.32726655889443
                    ],
                    [
                        23.055368275073135,
                        47.320677769941945
                    ],
                    [
                        23.051027468900788,
                        47.3160528276707
                    ],
                    [
                        23.045446414176627,
                        47.31426998776071
                    ],
                    [
                        23.033354112749894,
                        47.31974757750038
                    ],
                    [
                        23.01609418967742,
                        47.33302846075158
                    ],
                    [
                        23.00555218972025,
                        47.336852458753455
                    ],
                    [
                        22.964469445102164,
                        47.344035617578506
                    ],
                    [
                        22.949534957440253,
                        47.350030093214535
                    ],
                    [
                        22.925815463356887,
                        47.36597219055619
                    ],
                    [
                        22.91186282418903,
                        47.372044157806826
                    ],
                    [
                        22.801843709957172,
                        47.39276647170768
                    ],
                    [
                        22.782413353041974,
                        47.39289554152208
                    ],
                    [
                        22.7546631120713,
                        47.38793462275729
                    ],
                    [
                        22.62356000771036,
                        47.34470732163915
                    ],
                    [
                        22.580720246895762,
                        47.321401254874694
                    ],
                    [
                        22.571263453534435,
                        47.339048717964396
                    ],
                    [
                        22.56392540237717,
                        47.36380173687471
                    ],
                    [
                        22.554778670334983,
                        47.37581648875764
                    ],
                    [
                        22.54284142961185,
                        47.38294793968
                    ],
                    [
                        22.512869095332867,
                        47.39442007701987
                    ],
                    [
                        22.496901079695864,
                        47.40408359178445
                    ],
                    [
                        22.482793414669427,
                        47.410284769208275
                    ],
                    [
                        22.472251427331237,
                        47.41235185604058
                    ],
                    [
                        22.46248456648098,
                        47.4105430773817
                    ],
                    [
                        22.438403357545774,
                        47.40134473192702
                    ],
                    [
                        22.428481483194837,
                        47.399691089550444
                    ],
                    [
                        22.414063756440306,
                        47.40186148737044
                    ],
                    [
                        22.40491702575925,
                        47.402378243678605
                    ],
                    [
                        22.395770296290706,
                        47.40178395092249
                    ],
                    [
                        22.387502073877123,
                        47.399742780163294
                    ],
                    [
                        22.37727014168716,
                        47.398657586791074
                    ],
                    [
                        22.36021690345244,
                        47.401034586770976
                    ],
                    [
                        22.35153527845219,
                        47.40573725768488
                    ],
                    [
                        22.34533409455657,
                        47.41348863662347
                    ],
                    [
                        22.33381024490841,
                        47.43431420175806
                    ],
                    [
                        22.325593697237135,
                        47.44614813811892
                    ],
                    [
                        22.296913273076285,
                        47.476275473278086
                    ],
                    [
                        22.28120364845198,
                        47.49632599701681
                    ],
                    [
                        22.26616579904409,
                        47.5103302575487
                    ],
                    [
                        22.225031359140022,
                        47.531052507813904
                    ],
                    [
                        22.213404171758288,
                        47.53911410576723
                    ],
                    [
                        22.205032580635333,
                        47.548338285712106
                    ],
                    [
                        22.192785275215826,
                        47.56805290363942
                    ],
                    [
                        22.172321403912626,
                        47.589860330046506
                    ],
                    [
                        22.167608022262556,
                        47.594862389711764
                    ],
                    [
                        22.169116640194602,
                        47.601384864430834
                    ],
                    [
                        22.169840141986594,
                        47.608774811559485
                    ],
                    [
                        22.17283736619808,
                        47.61538933963495
                    ],
                    [
                        22.197642064395367,
                        47.63931559929647
                    ],
                    [
                        22.200742654260754,
                        47.64794559042989
                    ],
                    [
                        22.204153281562913,
                        47.666290607006715
                    ],
                    [
                        22.207873987087726,
                        47.67373203073126
                    ],
                    [
                        22.215212034045503,
                        47.67993315228014
                    ],
                    [
                        22.23216188769443,
                        47.68825294463946
                    ],
                    [
                        22.239810037242304,
                        47.69347252685793
                    ],
                    [
                        22.261720832400677,
                        47.7158483397766
                    ],
                    [
                        22.273089650145604,
                        47.7237548529259
                    ],
                    [
                        22.291589791360327,
                        47.73070517971413
                    ],
                    [
                        22.30936649716254,
                        47.735046097087285
                    ],
                    [
                        22.322078886997286,
                        47.735872828280776
                    ],
                    [
                        22.36827761894708,
                        47.731170285996804
                    ],
                    [
                        22.382643658171208,
                        47.7320228800504
                    ],
                    [
                        22.395872840430197,
                        47.73569201914001
                    ],
                    [
                        22.40734502728573,
                        47.74308187315067
                    ],
                    [
                        22.42367475721278,
                        47.78256251496262
                    ],
                    [
                        22.454370568656014,
                        47.78739433329706
                    ],
                    [
                        22.528474568388233,
                        47.76103932277627
                    ],
                    [
                        22.56299442056734,
                        47.757215234550664
                    ],
                    [
                        22.60123500703023,
                        47.76093612658413
                    ],
                    [
                        22.63771852874755,
                        47.77155535565622
                    ],
                    [
                        22.6669674128194,
                        47.78878961088729
                    ],
                    [
                        22.691668720469792,
                        47.8107002385364
                    ],
                    [
                        22.70386438537382,
                        47.81718580773782
                    ],
                    [
                        22.724224901749732,
                        47.82349034792243
                    ],
                    [
                        22.74582565781289,
                        47.82498901305593
                    ],
                    [
                        22.75182010984056,
                        47.827676091731874
                    ],
                    [
                        22.76029505803826,
                        47.83891580666462
                    ],
                    [
                        22.758331321013834,
                        47.84622779663753
                    ],
                    [
                        22.75326702846431,
                        47.85268733326616
                    ],
                    [
                        22.75285364325957,
                        47.86123997263748
                    ],
                    [
                        22.763602342628204,
                        47.87475336891133
                    ],
                    [
                        22.779622016550118,
                        47.882297990356626
                    ],
                    [
                        22.819722950903838,
                        47.89232337119101
                    ],
                    [
                        22.8360527144595,
                        47.90245202943481
                    ],
                    [
                        22.86116741806572,
                        47.93381932967068
                    ],
                    [
                        22.87760055943215,
                        47.94673867772765
                    ],
                    [
                        22.89785771317107,
                        47.950976103386964
                    ],
                    [
                        22.913182252365203,
                        47.95797768388786
                    ],
                    [
                        22.91324134965065,
                        47.95781554273178
                    ],
                    [
                        22.91351257100451,
                        47.95759144284027
                    ],
                    [
                        22.91385199901106,
                        47.95752609324797
                    ],
                    [
                        22.914372091057313,
                        47.95755321949205
                    ],
                    [
                        22.914751056887646,
                        47.95772060080363
                    ],
                    [
                        22.915012790544544,
                        47.95790586089323
                    ],
                    [
                        22.915231092415866,
                        47.95824000750672
                    ],
                    [
                        22.91533270522965,
                        47.95887840121741
                    ],
                    [
                        22.915338977501477,
                        47.958963171128865
                    ],
                    [
                        22.915841090964314,
                        47.95919251239374
                    ],
                    [
                        22.91651722652888,
                        47.9602862014273
                    ],
                    [
                        22.916722393081056,
                        47.96026092446453
                    ],
                    [
                        22.91690251781873,
                        47.9600670317371
                    ],
                    [
                        22.917006259409064,
                        47.95982813387857
                    ],
                    [
                        22.917000209835283,
                        47.959570124409694
                    ],
                    [
                        22.916739768034255,
                        47.95908924715151
                    ],
                    [
                        22.916446130755272,
                        47.958776985610044
                    ],
                    [
                        22.91622202496021,
                        47.958327859769874
                    ],
                    [
                        22.916259409692206,
                        47.95792096529836
                    ],
                    [
                        22.916536712008178,
                        47.95744964657357
                    ],
                    [
                        22.917272480062675,
                        47.95688554471221
                    ],
                    [
                        22.91789076160589,
                        47.95670182652569
                    ],
                    [
                        22.918397651976562,
                        47.95665127321934
                    ],
                    [
                        22.918891694518,
                        47.95666668581181
                    ],
                    [
                        22.91924453227529,
                        47.95682173653709
                    ],
                    [
                        22.919474737466548,
                        47.957023641679754
                    ],
                    [
                        22.91950685117278,
                        47.95729336250675
                    ],
                    [
                        22.919259088388486,
                        47.95761487005612
                    ],
                    [
                        22.918875436829723,
                        47.9579052443869
                    ],
                    [
                        22.918514910023895,
                        47.958149689242504
                    ],
                    [
                        22.918250257351062,
                        47.95841232126872
                    ],
                    [
                        22.91824422026482,
                        47.95865984908587
                    ],
                    [
                        22.91852546926631,
                        47.958818291658666
                    ],
                    [
                        22.918842790494573,
                        47.95886545454218
                    ],
                    [
                        22.91932445220957,
                        47.95872704845455
                    ],
                    [
                        22.919734205301385,
                        47.958448695206336
                    ],
                    [
                        22.920093931919087,
                        47.95828038871917
                    ],
                    [
                        22.920531854733838,
                        47.95814753146861
                    ],
                    [
                        22.92087048637925,
                        47.95815832033822
                    ],
                    [
                        22.921024273391566,
                        47.95831491311891
                    ],
                    [
                        22.92098005728002,
                        47.95853993832397
                    ],
                    [
                        22.92067620317047,
                        47.958713485277976
                    ],
                    [
                        22.92011372793012,
                        47.958902136790165
                    ],
                    [
                        22.919859357965862,
                        47.95918480603115
                    ],
                    [
                        22.919935959605617,
                        47.959372533082
                    ],
                    [
                        22.920336009699717,
                        47.95936051114906
                    ],
                    [
                        22.920886660312796,
                        47.959304408801714
                    ],
                    [
                        22.921294064966727,
                        47.959254779811104
                    ],
                    [
                        22.921760176753715,
                        47.95926741824894
                    ],
                    [
                        22.922096204985884,
                        47.95936390195058
                    ],
                    [
                        22.922298473473752,
                        47.959563034546946
                    ],
                    [
                        22.922463615458728,
                        47.95980655601704
                    ],
                    [
                        22.922765447607585,
                        47.96000507240286
                    ],
                    [
                        22.923125720794705,
                        47.96012282597464
                    ],
                    [
                        22.923494143054064,
                        47.96012683329599
                    ],
                    [
                        22.923794368923264,
                        47.959972397336344
                    ],
                    [
                        22.924119577365083,
                        47.95976278378856
                    ],
                    [
                        22.92450796371979,
                        47.95952049537416
                    ],
                    [
                        22.924852661021582,
                        47.95928406399712
                    ],
                    [
                        22.92522815380508,
                        47.959107434161695
                    ],
                    [
                        22.925543349337026,
                        47.959020814682624
                    ],
                    [
                        22.926048451533934,
                        47.958979816859795
                    ],
                    [
                        22.926460600258476,
                        47.958978275588386
                    ],
                    [
                        22.926809525776292,
                        47.95900910101837
                    ],
                    [
                        22.927222747279906,
                        47.95907445094066
                    ],
                    [
                        22.92761354632228,
                        47.95910897543378
                    ],
                    [
                        22.927884266646366,
                        47.95910435161751
                    ],
                    [
                        22.928329535269537,
                        47.95893388697486
                    ],
                    [
                        22.92900947201274,
                        47.95887007835469
                    ],
                    [
                        22.92961917334845,
                        47.95901958166531
                    ],
                    [
                        22.931027992788916,
                        47.95968479525677
                    ],
                    [
                        22.931607612741537,
                        47.95993910576289
                    ],
                    [
                        22.932751302086096,
                        47.960542361989866
                    ],
                    [
                        22.93413988624279,
                        47.96125443404181
                    ],
                    [
                        22.93447814149988,
                        47.9614609660856
                    ],
                    [
                        22.934755017115393,
                        47.96171435335868
                    ],
                    [
                        22.93497810371224,
                        47.96193444905074
                    ],
                    [
                        22.935383153843688,
                        47.96238542995482
                    ],
                    [
                        22.935736856282006,
                        47.96277198556688
                    ],
                    [
                        22.93606211029425,
                        47.963113844183795
                    ],
                    [
                        22.936310519316233,
                        47.963331166595395
                    ],
                    [
                        22.936641772829514,
                        47.96365144771945
                    ],
                    [
                        22.93676830309621,
                        47.96374854938044
                    ],
                    [
                        22.936926165186662,
                        47.96381266732025
                    ],
                    [
                        22.93705784578214,
                        47.96382900506677
                    ],
                    [
                        22.937231326014967,
                        47.96381328383897
                    ],
                    [
                        22.937429462378173,
                        47.96378091660792
                    ],
                    [
                        22.93764786746086,
                        47.96377166882827
                    ],
                    [
                        22.938456482196898,
                        47.96381205080155
                    ],
                    [
                        22.93995741374102,
                        47.963870928345
                    ],
                    [
                        22.940596090559193,
                        47.96392764808391
                    ],
                    [
                        22.941224335855438,
                        47.964018892904285
                    ],
                    [
                        22.941657153125448,
                        47.96409287521192
                    ],
                    [
                        22.94185976986345,
                        47.96418257878491
                    ],
                    [
                        22.94194209036833,
                        47.96428738711798
                    ],
                    [
                        22.941953028134826,
                        47.96437678249046
                    ],
                    [
                        22.941936161693146,
                        47.96453491988848
                    ],
                    [
                        22.941868385239136,
                        47.96498929565435
                    ],
                    [
                        22.94184144984907,
                        47.96532529989565
                    ],
                    [
                        22.94182545777274,
                        47.96553399263184
                    ],
                    [
                        22.941872879999448,
                        47.965635718834726
                    ],
                    [
                        22.9419589183616,
                        47.965722032004244
                    ],
                    [
                        22.94212514572077,
                        47.965779676885155
                    ],
                    [
                        22.942465609314613,
                        47.96583608873146
                    ],
                    [
                        22.942712025520816,
                        47.96586506531246
                    ],
                    [
                        22.943016220982674,
                        47.965925484575656
                    ],
                    [
                        22.943285291057645,
                        47.96600162519548
                    ],
                    [
                        22.944019526170482,
                        47.96624052807819
                    ],
                    [
                        22.944733315927092,
                        47.96647542374733
                    ],
                    [
                        22.946528224130546,
                        47.966937200820844
                    ],
                    [
                        22.947079160742135,
                        47.967078693407366
                    ],
                    [
                        22.94727985952862,
                        47.96714188728614
                    ],
                    [
                        22.94742957659132,
                        47.96719336718769
                    ],
                    [
                        22.94749530705811,
                        47.96725625282818
                    ],
                    [
                        22.94750643319566,
                        47.96732653679526
                    ],
                    [
                        22.947468651464263,
                        47.96739219683235
                    ],
                    [
                        22.947325008482753,
                        47.96752752437294
                    ],
                    [
                        22.94691298576134,
                        47.96790822974796
                    ],
                    [
                        22.94678263494026,
                        47.96806606078511
                    ],
                    [
                        22.946645744203874,
                        47.968220809267265
                    ],
                    [
                        22.94653660806237,
                        47.96830650666897
                    ],
                    [
                        22.94638736240346,
                        47.96834349836089
                    ],
                    [
                        22.946291008497813,
                        47.96832777689124
                    ],
                    [
                        22.946163646374703,
                        47.96827136456594
                    ],
                    [
                        22.94584283968138,
                        47.96807839133844
                    ],
                    [
                        22.945772728534987,
                        47.968055271551364
                    ],
                    [
                        22.94565923147274,
                        47.96805496328753
                    ],
                    [
                        22.945562519130004,
                        47.96807746654693
                    ],
                    [
                        22.945394131813078,
                        47.96819368203738
                    ],
                    [
                        22.94460945305418,
                        47.968856142038305
                    ],
                    [
                        22.943816231083165,
                        47.969587038451444
                    ],
                    [
                        22.943649895791,
                        47.96978340359313
                    ],
                    [
                        22.943559596699334,
                        47.96997206222039
                    ],
                    [
                        22.943306594250227,
                        47.97071868301056
                    ],
                    [
                        22.94316583826554,
                        47.97111049013923
                    ],
                    [
                        22.943106405201835,
                        47.9713592617349
                    ],
                    [
                        22.94305715459993,
                        47.97150137298891
                    ],
                    [
                        22.942833483420358,
                        47.97180008428745
                    ],
                    [
                        22.94256694558915,
                        47.97212715655354
                    ],
                    [
                        22.942476636869767,
                        47.97231581668816
                    ],
                    [
                        22.942404918611565,
                        47.97254547665632
                    ],
                    [
                        22.94241352022541,
                        47.972800106576194
                    ],
                    [
                        22.942441181393097,
                        47.972985067915694
                    ],
                    [
                        22.942500919520587,
                        47.97316910456428
                    ],
                    [
                        22.942615531595735,
                        47.9733725623001
                    ],
                    [
                        22.942757670546307,
                        47.97357108786321
                    ],
                    [
                        22.942854203995168,
                        47.97381215479913
                    ],
                    [
                        22.942935957134047,
                        47.974155567630596
                    ],
                    [
                        22.94307666853278,
                        47.974633078600505
                    ],
                    [
                        22.94317567557367,
                        47.974888635145895
                    ],
                    [
                        22.94321271149543,
                        47.97505294363349
                    ],
                    [
                        22.943185770999065,
                        47.97518981606494
                    ],
                    [
                        22.943139424492024,
                        47.97537169619657
                    ],
                    [
                        22.94290397981031,
                        47.975866164107664
                    ],
                    [
                        22.942648052840024,
                        47.97643708445373
                    ],
                    [
                        22.942164235701703,
                        47.97759989110187
                    ],
                    [
                        22.941900016158694,
                        47.97821304842643
                    ],
                    [
                        22.941764316855075,
                        47.97855153401474
                    ],
                    [
                        22.94150679805092,
                        47.97902257836175
                    ],
                    [
                        22.94137344495245,
                        47.979321913873505
                    ],
                    [
                        22.94121562091013,
                        47.97990887131538
                    ],
                    [
                        22.941088420427835,
                        47.98031240523844
                    ],
                    [
                        22.94095808592078,
                        47.980705150017926
                    ],
                    [
                        22.940839357692404,
                        47.98098444921582
                    ],
                    [
                        22.94068226022008,
                        47.98129580956258
                    ],
                    [
                        22.940427458158496,
                        47.98175267752163
                    ],
                    [
                        22.94014793399508,
                        47.98225363004975
                    ],
                    [
                        22.940036927328205,
                        47.982548036396544
                    ],
                    [
                        22.939869180835785,
                        47.98340227889483
                    ],
                    [
                        22.939689193071032,
                        47.984237718752276
                    ],
                    [
                        22.93967655389357,
                        47.98451917928496
                    ],
                    [
                        22.939735103991328,
                        47.98480834712369
                    ],
                    [
                        22.939841794640532,
                        47.98549489067286
                    ],
                    [
                        22.93994816291018,
                        47.986653725576026
                    ],
                    [
                        22.940074158223176,
                        47.987947902030406
                    ],
                    [
                        22.940070894844816,
                        47.98820871103146
                    ],
                    [
                        22.940028361540467,
                        47.988397998087855
                    ],
                    [
                        22.93986471671553,
                        47.98890574426512
                    ],
                    [
                        22.9392194073337,
                        47.99072648551817
                    ],
                    [
                        22.938921949311297,
                        47.99150861235318
                    ],
                    [
                        22.938769418139355,
                        47.992013589322596
                    ],
                    [
                        22.938486325754745,
                        47.99299364173813
                    ],
                    [
                        22.938014952641854,
                        47.99425393415839
                    ],
                    [
                        22.937752606542986,
                        47.994992601220126
                    ],
                    [
                        22.937628879166972,
                        47.99524293455376
                    ],
                    [
                        22.93755380558647,
                        47.99540787104204
                    ],
                    [
                        22.937421524688993,
                        47.99559284665346
                    ],
                    [
                        22.936573408310338,
                        47.99670886865609
                    ],
                    [
                        22.936266099079983,
                        47.99716113624286
                    ],
                    [
                        22.935689091765447,
                        47.998042859655335
                    ],
                    [
                        22.935218042848412,
                        47.99889159802287
                    ],
                    [
                        22.935135161571736,
                        47.998988094767576
                    ],
                    [
                        22.934967097151016,
                        47.9990842832476
                    ],
                    [
                        22.934781102740335,
                        47.99913576876116
                    ],
                    [
                        22.93464724270093,
                        47.999147484028974
                    ],
                    [
                        22.93437497105648,
                        47.9991770804971
                    ],
                    [
                        22.93399793659078,
                        47.999197428070715
                    ],
                    [
                        22.93358848609627,
                        47.999247063824335
                    ],
                    [
                        22.933234442114255,
                        47.99925847079995
                    ],
                    [
                        22.932873144468605,
                        47.99928035986255
                    ],
                    [
                        22.932295365976703,
                        47.999318588651825
                    ],
                    [
                        22.931598464288413,
                        47.99933893623526
                    ],
                    [
                        22.93002101569794,
                        47.99933893623526
                    ],
                    [
                        22.92944390315007,
                        47.99937346547097
                    ],
                    [
                        22.929052656048732,
                        47.99943913268944
                    ],
                    [
                        22.92874379631584,
                        47.999518981580586
                    ],
                    [
                        22.928472999138005,
                        47.99959513092951
                    ],
                    [
                        22.928143333592445,
                        47.99972708207495
                    ],
                    [
                        22.927782293897565,
                        47.99990959403775
                    ],
                    [
                        22.9270949597823,
                        48.000342443810105
                    ],
                    [
                        22.92666276521324,
                        48.00056164361856
                    ],
                    [
                        22.926346085995824,
                        48.00076234569689
                    ],
                    [
                        22.92598072845276,
                        48.001048446593444
                    ],
                    [
                        22.925740836646202,
                        48.0012380502512
                    ],
                    [
                        22.925491604850578,
                        48.00144861835989
                    ],
                    [
                        22.925208713112344,
                        48.00161294174763
                    ],
                    [
                        22.924749241676736,
                        48.00180840345848
                    ],
                    [
                        22.92404848358324,
                        48.00201095618938
                    ],
                    [
                        22.923249406903633,
                        48.00228010181593
                    ],
                    [
                        22.92307562721796,
                        48.00235039418529
                    ],
                    [
                        22.922905021584604,
                        48.00243178537091
                    ],
                    [
                        22.922794951259228,
                        48.00255818839348
                    ],
                    [
                        22.92274058170119,
                        48.002807294997865
                    ],
                    [
                        22.922729734104347,
                        48.00287265468661
                    ],
                    [
                        22.924109344978643,
                        48.004822969854786
                    ],
                    [
                        22.93930222360531,
                        48.005649838352234
                    ],
                    [
                        22.957078917124143,
                        48.000120469487854
                    ],
                    [
                        22.972478489777338,
                        47.99288574024199
                    ],
                    [
                        22.988188111485943,
                        47.986374420974194
                    ],
                    [
                        23.004414518910785,
                        47.98306717878003
                    ],
                    [
                        23.020330855655708,
                        47.98472079521063
                    ],
                    [
                        23.05491360815736,
                        48.00309802240464
                    ],
                    [
                        23.05698730431816,
                        48.00334188835255
                    ],
                    [
                        23.05860673310311,
                        48.00414778813987
                    ],
                    [
                        23.06566987204095,
                        48.00766090821792
                    ],
                    [
                        23.06956981776551,
                        48.008022242488025
                    ],
                    [
                        23.07457925003333,
                        48.0084862432082
                    ],
                    [
                        23.077795754483873,
                        48.00773705968652
                    ],
                    [
                        23.07808355960939,
                        48.007636860389866
                    ],
                    [
                        23.083419638813485,
                        48.00466635222224
                    ],
                    [
                        23.083813948465615,
                        48.00451065958013
                    ],
                    [
                        23.08407981785501,
                        48.004536865266566
                    ],
                    [
                        23.084663316032202,
                        48.004757609730206
                    ],
                    [
                        23.085091793500936,
                        48.004884322060455
                    ],
                    [
                        23.085637605201644,
                        48.004955848266256
                    ],
                    [
                        23.08644203905186,
                        48.00499931894297
                    ],
                    [
                        23.088186889113384,
                        48.00516333602254
                    ],
                    [
                        23.08942523432844,
                        48.00525921823005
                    ],
                    [
                        23.089718661861284,
                        48.00532642828494
                    ],
                    [
                        23.089972684456306,
                        48.00546331486652
                    ],
                    [
                        23.090197160406305,
                        48.00571211564171
                    ],
                    [
                        23.0903983387174,
                        48.005912204646656
                    ],
                    [
                        23.090647870400836,
                        48.00621989185824
                    ],
                    [
                        23.091000327035125,
                        48.00662993644101
                    ],
                    [
                        23.091408300888023,
                        48.00697307945481
                    ],
                    [
                        23.091836742117106,
                        48.007292791681785
                    ],
                    [
                        23.092020558919796,
                        48.00744478614178
                    ],
                    [
                        23.092187545117334,
                        48.007655975329946
                    ],
                    [
                        23.092307643153582,
                        48.00791680189551
                    ],
                    [
                        23.092356016354852,
                        48.00821801678849
                    ],
                    [
                        23.092340283833874,
                        48.008648412404305
                    ],
                    [
                        23.092108814581383,
                        48.00967939129854
                    ],
                    [
                        23.09212344158926,
                        48.010016680039485
                    ],
                    [
                        23.092227027032756,
                        48.01039065786441
                    ],
                    [
                        23.092498959910984,
                        48.01069341684968
                    ],
                    [
                        23.093097298226454,
                        48.01109945968781
                    ],
                    [
                        23.093447288953104,
                        48.011495020565306
                    ],
                    [
                        23.093849706340556,
                        48.01197690878001
                    ],
                    [
                        23.09489042881383,
                        48.013816600652724
                    ],
                    [
                        23.09537782615811,
                        48.01443846660453
                    ],
                    [
                        23.09560711336823,
                        48.014658910231866
                    ],
                    [
                        23.096004608057495,
                        48.01491881810677
                    ],
                    [
                        23.096558285880512,
                        48.01525302975906
                    ],
                    [
                        23.097149398154038,
                        48.01558724179354
                    ],
                    [
                        23.097422615183618,
                        48.01579134564102
                    ],
                    [
                        23.0902009465121,
                        48.016454221657774
                    ],
                    [
                        23.090200937018437,
                        48.016454221657774
                    ],
                    [
                        23.090053441207402,
                        48.017411848921874
                    ],
                    [
                        23.090053431563828,
                        48.017411848921874
                    ],
                    [
                        23.09005342307009,
                        48.017411848921874
                    ],
                    [
                        23.08983042460429,
                        48.01926699090096
                    ],
                    [
                        23.09238339273052,
                        48.02056439485202
                    ],
                    [
                        23.09202410818543,
                        48.02101608270364
                    ],
                    [
                        23.09253179873098,
                        48.0214458805298
                    ],
                    [
                        23.092709768562607,
                        48.022079478909156
                    ],
                    [
                        23.095929671345203,
                        48.02294709468642
                    ],
                    [
                        23.097528583435622,
                        48.02365592697361
                    ],
                    [
                        23.098591996327055,
                        48.024270414120046
                    ],
                    [
                        23.098820846327882,
                        48.02440823454569
                    ],
                    [
                        23.10137161105541,
                        48.025943071333586
                    ],
                    [
                        23.10151806038063,
                        48.026922620846264
                    ],
                    [
                        23.103224613081874,
                        48.029044526908656
                    ],
                    [
                        23.105579453916842,
                        48.030436323134026
                    ],
                    [
                        23.106863206835815,
                        48.032343964234705
                    ],
                    [
                        23.10923131397078,
                        48.03521115346266
                    ],
                    [
                        23.109049469538807,
                        48.035710347585116
                    ],
                    [
                        23.109157887825052,
                        48.03830962417889
                    ],
                    [
                        23.10710407780937,
                        48.039150462741006
                    ],
                    [
                        23.106334382832564,
                        48.03938140855709
                    ],
                    [
                        23.10448502155576,
                        48.03990805203681
                    ],
                    [
                        23.103427974500264,
                        48.04059349166725
                    ],
                    [
                        23.100894595871296,
                        48.040917865819296
                    ],
                    [
                        23.098540783972613,
                        48.043577932486244
                    ],
                    [
                        23.098234947155632,
                        48.044176736049934
                    ],
                    [
                        23.0982100428625,
                        48.04422514607255
                    ],
                    [
                        23.101670325077926,
                        48.04624819885594
                    ],
                    [
                        23.104906447892404,
                        48.04821452958408
                    ],
                    [
                        23.109757713940084,
                        48.05131899721
                    ],
                    [
                        23.11192111746779,
                        48.053731858676
                    ],
                    [
                        23.11242729988162,
                        48.0543695358191
                    ],
                    [
                        23.110813825103182,
                        48.055484549111554
                    ],
                    [
                        23.110874237132624,
                        48.05621967083009
                    ],
                    [
                        23.10913842566526,
                        48.05748146965068
                    ],
                    [
                        23.109449386427663,
                        48.0591179309591
                    ],
                    [
                        23.112494160359848,
                        48.06177569694019
                    ],
                    [
                        23.11071338093208,
                        48.06184877890941
                    ],
                    [
                        23.108319676265783,
                        48.06294346883051
                    ],
                    [
                        23.106687275737876,
                        48.06352041833066
                    ],
                    [
                        23.106825120677914,
                        48.065124226772895
                    ],
                    [
                        23.105738739606494,
                        48.06518250799986
                    ],
                    [
                        23.105206953669466,
                        48.06573078381764
                    ],
                    [
                        23.105509074392806,
                        48.066028974755305
                    ],
                    [
                        23.106015130093628,
                        48.06642584362314
                    ],
                    [
                        23.106762724935628,
                        48.066901038527654
                    ],
                    [
                        23.10722502899304,
                        48.067122446931265
                    ],
                    [
                        23.107810729955006,
                        48.06731795254199
                    ],
                    [
                        23.108325623957917,
                        48.067400595331755
                    ],
                    [
                        23.108940104430022,
                        48.06747892098254
                    ],
                    [
                        23.109292510894583,
                        48.06758839190778
                    ],
                    [
                        23.109537983542417,
                        48.067781430879116
                    ],
                    [
                        23.109649035098585,
                        48.0679519590227
                    ],
                    [
                        23.109787574127814,
                        48.068228566368745
                    ],
                    [
                        23.109882814572096,
                        48.068508874415855
                    ],
                    [
                        23.110042011519628,
                        48.06877715629817
                    ],
                    [
                        23.110259089816843,
                        48.068963720281715
                    ],
                    [
                        23.110682489091275,
                        48.069171253580926
                    ],
                    [
                        23.111348886941865,
                        48.06948795029767
                    ],
                    [
                        23.113231854937304,
                        48.06938649629731
                    ],
                    [
                        23.113635683949465,
                        48.06953883149659
                    ],
                    [
                        23.11483574432875,
                        48.07152012146812
                    ],
                    [
                        23.11780568391232,
                        48.07655342964417
                    ],
                    [
                        23.120675299999135,
                        48.075940065713624
                    ],
                    [
                        23.12333901706224,
                        48.07740887250132
                    ],
                    [
                        23.12177429105057,
                        48.078603227897894
                    ],
                    [
                        23.122283910897504,
                        48.07966344214598
                    ],
                    [
                        23.123397240544087,
                        48.0816102621528
                    ],
                    [
                        23.122306409102542,
                        48.08226218610367
                    ],
                    [
                        23.119448161811057,
                        48.083551235875966
                    ],
                    [
                        23.11391945571511,
                        48.08609943889742
                    ],
                    [
                        23.113852660399555,
                        48.08626041774064
                    ],
                    [
                        23.113973197374463,
                        48.0865570877966
                    ],
                    [
                        23.114263235563843,
                        48.086713441056126
                    ],
                    [
                        23.115268511414968,
                        48.08694380784639
                    ],
                    [
                        23.116909996099608,
                        48.087289204179605
                    ],
                    [
                        23.118063358707065,
                        48.087687644031476
                    ],
                    [
                        23.118170991542904,
                        48.087756415051935
                    ],
                    [
                        23.11821007666659,
                        48.0878671271774
                    ],
                    [
                        23.118195733251337,
                        48.08797783934509
                    ],
                    [
                        23.11815084491103,
                        48.088081458570926
                    ],
                    [
                        23.118041591178905,
                        48.088209440701505
                    ],
                    [
                        23.117947037924168,
                        48.08830689219297
                    ],
                    [
                        23.11793986291561,
                        48.08839940946197
                    ],
                    [
                        23.117977717339258,
                        48.0884980945814
                    ],
                    [
                        23.118072962804526,
                        48.088649206235544
                    ],
                    [
                        23.118162919704112,
                        48.08880956970962
                    ],
                    [
                        23.118206807857774,
                        48.088987511591284
                    ],
                    [
                        23.118231717611334,
                        48.0891901249238
                    ],
                    [
                        23.11854834415954,
                        48.089834664471475
                    ],
                    [
                        23.118680605957476,
                        48.09011468496968
                    ],
                    [
                        23.118714672109903,
                        48.09018684888634
                    ],
                    [
                        23.122523272543653,
                        48.09105405086061
                    ],
                    [
                        23.126978190022225,
                        48.09217383078452
                    ],
                    [
                        23.127653419456706,
                        48.09255932473506
                    ],
                    [
                        23.12971829008082,
                        48.09510945721471
                    ],
                    [
                        23.1314435072673,
                        48.09566488267996
                    ],
                    [
                        23.13638278552416,
                        48.09604791407554
                    ],
                    [
                        23.137585173811086,
                        48.09461386193091
                    ],
                    [
                        23.13884674993703,
                        48.094532753386964
                    ],
                    [
                        23.140530223276905,
                        48.09710479962298
                    ],
                    [
                        23.142352996260634,
                        48.097803635309354
                    ],
                    [
                        23.161717577405483,
                        48.09590265814863
                    ],
                    [
                        23.231377402196657,
                        48.07972789392222
                    ],
                    [
                        23.248637337346747,
                        48.07122716723664
                    ],
                    [
                        23.28977179178208,
                        48.03820602267561
                    ],
                    [
                        23.337520810234448,
                        48.01086915286076
                    ],
                    [
                        23.360051726739062,
                        47.9931440873192
                    ],
                    [
                        23.36728642171191,
                        47.991206181508254
                    ],
                    [
                        23.37472784165202,
                        47.99056031851721
                    ],
                    [
                        23.382169207404413,
                        47.99112849290126
                    ],
                    [
                        23.39012738435303,
                        47.993066398198046
                    ],
                    [
                        23.391574363050246,
                        47.993454227429
                    ],
                    [
                        23.393021300437727,
                        47.99358340118993
                    ],
                    [
                        23.39446824305296,
                        47.993454227429
                    ],
                    [
                        23.39601849734882,
                        47.993066398198046
                    ],
                    [
                        23.460820741910993,
                        47.97133644995649
                    ],
                    [
                        23.481594707474063,
                        47.97216353219099
                    ],
                    [
                        23.48228405389192,
                        47.97253129630408
                    ],
                    [
                        23.483675681644687,
                        47.97197641349397
                    ],
                    [
                        23.486266988169124,
                        47.9714455765881
                    ],
                    [
                        23.486761599407465,
                        47.971112648008436
                    ]
                ]
            ]
        },
        "type": "Feature",
        "properties": {
            "source": "https://simplemaps.com",
            "id": "ROSM",
            "name": "Satu Mare"
        },
        "id": 1
    },
    {
        "geometry": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        21.42353890919739,
                        46.65823093293306
                    ],
                    [
                        21.445337356514653,
                        46.653173339790435
                    ],
                    [
                        21.492001181565755,
                        46.64521521534363
                    ],
                    [
                        21.82577923957459,
                        46.65808251314739
                    ],
                    [
                        21.85172081797818,
                        46.654826964117454
                    ],
                    [
                        21.85823204720028,
                        46.64865162336307
                    ],
                    [
                        21.86613853550604,
                        46.6429154970401
                    ],
                    [
                        21.879936147130543,
                        46.63821297262845
                    ],
                    [
                        21.892855252849692,
                        46.637127748726016
                    ],
                    [
                        21.911923869040344,
                        46.637592931950195
                    ],
                    [
                        21.92463625980163,
                        46.63508653673596
                    ],
                    [
                        21.940604285573624,
                        46.62883375319975
                    ],
                    [
                        21.953833442273094,
                        46.61963527549545
                    ],
                    [
                        21.97863812674623,
                        46.613201541374494
                    ],
                    [
                        22.066798134108847,
                        46.610695329957636
                    ],
                    [
                        22.09377322139908,
                        46.60694870873543
                    ],
                    [
                        22.112221707463224,
                        46.60103176027831
                    ],
                    [
                        22.12297040796441,
                        46.59405546045437
                    ],
                    [
                        22.145449657205656,
                        46.58273833132529
                    ],
                    [
                        22.153046087883233,
                        46.57602035799105
                    ],
                    [
                        22.16064253901553,
                        46.564393273885415
                    ],
                    [
                        22.18224328683599,
                        46.524033972393994
                    ],
                    [
                        22.19433557219668,
                        46.5074975163707
                    ],
                    [
                        22.20937341356048,
                        46.49491430056698
                    ],
                    [
                        22.229062120389223,
                        46.48548325667984
                    ],
                    [
                        22.254383573396662,
                        46.47997972467055
                    ],
                    [
                        22.27050663462768,
                        46.47488969710814
                    ],
                    [
                        22.317997270571905,
                        46.446622655616146
                    ],
                    [
                        22.392928102881722,
                        46.4269081303375
                    ],
                    [
                        22.401506385914363,
                        46.42037102836104
                    ],
                    [
                        22.40445194975797,
                        46.411637757171746
                    ],
                    [
                        22.40910281377104,
                        46.40161243309846
                    ],
                    [
                        22.42026493715698,
                        46.39021787550333
                    ],
                    [
                        22.435147748856068,
                        46.38450762747076
                    ],
                    [
                        22.450650660169646,
                        46.38187199550975
                    ],
                    [
                        22.541291125055825,
                        46.38058010468702
                    ],
                    [
                        22.61761723259234,
                        46.3692630804588
                    ],
                    [
                        22.664952841272793,
                        46.3665242072394
                    ],
                    [
                        22.70670739617802,
                        46.36874628130972
                    ],
                    [
                        22.755283230862542,
                        46.33381293160235
                    ],
                    [
                        22.68965416228829,
                        46.30024908911714
                    ],
                    [
                        22.671929151907527,
                        46.27371328228213
                    ],
                    [
                        22.66309248584232,
                        46.25753858767561
                    ],
                    [
                        22.640303174409162,
                        46.23144195161518
                    ],
                    [
                        22.619322538482205,
                        46.21823859543536
                    ],
                    [
                        22.600719026646026,
                        46.21092641150782
                    ],
                    [
                        22.576534460148572,
                        46.20854931624948
                    ],
                    [
                        22.557879269879805,
                        46.209479505344156
                    ],
                    [
                        22.502017048049904,
                        46.2188587896511
                    ],
                    [
                        22.484188672749063,
                        46.217334288038856
                    ],
                    [
                        22.47023603302498,
                        46.21195991960709
                    ],
                    [
                        22.447084999010357,
                        46.19725802964653
                    ],
                    [
                        22.43809330059311,
                        46.187103619338416
                    ],
                    [
                        22.433597441731173,
                        46.17614814798788
                    ],
                    [
                        22.436543001927987,
                        46.143281962732935
                    ],
                    [
                        22.4345276257482,
                        46.12932935853291
                    ],
                    [
                        22.429566684198207,
                        46.114239809667666
                    ],
                    [
                        22.415303991866043,
                        46.09349174534349
                    ],
                    [
                        22.409567902085275,
                        46.08121855569388
                    ],
                    [
                        22.40724246491263,
                        46.07134837065385
                    ],
                    [
                        22.417784461178258,
                        46.04773226832143
                    ],
                    [
                        22.420109897045478,
                        46.037500305268566
                    ],
                    [
                        22.419644806304095,
                        46.02533048572343
                    ],
                    [
                        22.4125134638196,
                        46.00907828537351
                    ],
                    [
                        22.40150637968027,
                        45.99166330041811
                    ],
                    [
                        22.354945916317416,
                        45.949857082579264
                    ],
                    [
                        22.336755814688203,
                        45.943345869623585
                    ],
                    [
                        22.33288008390857,
                        45.94068454771309
                    ],
                    [
                        22.328229200178416,
                        45.936576236581445
                    ],
                    [
                        22.322183059308262,
                        45.922106851291964
                    ],
                    [
                        22.317842241181676,
                        45.91838615944433
                    ],
                    [
                        22.311796093471784,
                        45.9161640395674
                    ],
                    [
                        22.294277790272922,
                        45.915130557132
                    ],
                    [
                        22.257174110118225,
                        45.908903536415046
                    ],
                    [
                        22.249112580144228,
                        45.90619047673096
                    ],
                    [
                        22.241826205046063,
                        45.90133290309284
                    ],
                    [
                        22.23578006163941,
                        45.89642363211152
                    ],
                    [
                        22.228958780099468,
                        45.892754663698796
                    ],
                    [
                        22.220225459470182,
                        45.893064704051106
                    ],
                    [
                        22.195575799851255,
                        45.90246979730186
                    ],
                    [
                        22.181933218191705,
                        45.90448515733489
                    ],
                    [
                        22.16172773920392,
                        45.90257317238373
                    ],
                    [
                        22.146069773329106,
                        45.90267647092126
                    ],
                    [
                        22.13134199080398,
                        45.905156946533914
                    ],
                    [
                        22.12074832500479,
                        45.911874907885455
                    ],
                    [
                        22.11315189361452,
                        45.918256973173506
                    ],
                    [
                        22.10555545808133,
                        45.922597795289434
                    ],
                    [
                        22.089122348713513,
                        45.92784292041722
                    ],
                    [
                        22.081370882883203,
                        45.93177032463276
                    ],
                    [
                        22.077185088178638,
                        45.936602044524776
                    ],
                    [
                        22.074394561155604,
                        45.943655877277614
                    ],
                    [
                        22.06865847902824,
                        45.94913359157914
                    ],
                    [
                        22.058839954396518,
                        45.952595900286774
                    ],
                    [
                        22.019152463279077,
                        45.95512811153858
                    ],
                    [
                        22.001427443119884,
                        45.95859040194344
                    ],
                    [
                        21.98902509709981,
                        45.966341848482344
                    ],
                    [
                        21.980653516856535,
                        45.97357656180499
                    ],
                    [
                        21.969801468739657,
                        45.97905427719446
                    ],
                    [
                        21.955228709544226,
                        45.98215483021627
                    ],
                    [
                        21.931457554435823,
                        45.98220652930672
                    ],
                    [
                        21.919520299722244,
                        45.98065624918614
                    ],
                    [
                        21.91176883621794,
                        45.97765902950683
                    ],
                    [
                        21.907738067831165,
                        45.97259468718305
                    ],
                    [
                        21.904947543643186,
                        45.96647105217718
                    ],
                    [
                        21.89812625443475,
                        45.9440951573597
                    ],
                    [
                        21.89450890107796,
                        45.938824138422184
                    ],
                    [
                        21.888617786862298,
                        45.93549100276649
                    ],
                    [
                        21.880711301841387,
                        45.93458673312004
                    ],
                    [
                        21.858542111261613,
                        45.93466423310497
                    ],
                    [
                        21.848775264603795,
                        45.93688631493226
                    ],
                    [
                        21.839628529565573,
                        45.94272570195874
                    ],
                    [
                        21.83244551390635,
                        45.946136407716594
                    ],
                    [
                        21.82717451003544,
                        45.94644641779764
                    ],
                    [
                        21.82236860651301,
                        45.94050366033431
                    ],
                    [
                        21.820973337341023,
                        45.93334642932734
                    ],
                    [
                        21.820818314941423,
                        45.92520744466495
                    ],
                    [
                        21.821903519562582,
                        45.911306483678466
                    ],
                    [
                        21.820198199243844,
                        45.906268047132876
                    ],
                    [
                        21.816012405518084,
                        45.90495027148249
                    ],
                    [
                        21.809966260103582,
                        45.906913957302194
                    ],
                    [
                        21.80159468410752,
                        45.914200379548156
                    ],
                    [
                        21.789347359981146,
                        45.92799791747556
                    ],
                    [
                        21.78092411065135,
                        45.93381158103483
                    ],
                    [
                        21.76945193885336,
                        45.939263412551824
                    ],
                    [
                        21.73674075771603,
                        45.94965038165565
                    ],
                    [
                        21.722633087757657,
                        45.94934029220294
                    ],
                    [
                        21.714364866604885,
                        45.945929708951226
                    ],
                    [
                        21.707078487220368,
                        45.93957349323862
                    ],
                    [
                        21.69359093735112,
                        45.922933668454995
                    ],
                    [
                        21.683514036862746,
                        45.9071207100627
                    ],
                    [
                        21.677622920824373,
                        45.90239230429711
                    ],
                    [
                        21.670336541380617,
                        45.90174632571246
                    ],
                    [
                        21.662688426530167,
                        45.90789580425254
                    ],
                    [
                        21.657572464616706,
                        45.91409700110711
                    ],
                    [
                        21.65137128715687,
                        45.919367961312894
                    ],
                    [
                        21.638658891431014,
                        45.92577589097896
                    ],
                    [
                        21.634163037053987,
                        45.92887643962316
                    ],
                    [
                        21.633077833580806,
                        45.933320621619444
                    ],
                    [
                        21.6347831554031,
                        45.93828155597366
                    ],
                    [
                        21.63819379977511,
                        45.94350087341689
                    ],
                    [
                        21.639589068976015,
                        45.94908197388001
                    ],
                    [
                        21.635713329531875,
                        45.955929042739115
                    ],
                    [
                        21.62687666142122,
                        45.9640164197635
                    ],
                    [
                        21.60667118090311,
                        45.97585035488676
                    ],
                    [
                        21.58419192934861,
                        45.99202505071944
                    ],
                    [
                        21.573959999562863,
                        45.99639174221212
                    ],
                    [
                        21.56310794849944,
                        45.99791620210251
                    ],
                    [
                        21.53577110882695,
                        45.99522896585252
                    ],
                    [
                        21.52553917347131,
                        45.9974510431442
                    ],
                    [
                        21.51871788524024,
                        46.00463407548532
                    ],
                    [
                        21.51670251048956,
                        46.0124889389085
                    ],
                    [
                        21.516702512476716,
                        46.02031793283553
                    ],
                    [
                        21.515772330585666,
                        46.02706166295769
                    ],
                    [
                        21.50724572315203,
                        46.03284944835702
                    ],
                    [
                        21.49169111639835,
                        46.036621820701626
                    ],
                    [
                        21.45851484938375,
                        46.039102311921646
                    ],
                    [
                        21.441616648798554,
                        46.03786202583117
                    ],
                    [
                        21.43102298570274,
                        46.034038010172246
                    ],
                    [
                        21.428852571038263,
                        46.02840524617837
                    ],
                    [
                        21.428852575061327,
                        46.02140311946042
                    ],
                    [
                        21.42761233506007,
                        46.014710971285986
                    ],
                    [
                        21.423891632639844,
                        46.008328937169225
                    ],
                    [
                        21.417535434109478,
                        46.003445535879536
                    ],
                    [
                        21.390973745459277,
                        45.98866606438832
                    ],
                    [
                        21.36864953289649,
                        45.972904796901204
                    ],
                    [
                        21.361828238585755,
                        45.97073434091112
                    ],
                    [
                        21.35547203416044,
                        45.97210375088929
                    ],
                    [
                        21.341209340542996,
                        45.983705116880245
                    ],
                    [
                        21.330615679807508,
                        45.98742587845409
                    ],
                    [
                        21.31356245653061,
                        45.98758090145883
                    ],
                    [
                        21.299299759645866,
                        45.98603059786683
                    ],
                    [
                        21.28813765155687,
                        45.9826199691186
                    ],
                    [
                        21.26483157612081,
                        45.96887400437505
                    ],
                    [
                        21.250723912921092,
                        45.968925701533045
                    ],
                    [
                        21.233515661180974,
                        45.975281905252196
                    ],
                    [
                        21.207109000591917,
                        45.993471979020754
                    ],
                    [
                        21.199667600683085,
                        46.00566766469374
                    ],
                    [
                        21.19842735750226,
                        46.014710971285986
                    ],
                    [
                        21.195946894447143,
                        46.01879345309244
                    ],
                    [
                        21.1888155410941,
                        46.020472893635606
                    ],
                    [
                        21.173622673412464,
                        46.01905182214928
                    ],
                    [
                        21.163494088968356,
                        46.015356925127044
                    ],
                    [
                        21.154812452764688,
                        46.0096467125812
                    ],
                    [
                        21.15031659909543,
                        46.0041689843043
                    ],
                    [
                        21.14845625253249,
                        45.998484611399746
                    ],
                    [
                        21.148146193656324,
                        45.98685741028799
                    ],
                    [
                        21.146440873853326,
                        45.981379727718306
                    ],
                    [
                        21.14241010643519,
                        45.976832161915
                    ],
                    [
                        21.135123730264358,
                        45.97373157876391
                    ],
                    [
                        21.124581741506322,
                        45.973059813567126
                    ],
                    [
                        21.109957305293715,
                        45.97533352675247
                    ],
                    [
                        21.09693485129525,
                        45.980139490649975
                    ],
                    [
                        21.083912390833422,
                        45.99207675124785
                    ],
                    [
                        21.08174197533848,
                        45.99889799358895
                    ],
                    [
                        21.083912386834538,
                        46.01052520671503
                    ],
                    [
                        21.079726595404143,
                        46.01533111146224
                    ],
                    [
                        21.06949466415062,
                        46.01985282104457
                    ],
                    [
                        21.047893912006817,
                        46.02390939471319
                    ],
                    [
                        21.035646600578122,
                        46.02339264968957
                    ],
                    [
                        21.016888055570767,
                        46.02018870952131
                    ],
                    [
                        21.00820641571988,
                        46.019930339633916
                    ],
                    [
                        20.946298046817255,
                        46.027991829520104
                    ],
                    [
                        20.931518591386876,
                        46.0314025122677
                    ],
                    [
                        20.919581334370505,
                        46.037138585076626
                    ],
                    [
                        20.906093781487943,
                        46.0510136774317
                    ],
                    [
                        20.89601687888055,
                        46.07067657318365
                    ],
                    [
                        20.860463494529547,
                        46.095739648408596
                    ],
                    [
                        20.71897342703708,
                        46.164572693235925
                    ],
                    [
                        20.704367558555063,
                        46.16852633768157
                    ],
                    [
                        20.705330032601758,
                        46.18064480238991
                    ],
                    [
                        20.71029097547537,
                        46.18808624673834
                    ],
                    [
                        20.717835731004442,
                        46.18999824744785
                    ],
                    [
                        20.727137494070412,
                        46.187724524271445
                    ],
                    [
                        20.736645959161063,
                        46.18669101168727
                    ],
                    [
                        20.744707482583987,
                        46.19227206213974
                    ],
                    [
                        20.744810831721466,
                        46.200281878813094
                    ],
                    [
                        20.735509070731666,
                        46.222502721346046
                    ],
                    [
                        20.734992312978132,
                        46.23190788137005
                    ],
                    [
                        20.739333127491136,
                        46.23748889331803
                    ],
                    [
                        20.778503870303624,
                        46.26007154667689
                    ],
                    [
                        20.78736933136875,
                        46.263390368163584
                    ],
                    [
                        20.79865767402972,
                        46.26761626441514
                    ],
                    [
                        20.819638306626537,
                        46.2716987148912
                    ],
                    [
                        20.839688760093967,
                        46.27107857913222
                    ],
                    [
                        20.848990523234757,
                        46.267771335019766
                    ],
                    [
                        20.866973919021564,
                        46.25712597275333
                    ],
                    [
                        20.875138790090006,
                        46.25438707453934
                    ],
                    [
                        20.885060673358502,
                        46.255007256937
                    ],
                    [
                        20.899736779195315,
                        46.26069166263867
                    ],
                    [
                        20.906558061134664,
                        46.26219021693819
                    ],
                    [
                        20.924438111373917,
                        46.25955475867622
                    ],
                    [
                        20.96174849808058,
                        46.2483409869025
                    ],
                    [
                        20.981488895013957,
                        46.248857758115435
                    ],
                    [
                        20.990583948448062,
                        46.25159661246353
                    ],
                    [
                        20.99916223644994,
                        46.25159661246353
                    ],
                    [
                        21.00701705301886,
                        46.248857758115435
                    ],
                    [
                        21.013941694661778,
                        46.243069995345444
                    ],
                    [
                        21.03347537975519,
                        46.23133939963298
                    ],
                    [
                        21.051458776306717,
                        46.23609361272649
                    ],
                    [
                        21.099207807420875,
                        46.27634961535156
                    ],
                    [
                        21.10561568483156,
                        46.27867505080368
                    ],
                    [
                        21.134864538786886,
                        46.278519975291246
                    ],
                    [
                        21.144476357052792,
                        46.28373930503471
                    ],
                    [
                        21.15594852939333,
                        46.29893220837588
                    ],
                    [
                        21.164526822276773,
                        46.31825923182102
                    ],
                    [
                        21.168660923364104,
                        46.36275254182393
                    ],
                    [
                        21.178789513398637,
                        46.384456712008735
                    ],
                    [
                        21.195636026596144,
                        46.39809926091184
                    ],
                    [
                        21.215169717814657,
                        46.40290517058436
                    ],
                    [
                        21.257544390615816,
                        46.404171226830584
                    ],
                    [
                        21.280695442366643,
                        46.4163927846682
                    ],
                    [
                        21.274390902671396,
                        46.43835514924617
                    ],
                    [
                        21.24514204096806,
                        46.47687992387429
                    ],
                    [
                        21.247622516654438,
                        46.49747303276618
                    ],
                    [
                        21.261678498806035,
                        46.51333763715303
                    ],
                    [
                        21.2789384300566,
                        46.52840134290251
                    ],
                    [
                        21.29134077418254,
                        46.54672064648551
                    ],
                    [
                        21.29526818141641,
                        46.58503870815973
                    ],
                    [
                        21.300952591352722,
                        46.603926458846026
                    ],
                    [
                        21.316248813403202,
                        46.61663884615291
                    ],
                    [
                        21.337642853787287,
                        46.6204112054635
                    ],
                    [
                        21.37443648640247,
                        46.618447596637644
                    ],
                    [
                        21.396037239216103,
                        46.62635412783467
                    ],
                    [
                        21.416811159626548,
                        46.645215982737604
                    ],
                    [
                        21.42353890919739,
                        46.65823093293306
                    ]
                ]
            ]
        },
        "type": "Feature",
        "properties": {
            "source": "https://simplemaps.com",
            "id": "ROAR",
            "name": "Arad"
        },
        "id": 2
    },
    {
        "geometry": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        22.167608022262556,
                        47.594862389711764
                    ],
                    [
                        22.172321403912626,
                        47.589860330046506
                    ],
                    [
                        22.192785275215826,
                        47.56805290363942
                    ],
                    [
                        22.205032580635333,
                        47.548338285712106
                    ],
                    [
                        22.213404171758288,
                        47.53911410576723
                    ],
                    [
                        22.225031359140022,
                        47.531052507813904
                    ],
                    [
                        22.26616579904409,
                        47.5103302575487
                    ],
                    [
                        22.28120364845198,
                        47.49632599701681
                    ],
                    [
                        22.296913273076285,
                        47.476275473278086
                    ],
                    [
                        22.325593697237135,
                        47.44614813811892
                    ],
                    [
                        22.33381024490841,
                        47.43431420175806
                    ],
                    [
                        22.34533409455657,
                        47.41348863662347
                    ],
                    [
                        22.35153527845219,
                        47.40573725768488
                    ],
                    [
                        22.36021690345244,
                        47.401034586770976
                    ],
                    [
                        22.37727014168716,
                        47.398657586791074
                    ],
                    [
                        22.387502073877123,
                        47.399742780163294
                    ],
                    [
                        22.395770296290706,
                        47.40178395092249
                    ],
                    [
                        22.40491702575925,
                        47.402378243678605
                    ],
                    [
                        22.414063756440306,
                        47.40186148737044
                    ],
                    [
                        22.428481483194837,
                        47.399691089550444
                    ],
                    [
                        22.438403357545774,
                        47.40134473192702
                    ],
                    [
                        22.46248456648098,
                        47.4105430773817
                    ],
                    [
                        22.472251427331237,
                        47.41235185604058
                    ],
                    [
                        22.482793414669427,
                        47.410284769208275
                    ],
                    [
                        22.496901079695864,
                        47.40408359178445
                    ],
                    [
                        22.512869095332867,
                        47.39442007701987
                    ],
                    [
                        22.54284142961185,
                        47.38294793968
                    ],
                    [
                        22.554778670334983,
                        47.37581648875764
                    ],
                    [
                        22.56392540237717,
                        47.36380173687471
                    ],
                    [
                        22.571263453534435,
                        47.339048717964396
                    ],
                    [
                        22.580720246895762,
                        47.321401254874694
                    ],
                    [
                        22.570488315867678,
                        47.293702702011664
                    ],
                    [
                        22.56475223925935,
                        47.28543452272411
                    ],
                    [
                        22.553228382916494,
                        47.27264452792968
                    ],
                    [
                        22.54842248706957,
                        47.26476395578937
                    ],
                    [
                        22.5462520717407,
                        47.256108118779906
                    ],
                    [
                        22.54547692772265,
                        47.24758153067484
                    ],
                    [
                        22.54268638419107,
                        47.23995914098531
                    ],
                    [
                        22.536795278659685,
                        47.23241443087451
                    ],
                    [
                        22.511318811728067,
                        47.20678302187866
                    ],
                    [
                        22.5026371525014,
                        47.199806571654655
                    ],
                    [
                        22.49426558715928,
                        47.19417395853047
                    ],
                    [
                        22.49488569890245,
                        47.18063469840853
                    ],
                    [
                        22.507184691297255,
                        47.15991246067646
                    ],
                    [
                        22.550437853064576,
                        47.11366196472109
                    ],
                    [
                        22.579945109717926,
                        47.07469803122991
                    ],
                    [
                        22.58366580303052,
                        47.06645557181876
                    ],
                    [
                        22.590487092851347,
                        47.0585749202187
                    ],
                    [
                        22.601649209819357,
                        47.05012588427175
                    ],
                    [
                        22.663867623334397,
                        47.02552781690498
                    ],
                    [
                        22.702676619531037,
                        46.99875939735813
                    ],
                    [
                        22.719419783226634,
                        46.97935490036344
                    ],
                    [
                        22.71182335283442,
                        46.965402295253135
                    ],
                    [
                        22.689964227085976,
                        46.936075957783764
                    ],
                    [
                        22.686553589852153,
                        46.92687760584371
                    ],
                    [
                        22.688258910264516,
                        46.92028884055913
                    ],
                    [
                        22.696785505191794,
                        46.91558617287944
                    ],
                    [
                        22.747686791352205,
                        46.90212446389699
                    ],
                    [
                        22.76024417253651,
                        46.89481230562803
                    ],
                    [
                        22.76567019500299,
                        46.8843736508771
                    ],
                    [
                        22.761329385392727,
                        46.86587356071212
                    ],
                    [
                        22.7566784981988,
                        46.85419462938804
                    ],
                    [
                        22.751252465689912,
                        46.84331668377504
                    ],
                    [
                        22.74598147093333,
                        46.835177659044
                    ],
                    [
                        22.739160199784052,
                        46.82840816755888
                    ],
                    [
                        22.730271848187375,
                        46.823421358821776
                    ],
                    [
                        22.693529892488765,
                        46.81233667808358
                    ],
                    [
                        22.68221276706421,
                        46.806652364533775
                    ],
                    [
                        22.673634480588802,
                        46.799934443581755
                    ],
                    [
                        22.66805342473754,
                        46.79257053239159
                    ],
                    [
                        22.66619307524333,
                        46.784354004746355
                    ],
                    [
                        22.668828564746395,
                        46.77531056576549
                    ],
                    [
                        22.68081750651096,
                        46.7636575968394
                    ],
                    [
                        22.72081505370234,
                        46.73885283031505
                    ],
                    [
                        22.733837510888616,
                        46.72428004871789
                    ],
                    [
                        22.74691164752506,
                        46.70355779608094
                    ],
                    [
                        22.764274935977312,
                        46.65699737774687
                    ],
                    [
                        22.77342166727075,
                        46.64464673037239
                    ],
                    [
                        22.78272341381846,
                        46.63896224115097
                    ],
                    [
                        22.79388552238946,
                        46.63379459415408
                    ],
                    [
                        22.80339398811175,
                        46.62736089309847
                    ],
                    [
                        22.807889852657162,
                        46.61937699066421
                    ],
                    [
                        22.80354902588782,
                        46.5943138791118
                    ],
                    [
                        22.802773887451266,
                        46.5569001918347
                    ],
                    [
                        22.787581008636536,
                        46.563359693023955
                    ],
                    [
                        22.778072552778703,
                        46.56558183444654
                    ],
                    [
                        22.765050089982303,
                        46.56697708656621
                    ],
                    [
                        22.753112833579415,
                        46.56697708656621
                    ],
                    [
                        22.739780302396515,
                        46.56542670449778
                    ],
                    [
                        22.72810143083039,
                        46.560672489788615
                    ],
                    [
                        22.71554406818011,
                        46.55038895417215
                    ],
                    [
                        22.702521594406992,
                        46.53214708419802
                    ],
                    [
                        22.691979611344657,
                        46.50646395733593
                    ],
                    [
                        22.686863643632794,
                        46.48300285173421
                    ],
                    [
                        22.68810388538675,
                        46.421973044588654
                    ],
                    [
                        22.70670739617802,
                        46.36874628130972
                    ],
                    [
                        22.664952841272793,
                        46.3665242072394
                    ],
                    [
                        22.61761723259234,
                        46.3692630804588
                    ],
                    [
                        22.541291125055825,
                        46.38058010468702
                    ],
                    [
                        22.450650660169646,
                        46.38187199550975
                    ],
                    [
                        22.435147748856068,
                        46.38450762747076
                    ],
                    [
                        22.42026493715698,
                        46.39021787550333
                    ],
                    [
                        22.40910281377104,
                        46.40161243309846
                    ],
                    [
                        22.40445194975797,
                        46.411637757171746
                    ],
                    [
                        22.401506385914363,
                        46.42037102836104
                    ],
                    [
                        22.392928102881722,
                        46.4269081303375
                    ],
                    [
                        22.317997270571905,
                        46.446622655616146
                    ],
                    [
                        22.27050663462768,
                        46.47488969710814
                    ],
                    [
                        22.254383573396662,
                        46.47997972467055
                    ],
                    [
                        22.229062120389223,
                        46.48548325667984
                    ],
                    [
                        22.20937341356048,
                        46.49491430056698
                    ],
                    [
                        22.19433557219668,
                        46.5074975163707
                    ],
                    [
                        22.18224328683599,
                        46.524033972393994
                    ],
                    [
                        22.16064253901553,
                        46.564393273885415
                    ],
                    [
                        22.153046087883233,
                        46.57602035799105
                    ],
                    [
                        22.145449657205656,
                        46.58273833132529
                    ],
                    [
                        22.12297040796441,
                        46.59405546045437
                    ],
                    [
                        22.112221707463224,
                        46.60103176027831
                    ],
                    [
                        22.09377322139908,
                        46.60694870873543
                    ],
                    [
                        22.066798134108847,
                        46.610695329957636
                    ],
                    [
                        21.97863812674623,
                        46.613201541374494
                    ],
                    [
                        21.953833442273094,
                        46.61963527549545
                    ],
                    [
                        21.940604285573624,
                        46.62883375319975
                    ],
                    [
                        21.92463625980163,
                        46.63508653673596
                    ],
                    [
                        21.911923869040344,
                        46.637592931950195
                    ],
                    [
                        21.892855252849692,
                        46.637127748726016
                    ],
                    [
                        21.879936147130543,
                        46.63821297262845
                    ],
                    [
                        21.86613853550604,
                        46.6429154970401
                    ],
                    [
                        21.85823204720028,
                        46.64865162336307
                    ],
                    [
                        21.85172081797818,
                        46.654826964117454
                    ],
                    [
                        21.82577923957459,
                        46.65808251314739
                    ],
                    [
                        21.492001181565755,
                        46.64521521534363
                    ],
                    [
                        21.445337356514653,
                        46.653173339790435
                    ],
                    [
                        21.42353890919739,
                        46.65823093293306
                    ],
                    [
                        21.425492799943022,
                        46.66201082509613
                    ],
                    [
                        21.43624150090274,
                        46.67374139728228
                    ],
                    [
                        21.46352666014788,
                        46.67704870604226
                    ],
                    [
                        21.483577109287033,
                        46.68485179563044
                    ],
                    [
                        21.501767212889558,
                        46.703506985647444
                    ],
                    [
                        21.50517785272644,
                        46.723247351553766
                    ],
                    [
                        21.478202756829944,
                        46.73593392378003
                    ],
                    [
                        21.47520553464408,
                        46.737846032613675
                    ],
                    [
                        21.472621701571185,
                        46.74019722784275
                    ],
                    [
                        21.470451294937607,
                        46.743013618008966
                    ],
                    [
                        21.471381476732535,
                        46.74903397279209
                    ],
                    [
                        21.473655241800504,
                        46.75487342622827
                    ],
                    [
                        21.47706587303236,
                        46.760221833362415
                    ],
                    [
                        21.48151005817355,
                        46.764976148565104
                    ],
                    [
                        21.502904092129615,
                        46.80530953706255
                    ],
                    [
                        21.515719855226482,
                        46.82158768078715
                    ],
                    [
                        21.53659712508438,
                        46.83502347732728
                    ],
                    [
                        21.573080693502465,
                        46.841767306403455
                    ],
                    [
                        21.583415972974045,
                        46.847942591978914
                    ],
                    [
                        21.591787551257553,
                        46.86070664345593
                    ],
                    [
                        21.591477505178933,
                        46.87153295216922
                    ],
                    [
                        21.588066847856513,
                        46.882204035505254
                    ],
                    [
                        21.587136681904777,
                        46.89439974790667
                    ],
                    [
                        21.58868697347442,
                        46.9061819643102
                    ],
                    [
                        21.58992719959052,
                        46.90886907257639
                    ],
                    [
                        21.594371383020007,
                        46.91000603913293
                    ],
                    [
                        21.64005333935507,
                        46.93568915473842
                    ],
                    [
                        21.64852827117184,
                        46.94297550829394
                    ],
                    [
                        21.667545211441034,
                        46.99237826766017
                    ],
                    [
                        21.671369255957796,
                        46.99336004257285
                    ],
                    [
                        21.67074914358173,
                        46.99439359821868
                    ],
                    [
                        21.661757451734044,
                        47.006072532163294
                    ],
                    [
                        21.654832800780298,
                        47.00994819096404
                    ],
                    [
                        21.64522098183641,
                        47.01124008764892
                    ],
                    [
                        21.636642700429064,
                        47.014082340157266
                    ],
                    [
                        21.634269539890585,
                        47.01942196491349
                    ],
                    [
                        21.632818654241415,
                        47.02268653837117
                    ],
                    [
                        21.671886029839275,
                        47.05472587183701
                    ],
                    [
                        21.6942102413436,
                        47.06916937887499
                    ],
                    [
                        21.743509566228845,
                        47.09159701589976
                    ],
                    [
                        21.763766730218187,
                        47.10521377137468
                    ],
                    [
                        21.770484657297768,
                        47.114024544584794
                    ],
                    [
                        21.77544559466734,
                        47.131672033713244
                    ],
                    [
                        21.779889776622078,
                        47.1407413202335
                    ],
                    [
                        21.789398229686594,
                        47.1503013816041
                    ],
                    [
                        21.811515744966776,
                        47.1646932832219
                    ],
                    [
                        21.819887319858207,
                        47.17272891759907
                    ],
                    [
                        21.8259851445828,
                        47.18505378819505
                    ],
                    [
                        21.825675086843393,
                        47.19427804034936
                    ],
                    [
                        21.82329797576283,
                        47.20332145204479
                    ],
                    [
                        21.823608026321256,
                        47.21492274256025
                    ],
                    [
                        21.827742146434208,
                        47.22600738189791
                    ],
                    [
                        21.83931766605577,
                        47.24083850791997
                    ],
                    [
                        21.84458865978159,
                        47.24993354246698
                    ],
                    [
                        21.856060828280732,
                        47.285745321349665
                    ],
                    [
                        21.862158656386278,
                        47.2974242538961
                    ],
                    [
                        21.90081261810243,
                        47.33574226093693
                    ],
                    [
                        21.919002725761757,
                        47.34966908628625
                    ],
                    [
                        21.936986126413817,
                        47.3571621811553
                    ],
                    [
                        21.981531206950088,
                        47.36610217214152
                    ],
                    [
                        22.001581660773574,
                        47.39382656876455
                    ],
                    [
                        22.0002380754994,
                        47.42718371812849
                    ],
                    [
                        21.991453091249035,
                        47.4618069977694
                    ],
                    [
                        21.98886926155388,
                        47.492941986680975
                    ],
                    [
                        22.00788619216402,
                        47.5174108095379
                    ],
                    [
                        22.037445106731294,
                        47.53932157787152
                    ],
                    [
                        22.09956019000122,
                        47.57094764282391
                    ],
                    [
                        22.148549453090332,
                        47.57934509759698
                    ],
                    [
                        22.154177320092582,
                        47.582212544292524
                    ],
                    [
                        22.16208865850263,
                        47.586243763256505
                    ],
                    [
                        22.167359653995398,
                        47.593788511639445
                    ],
                    [
                        22.167608022262556,
                        47.594862389711764
                    ]
                ]
            ]
        },
        "type": "Feature",
        "properties": {
            "source": "https://simplemaps.com",
            "id": "ROBH",
            "name": "Bihor"
        },
        "id": 3
    },
    {
        "geometry": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        20.704367558555063,
                        46.16852633768157
                    ],
                    [
                        20.71897342703708,
                        46.164572693235925
                    ],
                    [
                        20.860463494529547,
                        46.095739648408596
                    ],
                    [
                        20.89601687888055,
                        46.07067657318365
                    ],
                    [
                        20.906093781487943,
                        46.0510136774317
                    ],
                    [
                        20.919581334370505,
                        46.037138585076626
                    ],
                    [
                        20.931518591386876,
                        46.0314025122677
                    ],
                    [
                        20.946298046817255,
                        46.027991829520104
                    ],
                    [
                        21.00820641571988,
                        46.019930339633916
                    ],
                    [
                        21.016888055570767,
                        46.02018870952131
                    ],
                    [
                        21.035646600578122,
                        46.02339264968957
                    ],
                    [
                        21.047893912006817,
                        46.02390939471319
                    ],
                    [
                        21.06949466415062,
                        46.01985282104457
                    ],
                    [
                        21.079726595404143,
                        46.01533111146224
                    ],
                    [
                        21.083912386834538,
                        46.01052520671503
                    ],
                    [
                        21.08174197533848,
                        45.99889799358895
                    ],
                    [
                        21.083912390833422,
                        45.99207675124785
                    ],
                    [
                        21.09693485129525,
                        45.980139490649975
                    ],
                    [
                        21.109957305293715,
                        45.97533352675247
                    ],
                    [
                        21.124581741506322,
                        45.973059813567126
                    ],
                    [
                        21.135123730264358,
                        45.97373157876391
                    ],
                    [
                        21.14241010643519,
                        45.976832161915
                    ],
                    [
                        21.146440873853326,
                        45.981379727718306
                    ],
                    [
                        21.148146193656324,
                        45.98685741028799
                    ],
                    [
                        21.14845625253249,
                        45.998484611399746
                    ],
                    [
                        21.15031659909543,
                        46.0041689843043
                    ],
                    [
                        21.154812452764688,
                        46.0096467125812
                    ],
                    [
                        21.163494088968356,
                        46.015356925127044
                    ],
                    [
                        21.173622673412464,
                        46.01905182214928
                    ],
                    [
                        21.1888155410941,
                        46.020472893635606
                    ],
                    [
                        21.195946894447143,
                        46.01879345309244
                    ],
                    [
                        21.19842735750226,
                        46.014710971285986
                    ],
                    [
                        21.199667600683085,
                        46.00566766469374
                    ],
                    [
                        21.207109000591917,
                        45.993471979020754
                    ],
                    [
                        21.233515661180974,
                        45.975281905252196
                    ],
                    [
                        21.250723912921092,
                        45.968925701533045
                    ],
                    [
                        21.26483157612081,
                        45.96887400437505
                    ],
                    [
                        21.28813765155687,
                        45.9826199691186
                    ],
                    [
                        21.299299759645866,
                        45.98603059786683
                    ],
                    [
                        21.31356245653061,
                        45.98758090145883
                    ],
                    [
                        21.330615679807508,
                        45.98742587845409
                    ],
                    [
                        21.341209340542996,
                        45.983705116880245
                    ],
                    [
                        21.35547203416044,
                        45.97210375088929
                    ],
                    [
                        21.361828238585755,
                        45.97073434091112
                    ],
                    [
                        21.36864953289649,
                        45.972904796901204
                    ],
                    [
                        21.390973745459277,
                        45.98866606438832
                    ],
                    [
                        21.417535434109478,
                        46.003445535879536
                    ],
                    [
                        21.423891632639844,
                        46.008328937169225
                    ],
                    [
                        21.42761233506007,
                        46.014710971285986
                    ],
                    [
                        21.428852575061327,
                        46.02140311946042
                    ],
                    [
                        21.428852571038263,
                        46.02840524617837
                    ],
                    [
                        21.43102298570274,
                        46.034038010172246
                    ],
                    [
                        21.441616648798554,
                        46.03786202583117
                    ],
                    [
                        21.45851484938375,
                        46.039102311921646
                    ],
                    [
                        21.49169111639835,
                        46.036621820701626
                    ],
                    [
                        21.50724572315203,
                        46.03284944835702
                    ],
                    [
                        21.515772330585666,
                        46.02706166295769
                    ],
                    [
                        21.516702512476716,
                        46.02031793283553
                    ],
                    [
                        21.51670251048956,
                        46.0124889389085
                    ],
                    [
                        21.51871788524024,
                        46.00463407548532
                    ],
                    [
                        21.52553917347131,
                        45.9974510431442
                    ],
                    [
                        21.53577110882695,
                        45.99522896585252
                    ],
                    [
                        21.56310794849944,
                        45.99791620210251
                    ],
                    [
                        21.573959999562863,
                        45.99639174221212
                    ],
                    [
                        21.58419192934861,
                        45.99202505071944
                    ],
                    [
                        21.60667118090311,
                        45.97585035488676
                    ],
                    [
                        21.62687666142122,
                        45.9640164197635
                    ],
                    [
                        21.635713329531875,
                        45.955929042739115
                    ],
                    [
                        21.639589068976015,
                        45.94908197388001
                    ],
                    [
                        21.63819379977511,
                        45.94350087341689
                    ],
                    [
                        21.6347831554031,
                        45.93828155597366
                    ],
                    [
                        21.633077833580806,
                        45.933320621619444
                    ],
                    [
                        21.634163037053987,
                        45.92887643962316
                    ],
                    [
                        21.638658891431014,
                        45.92577589097896
                    ],
                    [
                        21.65137128715687,
                        45.919367961312894
                    ],
                    [
                        21.657572464616706,
                        45.91409700110711
                    ],
                    [
                        21.662688426530167,
                        45.90789580425254
                    ],
                    [
                        21.670336541380617,
                        45.90174632571246
                    ],
                    [
                        21.677622920824373,
                        45.90239230429711
                    ],
                    [
                        21.683514036862746,
                        45.9071207100627
                    ],
                    [
                        21.69359093735112,
                        45.922933668454995
                    ],
                    [
                        21.707078487220368,
                        45.93957349323862
                    ],
                    [
                        21.714364866604885,
                        45.945929708951226
                    ],
                    [
                        21.722633087757657,
                        45.94934029220294
                    ],
                    [
                        21.73674075771603,
                        45.94965038165565
                    ],
                    [
                        21.76945193885336,
                        45.939263412551824
                    ],
                    [
                        21.78092411065135,
                        45.93381158103483
                    ],
                    [
                        21.789347359981146,
                        45.92799791747556
                    ],
                    [
                        21.80159468410752,
                        45.914200379548156
                    ],
                    [
                        21.809966260103582,
                        45.906913957302194
                    ],
                    [
                        21.816012405518084,
                        45.90495027148249
                    ],
                    [
                        21.820198199243844,
                        45.906268047132876
                    ],
                    [
                        21.821903519562582,
                        45.911306483678466
                    ],
                    [
                        21.820818314941423,
                        45.92520744466495
                    ],
                    [
                        21.820973337341023,
                        45.93334642932734
                    ],
                    [
                        21.82236860651301,
                        45.94050366033431
                    ],
                    [
                        21.82717451003544,
                        45.94644641779764
                    ],
                    [
                        21.83244551390635,
                        45.946136407716594
                    ],
                    [
                        21.839628529565573,
                        45.94272570195874
                    ],
                    [
                        21.848775264603795,
                        45.93688631493226
                    ],
                    [
                        21.858542111261613,
                        45.93466423310497
                    ],
                    [
                        21.880711301841387,
                        45.93458673312004
                    ],
                    [
                        21.888617786862298,
                        45.93549100276649
                    ],
                    [
                        21.89450890107796,
                        45.938824138422184
                    ],
                    [
                        21.89812625443475,
                        45.9440951573597
                    ],
                    [
                        21.904947543643186,
                        45.96647105217718
                    ],
                    [
                        21.907738067831165,
                        45.97259468718305
                    ],
                    [
                        21.91176883621794,
                        45.97765902950683
                    ],
                    [
                        21.919520299722244,
                        45.98065624918614
                    ],
                    [
                        21.931457554435823,
                        45.98220652930672
                    ],
                    [
                        21.955228709544226,
                        45.98215483021627
                    ],
                    [
                        21.969801468739657,
                        45.97905427719446
                    ],
                    [
                        21.980653516856535,
                        45.97357656180499
                    ],
                    [
                        21.98902509709981,
                        45.966341848482344
                    ],
                    [
                        22.001427443119884,
                        45.95859040194344
                    ],
                    [
                        22.019152463279077,
                        45.95512811153858
                    ],
                    [
                        22.058839954396518,
                        45.952595900286774
                    ],
                    [
                        22.06865847902824,
                        45.94913359157914
                    ],
                    [
                        22.074394561155604,
                        45.943655877277614
                    ],
                    [
                        22.077185088178638,
                        45.936602044524776
                    ],
                    [
                        22.081370882883203,
                        45.93177032463276
                    ],
                    [
                        22.089122348713513,
                        45.92784292041722
                    ],
                    [
                        22.10555545808133,
                        45.922597795289434
                    ],
                    [
                        22.11315189361452,
                        45.918256973173506
                    ],
                    [
                        22.12074832500479,
                        45.911874907885455
                    ],
                    [
                        22.13134199080398,
                        45.905156946533914
                    ],
                    [
                        22.146069773329106,
                        45.90267647092126
                    ],
                    [
                        22.16172773920392,
                        45.90257317238373
                    ],
                    [
                        22.181933218191705,
                        45.90448515733489
                    ],
                    [
                        22.195575799851255,
                        45.90246979730186
                    ],
                    [
                        22.220225459470182,
                        45.893064704051106
                    ],
                    [
                        22.228958780099468,
                        45.892754663698796
                    ],
                    [
                        22.23578006163941,
                        45.89642363211152
                    ],
                    [
                        22.241826205046063,
                        45.90133290309284
                    ],
                    [
                        22.249112580144228,
                        45.90619047673096
                    ],
                    [
                        22.257174110118225,
                        45.908903536415046
                    ],
                    [
                        22.294277790272922,
                        45.915130557132
                    ],
                    [
                        22.311796093471784,
                        45.9161640395674
                    ],
                    [
                        22.317842241181676,
                        45.91838615944433
                    ],
                    [
                        22.322183059308262,
                        45.922106851291964
                    ],
                    [
                        22.328229200178416,
                        45.936576236581445
                    ],
                    [
                        22.33288008390857,
                        45.94068454771309
                    ],
                    [
                        22.336755814688203,
                        45.943345869623585
                    ],
                    [
                        22.354945916317416,
                        45.949857082579264
                    ],
                    [
                        22.38905236026148,
                        45.92466480633596
                    ],
                    [
                        22.398870881545147,
                        45.908205857713654
                    ],
                    [
                        22.401816444435216,
                        45.889757416594996
                    ],
                    [
                        22.406002230301624,
                        45.877484225506514
                    ],
                    [
                        22.412513459845417,
                        45.862704762859096
                    ],
                    [
                        22.4219702517624,
                        45.85244702785188
                    ],
                    [
                        22.449410439649203,
                        45.83715081672192
                    ],
                    [
                        22.45767866777025,
                        45.83069126053784
                    ],
                    [
                        22.467290482329098,
                        45.818366417702194
                    ],
                    [
                        22.48604902189163,
                        45.78599109368181
                    ],
                    [
                        22.49411055068699,
                        45.77741284314196
                    ],
                    [
                        22.50248212805685,
                        45.774028002417225
                    ],
                    [
                        22.514781119575666,
                        45.77885974798729
                    ],
                    [
                        22.522532588667467,
                        45.780358405169885
                    ],
                    [
                        22.52981896350532,
                        45.779893298723145
                    ],
                    [
                        22.540826042170348,
                        45.775294089442205
                    ],
                    [
                        22.543616567057516,
                        45.768679484114614
                    ],
                    [
                        22.54113609907391,
                        45.76128975917545
                    ],
                    [
                        22.53276452275231,
                        45.75369336641913
                    ],
                    [
                        22.492715284623312,
                        45.72811351139484
                    ],
                    [
                        22.481088093607962,
                        45.71909601153303
                    ],
                    [
                        22.47302655991892,
                        45.708941526273364
                    ],
                    [
                        22.46822065861659,
                        45.69938143408294
                    ],
                    [
                        22.463879837609134,
                        45.680674557007286
                    ],
                    [
                        22.461554396405184,
                        45.67382742103679
                    ],
                    [
                        22.457368602033167,
                        45.668375531868634
                    ],
                    [
                        22.453647897260176,
                        45.665584993031565
                    ],
                    [
                        22.44537967352561,
                        45.66289785870288
                    ],
                    [
                        22.335050493745452,
                        45.64814426112364
                    ],
                    [
                        22.29815351704157,
                        45.62977326174756
                    ],
                    [
                        22.27019656914424,
                        45.589258955204045
                    ],
                    [
                        22.263995394633707,
                        45.58600331297424
                    ],
                    [
                        22.256864048981136,
                        45.58574494689771
                    ],
                    [
                        22.248647492766516,
                        45.58724354150727
                    ],
                    [
                        22.239190708999182,
                        45.587915357605475
                    ],
                    [
                        22.2254964564343,
                        45.586959353182934
                    ],
                    [
                        22.216969839899566,
                        45.58812204401271
                    ],
                    [
                        22.20999352345093,
                        45.590654200953345
                    ],
                    [
                        22.197746209936152,
                        45.60062776186844
                    ],
                    [
                        22.190149772758712,
                        45.6048652122685
                    ],
                    [
                        22.176662226725032,
                        45.606673910308295
                    ],
                    [
                        22.166223583898308,
                        45.60367664627578
                    ],
                    [
                        22.140798781727472,
                        45.58750194688311
                    ],
                    [
                        22.11578738607689,
                        45.57592640442132
                    ],
                    [
                        22.094858431731545,
                        45.570913796610405
                    ],
                    [
                        22.071759066600013,
                        45.56822662451083
                    ],
                    [
                        22.036825798974952,
                        45.56838165976204
                    ],
                    [
                        22.030469596743284,
                        45.564764302194746
                    ],
                    [
                        22.02938439168114,
                        45.559286597380414
                    ],
                    [
                        22.03186486063952,
                        45.55303375163796
                    ],
                    [
                        22.033570186521537,
                        45.541251552329655
                    ],
                    [
                        22.035895623958268,
                        45.53641979300136
                    ],
                    [
                        22.03961632733442,
                        45.53386180564995
                    ],
                    [
                        22.04488732522709,
                        45.53287996972004
                    ],
                    [
                        22.058529902919513,
                        45.53225985005867
                    ],
                    [
                        22.059666781216574,
                        45.52843576974378
                    ],
                    [
                        22.0531038761546,
                        45.52228628901984
                    ],
                    [
                        22.02767906998819,
                        45.50967722737774
                    ],
                    [
                        22.008093704166168,
                        45.504535438828796
                    ],
                    [
                        21.988249950926882,
                        45.502339163510236
                    ],
                    [
                        21.97538251897017,
                        45.50399281313395
                    ],
                    [
                        21.964375443309745,
                        45.507610192415065
                    ],
                    [
                        21.95584883181069,
                        45.51251944781447
                    ],
                    [
                        21.948665804919557,
                        45.51962494058457
                    ],
                    [
                        21.943239780756272,
                        45.527195546242716
                    ],
                    [
                        21.93378299081633,
                        45.543525282376784
                    ],
                    [
                        21.926651645797353,
                        45.551483466095014
                    ],
                    [
                        21.917039829552614,
                        45.55685781695519
                    ],
                    [
                        21.90231204364621,
                        45.5600875751298
                    ],
                    [
                        21.892545197545086,
                        45.558769826119594
                    ],
                    [
                        21.85683678690393,
                        45.54285350835438
                    ],
                    [
                        21.81074140961981,
                        45.52812573260561
                    ],
                    [
                        21.786401808542152,
                        45.523681551064186
                    ],
                    [
                        21.768676790860283,
                        45.5238365677533
                    ],
                    [
                        21.761235383410998,
                        45.52830656844758
                    ],
                    [
                        21.748212923496695,
                        45.53990793720674
                    ],
                    [
                        21.73844607835841,
                        45.544765522007616
                    ],
                    [
                        21.7269739130161,
                        45.5484087330991
                    ],
                    [
                        21.704132926827935,
                        45.55298207534905
                    ],
                    [
                        21.684754263814547,
                        45.56109526420342
                    ],
                    [
                        21.66909630833029,
                        45.56404085021171
                    ],
                    [
                        21.637883743120472,
                        45.56404085021171
                    ],
                    [
                        21.609358351290165,
                        45.55721955490073
                    ],
                    [
                        21.591788365544552,
                        45.54871878712682
                    ],
                    [
                        21.582331579220316,
                        45.538409342366116
                    ],
                    [
                        21.577835727734136,
                        45.527531438106514
                    ],
                    [
                        21.57597537780087,
                        45.51608512376789
                    ],
                    [
                        21.575975377012078,
                        45.506473301288565
                    ],
                    [
                        21.568844028114135,
                        45.496499740718505
                    ],
                    [
                        21.554994746773126,
                        45.486164470722436
                    ],
                    [
                        21.512826775745424,
                        45.4696538332583
                    ],
                    [
                        21.494636669770582,
                        45.458595061473794
                    ],
                    [
                        21.48548994509055,
                        45.449525883309185
                    ],
                    [
                        21.485800001268515,
                        45.441309307975715
                    ],
                    [
                        21.48735029439623,
                        45.43087067065193
                    ],
                    [
                        21.48704023498286,
                        45.42213734615429
                    ],
                    [
                        21.483164505505197,
                        45.413145671150275
                    ],
                    [
                        21.472932571897516,
                        45.399089684736175
                    ],
                    [
                        21.47014204218852,
                        45.3907697529958
                    ],
                    [
                        21.47091719004791,
                        45.382501542265835
                    ],
                    [
                        21.474017773428514,
                        45.373819878184484
                    ],
                    [
                        21.480218946171277,
                        45.36619761173374
                    ],
                    [
                        21.514377066495076,
                        45.340746956543875
                    ],
                    [
                        21.533910759672832,
                        45.32973989208955
                    ],
                    [
                        21.54181725516181,
                        45.323332025560475
                    ],
                    [
                        21.547088249092507,
                        45.316407369298574
                    ],
                    [
                        21.550188835150287,
                        45.308862608370156
                    ],
                    [
                        21.550653923011108,
                        45.3019379660872
                    ],
                    [
                        21.550033805452895,
                        45.2955300883747
                    ],
                    [
                        21.550808954539225,
                        45.29015575305025
                    ],
                    [
                        21.554064568821232,
                        45.28007884356532
                    ],
                    [
                        21.553444452363273,
                        45.274239408184926
                    ],
                    [
                        21.549568718077165,
                        45.26839996618227
                    ],
                    [
                        21.52972496915744,
                        45.25082998398579
                    ],
                    [
                        21.527089470007226,
                        45.242768454822915
                    ],
                    [
                        21.52708947110902,
                        45.232588205226314
                    ],
                    [
                        21.53236046671584,
                        45.205251365460605
                    ],
                    [
                        21.532050410009166,
                        45.19512279699645
                    ],
                    [
                        21.527244501325516,
                        45.185200922066834
                    ],
                    [
                        21.521818475080988,
                        45.177423612581435
                    ],
                    [
                        21.503628371260632,
                        45.16016368656924
                    ],
                    [
                        21.48450809110017,
                        45.15274811735011
                    ],
                    [
                        21.484388389262676,
                        45.15270169203725
                    ],
                    [
                        21.45939253778637,
                        45.174039618104445
                    ],
                    [
                        21.43376102723152,
                        45.18881907279854
                    ],
                    [
                        21.405545695943093,
                        45.19967112933558
                    ],
                    [
                        21.29929894974398,
                        45.22318389699918
                    ],
                    [
                        21.257130983013763,
                        45.2241140829368
                    ],
                    [
                        21.239250935960772,
                        45.22938507069197
                    ],
                    [
                        21.206074667123374,
                        45.24592153781219
                    ],
                    [
                        21.189744915212287,
                        45.25956411751463
                    ],
                    [
                        21.15563846961369,
                        45.29516917482064
                    ],
                    [
                        21.139412069086667,
                        45.303695781680595
                    ],
                    [
                        21.129180135359103,
                        45.301887107823525
                    ],
                    [
                        21.113057088849498,
                        45.28932973868708
                    ],
                    [
                        21.103341917974173,
                        45.28607410891896
                    ],
                    [
                        21.091559691915204,
                        45.28808949733106
                    ],
                    [
                        21.082774699602243,
                        45.29367055774717
                    ],
                    [
                        21.074299764665554,
                        45.30054352324754
                    ],
                    [
                        21.0639644773933,
                        45.30627959721341
                    ],
                    [
                        21.016668402543537,
                        45.32148191629529
                    ],
                    [
                        20.981488889049086,
                        45.33278959655726
                    ],
                    [
                        20.966192667802343,
                        45.34157461135349
                    ],
                    [
                        20.92764204964977,
                        45.37748972322207
                    ],
                    [
                        20.863046511141995,
                        45.418727536020334
                    ],
                    [
                        20.830387002817652,
                        45.452523896596425
                    ],
                    [
                        20.81602095542776,
                        45.46285919540284
                    ],
                    [
                        20.79948449664267,
                        45.468543597154444
                    ],
                    [
                        20.781604452838764,
                        45.47257437565181
                    ],
                    [
                        20.76713505168727,
                        45.47934398745242
                    ],
                    [
                        20.76072717249527,
                        45.49334828397518
                    ],
                    [
                        20.78315474722712,
                        45.50606070773271
                    ],
                    [
                        20.79762414672397,
                        45.51649933475834
                    ],
                    [
                        20.800207967602642,
                        45.530503646791125
                    ],
                    [
                        20.787392210355968,
                        45.553654670925106
                    ],
                    [
                        20.758039999575985,
                        45.58925975854092
                    ],
                    [
                        20.75442264926912,
                        45.60558950909697
                    ],
                    [
                        20.76217411478186,
                        45.630600905163874
                    ],
                    [
                        20.773232864798814,
                        45.648894315634536
                    ],
                    [
                        20.77726363423901,
                        45.65752433771283
                    ],
                    [
                        20.779950803191554,
                        45.67168363271356
                    ],
                    [
                        20.77912398529321,
                        45.7236701721025
                    ],
                    [
                        20.78160444748669,
                        45.73395372816147
                    ],
                    [
                        20.785531862437693,
                        45.74341055438691
                    ],
                    [
                        20.78573856283731,
                        45.752557246955085
                    ],
                    [
                        20.777470335092055,
                        45.7623241018879
                    ],
                    [
                        20.765171346589632,
                        45.76676829567143
                    ],
                    [
                        20.754112590071507,
                        45.76356435256634
                    ],
                    [
                        20.745327600037946,
                        45.75498609603504
                    ],
                    [
                        20.739436483434584,
                        45.74341055438691
                    ],
                    [
                        20.72682743711074,
                        45.73617587465586
                    ],
                    [
                        20.71339155791485,
                        45.73333361447342
                    ],
                    [
                        20.700059040210075,
                        45.735400689715625
                    ],
                    [
                        20.688070109674086,
                        45.743100489363236
                    ],
                    [
                        20.678561648785237,
                        45.75663973116717
                    ],
                    [
                        20.655617308295913,
                        45.77731026942741
                    ],
                    [
                        20.645902143888566,
                        45.788730805974815
                    ],
                    [
                        20.643489555044972,
                        45.79514130845324
                    ],
                    [
                        20.64228479395949,
                        45.79834262153838
                    ],
                    [
                        20.64011438089278,
                        45.81870311210801
                    ],
                    [
                        20.63670373855445,
                        45.8270230393013
                    ],
                    [
                        20.629675744767788,
                        45.833275895969635
                    ],
                    [
                        20.612312459863396,
                        45.841492418879994
                    ],
                    [
                        20.605284466081493,
                        45.84614330759117
                    ],
                    [
                        20.57210819514272,
                        45.887691143137985
                    ],
                    [
                        20.556708622636364,
                        45.898439876998154
                    ],
                    [
                        20.538001749034493,
                        45.903710836274925
                    ],
                    [
                        20.499864538856073,
                        45.906656358844785
                    ],
                    [
                        20.48167444008947,
                        45.91270254372252
                    ],
                    [
                        20.429067833143506,
                        45.94670565321325
                    ],
                    [
                        20.4102576098647,
                        45.955593980940016
                    ],
                    [
                        20.37098351841339,
                        45.96778959120374
                    ],
                    [
                        20.35393030136796,
                        45.976677986093954
                    ],
                    [
                        20.33863407573952,
                        45.992801018998236
                    ],
                    [
                        20.317653441348114,
                        46.03858631070632
                    ],
                    [
                        20.305664509416115,
                        46.05357248530001
                    ],
                    [
                        20.242825967488866,
                        46.108091113814936
                    ],
                    [
                        20.28323694220015,
                        46.143799573768916
                    ],
                    [
                        20.444157348509425,
                        46.14690012208649
                    ],
                    [
                        20.46854862571796,
                        46.17413361171509
                    ],
                    [
                        20.509373004404615,
                        46.16767403932141
                    ],
                    [
                        20.548957152959524,
                        46.156150207678486
                    ],
                    [
                        20.578102660062978,
                        46.13754668457276
                    ],
                    [
                        20.58802453900671,
                        46.13284416082149
                    ],
                    [
                        20.60011682367139,
                        46.129640219153885
                    ],
                    [
                        20.607558222529985,
                        46.12948513361357
                    ],
                    [
                        20.663988894659997,
                        46.13775341899474
                    ],
                    [
                        20.683522580472573,
                        46.14467802007253
                    ],
                    [
                        20.698818804874367,
                        46.15646024925788
                    ],
                    [
                        20.704193155241285,
                        46.16633045902647
                    ],
                    [
                        20.704367558555063,
                        46.16852633768157
                    ]
                ]
            ]
        },
        "type": "Feature",
        "properties": {
            "source": "https://simplemaps.com",
            "id": "ROTM",
            "name": "Timis"
        },
        "id": 4
    },
    {
        "geometry": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        23.008306723004157,
                        44.10044651944405
                    ],
                    [
                        22.98808474502788,
                        44.10702454934894
                    ],
                    [
                        22.942609482451324,
                        44.11146870306806
                    ],
                    [
                        22.906436005465363,
                        44.122889380740645
                    ],
                    [
                        22.691640378016363,
                        44.22843457652607
                    ],
                    [
                        22.69073857273394,
                        44.228877715376825
                    ],
                    [
                        22.685364214652353,
                        44.24365710743779
                    ],
                    [
                        22.68949831627148,
                        44.29171609048921
                    ],
                    [
                        22.681540165845153,
                        44.30530714519991
                    ],
                    [
                        22.662523228960186,
                        44.311663272318455
                    ],
                    [
                        22.621182069938865,
                        44.3159006427265
                    ],
                    [
                        22.582838177270588,
                        44.328406491029924
                    ],
                    [
                        22.5493518627277,
                        44.348973812085966
                    ],
                    [
                        22.522686813993186,
                        44.37507033702508
                    ],
                    [
                        22.505116804071022,
                        44.40406064379445
                    ],
                    [
                        22.503979945905503,
                        44.41170892736828
                    ],
                    [
                        22.5063570587186,
                        44.42752189141567
                    ],
                    [
                        22.505426885060768,
                        44.43501499200044
                    ],
                    [
                        22.500982686519155,
                        44.441939449709956
                    ],
                    [
                        22.48000209360481,
                        44.455789019799404
                    ],
                    [
                        22.47700483066104,
                        44.46395367079991
                    ],
                    [
                        22.477211528361362,
                        44.47697606947808
                    ],
                    [
                        22.479795369698078,
                        44.4904120877324
                    ],
                    [
                        22.484136185580834,
                        44.49976549833504
                    ],
                    [
                        22.49106081639874,
                        44.50420957994427
                    ],
                    [
                        22.500362584034306,
                        44.50638006226001
                    ],
                    [
                        22.535502549167607,
                        44.50751688442781
                    ],
                    [
                        22.548421682651046,
                        44.51170285869749
                    ],
                    [
                        22.55668990842472,
                        44.52146968800304
                    ],
                    [
                        22.559790481515456,
                        44.538781189004
                    ],
                    [
                        22.565578243605433,
                        44.555421015641315
                    ],
                    [
                        22.58046107806926,
                        44.5654980883277
                    ],
                    [
                        22.60030482676842,
                        44.56978721503391
                    ],
                    [
                        22.621182076636515,
                        44.56921856434397
                    ],
                    [
                        22.64216273609514,
                        44.563120957252146
                    ],
                    [
                        22.67854292528594,
                        44.545550822821696
                    ],
                    [
                        22.700143691786618,
                        44.54183025726323
                    ],
                    [
                        22.71936731285645,
                        44.5443623136196
                    ],
                    [
                        22.74169153410411,
                        44.55185541224904
                    ],
                    [
                        22.75926152792929,
                        44.56467121874402
                    ],
                    [
                        22.76515263805892,
                        44.58280962444152
                    ],
                    [
                        22.714716410540134,
                        44.62306533937113
                    ],
                    [
                        22.700143676818406,
                        44.63061025706795
                    ],
                    [
                        22.621182080603848,
                        44.637431483975654
                    ],
                    [
                        22.587489069029115,
                        44.64936890694892
                    ],
                    [
                        22.553279270530442,
                        44.66916097735576
                    ],
                    [
                        22.483722781816805,
                        44.72398959151889
                    ],
                    [
                        22.468943312829328,
                        44.73019068986616
                    ],
                    [
                        22.450546517941035,
                        44.73298133737691
                    ],
                    [
                        22.42605188897574,
                        44.733653123227406
                    ],
                    [
                        22.415509872251537,
                        44.72781350946917
                    ],
                    [
                        22.3806799632691,
                        44.70052838992047
                    ],
                    [
                        22.36114630025341,
                        44.692053672743945
                    ],
                    [
                        22.319701788460307,
                        44.68533564066377
                    ],
                    [
                        22.304922337200598,
                        44.677377529057
                    ],
                    [
                        22.299031218107274,
                        44.66166785469883
                    ],
                    [
                        22.185136346080846,
                        44.515113378986086
                    ],
                    [
                        22.17211390806648,
                        44.50534670127591
                    ],
                    [
                        22.14823936650239,
                        44.50090230215349
                    ],
                    [
                        22.126638649967024,
                        44.502659547655675
                    ],
                    [
                        22.10431442317388,
                        44.50963580729341
                    ],
                    [
                        22.086951142295842,
                        44.52177976927009
                    ],
                    [
                        22.076305783492366,
                        44.550718466849204
                    ],
                    [
                        22.06710738834585,
                        44.55722977311168
                    ],
                    [
                        22.055738573779784,
                        44.562139036451775
                    ],
                    [
                        22.045196562925867,
                        44.56921856434397
                    ],
                    [
                        22.039822240000984,
                        44.576866875682875
                    ],
                    [
                        22.03617362414791,
                        44.589489024640585
                    ],
                    [
                        22.034242908390254,
                        44.596168229130406
                    ],
                    [
                        22.05892894077237,
                        44.59937035450821
                    ],
                    [
                        22.08881229640843,
                        44.60324682198234
                    ],
                    [
                        22.102299855608297,
                        44.60203250289787
                    ],
                    [
                        22.127001190668317,
                        44.597019888235224
                    ],
                    [
                        22.138938429561502,
                        44.59655468067543
                    ],
                    [
                        22.149945495934617,
                        44.59769144864251
                    ],
                    [
                        22.16110760166552,
                        44.60182553786486
                    ],
                    [
                        22.16901411603533,
                        44.60895703970631
                    ],
                    [
                        22.173975042618878,
                        44.62146265387884
                    ],
                    [
                        22.172734829992347,
                        44.63386516227096
                    ],
                    [
                        22.168238949606238,
                        44.6474299905865
                    ],
                    [
                        22.160797569416285,
                        44.66435422535785
                    ],
                    [
                        22.15986740429616,
                        44.67748011488264
                    ],
                    [
                        22.161727720882798,
                        44.6905023143355
                    ],
                    [
                        22.165293406296534,
                        44.7022071109308
                    ],
                    [
                        22.17211471487461,
                        44.71711591303329
                    ],
                    [
                        22.182863384567856,
                        44.73391053964772
                    ],
                    [
                        22.205652685070135,
                        44.76129899867099
                    ],
                    [
                        22.214179315021756,
                        44.77757721952292
                    ],
                    [
                        22.218985211235022,
                        44.790857968124705
                    ],
                    [
                        22.218985232713987,
                        44.79897132997433
                    ],
                    [
                        22.221930777258137,
                        44.806154262836905
                    ],
                    [
                        22.228028608327815,
                        44.81121864530715
                    ],
                    [
                        22.24306645933422,
                        44.81349247672329
                    ],
                    [
                        22.253453404301485,
                        44.81204540830701
                    ],
                    [
                        22.262600150930588,
                        44.80832483552657
                    ],
                    [
                        22.297068314286758,
                        44.783881756356976
                    ],
                    [
                        22.30373456080694,
                        44.78018679225722
                    ],
                    [
                        22.311175991527904,
                        44.77786153844464
                    ],
                    [
                        22.321407909632217,
                        44.777112109625975
                    ],
                    [
                        22.354170769135337,
                        44.77770639984587
                    ],
                    [
                        22.36285242650031,
                        44.77628541857708
                    ],
                    [
                        22.369983746837317,
                        44.77308128152822
                    ],
                    [
                        22.376805051468327,
                        44.7688180964573
                    ],
                    [
                        22.38347130960382,
                        44.75814689494418
                    ],
                    [
                        22.38781214664433,
                        44.753651174142206
                    ],
                    [
                        22.395563589099613,
                        44.75101551169711
                    ],
                    [
                        22.406467314009937,
                        44.750343696894504
                    ],
                    [
                        22.421195111388887,
                        44.75210080034187
                    ],
                    [
                        22.431737079337125,
                        44.75825011205553
                    ],
                    [
                        22.441814003217438,
                        44.769412374415495
                    ],
                    [
                        22.451580844400386,
                        44.79152985062926
                    ],
                    [
                        22.466980409304394,
                        44.83933046080912
                    ],
                    [
                        22.49178512309043,
                        44.884599214753386
                    ],
                    [
                        22.533694685888534,
                        44.934234246116304
                    ],
                    [
                        22.544701790929718,
                        44.957721367179005
                    ],
                    [
                        22.550282827910454,
                        44.9734567071587
                    ],
                    [
                        22.55369348105656,
                        44.98686681039254
                    ],
                    [
                        22.554933709767262,
                        44.99740876768053
                    ],
                    [
                        22.558654412554322,
                        45.009190985851184
                    ],
                    [
                        22.566612582620387,
                        45.0239187695526
                    ],
                    [
                        22.59885867663952,
                        45.0602473011629
                    ],
                    [
                        22.641078322379133,
                        45.09239004323689
                    ],
                    [
                        22.680300734085666,
                        45.07941925527906
                    ],
                    [
                        22.723140496666492,
                        45.03988678656593
                    ],
                    [
                        22.741175570939436,
                        45.0330654958273
                    ],
                    [
                        22.756988560033776,
                        45.03084340966622
                    ],
                    [
                        22.804014112548828,
                        45.03458995134182
                    ],
                    [
                        22.823392775171918,
                        45.032548733150904
                    ],
                    [
                        22.835330030494074,
                        45.02836294080872
                    ],
                    [
                        22.845251906468427,
                        45.02200674238121
                    ],
                    [
                        22.85243492995894,
                        45.0134801292993
                    ],
                    [
                        22.86344201045394,
                        45.00402334220259
                    ],
                    [
                        22.88018517348468,
                        44.99275787854952
                    ],
                    [
                        22.90581667065609,
                        44.981750696581805
                    ],
                    [
                        22.9177539452372,
                        44.97299167446771
                    ],
                    [
                        22.922559855843208,
                        44.96423254037209
                    ],
                    [
                        22.922094754805368,
                        44.95529242232918
                    ],
                    [
                        22.917908972480973,
                        44.94676587423213
                    ],
                    [
                        22.91263796039619,
                        44.92991923895681
                    ],
                    [
                        22.912948025534604,
                        44.92116013839749
                    ],
                    [
                        22.915118429710116,
                        44.91172914500871
                    ],
                    [
                        22.92178471220165,
                        44.89470192711077
                    ],
                    [
                        22.924420192525403,
                        44.885374199074306
                    ],
                    [
                        22.927830855085908,
                        44.863902772121214
                    ],
                    [
                        22.93124147788327,
                        44.85271466459614
                    ],
                    [
                        22.937442654959337,
                        44.84163010876921
                    ],
                    [
                        23.02668784120279,
                        44.769308849055385
                    ],
                    [
                        23.10347902825037,
                        44.71768416036648
                    ],
                    [
                        23.12616498032826,
                        44.70657371129339
                    ],
                    [
                        23.14538860828713,
                        44.69964903357172
                    ],
                    [
                        23.31886640893267,
                        44.66419913039727
                    ],
                    [
                        23.342275811472646,
                        44.65644751105204
                    ],
                    [
                        23.406664649098843,
                        44.624744044725595
                    ],
                    [
                        23.462991978533136,
                        44.58523754108359
                    ],
                    [
                        23.472810478789512,
                        44.57461787815497
                    ],
                    [
                        23.48939863749904,
                        44.55030428376798
                    ],
                    [
                        23.475445984749562,
                        44.53924541504581
                    ],
                    [
                        23.420203906950903,
                        44.5409509390478
                    ],
                    [
                        23.395502576333833,
                        44.536816856374124
                    ],
                    [
                        23.379224488374298,
                        44.53211421647538
                    ],
                    [
                        23.36697718712814,
                        44.52653325904787
                    ],
                    [
                        23.30413860885937,
                        44.52327737964208
                    ],
                    [
                        23.29075441119065,
                        44.51878151300618
                    ],
                    [
                        23.28765383663721,
                        44.515215923928594
                    ],
                    [
                        23.294940224935996,
                        44.512942240010894
                    ],
                    [
                        23.304138622131045,
                        44.511934498505326
                    ],
                    [
                        23.310029749359835,
                        44.5097383508644
                    ],
                    [
                        23.31002975564017,
                        44.50568179560367
                    ],
                    [
                        23.2881189434828,
                        44.49216837274676
                    ],
                    [
                        23.28114260329553,
                        44.48529525295497
                    ],
                    [
                        23.27525151666632,
                        44.477699005661925
                    ],
                    [
                        23.26176396859568,
                        44.46679528569244
                    ],
                    [
                        23.246416036069103,
                        44.46121399669445
                    ],
                    [
                        23.227140734635295,
                        44.45671819992827
                    ],
                    [
                        23.218924176252372,
                        44.45155052032463
                    ],
                    [
                        23.21489343975008,
                        44.445866300314
                    ],
                    [
                        23.213343146216033,
                        44.437546389114225
                    ],
                    [
                        23.20574667918434,
                        44.41641049379219
                    ],
                    [
                        23.205901716958852,
                        44.40917585824153
                    ],
                    [
                        23.209312376573788,
                        44.402819759991026
                    ],
                    [
                        23.21752892944923,
                        44.39863397857744
                    ],
                    [
                        23.228535997563323,
                        44.39679937546152
                    ],
                    [
                        23.249671663424017,
                        44.395326634104485
                    ],
                    [
                        23.259593520297596,
                        44.39372453423308
                    ],
                    [
                        23.267345004716148,
                        44.39062408741837
                    ],
                    [
                        23.27323609905497,
                        44.3862831348466
                    ],
                    [
                        23.275716573522757,
                        44.380727953643174
                    ],
                    [
                        23.27385621488255,
                        44.374294190307765
                    ],
                    [
                        23.268275170148144,
                        44.37264061214216
                    ],
                    [
                        23.248276412288824,
                        44.375276272424514
                    ],
                    [
                        23.235047230924177,
                        44.37424263029831
                    ],
                    [
                        23.18228561318986,
                        44.35222861856409
                    ],
                    [
                        23.173448932017873,
                        44.34344353685181
                    ],
                    [
                        23.167712832120927,
                        44.33073101698971
                    ],
                    [
                        23.16306198177505,
                        44.31339378342672
                    ],
                    [
                        23.158566124203446,
                        44.287994764120604
                    ],
                    [
                        23.155465512171997,
                        44.27967466974734
                    ],
                    [
                        23.134381558695274,
                        44.247377123051464
                    ],
                    [
                        23.131591018867343,
                        44.235904868507376
                    ],
                    [
                        23.133451358793394,
                        44.22303734770808
                    ],
                    [
                        23.14011763173274,
                        44.2069143914359
                    ],
                    [
                        23.143063190970786,
                        44.19456374917962
                    ],
                    [
                        23.143683313197894,
                        44.182962424268446
                    ],
                    [
                        23.13949750213747,
                        44.170818321883246
                    ],
                    [
                        23.132056108192884,
                        44.16756279609812
                    ],
                    [
                        23.12146244187871,
                        44.1687255245437
                    ],
                    [
                        23.090611594223688,
                        44.162291678876855
                    ],
                    [
                        23.008601099057593,
                        44.10066756397513
                    ],
                    [
                        23.008306723004157,
                        44.10044651944405
                    ]
                ]
            ]
        },
        "type": "Feature",
        "properties": {
            "source": "https://simplemaps.com",
            "id": "ROMH",
            "name": "Mehedinti"
        },
        "id": 5
    },
    {
        "geometry": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        23.008306723004157,
                        44.10044651944405
                    ],
                    [
                        23.008601099057593,
                        44.10066756397513
                    ],
                    [
                        23.090611594223688,
                        44.162291678876855
                    ],
                    [
                        23.12146244187871,
                        44.1687255245437
                    ],
                    [
                        23.132056108192884,
                        44.16756279609812
                    ],
                    [
                        23.13949750213747,
                        44.170818321883246
                    ],
                    [
                        23.143683313197894,
                        44.182962424268446
                    ],
                    [
                        23.143063190970786,
                        44.19456374917962
                    ],
                    [
                        23.14011763173274,
                        44.2069143914359
                    ],
                    [
                        23.133451358793394,
                        44.22303734770808
                    ],
                    [
                        23.131591018867343,
                        44.235904868507376
                    ],
                    [
                        23.134381558695274,
                        44.247377123051464
                    ],
                    [
                        23.155465512171997,
                        44.27967466974734
                    ],
                    [
                        23.158566124203446,
                        44.287994764120604
                    ],
                    [
                        23.16306198177505,
                        44.31339378342672
                    ],
                    [
                        23.167712832120927,
                        44.33073101698971
                    ],
                    [
                        23.173448932017873,
                        44.34344353685181
                    ],
                    [
                        23.18228561318986,
                        44.35222861856409
                    ],
                    [
                        23.235047230924177,
                        44.37424263029831
                    ],
                    [
                        23.248276412288824,
                        44.375276272424514
                    ],
                    [
                        23.268275170148144,
                        44.37264061214216
                    ],
                    [
                        23.27385621488255,
                        44.374294190307765
                    ],
                    [
                        23.275716573522757,
                        44.380727953643174
                    ],
                    [
                        23.27323609905497,
                        44.3862831348466
                    ],
                    [
                        23.267345004716148,
                        44.39062408741837
                    ],
                    [
                        23.259593520297596,
                        44.39372453423308
                    ],
                    [
                        23.249671663424017,
                        44.395326634104485
                    ],
                    [
                        23.228535997563323,
                        44.39679937546152
                    ],
                    [
                        23.21752892944923,
                        44.39863397857744
                    ],
                    [
                        23.209312376573788,
                        44.402819759991026
                    ],
                    [
                        23.205901716958852,
                        44.40917585824153
                    ],
                    [
                        23.20574667918434,
                        44.41641049379219
                    ],
                    [
                        23.213343146216033,
                        44.437546389114225
                    ],
                    [
                        23.21489343975008,
                        44.445866300314
                    ],
                    [
                        23.218924176252372,
                        44.45155052032463
                    ],
                    [
                        23.227140734635295,
                        44.45671819992827
                    ],
                    [
                        23.246416036069103,
                        44.46121399669445
                    ],
                    [
                        23.26176396859568,
                        44.46679528569244
                    ],
                    [
                        23.27525151666632,
                        44.477699005661925
                    ],
                    [
                        23.28114260329553,
                        44.48529525295497
                    ],
                    [
                        23.2881189434828,
                        44.49216837274676
                    ],
                    [
                        23.31002975564017,
                        44.50568179560367
                    ],
                    [
                        23.310029749359835,
                        44.5097383508644
                    ],
                    [
                        23.304138622131045,
                        44.511934498505326
                    ],
                    [
                        23.294940224935996,
                        44.512942240010894
                    ],
                    [
                        23.28765383663721,
                        44.515215923928594
                    ],
                    [
                        23.29075441119065,
                        44.51878151300618
                    ],
                    [
                        23.30413860885937,
                        44.52327737964208
                    ],
                    [
                        23.36697718712814,
                        44.52653325904787
                    ],
                    [
                        23.379224488374298,
                        44.53211421647538
                    ],
                    [
                        23.395502576333833,
                        44.536816856374124
                    ],
                    [
                        23.420203906950903,
                        44.5409509390478
                    ],
                    [
                        23.475445984749562,
                        44.53924541504581
                    ],
                    [
                        23.48939863749904,
                        44.55030428376798
                    ],
                    [
                        23.581279312401865,
                        44.596812925751266
                    ],
                    [
                        23.675898874439547,
                        44.61831041891307
                    ],
                    [
                        23.723389512556388,
                        44.6198865333396
                    ],
                    [
                        23.73222617621567,
                        44.62389141173383
                    ],
                    [
                        23.736722024051847,
                        44.62939494040228
                    ],
                    [
                        23.737652207779746,
                        44.63688807734394
                    ],
                    [
                        23.736722019279764,
                        44.64417436600951
                    ],
                    [
                        23.734241553549506,
                        44.650608096423426
                    ],
                    [
                        23.73269126564402,
                        44.65660260304575
                    ],
                    [
                        23.732381220870224,
                        44.662519651172246
                    ],
                    [
                        23.736256971756735,
                        44.677686813187705
                    ],
                    [
                        23.73718711241745,
                        44.68884867846828
                    ],
                    [
                        23.736101901567842,
                        44.698202069078164
                    ],
                    [
                        23.73377650473944,
                        44.70683233178723
                    ],
                    [
                        23.732536251859663,
                        44.71417026114712
                    ],
                    [
                        23.732691264159406,
                        44.720733045401815
                    ],
                    [
                        23.73548181254267,
                        44.729156454360485
                    ],
                    [
                        23.740132702086633,
                        44.733083937325304
                    ],
                    [
                        23.745868754646228,
                        44.73458232704673
                    ],
                    [
                        23.752896760557995,
                        44.733858934207454
                    ],
                    [
                        23.765454147882952,
                        44.729905793904145
                    ],
                    [
                        23.775531055994442,
                        44.72254192909474
                    ],
                    [
                        23.78297244898858,
                        44.69913241260923
                    ],
                    [
                        23.784057666886262,
                        44.691174334832255
                    ],
                    [
                        23.788398490604507,
                        44.6818467535136
                    ],
                    [
                        23.796304968169046,
                        44.67494784022744
                    ],
                    [
                        23.81387494593652,
                        44.66740301354906
                    ],
                    [
                        23.829067807943307,
                        44.66270039101267
                    ],
                    [
                        23.862450816346485,
                        44.64755943456441
                    ],
                    [
                        23.872217640369037,
                        44.64171984262376
                    ],
                    [
                        23.88105431979913,
                        44.63277988568943
                    ],
                    [
                        23.90167322362139,
                        44.58335143259651
                    ],
                    [
                        23.91330042852403,
                        44.56826196320059
                    ],
                    [
                        23.929475126989264,
                        44.550665969044125
                    ],
                    [
                        23.958155540893358,
                        44.529659452605515
                    ],
                    [
                        23.92032840828235,
                        44.49780104773143
                    ],
                    [
                        23.906789170532832,
                        44.4802309707506
                    ],
                    [
                        23.904928843546845,
                        44.47284141164015
                    ],
                    [
                        23.90570398883685,
                        44.46545168032551
                    ],
                    [
                        23.91009646352372,
                        44.457906760165336
                    ],
                    [
                        23.918778119160507,
                        44.45103390850814
                    ],
                    [
                        23.958620630180867,
                        44.43429060518841
                    ],
                    [
                        23.969317671429337,
                        44.42651344405151
                    ],
                    [
                        23.995724324753766,
                        44.39904739849905
                    ],
                    [
                        24.003940855446015,
                        44.39274271338741
                    ],
                    [
                        24.01401775801,
                        44.3898488268001
                    ],
                    [
                        24.025541614747198,
                        44.38829861502653
                    ],
                    [
                        24.038254012836695,
                        44.383647709500394
                    ],
                    [
                        24.05220666797993,
                        44.37284746159527
                    ],
                    [
                        24.06538416205113,
                        44.35290038891044
                    ],
                    [
                        24.076908010055394,
                        44.34039471741234
                    ],
                    [
                        24.08915531262036,
                        44.33067946240138
                    ],
                    [
                        24.11147952740131,
                        44.317708653463214
                    ],
                    [
                        24.121401401496385,
                        44.309698801669896
                    ],
                    [
                        24.129462926465546,
                        44.29848502445403
                    ],
                    [
                        24.138196255464184,
                        44.28365397045553
                    ],
                    [
                        24.14904829543611,
                        44.27238843259389
                    ],
                    [
                        24.15943526337705,
                        44.26404272420654
                    ],
                    [
                        24.195557073772818,
                        44.24696354912798
                    ],
                    [
                        24.22056845609969,
                        44.239625425055955
                    ],
                    [
                        24.232350716488938,
                        44.23363119442626
                    ],
                    [
                        24.250850861587626,
                        44.219523407043994
                    ],
                    [
                        24.256741967982915,
                        44.2101699178051
                    ],
                    [
                        24.257052034613157,
                        44.202108457363
                    ],
                    [
                        24.252556165698476,
                        44.19554540744362
                    ],
                    [
                        24.248060340913614,
                        44.18743238653466
                    ],
                    [
                        24.246510042052364,
                        44.174590750374264
                    ],
                    [
                        24.24847372933185,
                        44.15965614506852
                    ],
                    [
                        24.255346699018503,
                        44.13521321760373
                    ],
                    [
                        24.276275662550162,
                        44.10828986002627
                    ],
                    [
                        24.27674073528003,
                        44.1021660965043
                    ],
                    [
                        24.27007448191105,
                        44.09973734839211
                    ],
                    [
                        24.258447302076032,
                        44.10079683696835
                    ],
                    [
                        24.246510031700513,
                        44.103406391542215
                    ],
                    [
                        24.23591639364078,
                        44.10469852186288
                    ],
                    [
                        24.22645960069872,
                        44.10387165556705
                    ],
                    [
                        24.22072350785504,
                        44.101106909379965
                    ],
                    [
                        24.216382696384294,
                        44.09684366235266
                    ],
                    [
                        24.215452488366367,
                        44.09164995573226
                    ],
                    [
                        24.2151424604124,
                        44.079351171654714
                    ],
                    [
                        24.210956678340928,
                        44.06426171705242
                    ],
                    [
                        24.20723593553909,
                        44.056380781560186
                    ],
                    [
                        24.20491051878599,
                        44.04583895257496
                    ],
                    [
                        24.20692589791325,
                        44.039431063241445
                    ],
                    [
                        24.21266196275846,
                        44.03359149354515
                    ],
                    [
                        24.220568476438373,
                        44.02987092845528
                    ],
                    [
                        24.22878504700758,
                        44.028294918505495
                    ],
                    [
                        24.26046268609199,
                        44.02728712875118
                    ],
                    [
                        24.273330097420608,
                        44.024858200667275
                    ],
                    [
                        24.286662630845314,
                        44.01684844545066
                    ],
                    [
                        24.29162355606976,
                        44.007624123464616
                    ],
                    [
                        24.293483914070993,
                        43.99726304142544
                    ],
                    [
                        24.292088669847978,
                        43.98863321573872
                    ],
                    [
                        24.28836793484395,
                        43.981940892992064
                    ],
                    [
                        24.269144325823582,
                        43.97411208179657
                    ],
                    [
                        24.25999761246198,
                        43.969047891429
                    ],
                    [
                        24.254416556491442,
                        43.96026289067383
                    ],
                    [
                        24.25674197090186,
                        43.95238205502409
                    ],
                    [
                        24.271004689285103,
                        43.93525148494129
                    ],
                    [
                        24.27348516125744,
                        43.92703495555469
                    ],
                    [
                        24.27193483817347,
                        43.91985171706852
                    ],
                    [
                        24.25953249545629,
                        43.89256656676854
                    ],
                    [
                        24.253951467411742,
                        43.885926334847305
                    ],
                    [
                        24.24010218696096,
                        43.878562471403164
                    ],
                    [
                        24.236846555979774,
                        43.87406650866185
                    ],
                    [
                        24.233590941002713,
                        43.86223260651179
                    ],
                    [
                        24.229250120329258,
                        43.85670322198138
                    ],
                    [
                        24.211266734378235,
                        43.846109648890994
                    ],
                    [
                        24.204290414294462,
                        43.83908163998034
                    ],
                    [
                        24.14982345439624,
                        43.75505575831447
                    ],
                    [
                        24.149605845110464,
                        43.75472004219352
                    ],
                    [
                        23.799921525530177,
                        43.81846355904081
                    ],
                    [
                        23.74287072695553,
                        43.84269968667883
                    ],
                    [
                        23.720753195028546,
                        43.84582596679325
                    ],
                    [
                        23.636107212452533,
                        43.83215764753762
                    ],
                    [
                        23.620853512574804,
                        43.834009905155646
                    ],
                    [
                        23.592699008264834,
                        43.8374286348321
                    ],
                    [
                        23.48469528873324,
                        43.88060447193501
                    ],
                    [
                        23.32515071848088,
                        43.88659218182592
                    ],
                    [
                        23.23447796943509,
                        43.87729692961502
                    ],
                    [
                        23.196960879154492,
                        43.86275001866879
                    ],
                    [
                        23.161924290358414,
                        43.85732423054052
                    ],
                    [
                        23.1318485998202,
                        43.84794490290113
                    ],
                    [
                        23.052551199020392,
                        43.84281974029106
                    ],
                    [
                        22.919561803396086,
                        43.83422471758462
                    ],
                    [
                        22.888762660730233,
                        43.83952162988601
                    ],
                    [
                        22.86344121096678,
                        43.85541214866825
                    ],
                    [
                        22.851038849162464,
                        43.874351428313425
                    ],
                    [
                        22.850522114929916,
                        43.89698592820074
                    ],
                    [
                        22.874706673503,
                        43.97204586047401
                    ],
                    [
                        22.88586875455174,
                        43.99452489996703
                    ],
                    [
                        22.905815875347354,
                        44.0039818196883
                    ],
                    [
                        22.92648643616639,
                        44.00615214004807
                    ],
                    [
                        22.96627732248818,
                        44.0155574977485
                    ],
                    [
                        22.988084752856537,
                        44.017676056254416
                    ],
                    [
                        23.023018012236825,
                        44.03162862846957
                    ],
                    [
                        23.040071261400062,
                        44.062324623101965
                    ],
                    [
                        23.030976186323766,
                        44.093071930460106
                    ],
                    [
                        23.008306723004157,
                        44.10044651944405
                    ]
                ]
            ]
        },
        "type": "Feature",
        "properties": {
            "source": "https://simplemaps.com",
            "id": "RODJ",
            "name": "Dolj"
        },
        "id": 6
    },
    {
        "geometry": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        27.252662452647993,
                        44.121518834295266
                    ],
                    [
                        27.25113204345522,
                        44.122372566818875
                    ],
                    [
                        27.226740742764722,
                        44.12071876652885
                    ],
                    [
                        27.205553422412393,
                        44.12924548156383
                    ],
                    [
                        27.100236852818107,
                        44.144490025754926
                    ],
                    [
                        27.027476433322285,
                        44.17704615572166
                    ],
                    [
                        27.00153487447716,
                        44.16510897089096
                    ],
                    [
                        26.884126008422,
                        44.15653060574762
                    ],
                    [
                        26.789454804907567,
                        44.11596473664531
                    ],
                    [
                        26.753694722315306,
                        44.10810997225272
                    ],
                    [
                        26.708684550281102,
                        44.10810997225272
                    ],
                    [
                        26.697212338533642,
                        44.10609431975134
                    ],
                    [
                        26.677316919034627,
                        44.09705098510533
                    ],
                    [
                        26.667808492734117,
                        44.09508752076683
                    ],
                    [
                        26.647758006171628,
                        44.09338199719769
                    ],
                    [
                        26.614168327076598,
                        44.08485539729633
                    ],
                    [
                        26.4157906853214,
                        44.06378887507651
                    ],
                    [
                        26.415731651337456,
                        44.06423580371317
                    ],
                    [
                        26.41392294433482,
                        44.07792985284964
                    ],
                    [
                        26.417488645463962,
                        44.0881102838594
                    ],
                    [
                        26.424464949230487,
                        44.10077092138872
                    ],
                    [
                        26.45350709129463,
                        44.13043310673942
                    ],
                    [
                        26.45986332820195,
                        44.143869207464334
                    ],
                    [
                        26.462343790651005,
                        44.16058649301859
                    ],
                    [
                        26.459708293785713,
                        44.185055292606414
                    ],
                    [
                        26.451491752936445,
                        44.206759468657424
                    ],
                    [
                        26.437797494186377,
                        44.22624145785472
                    ],
                    [
                        26.41500816275224,
                        44.244224699708425
                    ],
                    [
                        26.326279753223133,
                        44.282232874415115
                    ],
                    [
                        26.280029341912666,
                        44.32145525990102
                    ],
                    [
                        26.29072634683135,
                        44.34793932041419
                    ],
                    [
                        26.316461230758776,
                        44.37703328691278
                    ],
                    [
                        26.342402789505808,
                        44.40142449480443
                    ],
                    [
                        26.359766063060366,
                        44.41359424632185
                    ],
                    [
                        26.377956193667533,
                        44.42289617433659
                    ],
                    [
                        26.438314264180264,
                        44.44292077742408
                    ],
                    [
                        26.449631398271894,
                        44.451679902239675
                    ],
                    [
                        26.45645268274893,
                        44.46023232018516
                    ],
                    [
                        26.46048341062084,
                        44.46806108009601
                    ],
                    [
                        26.459708299014157,
                        44.473616523305296
                    ],
                    [
                        26.453817192397253,
                        44.477699005661925
                    ],
                    [
                        26.435316993681518,
                        44.482246300395126
                    ],
                    [
                        26.421209345278033,
                        44.48818920015726
                    ],
                    [
                        26.411597529610347,
                        44.4957856416701
                    ],
                    [
                        26.412682753683246,
                        44.50852400468818
                    ],
                    [
                        26.41640343854303,
                        44.51454419398339
                    ],
                    [
                        26.434076758070177,
                        44.52327737964208
                    ],
                    [
                        26.51355514968865,
                        44.55317244154843
                    ],
                    [
                        26.52967816228966,
                        44.555058410484264
                    ],
                    [
                        26.543940886235777,
                        44.55293986271674
                    ],
                    [
                        26.557945169870464,
                        44.54735862092586
                    ],
                    [
                        26.58988121752613,
                        44.53043467173114
                    ],
                    [
                        26.60233523955026,
                        44.527179066478666
                    ],
                    [
                        26.616597918174477,
                        44.5258612053275
                    ],
                    [
                        26.633496132000523,
                        44.5274116306519
                    ],
                    [
                        26.65742231376008,
                        44.53345773515431
                    ],
                    [
                        26.66703415092474,
                        44.53748862288796
                    ],
                    [
                        26.675560736812297,
                        44.54301784345839
                    ],
                    [
                        26.69059860748071,
                        44.55712569150772
                    ],
                    [
                        26.698040001213332,
                        44.5615697859662
                    ],
                    [
                        26.707031681437954,
                        44.56324915348998
                    ],
                    [
                        26.71592006160194,
                        44.560923924178404
                    ],
                    [
                        26.748166131958428,
                        44.537462680044364
                    ],
                    [
                        26.76506430699128,
                        44.53040872933506
                    ],
                    [
                        26.783719521136337,
                        44.526274753240024
                    ],
                    [
                        26.808834251991282,
                        44.52632633230789
                    ],
                    [
                        26.82433717782083,
                        44.52844504733042
                    ],
                    [
                        26.839426734166246,
                        44.52880701846778
                    ],
                    [
                        26.85120894583021,
                        44.526584838148295
                    ],
                    [
                        26.880974577693525,
                        44.51418254065278
                    ],
                    [
                        26.899474748733514,
                        44.511133678435044
                    ],
                    [
                        26.956887236171806,
                        44.51872993488925
                    ],
                    [
                        26.976731007605604,
                        44.517696542744
                    ],
                    [
                        27.000037076692895,
                        44.514027502867116
                    ],
                    [
                        27.07341759459429,
                        44.49214243277435
                    ],
                    [
                        27.09729210893313,
                        44.48803417220347
                    ],
                    [
                        27.127574497715813,
                        44.488421742197765
                    ],
                    [
                        27.18560713296491,
                        44.4959406725539
                    ],
                    [
                        27.363735792003858,
                        44.4935377004422
                    ],
                    [
                        27.38140912022766,
                        44.49684491881761
                    ],
                    [
                        27.410296275276615,
                        44.50498414050869
                    ],
                    [
                        27.43541098666643,
                        44.50769694514109
                    ],
                    [
                        27.46584839895175,
                        44.50645666413783
                    ],
                    [
                        27.605168085702697,
                        44.48780163038262
                    ],
                    [
                        27.634210244215502,
                        44.4775180426227
                    ],
                    [
                        27.68960739389712,
                        44.46883648789959
                    ],
                    [
                        27.702474817664932,
                        44.46457313628907
                    ],
                    [
                        27.717822709666002,
                        44.45483207326362
                    ],
                    [
                        27.739268439080238,
                        44.43770139802556
                    ],
                    [
                        27.780247841013413,
                        44.41775424421624
                    ],
                    [
                        27.871456764201053,
                        44.390004122887724
                    ],
                    [
                        28.02276531643026,
                        44.35470886599204
                    ],
                    [
                        27.993516460098792,
                        44.30442772133862
                    ],
                    [
                        27.967523251313786,
                        44.280553431257765
                    ],
                    [
                        27.93398523637053,
                        44.26603229517369
                    ],
                    [
                        27.788826144756733,
                        44.239884056663385
                    ],
                    [
                        27.75322104901931,
                        44.21885154690223
                    ],
                    [
                        27.732912247670264,
                        44.20986006989624
                    ],
                    [
                        27.691829449435485,
                        44.20453718699894
                    ],
                    [
                        27.60795859522442,
                        44.205467329526996
                    ],
                    [
                        27.569046233102444,
                        44.19554540744362
                    ],
                    [
                        27.51602625660211,
                        44.17270468436183
                    ],
                    [
                        27.506982885835757,
                        44.16547001498278
                    ],
                    [
                        27.499541436722218,
                        44.15585793173933
                    ],
                    [
                        27.481919804033023,
                        44.14583289910135
                    ],
                    [
                        27.461352596648226,
                        44.1377714544923
                    ],
                    [
                        27.444867776954013,
                        44.13412802979876
                    ],
                    [
                        27.292422301465656,
                        44.15156882169492
                    ],
                    [
                        27.277746226658614,
                        44.14249981240143
                    ],
                    [
                        27.265343864170664,
                        44.134748223891556
                    ],
                    [
                        27.252786469614637,
                        44.12164811368057
                    ],
                    [
                        27.252662452647993,
                        44.121518834295266
                    ]
                ]
            ]
        },
        "type": "Feature",
        "properties": {
            "source": "https://simplemaps.com",
            "id": "ROCL",
            "name": "Calarasi"
        },
        "id": 7
    },
    {
        "geometry": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        25.732947939939688,
                        43.718781033147806
                    ],
                    [
                        25.671383499977953,
                        43.71735847307891
                    ],
                    [
                        25.65350344690801,
                        43.70813418268852
                    ],
                    [
                        25.637897188546955,
                        43.697282291131806
                    ],
                    [
                        25.616503154815987,
                        43.68774804372949
                    ],
                    [
                        25.59386883368844,
                        43.68066808407037
                    ],
                    [
                        25.575058628458454,
                        43.677386742731
                    ],
                    [
                        25.556558463923757,
                        43.67035873063551
                    ],
                    [
                        25.533820835132715,
                        43.66867926146785
                    ],
                    [
                        25.488758993024206,
                        43.67053965316263
                    ],
                    [
                        25.482450047861235,
                        43.66971484198158
                    ],
                    [
                        25.46741661765079,
                        43.66774906859776
                    ],
                    [
                        25.426075460278394,
                        43.654390633510424
                    ],
                    [
                        25.40313113582407,
                        43.65004989260333
                    ],
                    [
                        25.359619583367078,
                        43.65428738355877
                    ],
                    [
                        25.32303265632179,
                        43.66971270990154
                    ],
                    [
                        25.28871950270232,
                        43.68896216298659
                    ],
                    [
                        25.28540477710486,
                        43.69039133128853
                    ],
                    [
                        25.252339316825275,
                        43.704646110423226
                    ],
                    [
                        25.211308241638143,
                        43.711880898778226
                    ],
                    [
                        25.08160037167248,
                        43.71893456025181
                    ],
                    [
                        24.963674752689716,
                        43.749604516213424
                    ],
                    [
                        24.752628224974057,
                        43.738804289199216
                    ],
                    [
                        24.705602672487572,
                        43.743765237842005
                    ],
                    [
                        24.661763238764717,
                        43.755656818770895
                    ],
                    [
                        24.661936894919727,
                        43.755882559380815
                    ],
                    [
                        24.66297040891934,
                        43.75722603831931
                    ],
                    [
                        24.68343425891388,
                        43.77660458650843
                    ],
                    [
                        24.694751430263565,
                        43.78471800628974
                    ],
                    [
                        24.708135628473823,
                        43.79200440203295
                    ],
                    [
                        24.735730820794533,
                        43.8018227679566
                    ],
                    [
                        24.74518761495413,
                        43.80714548443794
                    ],
                    [
                        24.746892939672676,
                        43.81466442848675
                    ],
                    [
                        24.74100181141486,
                        43.83024476343102
                    ],
                    [
                        24.697852007095374,
                        43.88171461001376
                    ],
                    [
                        24.66266034001563,
                        43.933649310265814
                    ],
                    [
                        24.631602833719406,
                        43.99098451498063
                    ],
                    [
                        24.630672629377482,
                        44.009820372437794
                    ],
                    [
                        24.636873801162242,
                        44.02475486179129
                    ],
                    [
                        24.657699409683246,
                        44.0447536895269
                    ],
                    [
                        24.675837845710557,
                        44.051678386159494
                    ],
                    [
                        24.692270935876707,
                        44.05545066342284
                    ],
                    [
                        24.70968591862249,
                        44.0564585201401
                    ],
                    [
                        24.72363856401479,
                        44.059223279150984
                    ],
                    [
                        24.734025508413392,
                        44.06348645160107
                    ],
                    [
                        24.763842787693022,
                        44.08671485030899
                    ],
                    [
                        24.775469999823258,
                        44.09281277947752
                    ],
                    [
                        24.78849247408403,
                        44.09591345519651
                    ],
                    [
                        24.82234051969347,
                        44.10066756397513
                    ],
                    [
                        24.835207950400843,
                        44.10655867206033
                    ],
                    [
                        24.8412540957749,
                        44.115757099697156
                    ],
                    [
                        24.839238726260078,
                        44.13446404438066
                    ],
                    [
                        24.83443280353668,
                        44.149811842143386
                    ],
                    [
                        24.832727503781747,
                        44.166322616958475
                    ],
                    [
                        24.83412275850515,
                        44.193323490224316
                    ],
                    [
                        24.84559492039446,
                        44.227223190406
                    ],
                    [
                        24.84838544550196,
                        44.24934068979178
                    ],
                    [
                        24.84481978063342,
                        44.2967280376354
                    ],
                    [
                        24.837068308353164,
                        44.340782148697286
                    ],
                    [
                        24.837533417513956,
                        44.356801986722594
                    ],
                    [
                        24.838773634635654,
                        44.366878767607844
                    ],
                    [
                        24.851330988069897,
                        44.389926322286406
                    ],
                    [
                        24.8941707618158,
                        44.39770370899064
                    ],
                    [
                        24.9487927763659,
                        44.38767865398496
                    ],
                    [
                        24.966001016621234,
                        44.38840204365695
                    ],
                    [
                        24.981245540909633,
                        44.391089061426825
                    ],
                    [
                        24.991632513264,
                        44.395068210794975
                    ],
                    [
                        24.99922897694943,
                        44.39956425026002
                    ],
                    [
                        25.012096372680404,
                        44.410881147225716
                    ],
                    [
                        25.022018271568168,
                        44.41646236418597
                    ],
                    [
                        25.03178509257712,
                        44.41739237094188
                    ],
                    [
                        25.063307714696666,
                        44.414136746235144
                    ],
                    [
                        25.08800907901629,
                        44.418581122788865
                    ],
                    [
                        25.101496620231117,
                        44.423025242123565
                    ],
                    [
                        25.12382084331366,
                        44.438657389313796
                    ],
                    [
                        25.144749782065407,
                        44.44726141081593
                    ],
                    [
                        25.190070011141998,
                        44.453462569467455
                    ],
                    [
                        25.212755981487252,
                        44.45341099956065
                    ],
                    [
                        25.23027428516783,
                        44.45180897904928
                    ],
                    [
                        25.246397351561548,
                        44.4484243116579
                    ],
                    [
                        25.2785400775796,
                        44.43728793934651
                    ],
                    [
                        25.299934135899868,
                        44.43072513938421
                    ],
                    [
                        25.31114788686964,
                        44.431629242169805
                    ],
                    [
                        25.328356159939712,
                        44.435685981595334
                    ],
                    [
                        25.348044879712297,
                        44.449354390582535
                    ],
                    [
                        25.35905196436618,
                        44.46038733764408
                    ],
                    [
                        25.37414146872138,
                        44.47930082194424
                    ],
                    [
                        25.380342651145487,
                        44.48539870595143
                    ],
                    [
                        25.3936751817428,
                        44.49635419025692
                    ],
                    [
                        25.398171017240546,
                        44.50203849875784
                    ],
                    [
                        25.39817099959303,
                        44.5078519805305
                    ],
                    [
                        25.39088464313633,
                        44.51829075816855
                    ],
                    [
                        25.39041954270768,
                        44.52420762825725
                    ],
                    [
                        25.395845585871157,
                        44.527954280903614
                    ],
                    [
                        25.40979821293141,
                        44.52953035129544
                    ],
                    [
                        25.432329128620193,
                        44.52655889599638
                    ],
                    [
                        25.48834637127344,
                        44.50746439216697
                    ],
                    [
                        25.513616153815107,
                        44.50586246588314
                    ],
                    [
                        25.534545102639438,
                        44.49382182048999
                    ],
                    [
                        25.53707728170099,
                        44.48720745916342
                    ],
                    [
                        25.536560498938925,
                        44.47868072391084
                    ],
                    [
                        25.51935223290607,
                        44.457338264814545
                    ],
                    [
                        25.498268246600613,
                        44.419666136449905
                    ],
                    [
                        25.49361739207783,
                        44.40659215595736
                    ],
                    [
                        25.497028045440267,
                        44.398323990184494
                    ],
                    [
                        25.50446945289531,
                        44.38767865398496
                    ],
                    [
                        25.51454632850813,
                        44.37548281810586
                    ],
                    [
                        25.527413770444078,
                        44.348714502518476
                    ],
                    [
                        25.537697395278975,
                        44.33662231486037
                    ],
                    [
                        25.55009973893862,
                        44.329490963135015
                    ],
                    [
                        25.63789796293039,
                        44.32148088409659
                    ],
                    [
                        25.652625768080824,
                        44.317708653463214
                    ],
                    [
                        25.68089277135072,
                        44.29900175080914
                    ],
                    [
                        25.700736515874606,
                        44.28866643056676
                    ],
                    [
                        25.70946982451078,
                        44.28225849619391
                    ],
                    [
                        25.71458579211501,
                        44.2709155227901
                    ],
                    [
                        25.718926628710644,
                        44.25543854144498
                    ],
                    [
                        25.7195467449138,
                        44.229445287571004
                    ],
                    [
                        25.717221319550347,
                        44.214614247743285
                    ],
                    [
                        25.721872180624633,
                        44.1862696062562
                    ],
                    [
                        25.7218721949593,
                        44.171050991093836
                    ],
                    [
                        25.71939172454769,
                        44.159811355383106
                    ],
                    [
                        25.71102012383679,
                        44.15528954438648
                    ],
                    [
                        25.70166671788538,
                        44.15280926221774
                    ],
                    [
                        25.690349569764496,
                        44.151517289215484
                    ],
                    [
                        25.681667941627456,
                        44.14919193077012
                    ],
                    [
                        25.672831234374286,
                        44.14410155683516
                    ],
                    [
                        25.668490444628734,
                        44.13616942923847
                    ],
                    [
                        25.663839533427566,
                        44.114723489978914
                    ],
                    [
                        25.659343710633905,
                        44.10456924767435
                    ],
                    [
                        25.647561487912007,
                        44.08617247089178
                    ],
                    [
                        25.642393842775423,
                        44.07384762742573
                    ],
                    [
                        25.64053346028268,
                        44.06038570885717
                    ],
                    [
                        25.640378440540655,
                        44.0451670646748
                    ],
                    [
                        25.64849163301063,
                        43.987547794065115
                    ],
                    [
                        25.674226505473353,
                        43.8835231996137
                    ],
                    [
                        25.686163749377524,
                        43.85877010527026
                    ],
                    [
                        25.710400015036836,
                        43.83401721791746
                    ],
                    [
                        25.715826033890917,
                        43.82130477848958
                    ],
                    [
                        25.732879275230463,
                        43.71919226658413
                    ],
                    [
                        25.732947939939688,
                        43.718781033147806
                    ]
                ]
            ]
        },
        "type": "Feature",
        "properties": {
            "source": "https://simplemaps.com",
            "id": "ROTR",
            "name": "Teleorman"
        },
        "id": 8
    },
    {
        "geometry": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        26.280029341912666,
                        44.32145525990102
                    ],
                    [
                        26.326279753223133,
                        44.282232874415115
                    ],
                    [
                        26.41500816275224,
                        44.244224699708425
                    ],
                    [
                        26.437797494186377,
                        44.22624145785472
                    ],
                    [
                        26.451491752936445,
                        44.206759468657424
                    ],
                    [
                        26.459708293785713,
                        44.185055292606414
                    ],
                    [
                        26.462343790651005,
                        44.16058649301859
                    ],
                    [
                        26.45986332820195,
                        44.143869207464334
                    ],
                    [
                        26.45350709129463,
                        44.13043310673942
                    ],
                    [
                        26.424464949230487,
                        44.10077092138872
                    ],
                    [
                        26.417488645463962,
                        44.0881102838594
                    ],
                    [
                        26.41392294433482,
                        44.07792985284964
                    ],
                    [
                        26.415731651337456,
                        44.06423580371317
                    ],
                    [
                        26.4157906853214,
                        44.06378887507651
                    ],
                    [
                        26.332335499869025,
                        44.05492631060455
                    ],
                    [
                        26.310517627579358,
                        44.052609410575066
                    ],
                    [
                        26.231452695423133,
                        44.02749472227071
                    ],
                    [
                        26.15073407418763,
                        44.012404980323
                    ],
                    [
                        26.116214216936186,
                        43.99886576003417
                    ],
                    [
                        26.07931725038177,
                        43.96904850101799
                    ],
                    [
                        26.06164390120276,
                        43.94977312421702
                    ],
                    [
                        26.05430585815447,
                        43.9343219364143
                    ],
                    [
                        25.93400314560394,
                        43.87032082319137
                    ],
                    [
                        25.924494653501334,
                        43.85861591902943
                    ],
                    [
                        25.916433153637353,
                        43.84437922147553
                    ],
                    [
                        25.869304248330568,
                        43.80089350821627
                    ],
                    [
                        25.83933191728693,
                        43.78843948800796
                    ],
                    [
                        25.806258976875586,
                        43.763660476762745
                    ],
                    [
                        25.804398623055736,
                        43.75991392263991
                    ],
                    [
                        25.781144224840702,
                        43.7320086280292
                    ],
                    [
                        25.739596384401548,
                        43.71893456025181
                    ],
                    [
                        25.732947939939688,
                        43.718781033147806
                    ],
                    [
                        25.732879275230463,
                        43.71919226658413
                    ],
                    [
                        25.715826033890917,
                        43.82130477848958
                    ],
                    [
                        25.710400015036836,
                        43.83401721791746
                    ],
                    [
                        25.686163749377524,
                        43.85877010527026
                    ],
                    [
                        25.674226505473353,
                        43.8835231996137
                    ],
                    [
                        25.64849163301063,
                        43.987547794065115
                    ],
                    [
                        25.640378440540655,
                        44.0451670646748
                    ],
                    [
                        25.64053346028268,
                        44.06038570885717
                    ],
                    [
                        25.642393842775423,
                        44.07384762742573
                    ],
                    [
                        25.647561487912007,
                        44.08617247089178
                    ],
                    [
                        25.659343710633905,
                        44.10456924767435
                    ],
                    [
                        25.663839533427566,
                        44.114723489978914
                    ],
                    [
                        25.668490444628734,
                        44.13616942923847
                    ],
                    [
                        25.672831234374286,
                        44.14410155683516
                    ],
                    [
                        25.681667941627456,
                        44.14919193077012
                    ],
                    [
                        25.690349569764496,
                        44.151517289215484
                    ],
                    [
                        25.70166671788538,
                        44.15280926221774
                    ],
                    [
                        25.71102012383679,
                        44.15528954438648
                    ],
                    [
                        25.71939172454769,
                        44.159811355383106
                    ],
                    [
                        25.7218721949593,
                        44.171050991093836
                    ],
                    [
                        25.721872180624633,
                        44.1862696062562
                    ],
                    [
                        25.717221319550347,
                        44.214614247743285
                    ],
                    [
                        25.7195467449138,
                        44.229445287571004
                    ],
                    [
                        25.718926628710644,
                        44.25543854144498
                    ],
                    [
                        25.71458579211501,
                        44.2709155227901
                    ],
                    [
                        25.70946982451078,
                        44.28225849619391
                    ],
                    [
                        25.700736515874606,
                        44.28866643056676
                    ],
                    [
                        25.68089277135072,
                        44.29900175080914
                    ],
                    [
                        25.652625768080824,
                        44.317708653463214
                    ],
                    [
                        25.63789796293039,
                        44.32148088409659
                    ],
                    [
                        25.55009973893862,
                        44.329490963135015
                    ],
                    [
                        25.537697395278975,
                        44.33662231486037
                    ],
                    [
                        25.527413770444078,
                        44.348714502518476
                    ],
                    [
                        25.51454632850813,
                        44.37548281810586
                    ],
                    [
                        25.50446945289531,
                        44.38767865398496
                    ],
                    [
                        25.497028045440267,
                        44.398323990184494
                    ],
                    [
                        25.49361739207783,
                        44.40659215595736
                    ],
                    [
                        25.498268246600613,
                        44.419666136449905
                    ],
                    [
                        25.51935223290607,
                        44.457338264814545
                    ],
                    [
                        25.536560498938925,
                        44.47868072391084
                    ],
                    [
                        25.53707728170099,
                        44.48720745916342
                    ],
                    [
                        25.534545102639438,
                        44.49382182048999
                    ],
                    [
                        25.513616153815107,
                        44.50586246588314
                    ],
                    [
                        25.54028119763138,
                        44.53118394988084
                    ],
                    [
                        25.551339966850456,
                        44.53965897649362
                    ],
                    [
                        25.57087363085214,
                        44.54704852026057
                    ],
                    [
                        25.5991406741285,
                        44.55293986271674
                    ],
                    [
                        25.907132181845068,
                        44.56591045543884
                    ],
                    [
                        25.93198856256121,
                        44.52733410924615
                    ],
                    [
                        25.931058389711634,
                        44.514854270004705
                    ],
                    [
                        25.928371201402726,
                        44.498860330086124
                    ],
                    [
                        25.923100229767524,
                        44.48798259795622
                    ],
                    [
                        25.907752331513457,
                        44.46537417063369
                    ],
                    [
                        25.8978304374829,
                        44.44591786927505
                    ],
                    [
                        25.888838752791102,
                        44.40070108232497
                    ],
                    [
                        25.894729864448692,
                        44.38194253296359
                    ],
                    [
                        25.905116797252415,
                        44.369281611161945
                    ],
                    [
                        25.931781875806642,
                        44.360186818101006
                    ],
                    [
                        25.95074712478107,
                        44.355535923509635
                    ],
                    [
                        25.964854758533228,
                        44.34835268967543
                    ],
                    [
                        25.972296190833934,
                        44.33636392820059
                    ],
                    [
                        25.980202652684824,
                        44.33080850141262
                    ],
                    [
                        25.989349395601344,
                        44.32902575323511
                    ],
                    [
                        26.000408160508233,
                        44.329645931532205
                    ],
                    [
                        26.011260201836066,
                        44.32902575323511
                    ],
                    [
                        26.022887412128856,
                        44.32473669505071
                    ],
                    [
                        26.09921351104568,
                        44.27590251322958
                    ],
                    [
                        26.11569828239638,
                        44.26835769262072
                    ],
                    [
                        26.131356248321072,
                        44.26324177435563
                    ],
                    [
                        26.147324243929738,
                        44.26003768532977
                    ],
                    [
                        26.16225874634253,
                        44.25843580254874
                    ],
                    [
                        26.175591238770373,
                        44.25874568647585
                    ],
                    [
                        26.188768749608798,
                        44.26122629120922
                    ],
                    [
                        26.201326131497396,
                        44.26629063813733
                    ],
                    [
                        26.225872407914576,
                        44.28091488003952
                    ],
                    [
                        26.280029341912666,
                        44.32145525990102
                    ]
                ]
            ]
        },
        "type": "Feature",
        "properties": {
            "source": "https://simplemaps.com",
            "id": "ROGR",
            "name": "Giurgiu"
        },
        "id": 9
    },
    {
        "geometry": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        27.252662452647993,
                        44.121518834295266
                    ],
                    [
                        27.252786469614637,
                        44.12164811368057
                    ],
                    [
                        27.265343864170664,
                        44.134748223891556
                    ],
                    [
                        27.277746226658614,
                        44.14249981240143
                    ],
                    [
                        27.292422301465656,
                        44.15156882169492
                    ],
                    [
                        27.444867776954013,
                        44.13412802979876
                    ],
                    [
                        27.461352596648226,
                        44.1377714544923
                    ],
                    [
                        27.481919804033023,
                        44.14583289910135
                    ],
                    [
                        27.499541436722218,
                        44.15585793173933
                    ],
                    [
                        27.506982885835757,
                        44.16547001498278
                    ],
                    [
                        27.51602625660211,
                        44.17270468436183
                    ],
                    [
                        27.569046233102444,
                        44.19554540744362
                    ],
                    [
                        27.60795859522442,
                        44.205467329526996
                    ],
                    [
                        27.691829449435485,
                        44.20453718699894
                    ],
                    [
                        27.732912247670264,
                        44.20986006989624
                    ],
                    [
                        27.75322104901931,
                        44.21885154690223
                    ],
                    [
                        27.788826144756733,
                        44.239884056663385
                    ],
                    [
                        27.93398523637053,
                        44.26603229517369
                    ],
                    [
                        27.967523251313786,
                        44.280553431257765
                    ],
                    [
                        27.993516460098792,
                        44.30442772133862
                    ],
                    [
                        28.02276531643026,
                        44.35470886599204
                    ],
                    [
                        28.04819014285752,
                        44.39822055906973
                    ],
                    [
                        28.05728520682015,
                        44.40586873442115
                    ],
                    [
                        28.098781380285963,
                        44.430389190795395
                    ],
                    [
                        28.110253511776094,
                        44.44261045058992
                    ],
                    [
                        28.10901327624721,
                        44.45780331409292
                    ],
                    [
                        28.102192009478863,
                        44.478525699548825
                    ],
                    [
                        28.093355360443024,
                        44.496819283728975
                    ],
                    [
                        28.0860689791465,
                        44.50467407195884
                    ],
                    [
                        28.067000339489635,
                        44.507154321740174
                    ],
                    [
                        28.042609061024237,
                        44.513510507210746
                    ],
                    [
                        28.02033652678708,
                        44.5222955545753
                    ],
                    [
                        28.007210751667614,
                        44.531985114390416
                    ],
                    [
                        28.003903416516657,
                        44.539917185550685
                    ],
                    [
                        28.015220573696585,
                        44.543327941064476
                    ],
                    [
                        28.021525103306146,
                        44.55247470545077
                    ],
                    [
                        28.021370092042737,
                        44.58797651948186
                    ],
                    [
                        28.028036317198087,
                        44.598208245655755
                    ],
                    [
                        28.033617376890806,
                        44.62182440233757
                    ],
                    [
                        28.03454754633972,
                        44.63097109783322
                    ],
                    [
                        28.030775199702738,
                        44.637069111045506
                    ],
                    [
                        27.97796184308432,
                        44.67928849964407
                    ],
                    [
                        27.960288551797497,
                        44.686420142038614
                    ],
                    [
                        27.935225452502813,
                        44.689003782874515
                    ],
                    [
                        27.916363561193712,
                        44.69445567948853
                    ],
                    [
                        27.89853521127047,
                        44.70812421538796
                    ],
                    [
                        27.88447917661252,
                        44.72600399143348
                    ],
                    [
                        27.876882746837758,
                        44.74424580733658
                    ],
                    [
                        27.883704031877407,
                        44.75791419847667
                    ],
                    [
                        27.894762834218536,
                        44.76897323162579
                    ],
                    [
                        27.91088588117275,
                        44.775303591557424
                    ],
                    [
                        27.926647167464594,
                        44.77783558021037
                    ],
                    [
                        27.94576742869576,
                        44.778403913229205
                    ],
                    [
                        27.965094449359196,
                        44.77522602274425
                    ],
                    [
                        27.99506678763677,
                        44.761092562910555
                    ],
                    [
                        28.014083670781268,
                        44.75791419847667
                    ],
                    [
                        28.03470257839921,
                        44.763236934805846
                    ],
                    [
                        28.054804741122442,
                        44.777008887673226
                    ],
                    [
                        28.14521914823931,
                        44.78254901226742
                    ],
                    [
                        28.19563001135421,
                        44.76814594654664
                    ],
                    [
                        28.23883928203538,
                        44.73933952994485
                    ],
                    [
                        28.282048590876524,
                        44.71053334049254
                    ],
                    [
                        28.32525788975503,
                        44.71773484770103
                    ],
                    [
                        28.34686254267157,
                        44.76094414910091
                    ],
                    [
                        28.4044749511195,
                        44.76094414910091
                    ],
                    [
                        28.454885808765937,
                        44.71773484770103
                    ],
                    [
                        28.526901355300804,
                        44.696130405995206
                    ],
                    [
                        28.606118416568847,
                        44.696130405995206
                    ],
                    [
                        28.670932348011934,
                        44.71053334049254
                    ],
                    [
                        28.72854475400197,
                        44.68892867325305
                    ],
                    [
                        28.785410992660005,
                        44.67967350375752
                    ],
                    [
                        28.781016463918785,
                        44.66526922577272
                    ],
                    [
                        28.784027532017106,
                        44.64923732533749
                    ],
                    [
                        28.792491093174075,
                        44.644720835301804
                    ],
                    [
                        28.84555096676507,
                        44.651556648304016
                    ],
                    [
                        28.869476780035424,
                        44.6618107365629
                    ],
                    [
                        28.89136805549968,
                        44.677191592314266
                    ],
                    [
                        28.91195725157931,
                        44.69635665490308
                    ],
                    [
                        28.897715715453774,
                        44.71678308718604
                    ],
                    [
                        28.967458540241893,
                        44.70099524342637
                    ],
                    [
                        28.983409051268147,
                        44.69261303035518
                    ],
                    [
                        28.987559452387526,
                        44.67527910506117
                    ],
                    [
                        28.979340025560134,
                        44.655340803173786
                    ],
                    [
                        28.962087459139358,
                        44.63939050145057
                    ],
                    [
                        28.93873134035937,
                        44.63426355566807
                    ],
                    [
                        28.9563908155629,
                        44.65110908540863
                    ],
                    [
                        28.972666873735527,
                        44.670233528317056
                    ],
                    [
                        28.97535241801395,
                        44.68683507449928
                    ],
                    [
                        28.952403215613707,
                        44.69635665490308
                    ],
                    [
                        28.95240321353184,
                        44.68891035383529
                    ],
                    [
                        28.95997152801194,
                        44.68195208833754
                    ],
                    [
                        28.957774272829425,
                        44.67877831632766
                    ],
                    [
                        28.93873134188014,
                        44.675238498389554
                    ],
                    [
                        28.924164246907488,
                        44.68207421570402
                    ],
                    [
                        28.918223488653435,
                        44.68268454777038
                    ],
                    [
                        28.91382898010806,
                        44.67991775715182
                    ],
                    [
                        28.909434428692638,
                        44.67519758640875
                    ],
                    [
                        28.904551607498956,
                        44.66840228589187
                    ],
                    [
                        28.88542726560813,
                        44.65810773118548
                    ],
                    [
                        28.854177274309283,
                        44.63434476080694
                    ],
                    [
                        28.836273624987605,
                        44.627427423392156
                    ],
                    [
                        28.78785239367189,
                        44.609605114493974
                    ],
                    [
                        28.774180533874773,
                        44.60077545141358
                    ],
                    [
                        28.79151453518646,
                        44.6238468416374
                    ],
                    [
                        28.794688371238124,
                        44.63426355566807
                    ],
                    [
                        28.77979574709753,
                        44.6358095089204
                    ],
                    [
                        28.766937706175693,
                        44.63373450153314
                    ],
                    [
                        28.757823136695475,
                        44.62677657269474
                    ],
                    [
                        28.75367270542486,
                        44.61375550394189
                    ],
                    [
                        28.766774919417262,
                        44.61375550394189
                    ],
                    [
                        28.760590018007292,
                        44.603705016223614
                    ],
                    [
                        28.76441489975442,
                        44.59589258500607
                    ],
                    [
                        28.77442468224065,
                        44.59015538338797
                    ],
                    [
                        28.787852425825868,
                        44.586493323610824
                    ],
                    [
                        28.748057504762286,
                        44.577785647243786
                    ],
                    [
                        28.732676639319667,
                        44.56785722452815
                    ],
                    [
                        28.732676629805624,
                        44.552313548726325
                    ],
                    [
                        28.737152561783706,
                        44.55707441377708
                    ],
                    [
                        28.74390708450772,
                        44.56199771574776
                    ],
                    [
                        28.746918186034,
                        44.5659855423152
                    ],
                    [
                        28.76107834352215,
                        44.56020755599026
                    ],
                    [
                        28.77418053580678,
                        44.552313548726325
                    ],
                    [
                        28.765635624490116,
                        44.538885876355955
                    ],
                    [
                        28.753428592840564,
                        44.51349524760862
                    ],
                    [
                        28.745616104101632,
                        44.48615156379393
                    ],
                    [
                        28.750254760369437,
                        44.466701602413984
                    ],
                    [
                        28.75847415927715,
                        44.46527743611757
                    ],
                    [
                        28.766368022146203,
                        44.472601554547246
                    ],
                    [
                        28.771983245898568,
                        44.48370989245121
                    ],
                    [
                        28.778330940100282,
                        44.507391757538066
                    ],
                    [
                        28.78809656120229,
                        44.51536699464959
                    ],
                    [
                        28.808360226780977,
                        44.525051201992625
                    ],
                    [
                        28.838145371597992,
                        44.55402248473074
                    ],
                    [
                        28.855642145698404,
                        44.5676945355671
                    ],
                    [
                        28.873545772119286,
                        44.573431726203935
                    ],
                    [
                        28.892425967525433,
                        44.577053071745524
                    ],
                    [
                        28.906260625448212,
                        44.58771400654496
                    ],
                    [
                        28.914886889624956,
                        44.60138566120473
                    ],
                    [
                        28.924978053607337,
                        44.620550804973455
                    ],
                    [
                        28.918467654186525,
                        44.601019657323235
                    ],
                    [
                        28.90967859559158,
                        44.58421466420456
                    ],
                    [
                        28.84400477062028,
                        44.49371989125577
                    ],
                    [
                        28.796722846052866,
                        44.46792223312311
                    ],
                    [
                        28.70655358492055,
                        44.381048912212414
                    ],
                    [
                        28.69629967947385,
                        44.3583438433897
                    ],
                    [
                        28.693125827201555,
                        44.346136669170996
                    ],
                    [
                        28.680186419448244,
                        44.35333908421137
                    ],
                    [
                        28.664398619219057,
                        44.348374654695675
                    ],
                    [
                        28.651215031014765,
                        44.34003321689417
                    ],
                    [
                        28.640879762881795,
                        44.328558713525744
                    ],
                    [
                        28.635101768623883,
                        44.31639237694109
                    ],
                    [
                        28.632334817235826,
                        44.302435526609614
                    ],
                    [
                        28.631032728625364,
                        44.26434956221884
                    ],
                    [
                        28.635264541439128,
                        44.252020707951935
                    ],
                    [
                        28.651215015939147,
                        44.23078019845058
                    ],
                    [
                        28.66521246003859,
                        44.19928634244773
                    ],
                    [
                        28.668142104021058,
                        44.18431212950781
                    ],
                    [
                        28.66488693640125,
                        44.17560468588843
                    ],
                    [
                        28.671722828437666,
                        44.168687102309185
                    ],
                    [
                        28.658376477432583,
                        44.17446511402397
                    ],
                    [
                        28.645843932694294,
                        44.172023751050816
                    ],
                    [
                        28.636241073352174,
                        44.16429265866185
                    ],
                    [
                        28.630869982635346,
                        44.15448636313929
                    ],
                    [
                        28.63746178906483,
                        44.135891042144905
                    ],
                    [
                        28.654144737867096,
                        44.0549177746338
                    ],
                    [
                        28.671234594935264,
                        44.00332280044656
                    ],
                    [
                        28.67172285471631,
                        43.99738191916736
                    ],
                    [
                        28.669118662757366,
                        43.98916236361849
                    ],
                    [
                        28.660004125767166,
                        43.979803919580256
                    ],
                    [
                        28.654958520102493,
                        43.96137110200427
                    ],
                    [
                        28.640879774438446,
                        43.93219647797064
                    ],
                    [
                        28.63770594983092,
                        43.91864670024864
                    ],
                    [
                        28.613780144163886,
                        43.884182033979634
                    ],
                    [
                        28.609385597672176,
                        43.87449769729897
                    ],
                    [
                        28.593516461650918,
                        43.819525395967226
                    ],
                    [
                        28.587657085667036,
                        43.81024804604031
                    ],
                    [
                        28.584483272499874,
                        43.80084872099404
                    ],
                    [
                        28.589203305662874,
                        43.791327123991096
                    ],
                    [
                        28.58480877189943,
                        43.78241597437231
                    ],
                    [
                        28.58253013912437,
                        43.77236559772966
                    ],
                    [
                        28.581879122124707,
                        43.761704940849064
                    ],
                    [
                        28.5830184125515,
                        43.751043937229355
                    ],
                    [
                        28.578379774710907,
                        43.74127851144796
                    ],
                    [
                        28.434574014069273,
                        43.73521270137751
                    ],
                    [
                        28.221253678575753,
                        43.76198095145827
                    ],
                    [
                        28.014806376721832,
                        43.83003909385541
                    ],
                    [
                        27.98100997804228,
                        43.84934016434473
                    ],
                    [
                        27.935844764125207,
                        43.96439766742395
                    ],
                    [
                        27.91207360336039,
                        43.99323310562997
                    ],
                    [
                        27.912073599796816,
                        43.99333643684009
                    ],
                    [
                        27.85646974959601,
                        43.98863382535575
                    ],
                    [
                        27.787326707096106,
                        43.96041863747182
                    ],
                    [
                        27.72169761284355,
                        43.94873961409858
                    ],
                    [
                        27.682514989214106,
                        43.98725609317745
                    ],
                    [
                        27.67611900381145,
                        43.99354309933566
                    ],
                    [
                        27.65627526563993,
                        44.02387724444572
                    ],
                    [
                        27.633434306207743,
                        44.02976850287254
                    ],
                    [
                        27.57452315713051,
                        44.01628085473789
                    ],
                    [
                        27.383837127559282,
                        44.01509233077787
                    ],
                    [
                        27.37288170984078,
                        44.02072497008329
                    ],
                    [
                        27.353554731381436,
                        44.04527132307224
                    ],
                    [
                        27.341669128279786,
                        44.053074313840796
                    ],
                    [
                        27.285341846099417,
                        44.07245315556852
                    ],
                    [
                        27.264309506959364,
                        44.08976456609157
                    ],
                    [
                        27.269012078193892,
                        44.11239894451935
                    ],
                    [
                        27.252662452647993,
                        44.121518834295266
                    ]
                ]
            ]
        },
        "type": "Feature",
        "properties": {
            "source": "https://simplemaps.com",
            "id": "ROCT",
            "name": "Constanta"
        },
        "id": 10
    },
    {
        "geometry": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        24.149605845110464,
                        43.75472004219352
                    ],
                    [
                        24.14982345439624,
                        43.75505575831447
                    ],
                    [
                        24.204290414294462,
                        43.83908163998034
                    ],
                    [
                        24.211266734378235,
                        43.846109648890994
                    ],
                    [
                        24.229250120329258,
                        43.85670322198138
                    ],
                    [
                        24.233590941002713,
                        43.86223260651179
                    ],
                    [
                        24.236846555979774,
                        43.87406650866185
                    ],
                    [
                        24.24010218696096,
                        43.878562471403164
                    ],
                    [
                        24.253951467411742,
                        43.885926334847305
                    ],
                    [
                        24.25953249545629,
                        43.89256656676854
                    ],
                    [
                        24.27193483817347,
                        43.91985171706852
                    ],
                    [
                        24.27348516125744,
                        43.92703495555469
                    ],
                    [
                        24.271004689285103,
                        43.93525148494129
                    ],
                    [
                        24.25674197090186,
                        43.95238205502409
                    ],
                    [
                        24.254416556491442,
                        43.96026289067383
                    ],
                    [
                        24.25999761246198,
                        43.969047891429
                    ],
                    [
                        24.269144325823582,
                        43.97411208179657
                    ],
                    [
                        24.28836793484395,
                        43.981940892992064
                    ],
                    [
                        24.292088669847978,
                        43.98863321573872
                    ],
                    [
                        24.293483914070993,
                        43.99726304142544
                    ],
                    [
                        24.29162355606976,
                        44.007624123464616
                    ],
                    [
                        24.286662630845314,
                        44.01684844545066
                    ],
                    [
                        24.273330097420608,
                        44.024858200667275
                    ],
                    [
                        24.26046268609199,
                        44.02728712875118
                    ],
                    [
                        24.22878504700758,
                        44.028294918505495
                    ],
                    [
                        24.220568476438373,
                        44.02987092845528
                    ],
                    [
                        24.21266196275846,
                        44.03359149354515
                    ],
                    [
                        24.20692589791325,
                        44.039431063241445
                    ],
                    [
                        24.20491051878599,
                        44.04583895257496
                    ],
                    [
                        24.20723593553909,
                        44.056380781560186
                    ],
                    [
                        24.210956678340928,
                        44.06426171705242
                    ],
                    [
                        24.2151424604124,
                        44.079351171654714
                    ],
                    [
                        24.215452488366367,
                        44.09164995573226
                    ],
                    [
                        24.216382696384294,
                        44.09684366235266
                    ],
                    [
                        24.22072350785504,
                        44.101106909379965
                    ],
                    [
                        24.22645960069872,
                        44.10387165556705
                    ],
                    [
                        24.23591639364078,
                        44.10469852186288
                    ],
                    [
                        24.246510031700513,
                        44.103406391542215
                    ],
                    [
                        24.258447302076032,
                        44.10079683696835
                    ],
                    [
                        24.27007448191105,
                        44.09973734839211
                    ],
                    [
                        24.27674073528003,
                        44.1021660965043
                    ],
                    [
                        24.276275662550162,
                        44.10828986002627
                    ],
                    [
                        24.255346699018503,
                        44.13521321760373
                    ],
                    [
                        24.24847372933185,
                        44.15965614506852
                    ],
                    [
                        24.246510042052364,
                        44.174590750374264
                    ],
                    [
                        24.248060340913614,
                        44.18743238653466
                    ],
                    [
                        24.252556165698476,
                        44.19554540744362
                    ],
                    [
                        24.257052034613157,
                        44.202108457363
                    ],
                    [
                        24.256741967982915,
                        44.2101699178051
                    ],
                    [
                        24.250850861587626,
                        44.219523407043994
                    ],
                    [
                        24.232350716488938,
                        44.23363119442626
                    ],
                    [
                        24.22056845609969,
                        44.239625425055955
                    ],
                    [
                        24.195557073772818,
                        44.24696354912798
                    ],
                    [
                        24.15943526337705,
                        44.26404272420654
                    ],
                    [
                        24.14904829543611,
                        44.27238843259389
                    ],
                    [
                        24.138196255464184,
                        44.28365397045553
                    ],
                    [
                        24.129462926465546,
                        44.29848502445403
                    ],
                    [
                        24.121401401496385,
                        44.309698801669896
                    ],
                    [
                        24.11147952740131,
                        44.317708653463214
                    ],
                    [
                        24.08915531262036,
                        44.33067946240138
                    ],
                    [
                        24.076908010055394,
                        44.34039471741234
                    ],
                    [
                        24.06538416205113,
                        44.35290038891044
                    ],
                    [
                        24.05220666797993,
                        44.37284746159527
                    ],
                    [
                        24.038254012836695,
                        44.383647709500394
                    ],
                    [
                        24.025541614747198,
                        44.38829861502653
                    ],
                    [
                        24.01401775801,
                        44.3898488268001
                    ],
                    [
                        24.003940855446015,
                        44.39274271338741
                    ],
                    [
                        23.995724324753766,
                        44.39904739849905
                    ],
                    [
                        23.969317671429337,
                        44.42651344405151
                    ],
                    [
                        23.958620630180867,
                        44.43429060518841
                    ],
                    [
                        23.918778119160507,
                        44.45103390850814
                    ],
                    [
                        23.91009646352372,
                        44.457906760165336
                    ],
                    [
                        23.90570398883685,
                        44.46545168032551
                    ],
                    [
                        23.904928843546845,
                        44.47284141164015
                    ],
                    [
                        23.906789170532832,
                        44.4802309707506
                    ],
                    [
                        23.92032840828235,
                        44.49780104773143
                    ],
                    [
                        23.958155540893358,
                        44.529659452605515
                    ],
                    [
                        23.996344423364306,
                        44.5466868381875
                    ],
                    [
                        24.006731392272112,
                        44.549167342686125
                    ],
                    [
                        24.019908903262376,
                        44.550924490277474
                    ],
                    [
                        24.030967645501967,
                        44.549477444959955
                    ],
                    [
                        24.041664669676763,
                        44.54596347500194
                    ],
                    [
                        24.050656381450512,
                        44.5409509390478
                    ],
                    [
                        24.058872921364635,
                        44.53384534813335
                    ],
                    [
                        24.06817467592348,
                        44.52208893517675
                    ],
                    [
                        24.075616092723376,
                        44.51723142557123
                    ],
                    [
                        24.083522556814238,
                        44.517024503534316
                    ],
                    [
                        24.095666522843292,
                        44.520616050137896
                    ],
                    [
                        24.127137481882126,
                        44.55350818550235
                    ],
                    [
                        24.1373694078851,
                        44.561388785844144
                    ],
                    [
                        24.149668423447462,
                        44.56640157269755
                    ],
                    [
                        24.1605204529777,
                        44.567770843702085
                    ],
                    [
                        24.173232869034297,
                        44.567202501055334
                    ],
                    [
                        24.196693982699937,
                        44.562629233484806
                    ],
                    [
                        24.20692589759997,
                        44.562448232892834
                    ],
                    [
                        24.21669276387853,
                        44.564412078344525
                    ],
                    [
                        24.245993267474358,
                        44.57640077542033
                    ],
                    [
                        24.254261489829833,
                        44.58373878771352
                    ],
                    [
                        24.260307672440305,
                        44.60471970004435
                    ],
                    [
                        24.26557864868515,
                        44.61306529575792
                    ],
                    [
                        24.27798098381073,
                        44.6198865333396
                    ],
                    [
                        24.287437774163706,
                        44.619964072343855
                    ],
                    [
                        24.29332889827732,
                        44.6178970829242
                    ],
                    [
                        24.295189232771218,
                        44.613840368186956
                    ],
                    [
                        24.293483924263377,
                        44.60389275085527
                    ],
                    [
                        24.293638948039554,
                        44.59727813360619
                    ],
                    [
                        24.296274446740448,
                        44.59079274449272
                    ],
                    [
                        24.301390432196413,
                        44.58394574355345
                    ],
                    [
                        24.30903853936429,
                        44.57725361415729
                    ],
                    [
                        24.317875189731023,
                        44.57361028977417
                    ],
                    [
                        24.324851536565333,
                        44.578519750261705
                    ],
                    [
                        24.33322308883378,
                        44.583170422806006
                    ],
                    [
                        24.330897642213703,
                        44.60154134268865
                    ],
                    [
                        24.322991159494944,
                        44.62440824204478
                    ],
                    [
                        24.311984093779916,
                        44.6430893671493
                    ],
                    [
                        24.299840134961993,
                        44.65551757093278
                    ],
                    [
                        24.30449098608608,
                        44.672622277132135
                    ],
                    [
                        24.290538370989246,
                        44.71587560379326
                    ],
                    [
                        24.28619754183719,
                        44.737424610850404
                    ],
                    [
                        24.286352588571575,
                        44.74589967020562
                    ],
                    [
                        24.305007743584124,
                        44.75990372707933
                    ],
                    [
                        24.32082073577135,
                        44.77768044162161
                    ],
                    [
                        24.329967481554746,
                        44.790289617483914
                    ],
                    [
                        24.335703584698106,
                        44.80119347787036
                    ],
                    [
                        24.342524875411932,
                        44.823466029371254
                    ],
                    [
                        24.344695281727706,
                        44.836953550749215
                    ],
                    [
                        24.348260943074283,
                        44.84894239906475
                    ],
                    [
                        24.353376920159057,
                        44.860259607920106
                    ],
                    [
                        24.381333835800138,
                        44.89570940200375
                    ],
                    [
                        24.388775260778747,
                        44.90320261463333
                    ],
                    [
                        24.39699183727853,
                        44.909507298912935
                    ],
                    [
                        24.407533823340586,
                        44.91348634597319
                    ],
                    [
                        24.416422174744,
                        44.91410650046043
                    ],
                    [
                        24.426964128717696,
                        44.91209084916292
                    ],
                    [
                        24.434560582856,
                        44.90382275310347
                    ],
                    [
                        24.43983159184856,
                        44.89656230572315
                    ],
                    [
                        24.43781620665845,
                        44.8500276471937
                    ],
                    [
                        24.449443393082387,
                        44.82625640844094
                    ],
                    [
                        24.456109649514023,
                        44.82201892493838
                    ],
                    [
                        24.465101359273735,
                        44.81984858351323
                    ],
                    [
                        24.473679657477042,
                        44.82269085965175
                    ],
                    [
                        24.514297304535088,
                        44.84708193691882
                    ],
                    [
                        24.52111859642912,
                        44.85297307372391
                    ],
                    [
                        24.525149361188586,
                        44.85909674695865
                    ],
                    [
                        24.53481287757748,
                        44.87731284730439
                    ],
                    [
                        24.545974953612046,
                        44.88834554629441
                    ],
                    [
                        24.55434654002854,
                        44.89219547014978
                    ],
                    [
                        24.563648320048642,
                        44.89142047257073
                    ],
                    [
                        24.568919303127927,
                        44.88594268478595
                    ],
                    [
                        24.57108973700186,
                        44.87788132152822
                    ],
                    [
                        24.57031456873542,
                        44.86909617892561
                    ],
                    [
                        24.56829919891942,
                        44.85956195202775
                    ],
                    [
                        24.569694433823017,
                        44.8479603940788
                    ],
                    [
                        24.57682578574378,
                        44.83467958614325
                    ],
                    [
                        24.621680943193695,
                        44.768482174053446
                    ],
                    [
                        24.633153105503833,
                        44.75713915530726
                    ],
                    [
                        24.653203548514103,
                        44.743574003826986
                    ],
                    [
                        24.66870651122062,
                        44.73980184792615
                    ],
                    [
                        24.68482956229162,
                        44.74000857813299
                    ],
                    [
                        24.700229107065073,
                        44.74264386318089
                    ],
                    [
                        24.717747408976667,
                        44.74155860002023
                    ],
                    [
                        24.72596397996171,
                        44.737424610850404
                    ],
                    [
                        24.730614844471326,
                        44.732153515534506
                    ],
                    [
                        24.729529653994902,
                        44.7283295564313
                    ],
                    [
                        24.72472373475713,
                        44.72574566400625
                    ],
                    [
                        24.707205434348708,
                        44.72013883926011
                    ],
                    [
                        24.698678818475837,
                        44.71605636748266
                    ],
                    [
                        24.692736022139965,
                        44.710940358865514
                    ],
                    [
                        24.68979049371767,
                        44.705178629100594
                    ],
                    [
                        24.692425991793296,
                        44.6958510299882
                    ],
                    [
                        24.716817256302992,
                        44.66636954932908
                    ],
                    [
                        24.724878786018294,
                        44.65107336588095
                    ],
                    [
                        24.729994739560855,
                        44.62869737897528
                    ],
                    [
                        24.73139002247543,
                        44.616760258487524
                    ],
                    [
                        24.73449059656522,
                        44.607148357878856
                    ],
                    [
                        24.741466933659026,
                        44.59097375767032
                    ],
                    [
                        24.75097536315803,
                        44.54586000670162
                    ],
                    [
                        24.750458612048927,
                        44.53919383434848
                    ],
                    [
                        24.745187604067254,
                        44.52617128992234
                    ],
                    [
                        24.743327249362757,
                        44.51764465956864
                    ],
                    [
                        24.74379234496282,
                        44.509014747821304
                    ],
                    [
                        24.75562623947465,
                        44.47568339317659
                    ],
                    [
                        24.760277153342624,
                        44.43144860453262
                    ],
                    [
                        24.765393109460014,
                        44.41646236418597
                    ],
                    [
                        24.772059357702094,
                        44.40788400507729
                    ],
                    [
                        24.781516142383893,
                        44.40312975175957
                    ],
                    [
                        24.83009200657837,
                        44.40070108232497
                    ],
                    [
                        24.851330988069897,
                        44.389926322286406
                    ],
                    [
                        24.838773634635654,
                        44.366878767607844
                    ],
                    [
                        24.837533417513956,
                        44.356801986722594
                    ],
                    [
                        24.837068308353164,
                        44.340782148697286
                    ],
                    [
                        24.84481978063342,
                        44.2967280376354
                    ],
                    [
                        24.84838544550196,
                        44.24934068979178
                    ],
                    [
                        24.84559492039446,
                        44.227223190406
                    ],
                    [
                        24.83412275850515,
                        44.193323490224316
                    ],
                    [
                        24.832727503781747,
                        44.166322616958475
                    ],
                    [
                        24.83443280353668,
                        44.149811842143386
                    ],
                    [
                        24.839238726260078,
                        44.13446404438066
                    ],
                    [
                        24.8412540957749,
                        44.115757099697156
                    ],
                    [
                        24.835207950400843,
                        44.10655867206033
                    ],
                    [
                        24.82234051969347,
                        44.10066756397513
                    ],
                    [
                        24.78849247408403,
                        44.09591345519651
                    ],
                    [
                        24.775469999823258,
                        44.09281277947752
                    ],
                    [
                        24.763842787693022,
                        44.08671485030899
                    ],
                    [
                        24.734025508413392,
                        44.06348645160107
                    ],
                    [
                        24.72363856401479,
                        44.059223279150984
                    ],
                    [
                        24.70968591862249,
                        44.0564585201401
                    ],
                    [
                        24.692270935876707,
                        44.05545066342284
                    ],
                    [
                        24.675837845710557,
                        44.051678386159494
                    ],
                    [
                        24.657699409683246,
                        44.0447536895269
                    ],
                    [
                        24.636873801162242,
                        44.02475486179129
                    ],
                    [
                        24.630672629377482,
                        44.009820372437794
                    ],
                    [
                        24.631602833719406,
                        43.99098451498063
                    ],
                    [
                        24.66266034001563,
                        43.933649310265814
                    ],
                    [
                        24.697852007095374,
                        43.88171461001376
                    ],
                    [
                        24.74100181141486,
                        43.83024476343102
                    ],
                    [
                        24.746892939672676,
                        43.81466442848675
                    ],
                    [
                        24.74518761495413,
                        43.80714548443794
                    ],
                    [
                        24.735730820794533,
                        43.8018227679566
                    ],
                    [
                        24.708135628473823,
                        43.79200440203295
                    ],
                    [
                        24.694751430263565,
                        43.78471800628974
                    ],
                    [
                        24.68343425891388,
                        43.77660458650843
                    ],
                    [
                        24.66297040891934,
                        43.75722603831931
                    ],
                    [
                        24.661936894919727,
                        43.755882559380815
                    ],
                    [
                        24.661763238764717,
                        43.755656818770895
                    ],
                    [
                        24.500137152996206,
                        43.79949809898708
                    ],
                    [
                        24.466340763577374,
                        43.802417799916554
                    ],
                    [
                        24.431200800275477,
                        43.79417547681583
                    ],
                    [
                        24.375493618151793,
                        43.76386733331396
                    ],
                    [
                        24.35823369923178,
                        43.760017502331074
                    ],
                    [
                        24.336705399493844,
                        43.75925101320331
                    ],
                    [
                        24.1593827521331,
                        43.75293758282828
                    ],
                    [
                        24.149605845110464,
                        43.75472004219352
                    ]
                ]
            ]
        },
        "type": "Feature",
        "properties": {
            "source": "https://simplemaps.com",
            "id": "ROOT",
            "name": "Olt"
        },
        "id": 11
    },
    {
        "geometry": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        21.484388389262676,
                        45.15270169203725
                    ],
                    [
                        21.48450809110017,
                        45.15274811735011
                    ],
                    [
                        21.503628371260632,
                        45.16016368656924
                    ],
                    [
                        21.521818475080988,
                        45.177423612581435
                    ],
                    [
                        21.527244501325516,
                        45.185200922066834
                    ],
                    [
                        21.532050410009166,
                        45.19512279699645
                    ],
                    [
                        21.53236046671584,
                        45.205251365460605
                    ],
                    [
                        21.52708947110902,
                        45.232588205226314
                    ],
                    [
                        21.527089470007226,
                        45.242768454822915
                    ],
                    [
                        21.52972496915744,
                        45.25082998398579
                    ],
                    [
                        21.549568718077165,
                        45.26839996618227
                    ],
                    [
                        21.553444452363273,
                        45.274239408184926
                    ],
                    [
                        21.554064568821232,
                        45.28007884356532
                    ],
                    [
                        21.550808954539225,
                        45.29015575305025
                    ],
                    [
                        21.550033805452895,
                        45.2955300883747
                    ],
                    [
                        21.550653923011108,
                        45.3019379660872
                    ],
                    [
                        21.550188835150287,
                        45.308862608370156
                    ],
                    [
                        21.547088249092507,
                        45.316407369298574
                    ],
                    [
                        21.54181725516181,
                        45.323332025560475
                    ],
                    [
                        21.533910759672832,
                        45.32973989208955
                    ],
                    [
                        21.514377066495076,
                        45.340746956543875
                    ],
                    [
                        21.480218946171277,
                        45.36619761173374
                    ],
                    [
                        21.474017773428514,
                        45.373819878184484
                    ],
                    [
                        21.47091719004791,
                        45.382501542265835
                    ],
                    [
                        21.47014204218852,
                        45.3907697529958
                    ],
                    [
                        21.472932571897516,
                        45.399089684736175
                    ],
                    [
                        21.483164505505197,
                        45.413145671150275
                    ],
                    [
                        21.48704023498286,
                        45.42213734615429
                    ],
                    [
                        21.48735029439623,
                        45.43087067065193
                    ],
                    [
                        21.485800001268515,
                        45.441309307975715
                    ],
                    [
                        21.48548994509055,
                        45.449525883309185
                    ],
                    [
                        21.494636669770582,
                        45.458595061473794
                    ],
                    [
                        21.512826775745424,
                        45.4696538332583
                    ],
                    [
                        21.554994746773126,
                        45.486164470722436
                    ],
                    [
                        21.568844028114135,
                        45.496499740718505
                    ],
                    [
                        21.575975377012078,
                        45.506473301288565
                    ],
                    [
                        21.57597537780087,
                        45.51608512376789
                    ],
                    [
                        21.577835727734136,
                        45.527531438106514
                    ],
                    [
                        21.582331579220316,
                        45.538409342366116
                    ],
                    [
                        21.591788365544552,
                        45.54871878712682
                    ],
                    [
                        21.609358351290165,
                        45.55721955490073
                    ],
                    [
                        21.637883743120472,
                        45.56404085021171
                    ],
                    [
                        21.66909630833029,
                        45.56404085021171
                    ],
                    [
                        21.684754263814547,
                        45.56109526420342
                    ],
                    [
                        21.704132926827935,
                        45.55298207534905
                    ],
                    [
                        21.7269739130161,
                        45.5484087330991
                    ],
                    [
                        21.73844607835841,
                        45.544765522007616
                    ],
                    [
                        21.748212923496695,
                        45.53990793720674
                    ],
                    [
                        21.761235383410998,
                        45.52830656844758
                    ],
                    [
                        21.768676790860283,
                        45.5238365677533
                    ],
                    [
                        21.786401808542152,
                        45.523681551064186
                    ],
                    [
                        21.81074140961981,
                        45.52812573260561
                    ],
                    [
                        21.85683678690393,
                        45.54285350835438
                    ],
                    [
                        21.892545197545086,
                        45.558769826119594
                    ],
                    [
                        21.90231204364621,
                        45.5600875751298
                    ],
                    [
                        21.917039829552614,
                        45.55685781695519
                    ],
                    [
                        21.926651645797353,
                        45.551483466095014
                    ],
                    [
                        21.93378299081633,
                        45.543525282376784
                    ],
                    [
                        21.943239780756272,
                        45.527195546242716
                    ],
                    [
                        21.948665804919557,
                        45.51962494058457
                    ],
                    [
                        21.95584883181069,
                        45.51251944781447
                    ],
                    [
                        21.964375443309745,
                        45.507610192415065
                    ],
                    [
                        21.97538251897017,
                        45.50399281313395
                    ],
                    [
                        21.988249950926882,
                        45.502339163510236
                    ],
                    [
                        22.008093704166168,
                        45.504535438828796
                    ],
                    [
                        22.02767906998819,
                        45.50967722737774
                    ],
                    [
                        22.0531038761546,
                        45.52228628901984
                    ],
                    [
                        22.059666781216574,
                        45.52843576974378
                    ],
                    [
                        22.058529902919513,
                        45.53225985005867
                    ],
                    [
                        22.04488732522709,
                        45.53287996972004
                    ],
                    [
                        22.03961632733442,
                        45.53386180564995
                    ],
                    [
                        22.035895623958268,
                        45.53641979300136
                    ],
                    [
                        22.033570186521537,
                        45.541251552329655
                    ],
                    [
                        22.03186486063952,
                        45.55303375163796
                    ],
                    [
                        22.02938439168114,
                        45.559286597380414
                    ],
                    [
                        22.030469596743284,
                        45.564764302194746
                    ],
                    [
                        22.036825798974952,
                        45.56838165976204
                    ],
                    [
                        22.071759066600013,
                        45.56822662451083
                    ],
                    [
                        22.094858431731545,
                        45.570913796610405
                    ],
                    [
                        22.11578738607689,
                        45.57592640442132
                    ],
                    [
                        22.140798781727472,
                        45.58750194688311
                    ],
                    [
                        22.166223583898308,
                        45.60367664627578
                    ],
                    [
                        22.176662226725032,
                        45.606673910308295
                    ],
                    [
                        22.190149772758712,
                        45.6048652122685
                    ],
                    [
                        22.197746209936152,
                        45.60062776186844
                    ],
                    [
                        22.20999352345093,
                        45.590654200953345
                    ],
                    [
                        22.216969839899566,
                        45.58812204401271
                    ],
                    [
                        22.2254964564343,
                        45.586959353182934
                    ],
                    [
                        22.239190708999182,
                        45.587915357605475
                    ],
                    [
                        22.248647492766516,
                        45.58724354150727
                    ],
                    [
                        22.256864048981136,
                        45.58574494689771
                    ],
                    [
                        22.263995394633707,
                        45.58600331297424
                    ],
                    [
                        22.27019656914424,
                        45.589258955204045
                    ],
                    [
                        22.29815351704157,
                        45.62977326174756
                    ],
                    [
                        22.335050493745452,
                        45.64814426112364
                    ],
                    [
                        22.44537967352561,
                        45.66289785870288
                    ],
                    [
                        22.4536479009976,
                        45.64005686217893
                    ],
                    [
                        22.48341352791986,
                        45.61153148989118
                    ],
                    [
                        22.49674604677366,
                        45.604916895790666
                    ],
                    [
                        22.51100874045389,
                        45.60140289180805
                    ],
                    [
                        22.522842647140312,
                        45.60036938558294
                    ],
                    [
                        22.537415397549754,
                        45.597320451930976
                    ],
                    [
                        22.542376337280185,
                        45.59243704599627
                    ],
                    [
                        22.542996452475943,
                        45.585538223563276
                    ],
                    [
                        22.541136102375432,
                        45.57804515435164
                    ],
                    [
                        22.54237633524597,
                        45.570035296633996
                    ],
                    [
                        22.547957391431982,
                        45.56734813089586
                    ],
                    [
                        22.55648400205031,
                        45.5672964526155
                    ],
                    [
                        22.565785758946163,
                        45.568614193634275
                    ],
                    [
                        22.57606936897652,
                        45.567089739566036
                    ],
                    [
                        22.582580602233428,
                        45.56233552420189
                    ],
                    [
                        22.588626744880692,
                        45.554454871523724
                    ],
                    [
                        22.601029084941906,
                        45.546780896319035
                    ],
                    [
                        22.620252718860307,
                        45.53843516037317
                    ],
                    [
                        22.653325635651225,
                        45.52021922248424
                    ],
                    [
                        22.66867353731534,
                        45.50652497112915
                    ],
                    [
                        22.678440382965373,
                        45.49254649348719
                    ],
                    [
                        22.690274285275603,
                        45.46322011573853
                    ],
                    [
                        22.693529899062717,
                        45.45143787881736
                    ],
                    [
                        22.694615107829957,
                        45.440482505708545
                    ],
                    [
                        22.694150017389603,
                        45.429656274581795
                    ],
                    [
                        22.698025751056683,
                        45.41301647132081
                    ],
                    [
                        22.696320430527177,
                        45.40368888807997
                    ],
                    [
                        22.691204459306004,
                        45.393611953911574
                    ],
                    [
                        22.67875044133423,
                        45.38043447955529
                    ],
                    [
                        22.675339794372324,
                        45.37394906462942
                    ],
                    [
                        22.67740685386777,
                        45.36508657127673
                    ],
                    [
                        22.684693229986646,
                        45.355526428255956
                    ],
                    [
                        22.698180778135743,
                        45.342090548953
                    ],
                    [
                        22.70407189355788,
                        45.33160024828567
                    ],
                    [
                        22.706862418961244,
                        45.32232432308917
                    ],
                    [
                        22.706397331275017,
                        45.314288640037255
                    ],
                    [
                        22.704226922713833,
                        45.306795563505624
                    ],
                    [
                        22.698645868065714,
                        45.29863068315038
                    ],
                    [
                        22.67709679540644,
                        45.27547964292571
                    ],
                    [
                        22.67223921108174,
                        45.2669013582593
                    ],
                    [
                        22.669913769651398,
                        45.259614970160676
                    ],
                    [
                        22.669138625564017,
                        45.24046886080924
                    ],
                    [
                        22.601029086572833,
                        45.197706608992526
                    ],
                    [
                        22.572658726062212,
                        45.170757354137486
                    ],
                    [
                        22.564545526172807,
                        45.156933907481914
                    ],
                    [
                        22.562530144997222,
                        45.146856999582155
                    ],
                    [
                        22.566095818749112,
                        45.1388471551786
                    ],
                    [
                        22.574519077071525,
                        45.13429963111321
                    ],
                    [
                        22.58723147983952,
                        45.13106984703576
                    ],
                    [
                        22.62511030456421,
                        45.12964875052232
                    ],
                    [
                        22.634567092033908,
                        45.127530015328375
                    ],
                    [
                        22.641388380887573,
                        45.12169058160089
                    ],
                    [
                        22.646504347013803,
                        45.1135773810171
                    ],
                    [
                        22.641078322379133,
                        45.09239004323689
                    ],
                    [
                        22.59885867663952,
                        45.0602473011629
                    ],
                    [
                        22.566612582620387,
                        45.0239187695526
                    ],
                    [
                        22.558654412554322,
                        45.009190985851184
                    ],
                    [
                        22.554933709767262,
                        44.99740876768053
                    ],
                    [
                        22.55369348105656,
                        44.98686681039254
                    ],
                    [
                        22.550282827910454,
                        44.9734567071587
                    ],
                    [
                        22.544701790929718,
                        44.957721367179005
                    ],
                    [
                        22.533694685888534,
                        44.934234246116304
                    ],
                    [
                        22.49178512309043,
                        44.884599214753386
                    ],
                    [
                        22.466980409304394,
                        44.83933046080912
                    ],
                    [
                        22.451580844400386,
                        44.79152985062926
                    ],
                    [
                        22.441814003217438,
                        44.769412374415495
                    ],
                    [
                        22.431737079337125,
                        44.75825011205553
                    ],
                    [
                        22.421195111388887,
                        44.75210080034187
                    ],
                    [
                        22.406467314009937,
                        44.750343696894504
                    ],
                    [
                        22.395563589099613,
                        44.75101551169711
                    ],
                    [
                        22.38781214664433,
                        44.753651174142206
                    ],
                    [
                        22.38347130960382,
                        44.75814689494418
                    ],
                    [
                        22.376805051468327,
                        44.7688180964573
                    ],
                    [
                        22.369983746837317,
                        44.77308128152822
                    ],
                    [
                        22.36285242650031,
                        44.77628541857708
                    ],
                    [
                        22.354170769135337,
                        44.77770639984587
                    ],
                    [
                        22.321407909632217,
                        44.777112109625975
                    ],
                    [
                        22.311175991527904,
                        44.77786153844464
                    ],
                    [
                        22.30373456080694,
                        44.78018679225722
                    ],
                    [
                        22.297068314286758,
                        44.783881756356976
                    ],
                    [
                        22.262600150930588,
                        44.80832483552657
                    ],
                    [
                        22.253453404301485,
                        44.81204540830701
                    ],
                    [
                        22.24306645933422,
                        44.81349247672329
                    ],
                    [
                        22.228028608327815,
                        44.81121864530715
                    ],
                    [
                        22.221930777258137,
                        44.806154262836905
                    ],
                    [
                        22.218985232713987,
                        44.79897132997433
                    ],
                    [
                        22.218985211235022,
                        44.790857968124705
                    ],
                    [
                        22.214179315021756,
                        44.77757721952292
                    ],
                    [
                        22.205652685070135,
                        44.76129899867099
                    ],
                    [
                        22.182863384567856,
                        44.73391053964772
                    ],
                    [
                        22.17211471487461,
                        44.71711591303329
                    ],
                    [
                        22.165293406296534,
                        44.7022071109308
                    ],
                    [
                        22.161727720882798,
                        44.6905023143355
                    ],
                    [
                        22.15986740429616,
                        44.67748011488264
                    ],
                    [
                        22.160797569416285,
                        44.66435422535785
                    ],
                    [
                        22.168238949606238,
                        44.6474299905865
                    ],
                    [
                        22.172734829992347,
                        44.63386516227096
                    ],
                    [
                        22.173975042618878,
                        44.62146265387884
                    ],
                    [
                        22.16901411603533,
                        44.60895703970631
                    ],
                    [
                        22.16110760166552,
                        44.60182553786486
                    ],
                    [
                        22.149945495934617,
                        44.59769144864251
                    ],
                    [
                        22.138938429561502,
                        44.59655468067543
                    ],
                    [
                        22.127001190668317,
                        44.597019888235224
                    ],
                    [
                        22.102299855608297,
                        44.60203250289787
                    ],
                    [
                        22.08881229640843,
                        44.60324682198234
                    ],
                    [
                        22.05892894077237,
                        44.59937035450821
                    ],
                    [
                        22.034242908390254,
                        44.596168229130406
                    ],
                    [
                        22.032174096559178,
                        44.603324968332096
                    ],
                    [
                        22.004268844422985,
                        44.65153924646324
                    ],
                    [
                        21.9943469651162,
                        44.65856720853648
                    ],
                    [
                        21.96241093296629,
                        44.66228792571774
                    ],
                    [
                        21.871977154494356,
                        44.69598079477619
                    ],
                    [
                        21.855440700680983,
                        44.698461294874676
                    ],
                    [
                        21.838284149472976,
                        44.69520587061365
                    ],
                    [
                        21.801697234776224,
                        44.6838887273941
                    ],
                    [
                        21.756842075606375,
                        44.677274027312826
                    ],
                    [
                        21.705165644639706,
                        44.67706732921858
                    ],
                    [
                        21.656279737207306,
                        44.687660971502794
                    ],
                    [
                        21.619692816230817,
                        44.713912551980876
                    ],
                    [
                        21.61028771632391,
                        44.73194770542512
                    ],
                    [
                        21.604293246355866,
                        44.749982749586216
                    ],
                    [
                        21.595611615740292,
                        44.76595085507267
                    ],
                    [
                        21.578041623530712,
                        44.77768135779421
                    ],
                    [
                        21.558404563252765,
                        44.781660315068194
                    ],
                    [
                        21.497219703309433,
                        44.77804324613161
                    ],
                    [
                        21.412160262580127,
                        44.78481260315596
                    ],
                    [
                        21.39593386199056,
                        44.79023861561191
                    ],
                    [
                        21.37857058595056,
                        44.816645320323396
                    ],
                    [
                        21.360587189403574,
                        44.8264121766721
                    ],
                    [
                        21.359799623404093,
                        44.8266571299738
                    ],
                    [
                        21.34281051258225,
                        44.83194168270399
                    ],
                    [
                        21.346427867681516,
                        44.84563596886969
                    ],
                    [
                        21.3555229260909,
                        44.85659142995688
                    ],
                    [
                        21.368545362154407,
                        44.86485946332413
                    ],
                    [
                        21.395313752825157,
                        44.871629065989495
                    ],
                    [
                        21.453398063492617,
                        44.86956200656344
                    ],
                    [
                        21.481510069741233,
                        44.872611129153924
                    ],
                    [
                        21.522127737417982,
                        44.88077594007863
                    ],
                    [
                        21.53628708491985,
                        44.88930260157323
                    ],
                    [
                        21.539077596950946,
                        44.90847443339057
                    ],
                    [
                        21.53101608903257,
                        44.9246492746218
                    ],
                    [
                        21.51633994918361,
                        44.933899101217456
                    ],
                    [
                        21.481510062533328,
                        44.9435628138245
                    ],
                    [
                        21.456498663379477,
                        44.952347766734675
                    ],
                    [
                        21.408439577400998,
                        44.95834220175784
                    ],
                    [
                        21.385185175783967,
                        44.969504252212204
                    ],
                    [
                        21.384565064758913,
                        44.97493033275253
                    ],
                    [
                        21.38704551356452,
                        44.98154475788485
                    ],
                    [
                        21.38394494600456,
                        44.98666086903534
                    ],
                    [
                        21.36699509640753,
                        44.987281137839204
                    ],
                    [
                        21.353455867223435,
                        44.98981325017367
                    ],
                    [
                        21.351388811807762,
                        44.99823652839735
                    ],
                    [
                        21.35614302598135,
                        45.00857167585371
                    ],
                    [
                        21.363377726050288,
                        45.01652984739244
                    ],
                    [
                        21.373299600930093,
                        45.020095519453264
                    ],
                    [
                        21.39882775812577,
                        45.02138743198151
                    ],
                    [
                        21.40926639800203,
                        45.02397125301495
                    ],
                    [
                        21.421875447042925,
                        45.03141265933441
                    ],
                    [
                        21.42507938592755,
                        45.036218566434364
                    ],
                    [
                        21.425596150197823,
                        45.04324656354159
                    ],
                    [
                        21.429523560036337,
                        45.05730255228249
                    ],
                    [
                        21.43252079187622,
                        45.061488342035744
                    ],
                    [
                        21.440995727292385,
                        45.068723045275426
                    ],
                    [
                        21.443786254822406,
                        45.072908832617195
                    ],
                    [
                        21.444406371766817,
                        45.07786977018482
                    ],
                    [
                        21.444406371717953,
                        45.08525949980482
                    ],
                    [
                        21.443786254392837,
                        45.09146066927515
                    ],
                    [
                        21.44244266729686,
                        45.0929076153092
                    ],
                    [
                        21.449987427456552,
                        45.10102081655017
                    ],
                    [
                        21.458565714467113,
                        45.107325333856984
                    ],
                    [
                        21.469004352961992,
                        45.11104604070454
                    ],
                    [
                        21.481510051063143,
                        45.11156280649002
                    ],
                    [
                        21.49411910003566,
                        45.11931427027561
                    ],
                    [
                        21.49783980298875,
                        45.13187164291236
                    ],
                    [
                        21.493292276524823,
                        45.14510080631394
                    ],
                    [
                        21.484388389262676,
                        45.15270169203725
                    ]
                ]
            ]
        },
        "type": "Feature",
        "properties": {
            "source": "https://simplemaps.com",
            "id": "ROCS",
            "name": "Caras-Severin"
        },
        "id": 12
    },
    {
        "geometry": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        27.43134228470904,
                        47.572637459177166
                    ],
                    [
                        27.431225231170092,
                        47.572600516471105
                    ],
                    [
                        27.417184410715763,
                        47.568148491470986
                    ],
                    [
                        27.376138130810382,
                        47.55513373798474
                    ],
                    [
                        27.33562380315773,
                        47.555495448075014
                    ],
                    [
                        27.319500756899885,
                        47.557846728056965
                    ],
                    [
                        27.30709842008309,
                        47.557510873782114
                    ],
                    [
                        27.295936313073753,
                        47.55260162546497
                    ],
                    [
                        27.278883087983587,
                        47.539475796841664
                    ],
                    [
                        27.26937463155813,
                        47.533558892573936
                    ],
                    [
                        27.26100303622202,
                        47.52707342380801
                    ],
                    [
                        27.255887071058964,
                        47.51958034640292
                    ],
                    [
                        27.2515462534877,
                        47.50244962732623
                    ],
                    [
                        27.243794796980602,
                        47.49531833054706
                    ],
                    [
                        27.232012575583767,
                        47.49110672686614
                    ],
                    [
                        27.20483076771362,
                        47.49079664506383
                    ],
                    [
                        27.190878133279337,
                        47.49322544804881
                    ],
                    [
                        27.173979938030214,
                        47.49999505130791
                    ],
                    [
                        27.156099890540347,
                        47.50477510619462
                    ],
                    [
                        27.128194613736657,
                        47.509193426246824
                    ],
                    [
                        27.11186485433199,
                        47.51771999491717
                    ],
                    [
                        27.10395837487892,
                        47.51947707874603
                    ],
                    [
                        27.092486210019615,
                        47.51834021342075
                    ],
                    [
                        27.081634140501837,
                        47.512500667534766
                    ],
                    [
                        27.074657824946144,
                        47.505937775311004
                    ],
                    [
                        27.071247184658194,
                        47.4983930471077
                    ],
                    [
                        27.07310753079112,
                        47.48986640154028
                    ],
                    [
                        27.09093589669584,
                        47.46278793414936
                    ],
                    [
                        27.092021107808574,
                        47.45426135518411
                    ],
                    [
                        27.087215205045375,
                        47.447336742038075
                    ],
                    [
                        27.076983276939064,
                        47.441549015079794
                    ],
                    [
                        27.0558475985526,
                        47.43632959915048
                    ],
                    [
                        27.04065473554889,
                        47.434469291034596
                    ],
                    [
                        27.021431098851526,
                        47.43870673571654
                    ],
                    [
                        27.00933881354592,
                        47.44470120176133
                    ],
                    [
                        26.998900169977425,
                        47.45245263807283
                    ],
                    [
                        26.98417238645468,
                        47.46563012845076
                    ],
                    [
                        26.975800828924303,
                        47.470565370322
                    ],
                    [
                        26.966964139381073,
                        47.47426012163481
                    ],
                    [
                        26.95688724079012,
                        47.47668894745592
                    ],
                    [
                        26.789300578818914,
                        47.47707657038641
                    ],
                    [
                        26.77390100489494,
                        47.47971208076955
                    ],
                    [
                        26.76289390593105,
                        47.48376856745381
                    ],
                    [
                        26.74367028449955,
                        47.492656986699416
                    ],
                    [
                        26.733903437188264,
                        47.49343211955897
                    ],
                    [
                        26.724911737448252,
                        47.490486563575395
                    ],
                    [
                        26.718193797087192,
                        47.4843887171465
                    ],
                    [
                        26.713129497003106,
                        47.473588289403544
                    ],
                    [
                        26.698660119805037,
                        47.453434621660996
                    ],
                    [
                        26.658455842534458,
                        47.42666615098772
                    ],
                    [
                        26.617218042135903,
                        47.430722706760136
                    ],
                    [
                        26.606469365328348,
                        47.43586463646196
                    ],
                    [
                        26.59220666719893,
                        47.44454626119158
                    ],
                    [
                        26.567557009272452,
                        47.46805903983622
                    ],
                    [
                        26.56228599729152,
                        47.47808417686626
                    ],
                    [
                        26.559960565202474,
                        47.489401357780906
                    ],
                    [
                        26.560580683195674,
                        47.500976879352514
                    ],
                    [
                        26.562751089452366,
                        47.51565296809576
                    ],
                    [
                        26.562130987723332,
                        47.52836545843287
                    ],
                    [
                        26.546318010101015,
                        47.580584555344764
                    ],
                    [
                        26.537119584594315,
                        47.60231437083217
                    ],
                    [
                        26.526732643582744,
                        47.61404505434813
                    ],
                    [
                        26.494641566902793,
                        47.636472553724445
                    ],
                    [
                        26.482187508699543,
                        47.65089005473573
                    ],
                    [
                        26.416093396673435,
                        47.70649415959159
                    ],
                    [
                        26.397024778839942,
                        47.72837904309792
                    ],
                    [
                        26.283284938289743,
                        47.82625413387277
                    ],
                    [
                        26.259668807558388,
                        47.842273814914485
                    ],
                    [
                        26.2086641796834,
                        47.86162670383323
                    ],
                    [
                        26.16830488636504,
                        47.885036129687045
                    ],
                    [
                        26.14158818915756,
                        47.89627586422103
                    ],
                    [
                        26.126705370232724,
                        47.90627521443057
                    ],
                    [
                        26.119418984150858,
                        47.91748894345707
                    ],
                    [
                        26.102530432051946,
                        47.97826699646761
                    ],
                    [
                        26.125722690464723,
                        47.97841620138744
                    ],
                    [
                        26.15631056803573,
                        47.98793310436352
                    ],
                    [
                        26.157105152493635,
                        47.98803977089553
                    ],
                    [
                        26.159420041903104,
                        47.98828547400865
                    ],
                    [
                        26.161402924498333,
                        47.988586360410345
                    ],
                    [
                        26.16296203284148,
                        47.98880585970169
                    ],
                    [
                        26.16361190064584,
                        47.98892732426787
                    ],
                    [
                        26.164679051687312,
                        47.98912709351166
                    ],
                    [
                        26.165338442951896,
                        47.98926705537782
                    ],
                    [
                        26.16991074539038,
                        47.990342667634444
                    ],
                    [
                        26.18462835309133,
                        47.99476970607984
                    ],
                    [
                        26.18664346851508,
                        47.99604634568879
                    ],
                    [
                        26.187730294859414,
                        47.99689908609037
                    ],
                    [
                        26.194120615602824,
                        48.00191137545332
                    ],
                    [
                        26.199175369374334,
                        48.00783880054596
                    ],
                    [
                        26.200875886095037,
                        48.011415476713736
                    ],
                    [
                        26.202621814632327,
                        48.0155900166183
                    ],
                    [
                        26.20426911141661,
                        48.01960089920931
                    ],
                    [
                        26.20581428087306,
                        48.0234071109204
                    ],
                    [
                        26.207957754878727,
                        48.028720165959584
                    ],
                    [
                        26.207929152268786,
                        48.029054701735085
                    ],
                    [
                        26.207988495629092,
                        48.03069007845593
                    ],
                    [
                        26.207961318446706,
                        48.03116490674701
                    ],
                    [
                        26.20803372131032,
                        48.0314908120667
                    ],
                    [
                        26.20851839734702,
                        48.03293102810786
                    ],
                    [
                        26.208606028587383,
                        48.03429231784251
                    ],
                    [
                        26.20863226342849,
                        48.034555943202555
                    ],
                    [
                        26.20900447713303,
                        48.03582658994627
                    ],
                    [
                        26.20974017271545,
                        48.039186230038325
                    ],
                    [
                        26.210016081315516,
                        48.04190455747374
                    ],
                    [
                        26.217086610372345,
                        48.04802427872055
                    ],
                    [
                        26.24323488266589,
                        48.06290708188808
                    ],
                    [
                        26.253705698416336,
                        48.07107359766269
                    ],
                    [
                        26.258797717441407,
                        48.073470279053716
                    ],
                    [
                        26.260960782143425,
                        48.07436857710505
                    ],
                    [
                        26.264836410953183,
                        48.07560331743941
                    ],
                    [
                        26.266056111550306,
                        48.07606094980467
                    ],
                    [
                        26.2666977690355,
                        48.076291924904154
                    ],
                    [
                        26.267271957406525,
                        48.07671162779102
                    ],
                    [
                        26.27001591722441,
                        48.07929492628373
                    ],
                    [
                        26.272637005436415,
                        48.081631849015174
                    ],
                    [
                        26.273482016591014,
                        48.08279445811533
                    ],
                    [
                        26.275431853690893,
                        48.08606798327179
                    ],
                    [
                        26.276466882620937,
                        48.08973073622753
                    ],
                    [
                        26.2777860044388,
                        48.09505394556645
                    ],
                    [
                        26.280141282146555,
                        48.09784403583521
                    ],
                    [
                        26.282451252063424,
                        48.100574014174995
                    ],
                    [
                        26.28292147196435,
                        48.10170925109642
                    ],
                    [
                        26.28449524380377,
                        48.10696883923665
                    ],
                    [
                        26.28464243120545,
                        48.11114413318754
                    ],
                    [
                        26.284849384084886,
                        48.11315007213652
                    ],
                    [
                        26.285914332763095,
                        48.115614028147164
                    ],
                    [
                        26.28724213745694,
                        48.118272002943705
                    ],
                    [
                        26.287567569986802,
                        48.118717365692696
                    ],
                    [
                        26.290220299123362,
                        48.122348763146135
                    ],
                    [
                        26.294019812965963,
                        48.12790297097228
                    ],
                    [
                        26.297016802750694,
                        48.13225252557246
                    ],
                    [
                        26.297858807090215,
                        48.133488129313214
                    ],
                    [
                        26.302226412052125,
                        48.13683131827354
                    ],
                    [
                        26.30825736930538,
                        48.14248728378152
                    ],
                    [
                        26.30962967275731,
                        48.14375377625626
                    ],
                    [
                        26.31646264184878,
                        48.14851258036067
                    ],
                    [
                        26.32381380695675,
                        48.15127172326347
                    ],
                    [
                        26.328035788274025,
                        48.15280445473054
                    ],
                    [
                        26.331284294404483,
                        48.15590973378542
                    ],
                    [
                        26.334321126136462,
                        48.15900239913556
                    ],
                    [
                        26.33506750109753,
                        48.16147600003713
                    ],
                    [
                        26.33441142053285,
                        48.165039762383046
                    ],
                    [
                        26.334075645631348,
                        48.16597782919437
                    ],
                    [
                        26.33357115975206,
                        48.16673451602425
                    ],
                    [
                        26.33021459290212,
                        48.1719989890286
                    ],
                    [
                        26.329712722757453,
                        48.172898826831705
                    ],
                    [
                        26.327841647021753,
                        48.17610581361819
                    ],
                    [
                        26.327972276759958,
                        48.17707106316657
                    ],
                    [
                        26.329149034863065,
                        48.1800127960235
                    ],
                    [
                        26.33299408332352,
                        48.18232091743923
                    ],
                    [
                        26.332934201729667,
                        48.183097699162516
                    ],
                    [
                        26.333043278298547,
                        48.183495345581534
                    ],
                    [
                        26.333199053067833,
                        48.183858132863385
                    ],
                    [
                        26.3332764740774,
                        48.1840018905352
                    ],
                    [
                        26.333365953885224,
                        48.18405371735294
                    ],
                    [
                        26.33348305951844,
                        48.18405680228287
                    ],
                    [
                        26.333625797092346,
                        48.183986465888864
                    ],
                    [
                        26.333790222681,
                        48.183831602485455
                    ],
                    [
                        26.33412371510901,
                        48.18365113428179
                    ],
                    [
                        26.334513639725458,
                        48.18348794176421
                    ],
                    [
                        26.33492269145659,
                        48.183383054372676
                    ],
                    [
                        26.335779989422615,
                        48.18336516182143
                    ],
                    [
                        26.33633296852993,
                        48.1832525621712
                    ],
                    [
                        26.337158986338423,
                        48.18307517924985
                    ],
                    [
                        26.337885290447357,
                        48.18296844105768
                    ],
                    [
                        26.338471342098156,
                        48.1829132210258
                    ],
                    [
                        26.34027053401691,
                        48.18275064590962
                    ],
                    [
                        26.341631836281394,
                        48.182801238535546
                    ],
                    [
                        26.342636286010688,
                        48.18279815361908
                    ],
                    [
                        26.3438018633434,
                        48.18266951263172
                    ],
                    [
                        26.344722344118324,
                        48.18256308308132
                    ],
                    [
                        26.345938047412798,
                        48.182722881667466
                    ],
                    [
                        26.347384205056372,
                        48.183106953921644
                    ],
                    [
                        26.34874378426419,
                        48.1838294430362
                    ],
                    [
                        26.34935717535646,
                        48.18453681778134
                    ],
                    [
                        26.349570251155537,
                        48.18503503522802
                    ],
                    [
                        26.349639512982495,
                        48.18565387494128
                    ],
                    [
                        26.349431087101973,
                        48.18627055651723
                    ],
                    [
                        26.348842206418734,
                        48.18716056702376
                    ],
                    [
                        26.34759207898117,
                        48.18902296533117
                    ],
                    [
                        26.347486464910908,
                        48.189382057594884
                    ],
                    [
                        26.34744442879237,
                        48.190042862570664
                    ],
                    [
                        26.348109479595447,
                        48.19072989157498
                    ],
                    [
                        26.34910214462514,
                        48.19126853333351
                    ],
                    [
                        26.350038472056887,
                        48.19146597386408
                    ],
                    [
                        26.351136658712115,
                        48.19158752325808
                    ],
                    [
                        26.351732019330985,
                        48.191480164907446
                    ],
                    [
                        26.352378707251553,
                        48.19105875291822
                    ],
                    [
                        26.352871207793434,
                        48.19055836554511
                    ],
                    [
                        26.353271452493487,
                        48.18978125519059
                    ],
                    [
                        26.354208333311444,
                        48.18783463227162
                    ],
                    [
                        26.354924769128452,
                        48.18643251662991
                    ],
                    [
                        26.35527053625921,
                        48.185909308670425
                    ],
                    [
                        26.355761171972258,
                        48.18542342948882
                    ],
                    [
                        26.356773841719136,
                        48.18509673404301
                    ],
                    [
                        26.357436092755755,
                        48.18503472673399
                    ],
                    [
                        26.35827911437382,
                        48.18512634947891
                    ],
                    [
                        26.359481930653196,
                        48.18541047272186
                    ],
                    [
                        26.361243842114593,
                        48.185998772228146
                    ],
                    [
                        26.363410954031906,
                        48.18725373292739
                    ],
                    [
                        26.364403676244905,
                        48.18784018521841
                    ],
                    [
                        26.36572947755373,
                        48.18866017154036
                    ],
                    [
                        26.368010118842975,
                        48.19006106403639
                    ],
                    [
                        26.369597089062587,
                        48.191008158840965
                    ],
                    [
                        26.370007744957995,
                        48.19141291170818
                    ],
                    [
                        26.370263483045107,
                        48.19177694297447
                    ],
                    [
                        26.370299320761465,
                        48.192160101804774
                    ],
                    [
                        26.370016777823604,
                        48.19258089840273
                    ],
                    [
                        26.369755780252024,
                        48.19307666175323
                    ],
                    [
                        26.369639918492453,
                        48.19377233609685
                    ],
                    [
                        26.369959229686412,
                        48.19447541622254
                    ],
                    [
                        26.370655235523213,
                        48.19555703384748
                    ],
                    [
                        26.37141812976672,
                        48.19638228676739
                    ],
                    [
                        26.37245921003443,
                        48.19704958646727
                    ],
                    [
                        26.373175348012012,
                        48.19746267753359
                    ],
                    [
                        26.373970149029006,
                        48.19770886651698
                    ],
                    [
                        26.37474455620411,
                        48.19778229134231
                    ],
                    [
                        26.3766474564611,
                        48.19761600573531
                    ],
                    [
                        26.379113697644822,
                        48.19728250928832
                    ],
                    [
                        26.381038604289888,
                        48.196945928159884
                    ],
                    [
                        26.382108043754705,
                        48.19672195230188
                    ],
                    [
                        26.383111443188973,
                        48.19623667187452
                    ],
                    [
                        26.383529415297197,
                        48.19587016691964
                    ],
                    [
                        26.383696720511075,
                        48.19553327893869
                    ],
                    [
                        26.38377361661107,
                        48.19508378707302
                    ],
                    [
                        26.383645321359655,
                        48.194533415010824
                    ],
                    [
                        26.383270360991904,
                        48.19401605389229
                    ],
                    [
                        26.38228472161564,
                        48.19348265154271
                    ],
                    [
                        26.3800890996708,
                        48.192498219843706
                    ],
                    [
                        26.37944786030812,
                        48.19194631022058
                    ],
                    [
                        26.379242081337086,
                        48.191334243995044
                    ],
                    [
                        26.379380113691383,
                        48.19081812263018
                    ],
                    [
                        26.379912809280974,
                        48.19011505144145
                    ],
                    [
                        26.381678951223144,
                        48.189130939762
                    ],
                    [
                        26.382980886747028,
                        48.18832020702558
                    ],
                    [
                        26.38347734160235,
                        48.18778650673706
                    ],
                    [
                        26.3839368350734,
                        48.18709855927018
                    ],
                    [
                        26.38447766216759,
                        48.186662962890104
                    ],
                    [
                        26.385273737641633,
                        48.1863467548827
                    ],
                    [
                        26.385752725649823,
                        48.18627919438761
                    ],
                    [
                        26.386425505114676,
                        48.186365573105604
                    ],
                    [
                        26.387636858016155,
                        48.18702637115597
                    ],
                    [
                        26.38881751001037,
                        48.18770444654927
                    ],
                    [
                        26.390700769677398,
                        48.18868053240426
                    ],
                    [
                        26.392570026548864,
                        48.18910286640608
                    ],
                    [
                        26.394198432048544,
                        48.18907294206268
                    ],
                    [
                        26.395631028199084,
                        48.18879344267569
                    ],
                    [
                        26.397227303596242,
                        48.18857132415109
                    ],
                    [
                        26.39853156446083,
                        48.18851301806679
                    ],
                    [
                        26.400484796722807,
                        48.188616056340166
                    ],
                    [
                        26.40211296504,
                        48.188919618413905
                    ],
                    [
                        26.404060628042192,
                        48.18950823359118
                    ],
                    [
                        26.40553668937254,
                        48.19010795595336
                    ],
                    [
                        26.407471856160477,
                        48.191458261340806
                    ],
                    [
                        26.407901646255528,
                        48.19172665727211
                    ],
                    [
                        26.409925162195236,
                        48.19299058952344
                    ],
                    [
                        26.412414759554967,
                        48.19435386560844
                    ],
                    [
                        26.415199396314808,
                        48.1959719738047
                    ],
                    [
                        26.416427770965054,
                        48.19694777920078
                    ],
                    [
                        26.416973132347724,
                        48.197693749643506
                    ],
                    [
                        26.4178483334643,
                        48.19942108896096
                    ],
                    [
                        26.41822644005631,
                        48.200138682876535
                    ],
                    [
                        26.41897326261803,
                        48.20064834223961
                    ],
                    [
                        26.419843092332876,
                        48.201089204487616
                    ],
                    [
                        26.420771609651034,
                        48.20129498156955
                    ],
                    [
                        26.421946008869398,
                        48.201362545591124
                    ],
                    [
                        26.422925189926243,
                        48.20128541771392
                    ],
                    [
                        26.424035806161974,
                        48.20088095946467
                    ],
                    [
                        26.42542678653249,
                        48.20000910860623
                    ],
                    [
                        26.427279062892733,
                        48.19890557010382
                    ],
                    [
                        26.42863792963235,
                        48.198202170640485
                    ],
                    [
                        26.43015160470515,
                        48.197402827110814
                    ],
                    [
                        26.430833694132833,
                        48.19664143209802
                    ],
                    [
                        26.43122634579104,
                        48.19602565381315
                    ],
                    [
                        26.431471045246766,
                        48.1952297098872
                    ],
                    [
                        26.431717779510688,
                        48.19452940445592
                    ],
                    [
                        26.432012194065432,
                        48.193679168082774
                    ],
                    [
                        26.432358266692283,
                        48.193203456375194
                    ],
                    [
                        26.432937914101483,
                        48.19301742924824
                    ],
                    [
                        26.433934302621218,
                        48.193026992828955
                    ],
                    [
                        26.435104482721734,
                        48.19323708318211
                    ],
                    [
                        26.43642746723023,
                        48.19358939363414
                    ],
                    [
                        26.437239913336096,
                        48.19358815962129
                    ],
                    [
                        26.437693877152338,
                        48.19360481879516
                    ],
                    [
                        26.43836648503967,
                        48.193805345963405
                    ],
                    [
                        26.438961900692902,
                        48.19416351868399
                    ],
                    [
                        26.439347894300035,
                        48.19470957097668
                    ],
                    [
                        26.439579937656088,
                        48.19545676963535
                    ],
                    [
                        26.439485734708413,
                        48.19608025934927
                    ],
                    [
                        26.439066510187512,
                        48.19690427974334
                    ],
                    [
                        26.437815700156833,
                        48.19776624894189
                    ],
                    [
                        26.43460414355826,
                        48.199468907932314
                    ],
                    [
                        26.43333869220612,
                        48.20011091695657
                    ],
                    [
                        26.432736204868558,
                        48.20069554439339
                    ],
                    [
                        26.432586986270376,
                        48.20119224726586
                    ],
                    [
                        26.432504408572118,
                        48.20183549418649
                    ],
                    [
                        26.433116317546705,
                        48.20284247930647
                    ],
                    [
                        26.434241318550757,
                        48.20385039349664
                    ],
                    [
                        26.435493370232283,
                        48.20431285668471
                    ],
                    [
                        26.436656533307385,
                        48.20457972203844
                    ],
                    [
                        26.437955948506342,
                        48.204673202099535
                    ],
                    [
                        26.440655190778838,
                        48.204559360048954
                    ],
                    [
                        26.444211774179962,
                        48.20435512320398
                    ],
                    [
                        26.446601615607904,
                        48.20428231372939
                    ],
                    [
                        26.44794591962843,
                        48.20435913389591
                    ],
                    [
                        26.44959876215898,
                        48.204587126398586
                    ],
                    [
                        26.45479928770546,
                        48.20560892993132
                    ],
                    [
                        26.45631892343149,
                        48.206210536971284
                    ],
                    [
                        26.45719360938214,
                        48.206727302998345
                    ],
                    [
                        26.457736769037574,
                        48.207272762117434
                    ],
                    [
                        26.458196417542926,
                        48.20813784759475
                    ],
                    [
                        26.458379757398053,
                        48.20871045910079
                    ],
                    [
                        26.45838598332608,
                        48.20932996679986
                    ],
                    [
                        26.458133392525767,
                        48.20974430959708
                    ],
                    [
                        26.45748220534477,
                        48.21048846212278
                    ],
                    [
                        26.456492570063542,
                        48.21120392401797
                    ],
                    [
                        26.45584328789187,
                        48.21170990073326
                    ],
                    [
                        26.45564570771587,
                        48.21225135851035
                    ],
                    [
                        26.455587206436114,
                        48.21281965888195
                    ],
                    [
                        26.455771283821697,
                        48.213163663182016
                    ],
                    [
                        26.45643463204515,
                        48.21377330768917
                    ],
                    [
                        26.4576354641646,
                        48.2145279605265
                    ],
                    [
                        26.45864173725789,
                        48.21490960705417
                    ],
                    [
                        26.46018415394391,
                        48.21511200024472
                    ],
                    [
                        26.461215348431512,
                        48.21507559414201
                    ],
                    [
                        26.462363070523526,
                        48.215131745929526
                    ],
                    [
                        26.463238174134233,
                        48.21520054731049
                    ],
                    [
                        26.463815376326263,
                        48.21548130647995
                    ],
                    [
                        26.46444521944766,
                        48.21590799923784
                    ],
                    [
                        26.46486443704587,
                        48.21653215037943
                    ],
                    [
                        26.465442257922124,
                        48.21814698963448
                    ],
                    [
                        26.466073083194384,
                        48.21979330816864
                    ],
                    [
                        26.466339770530517,
                        48.22016107776711
                    ],
                    [
                        26.46683296136969,
                        48.22054180618677
                    ],
                    [
                        26.467326538693733,
                        48.22080837808754
                    ],
                    [
                        26.467910214631214,
                        48.22092747163247
                    ],
                    [
                        26.46852008205447,
                        48.22095246277124
                    ],
                    [
                        26.46921652198968,
                        48.22085897741145
                    ],
                    [
                        26.469873440458635,
                        48.22075747024014
                    ],
                    [
                        26.470569249782805,
                        48.22065010099161
                    ],
                    [
                        26.471210593649797,
                        48.22042950050643
                    ],
                    [
                        26.472000539712393,
                        48.21982662955578
                    ],
                    [
                        26.47310740812291,
                        48.218975084208715
                    ],
                    [
                        26.474464842860993,
                        48.21794706253935
                    ],
                    [
                        26.475297498599176,
                        48.217232200901435
                    ],
                    [
                        26.476327081734606,
                        48.216538012408435
                    ],
                    [
                        26.47745753076216,
                        48.21605948611788
                    ],
                    [
                        26.479030325765596,
                        48.21557725830299
                    ],
                    [
                        26.48030608664707,
                        48.21541157945179
                    ],
                    [
                        26.481894171971057,
                        48.21536869425263
                    ],
                    [
                        26.483297900738542,
                        48.21542947399721
                    ],
                    [
                        26.48467548216452,
                        48.21558435441979
                    ],
                    [
                        26.4860442688409,
                        48.21591941474334
                    ],
                    [
                        26.48724684581116,
                        48.216216526572765
                    ],
                    [
                        26.488159116623265,
                        48.216554364384734
                    ],
                    [
                        26.488796383847625,
                        48.21692398100339
                    ],
                    [
                        26.489836033306503,
                        48.21737906054884
                    ],
                    [
                        26.490442673509698,
                        48.21765611949997
                    ],
                    [
                        26.491266703202523,
                        48.21790294284421
                    ],
                    [
                        26.492075703608766,
                        48.21804424930432
                    ],
                    [
                        26.492796466716868,
                        48.218094848141014
                    ],
                    [
                        26.493947015352596,
                        48.21801740724214
                    ],
                    [
                        26.49460778312797,
                        48.21797853253584
                    ],
                    [
                        26.49868936278905,
                        48.21727662902214
                    ],
                    [
                        26.50141590888978,
                        48.216802729422454
                    ],
                    [
                        26.5032433488274,
                        48.21633469262983
                    ],
                    [
                        26.50456327044394,
                        48.215932989939645
                    ],
                    [
                        26.505569399908644,
                        48.215532830445255
                    ],
                    [
                        26.507320079756692,
                        48.214545855016894
                    ],
                    [
                        26.50888667189065,
                        48.21354839314292
                    ],
                    [
                        26.50974708808507,
                        48.21283477655105
                    ],
                    [
                        26.510315048417837,
                        48.21206655314863
                    ],
                    [
                        26.51093964261914,
                        48.211301725545276
                    ],
                    [
                        26.512211183125817,
                        48.21083061250063
                    ],
                    [
                        26.51339871554532,
                        48.21045946111761
                    ],
                    [
                        26.514099512417513,
                        48.210442183924414
                    ],
                    [
                        26.51549884346029,
                        48.21087380554392
                    ],
                    [
                        26.51679891435586,
                        48.2114143361779
                    ],
                    [
                        26.51763913802208,
                        48.21187187517498
                    ],
                    [
                        26.51971672903446,
                        48.2129282592981
                    ],
                    [
                        26.52035554086322,
                        48.21327380634993
                    ],
                    [
                        26.52100887214407,
                        48.213406163321864
                    ],
                    [
                        26.522230074985874,
                        48.21333242598033
                    ],
                    [
                        26.522948842805913,
                        48.2131729189088
                    ],
                    [
                        26.523554604720562,
                        48.212892779043976
                    ],
                    [
                        26.523750071797686,
                        48.212475037946945
                    ],
                    [
                        26.523792418030673,
                        48.21191506837486
                    ],
                    [
                        26.523507077841998,
                        48.21124156371855
                    ],
                    [
                        26.522901855301164,
                        48.21005437291522
                    ],
                    [
                        26.52254812313682,
                        48.20935773361049
                    ],
                    [
                        26.52245134763838,
                        48.20877092891696
                    ],
                    [
                        26.522764878320555,
                        48.20832203339112
                    ],
                    [
                        26.52316977772369,
                        48.208163763177055
                    ],
                    [
                        26.52413006390307,
                        48.20812273017284
                    ],
                    [
                        26.52499664671452,
                        48.20837201347682
                    ],
                    [
                        26.52625908234946,
                        48.208872123331695
                    ],
                    [
                        26.527142980242143,
                        48.20926116682511
                    ],
                    [
                        26.529364982195883,
                        48.2102388684613
                    ],
                    [
                        26.533719092161864,
                        48.2123334257041
                    ],
                    [
                        26.536202930462853,
                        48.2134360901981
                    ],
                    [
                        26.53637069559297,
                        48.213513221336804
                    ],
                    [
                        26.538399156442622,
                        48.21444620123127
                    ],
                    [
                        26.53916461184968,
                        48.21459429355675
                    ],
                    [
                        26.540382014085306,
                        48.21466278628311
                    ],
                    [
                        26.544583049348553,
                        48.21481396398022
                    ],
                    [
                        26.545698887523113,
                        48.21501049510544
                    ],
                    [
                        26.547110429654097,
                        48.21546156077114
                    ],
                    [
                        26.54807225824119,
                        48.21608756210643
                    ],
                    [
                        26.548969945221938,
                        48.21699555956882
                    ],
                    [
                        26.54957753483592,
                        48.2178301299356
                    ],
                    [
                        26.549761958346863,
                        48.21840276076626
                    ],
                    [
                        26.549714235188073,
                        48.21878132714194
                    ],
                    [
                        26.549132601373724,
                        48.219548951447656
                    ],
                    [
                        26.54801309281417,
                        48.22096264434694
                    ],
                    [
                        26.547503233649447,
                        48.22183918680675
                    ],
                    [
                        26.547379933978004,
                        48.22225169645153
                    ],
                    [
                        26.54761958357694,
                        48.22295114385351
                    ],
                    [
                        26.547992643140116,
                        48.22361048334925
                    ],
                    [
                        26.548588855537847,
                        48.2241967013001
                    ],
                    [
                        26.54935401528704,
                        48.22468789115792
                    ],
                    [
                        26.55025984889254,
                        48.224967425459994
                    ],
                    [
                        26.551390209587012,
                        48.225050113363125
                    ],
                    [
                        26.55258440908963,
                        48.22507942437931
                    ],
                    [
                        26.553447120192782,
                        48.2250232706457
                    ],
                    [
                        26.55469957293775,
                        48.22470300945207
                    ],
                    [
                        26.556237019419807,
                        48.2239319774666
                    ],
                    [
                        26.55742640124559,
                        48.22309368693853
                    ],
                    [
                        26.55816209178715,
                        48.22268734677251
                    ],
                    [
                        26.55929045316758,
                        48.222445764395246
                    ],
                    [
                        26.561031390185548,
                        48.22209588683015
                    ],
                    [
                        26.563104033702572,
                        48.22160254167609
                    ],
                    [
                        26.56447200725508,
                        48.22126963444972
                    ],
                    [
                        26.566797353009363,
                        48.2205809897724
                    ],
                    [
                        26.567591197304655,
                        48.22032058872102
                    ],
                    [
                        26.569400074959443,
                        48.219726665405915
                    ],
                    [
                        26.57061807004576,
                        48.21945207270425
                    ],
                    [
                        26.571410928805747,
                        48.21949650116849
                    ],
                    [
                        26.571930034591908,
                        48.21956376093998
                    ],
                    [
                        26.572451506926782,
                        48.22003457978159
                    ],
                    [
                        26.57280543226115,
                        48.220880266154076
                    ],
                    [
                        26.572923505750676,
                        48.22198265494056
                    ],
                    [
                        26.57293781997682,
                        48.223002977694435
                    ],
                    [
                        26.57219175318398,
                        48.225648367223066
                    ],
                    [
                        26.57178725925424,
                        48.22648296275292
                    ],
                    [
                        26.57095325920437,
                        48.22733206206466
                    ],
                    [
                        26.569164777828234,
                        48.228965783108855
                    ],
                    [
                        26.568570324381014,
                        48.22972325277506
                    ],
                    [
                        26.56852149467883,
                        48.23011109036022
                    ],
                    [
                        26.56858837380387,
                        48.23048658675586
                    ],
                    [
                        26.569253900646835,
                        48.23165781778456
                    ],
                    [
                        26.569978586414205,
                        48.232698847482915
                    ],
                    [
                        26.570388600199912,
                        48.23340819383205
                    ],
                    [
                        26.57070759782167,
                        48.23415950429754
                    ],
                    [
                        26.5709695249306,
                        48.23536530771494
                    ],
                    [
                        26.570901677373424,
                        48.23590465029159
                    ],
                    [
                        26.570722802143482,
                        48.236533164631844
                    ],
                    [
                        26.570624232725887,
                        48.23708978820278
                    ],
                    [
                        26.570624802395567,
                        48.23765196676467
                    ],
                    [
                        26.57074461822064,
                        48.23817310912783
                    ],
                    [
                        26.571098141204892,
                        48.238764910781704
                    ],
                    [
                        26.571769157886333,
                        48.239326475524955
                    ],
                    [
                        26.57303464202159,
                        48.24037894955462
                    ],
                    [
                        26.575483151129603,
                        48.242460150419774
                    ],
                    [
                        26.576094196902744,
                        48.24293285819399
                    ],
                    [
                        26.576393915380798,
                        48.243044864132074
                    ],
                    [
                        26.576783536639688,
                        48.243009688708796
                    ],
                    [
                        26.57877907776546,
                        48.24245459641663
                    ],
                    [
                        26.5795546911783,
                        48.24241232428502
                    ],
                    [
                        26.58034537466806,
                        48.2427045266652
                    ],
                    [
                        26.581652705596802,
                        48.24342562293783
                    ],
                    [
                        26.583283069606786,
                        48.24475581427808
                    ],
                    [
                        26.584156130220528,
                        48.24541458680695
                    ],
                    [
                        26.585625243313768,
                        48.24621128703722
                    ],
                    [
                        26.586459714331017,
                        48.246496396411025
                    ],
                    [
                        26.587265997835182,
                        48.24655101155075
                    ],
                    [
                        26.588144470497976,
                        48.24637142960513
                    ],
                    [
                        26.588538851419,
                        48.24629830090696
                    ],
                    [
                        26.589226226342152,
                        48.245936668969385
                    ],
                    [
                        26.59000947642222,
                        48.24515138617219
                    ],
                    [
                        26.591507515544833,
                        48.243558302381246
                    ],
                    [
                        26.59214796137563,
                        48.24266040316103
                    ],
                    [
                        26.593319768300578,
                        48.24150640623415
                    ],
                    [
                        26.595096099154457,
                        48.239966722385304
                    ],
                    [
                        26.595815370686957,
                        48.239349616952815
                    ],
                    [
                        26.59665484917842,
                        48.2390250200287
                    ],
                    [
                        26.597678993668737,
                        48.2388278553465
                    ],
                    [
                        26.598691332042367,
                        48.23877509298979
                    ],
                    [
                        26.599989513895206,
                        48.23904939564047
                    ],
                    [
                        26.601512073383816,
                        48.239420275457455
                    ],
                    [
                        26.602449214366757,
                        48.23968223661582
                    ],
                    [
                        26.603976644465263,
                        48.23978652746162
                    ],
                    [
                        26.606964327875637,
                        48.2398485465921
                    ],
                    [
                        26.608415068993718,
                        48.239996343479476
                    ],
                    [
                        26.610847892867035,
                        48.24027496704654
                    ],
                    [
                        26.611456995187968,
                        48.240308907920394
                    ],
                    [
                        26.612500610682176,
                        48.24017684708835
                    ],
                    [
                        26.61543772102459,
                        48.23950204187105
                    ],
                    [
                        26.61760865986998,
                        48.23902286016447
                    ],
                    [
                        26.618656857539357,
                        48.23896670370014
                    ],
                    [
                        26.619348604939226,
                        48.23902440292463
                    ],
                    [
                        26.61999430864986,
                        48.239222493398806
                    ],
                    [
                        26.62069900588593,
                        48.23951901226171
                    ],
                    [
                        26.62097874497682,
                        48.23990624599418
                    ],
                    [
                        26.62100584863696,
                        48.24037462980576
                    ],
                    [
                        26.620775573353747,
                        48.2411907549432
                    ],
                    [
                        26.620428418725094,
                        48.241800150465416
                    ],
                    [
                        26.61966804904109,
                        48.242863124491564
                    ],
                    [
                        26.618164859796348,
                        48.24530443129497
                    ],
                    [
                        26.617064254558017,
                        48.246920049716934
                    ],
                    [
                        26.61635689891625,
                        48.24767139561374
                    ],
                    [
                        26.61465406644048,
                        48.24919630985641
                    ],
                    [
                        26.61433051832339,
                        48.24950240450748
                    ],
                    [
                        26.614194626053887,
                        48.249904462797424
                    ],
                    [
                        26.614247675314935,
                        48.25016458216073
                    ],
                    [
                        26.61460658544359,
                        48.25037533147418
                    ],
                    [
                        26.61538579366251,
                        48.25053300785555
                    ],
                    [
                        26.617294993211907,
                        48.25066815910872
                    ],
                    [
                        26.61921362555676,
                        48.25061292605462
                    ],
                    [
                        26.62001656156959,
                        48.25046728363907
                    ],
                    [
                        26.62088085347838,
                        48.25017229626171
                    ],
                    [
                        26.621416930073963,
                        48.24987823487949
                    ],
                    [
                        26.62233200710487,
                        48.24929073014733
                    ],
                    [
                        26.623123135430667,
                        48.24855357386677
                    ],
                    [
                        26.623761874704254,
                        48.24800772768064
                    ],
                    [
                        26.624622596509923,
                        48.24728384282283
                    ],
                    [
                        26.625532922515113,
                        48.24662012903064
                    ],
                    [
                        26.626369962254437,
                        48.24631403746068
                    ],
                    [
                        26.627150333166647,
                        48.24623350334186
                    ],
                    [
                        26.627786732392867,
                        48.24639302880224
                    ],
                    [
                        26.62826959994583,
                        48.24686759443022
                    ],
                    [
                        26.62850326480191,
                        48.24748286469214
                    ],
                    [
                        26.628571103541788,
                        48.247449540090436
                    ],
                    [
                        26.62895407187463,
                        48.24873562568089
                    ],
                    [
                        26.629943039648253,
                        48.25045833527272
                    ],
                    [
                        26.63062203400933,
                        48.25180614753341
                    ],
                    [
                        26.63075492699774,
                        48.252528192426425
                    ],
                    [
                        26.630326970187784,
                        48.253457287915225
                    ],
                    [
                        26.62927912248377,
                        48.25578111982859
                    ],
                    [
                        26.62906877790961,
                        48.25639455782536
                    ],
                    [
                        26.629220139844186,
                        48.25768346075822
                    ],
                    [
                        26.629615013893414,
                        48.25880697413243
                    ],
                    [
                        26.630012987232305,
                        48.25964938062807
                    ],
                    [
                        26.627837718202308,
                        48.26213711714909
                    ],
                    [
                        26.627933643432893,
                        48.26216766626838
                    ],
                    [
                        26.66574138882115,
                        48.27421198804936
                    ],
                    [
                        26.688530720753075,
                        48.27483225458627
                    ],
                    [
                        26.711475040264396,
                        48.261318772258534
                    ],
                    [
                        26.722378769192375,
                        48.25976849031809
                    ],
                    [
                        26.733127503178476,
                        48.27074993801756
                    ],
                    [
                        26.744031195934372,
                        48.25558270932942
                    ],
                    [
                        26.763719913596688,
                        48.25274048631413
                    ],
                    [
                        26.804906064188845,
                        48.258270057001056
                    ],
                    [
                        26.82190757047431,
                        48.25253374662499
                    ],
                    [
                        26.84474860105568,
                        48.233310384770505
                    ],
                    [
                        26.85549726026776,
                        48.237831851795356
                    ],
                    [
                        26.897665224274135,
                        48.208970541104605
                    ],
                    [
                        26.903429738889606,
                        48.20209587848112
                    ],
                    [
                        26.903969764091308,
                        48.20145170544291
                    ],
                    [
                        26.905461443208324,
                        48.19518837022409
                    ],
                    [
                        26.9080005066947,
                        48.184527562976264
                    ],
                    [
                        26.91771570392953,
                        48.18796420105848
                    ],
                    [
                        26.91838084309236,
                        48.188612662863534
                    ],
                    [
                        26.92908450443288,
                        48.19904871827545
                    ],
                    [
                        26.930156399904263,
                        48.19973175816204
                    ],
                    [
                        26.93812790850456,
                        48.20481079986859
                    ],
                    [
                        26.950581920615793,
                        48.197524379013394
                    ],
                    [
                        26.955646226126692,
                        48.18600062319861
                    ],
                    [
                        26.963087590873798,
                        48.17538087600703
                    ],
                    [
                        26.997607457751407,
                        48.16657009918997
                    ],
                    [
                        26.99760744144981,
                        48.157940043566725
                    ],
                    [
                        26.990024843956867,
                        48.152925370901954
                    ],
                    [
                        26.986238657911468,
                        48.15042130603341
                    ],
                    [
                        26.96660158752818,
                        48.14959433397254
                    ],
                    [
                        26.966601628733862,
                        48.14773373260711
                    ],
                    [
                        26.966601581351355,
                        48.14336728880196
                    ],
                    [
                        26.99399010845978,
                        48.13241198786542
                    ],
                    [
                        27.010433978112538,
                        48.12864166890564
                    ],
                    [
                        27.01269698347845,
                        48.12812288377157
                    ],
                    [
                        27.02509934168657,
                        48.135047600781775
                    ],
                    [
                        27.02898823130244,
                        48.133840983672
                    ],
                    [
                        27.033677595992067,
                        48.1323860790923
                    ],
                    [
                        27.03745072276506,
                        48.130274521885816
                    ],
                    [
                        27.040418237606602,
                        48.128613601434026
                    ],
                    [
                        27.04277265246461,
                        48.12729597550166
                    ],
                    [
                        27.048043681837477,
                        48.12223186931322
                    ],
                    [
                        27.047954740945368,
                        48.12140929583958
                    ],
                    [
                        27.047423566938356,
                        48.116495801950926
                    ],
                    [
                        27.03860832768013,
                        48.108847066404024
                    ],
                    [
                        27.036881526973726,
                        48.107348801451664
                    ],
                    [
                        27.034297722679817,
                        48.10176784806981
                    ],
                    [
                        27.035764517021374,
                        48.09693980556493
                    ],
                    [
                        27.040026486435696,
                        48.08291071928125
                    ],
                    [
                        27.041739123984378,
                        48.077273185650846
                    ],
                    [
                        27.043434118237485,
                        48.07540780625772
                    ],
                    [
                        27.051657917259224,
                        48.066356769282436
                    ],
                    [
                        27.05920579694532,
                        48.05804977427815
                    ],
                    [
                        27.082916156690267,
                        48.0438181321202
                    ],
                    [
                        27.083183645102544,
                        48.04365779344657
                    ],
                    [
                        27.109331905810023,
                        48.03350329318846
                    ],
                    [
                        27.109331897280573,
                        48.02608767569758
                    ],
                    [
                        27.092501532183086,
                        48.02089768800466
                    ],
                    [
                        27.092266012145004,
                        48.02042256809393
                    ],
                    [
                        27.09062099501236,
                        48.01619647061859
                    ],
                    [
                        27.090359603138538,
                        48.014698374283384
                    ],
                    [
                        27.091451849766276,
                        48.01185080999574
                    ],
                    [
                        27.093363902289997,
                        48.00844030556254
                    ],
                    [
                        27.095792684068368,
                        48.00559804338888
                    ],
                    [
                        27.105468479261276,
                        48.00846003716784
                    ],
                    [
                        27.121475862153638,
                        48.013194427712875
                    ],
                    [
                        27.126467837268773,
                        48.00834997182398
                    ],
                    [
                        27.134601679320408,
                        48.00045620571551
                    ],
                    [
                        27.14025117243037,
                        47.99204565138178
                    ],
                    [
                        27.14374843454955,
                        47.98683962050831
                    ],
                    [
                        27.157184259953258,
                        47.99195532270473
                    ],
                    [
                        27.160843155371055,
                        47.98914589895672
                    ],
                    [
                        27.168759816523796,
                        47.98306717878003
                    ],
                    [
                        27.16979333384714,
                        47.97379119244903
                    ],
                    [
                        27.162868700737132,
                        47.965006249987596
                    ],
                    [
                        27.153769826304714,
                        47.95948751210676
                    ],
                    [
                        27.172946012504358,
                        47.94960657010276
                    ],
                    [
                        27.178135024259937,
                        47.94693163693423
                    ],
                    [
                        27.177578995682627,
                        47.946386974451656
                    ],
                    [
                        27.176085766098204,
                        47.94492499067201
                    ],
                    [
                        27.178268249250703,
                        47.94412880901464
                    ],
                    [
                        27.17826828498576,
                        47.9427099896706
                    ],
                    [
                        27.17826827114905,
                        47.942095673533785
                    ],
                    [
                        27.178268265268475,
                        47.937927728089356
                    ],
                    [
                        27.160698280865716,
                        47.92172718084617
                    ],
                    [
                        27.170762079747643,
                        47.913292683083355
                    ],
                    [
                        27.1828485085828,
                        47.90835032623072
                    ],
                    [
                        27.194184588107248,
                        47.90405372372195
                    ],
                    [
                        27.195052926206152,
                        47.90335935720732
                    ],
                    [
                        27.200221102393034,
                        47.89922647713117
                    ],
                    [
                        27.212374705897243,
                        47.889506886206824
                    ],
                    [
                        27.211547905944684,
                        47.88501116735688
                    ],
                    [
                        27.213201530541202,
                        47.85413437751015
                    ],
                    [
                        27.21237473067015,
                        47.847933337287465
                    ],
                    [
                        27.222813375742717,
                        47.84266237016637
                    ],
                    [
                        27.234905616121235,
                        47.840207486016396
                    ],
                    [
                        27.243725999437924,
                        47.8372814952353
                    ],
                    [
                        27.24540479376021,
                        47.83672440169135
                    ],
                    [
                        27.245809383619935,
                        47.83659036661971
                    ],
                    [
                        27.253405817354064,
                        47.82808958541366
                    ],
                    [
                        27.2209143469757,
                        47.81449420232825
                    ],
                    [
                        27.219195997573273,
                        47.813775089346755
                    ],
                    [
                        27.231081608753016,
                        47.80708317014071
                    ],
                    [
                        27.23207364515829,
                        47.806040883377555
                    ],
                    [
                        27.2405258479935,
                        47.797161413589784
                    ],
                    [
                        27.244879213405152,
                        47.792587916751145
                    ],
                    [
                        27.248789152793442,
                        47.787392484843565
                    ],
                    [
                        27.250870566360476,
                        47.78462659508404
                    ],
                    [
                        27.256196327673862,
                        47.77754994043707
                    ],
                    [
                        27.260847183455834,
                        47.769074873022035
                    ],
                    [
                        27.264671251094263,
                        47.764553251396244
                    ],
                    [
                        27.265403692292534,
                        47.76418820998704
                    ],
                    [
                        27.27166566207065,
                        47.76106643103564
                    ],
                    [
                        27.282447941295896,
                        47.755690726468416
                    ],
                    [
                        27.28507986270257,
                        47.75394505258269
                    ],
                    [
                        27.28751224643984,
                        47.75233184580647
                    ],
                    [
                        27.288114471890896,
                        47.75068014301391
                    ],
                    [
                        27.288716433141648,
                        47.74902906541287
                    ],
                    [
                        27.290002499668436,
                        47.74550145775245
                    ],
                    [
                        27.29112961320629,
                        47.74241006070416
                    ],
                    [
                        27.28957930956696,
                        47.73168714005045
                    ],
                    [
                        27.29129910580259,
                        47.72940750620009
                    ],
                    [
                        27.294612175660916,
                        47.72501615663332
                    ],
                    [
                        27.295057015509897,
                        47.72442662354416
                    ],
                    [
                        27.295057013342827,
                        47.718173763189675
                    ],
                    [
                        27.272009341046527,
                        47.714969919621694
                    ],
                    [
                        27.27834760936643,
                        47.69966419974578
                    ],
                    [
                        27.279457971795626,
                        47.69698289160309
                    ],
                    [
                        27.281104346721637,
                        47.69300717100062
                    ],
                    [
                        27.29075084258236,
                        47.6818835016225
                    ],
                    [
                        27.29628483187079,
                        47.67550187495823
                    ],
                    [
                        27.304048707249954,
                        47.66654897814144
                    ],
                    [
                        27.35392790909623,
                        47.621934733347445
                    ],
                    [
                        27.36339738277513,
                        47.613464975229014
                    ],
                    [
                        27.369161002990857,
                        47.60830958625852
                    ],
                    [
                        27.397066289349574,
                        47.58908602953934
                    ],
                    [
                        27.406239649936207,
                        47.5867246560932
                    ],
                    [
                        27.41844504100454,
                        47.58358254931709
                    ],
                    [
                        27.42838220520018,
                        47.581024493252684
                    ],
                    [
                        27.428407443276942,
                        47.58095306872046
                    ],
                    [
                        27.429403884056907,
                        47.578129658098966
                    ],
                    [
                        27.43134228470904,
                        47.572637459177166
                    ]
                ]
            ]
        },
        "type": "Feature",
        "properties": {
            "source": "https://simplemaps.com",
            "id": "ROBT",
            "name": "Botosani"
        },
        "id": 13
    },
    {
        "geometry": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        26.658455842534458,
                        47.42666615098772
                    ],
                    [
                        26.698660119805037,
                        47.453434621660996
                    ],
                    [
                        26.713129497003106,
                        47.473588289403544
                    ],
                    [
                        26.718193797087192,
                        47.4843887171465
                    ],
                    [
                        26.724911737448252,
                        47.490486563575395
                    ],
                    [
                        26.733903437188264,
                        47.49343211955897
                    ],
                    [
                        26.74367028449955,
                        47.492656986699416
                    ],
                    [
                        26.76289390593105,
                        47.48376856745381
                    ],
                    [
                        26.77390100489494,
                        47.47971208076955
                    ],
                    [
                        26.789300578818914,
                        47.47707657038641
                    ],
                    [
                        26.95688724079012,
                        47.47668894745592
                    ],
                    [
                        26.966964139381073,
                        47.47426012163481
                    ],
                    [
                        26.975800828924303,
                        47.470565370322
                    ],
                    [
                        26.98417238645468,
                        47.46563012845076
                    ],
                    [
                        26.998900169977425,
                        47.45245263807283
                    ],
                    [
                        27.00933881354592,
                        47.44470120176133
                    ],
                    [
                        27.021431098851526,
                        47.43870673571654
                    ],
                    [
                        27.04065473554889,
                        47.434469291034596
                    ],
                    [
                        27.0558475985526,
                        47.43632959915048
                    ],
                    [
                        27.076983276939064,
                        47.441549015079794
                    ],
                    [
                        27.087215205045375,
                        47.447336742038075
                    ],
                    [
                        27.092021107808574,
                        47.45426135518411
                    ],
                    [
                        27.09093589669584,
                        47.46278793414936
                    ],
                    [
                        27.07310753079112,
                        47.48986640154028
                    ],
                    [
                        27.071247184658194,
                        47.4983930471077
                    ],
                    [
                        27.074657824946144,
                        47.505937775311004
                    ],
                    [
                        27.081634140501837,
                        47.512500667534766
                    ],
                    [
                        27.092486210019615,
                        47.51834021342075
                    ],
                    [
                        27.10395837487892,
                        47.51947707874603
                    ],
                    [
                        27.11186485433199,
                        47.51771999491717
                    ],
                    [
                        27.128194613736657,
                        47.509193426246824
                    ],
                    [
                        27.156099890540347,
                        47.50477510619462
                    ],
                    [
                        27.173979938030214,
                        47.49999505130791
                    ],
                    [
                        27.190878133279337,
                        47.49322544804881
                    ],
                    [
                        27.20483076771362,
                        47.49079664506383
                    ],
                    [
                        27.232012575583767,
                        47.49110672686614
                    ],
                    [
                        27.243794796980602,
                        47.49531833054706
                    ],
                    [
                        27.2515462534877,
                        47.50244962732623
                    ],
                    [
                        27.255887071058964,
                        47.51958034640292
                    ],
                    [
                        27.26100303622202,
                        47.52707342380801
                    ],
                    [
                        27.26937463155813,
                        47.533558892573936
                    ],
                    [
                        27.278883087983587,
                        47.539475796841664
                    ],
                    [
                        27.295936313073753,
                        47.55260162546497
                    ],
                    [
                        27.30709842008309,
                        47.557510873782114
                    ],
                    [
                        27.319500756899885,
                        47.557846728056965
                    ],
                    [
                        27.33562380315773,
                        47.555495448075014
                    ],
                    [
                        27.376138130810382,
                        47.55513373798474
                    ],
                    [
                        27.417184410715763,
                        47.568148491470986
                    ],
                    [
                        27.431225231170092,
                        47.572600516471105
                    ],
                    [
                        27.43134228470904,
                        47.572637459177166
                    ],
                    [
                        27.435823612272145,
                        47.5599405153777
                    ],
                    [
                        27.438975878551016,
                        47.5537135297984
                    ],
                    [
                        27.440267787354536,
                        47.55009616155891
                    ],
                    [
                        27.440061076127517,
                        47.54102691772738
                    ],
                    [
                        27.441832120454006,
                        47.53726348546778
                    ],
                    [
                        27.442128140245956,
                        47.53663445565938
                    ],
                    [
                        27.44605554287277,
                        47.53487742698182
                    ],
                    [
                        27.45636681319035,
                        47.53394443286122
                    ],
                    [
                        27.45690760612563,
                        47.5338956439037
                    ],
                    [
                        27.45949142444541,
                        47.533223834604144
                    ],
                    [
                        27.46672611990537,
                        47.506352059007824
                    ],
                    [
                        27.473133980801762,
                        47.49177921304472
                    ],
                    [
                        27.482132771496932,
                        47.48635350738732
                    ],
                    [
                        27.48367599331352,
                        47.485423123470845
                    ],
                    [
                        27.492564335401457,
                        47.48454460112516
                    ],
                    [
                        27.492717581168396,
                        47.48447920063089
                    ],
                    [
                        27.49752525802981,
                        47.482425786091625
                    ],
                    [
                        27.501452676355825,
                        47.479945364615645
                    ],
                    [
                        27.506207429384023,
                        47.478332078112764
                    ],
                    [
                        27.50724044196223,
                        47.47798169261065
                    ],
                    [
                        27.51202335395346,
                        47.47787597690535
                    ],
                    [
                        27.52108282808836,
                        47.47767593273015
                    ],
                    [
                        27.532975306356338,
                        47.47741325953824
                    ],
                    [
                        27.534525597966194,
                        47.47798169261065
                    ],
                    [
                        27.54473116903688,
                        47.475198319496414
                    ],
                    [
                        27.548168158844113,
                        47.474260891026695
                    ],
                    [
                        27.563154338342695,
                        47.46834401695198
                    ],
                    [
                        27.57112233056307,
                        47.463372035166934
                    ],
                    [
                        27.57307194555171,
                        47.46215567220842
                    ],
                    [
                        27.575866740138895,
                        47.46041168848621
                    ],
                    [
                        27.58299809215882,
                        47.4506707043836
                    ],
                    [
                        27.57478152872809,
                        47.446252304259325
                    ],
                    [
                        27.569355511713255,
                        47.438552567467944
                    ],
                    [
                        27.565531466248203,
                        47.42826901185871
                    ],
                    [
                        27.564378638351968,
                        47.42375708288972
                    ],
                    [
                        27.56253421808688,
                        47.41653838008257
                    ],
                    [
                        27.57477782963146,
                        47.409277692474255
                    ],
                    [
                        27.57767708038692,
                        47.4075583157769
                    ],
                    [
                        27.580310900952625,
                        47.40599633127343
                    ],
                    [
                        27.57835680516307,
                        47.39843374882526
                    ],
                    [
                        27.572352730384587,
                        47.375197172942045
                    ],
                    [
                        27.575632323772346,
                        47.37369611406661
                    ],
                    [
                        27.578415003455206,
                        47.3724224194781
                    ],
                    [
                        27.586408726642272,
                        47.36876349940631
                    ],
                    [
                        27.587931605549972,
                        47.36785962082322
                    ],
                    [
                        27.588723986101872,
                        47.367389377341276
                    ],
                    [
                        27.59904071093168,
                        47.361266278589845
                    ],
                    [
                        27.59994796717407,
                        47.36072790208108
                    ],
                    [
                        27.610388399897438,
                        47.34368922988343
                    ],
                    [
                        27.613989569318186,
                        47.33781238777224
                    ],
                    [
                        27.621402409530976,
                        47.325714822625564
                    ],
                    [
                        27.62402916431063,
                        47.32142786266472
                    ],
                    [
                        27.626831257908297,
                        47.318228023078014
                    ],
                    [
                        27.63694827827855,
                        47.306674269035994
                    ],
                    [
                        27.644699757258287,
                        47.30398717486173
                    ],
                    [
                        27.64608675237083,
                        47.30377493970211
                    ],
                    [
                        27.66971826131534,
                        47.300160197264155
                    ],
                    [
                        27.671726532792565,
                        47.29985307527488
                    ],
                    [
                        27.67329626884572,
                        47.29917147162046
                    ],
                    [
                        27.680702338875495,
                        47.295956174114195
                    ],
                    [
                        27.682320193177173,
                        47.29525381741697
                    ],
                    [
                        27.68959665351443,
                        47.29104247861704
                    ],
                    [
                        27.689864951318977,
                        47.2908871535214
                    ],
                    [
                        27.69782311577952,
                        47.287502315935846
                    ],
                    [
                        27.722834523671608,
                        47.28331660979936
                    ],
                    [
                        27.733273154077093,
                        47.27561676713521
                    ],
                    [
                        27.748541101476697,
                        47.257481134755515
                    ],
                    [
                        27.750967012490662,
                        47.25459963801784
                    ],
                    [
                        27.753633661665575,
                        47.251432159611085
                    ],
                    [
                        27.75307907222359,
                        47.24583998311311
                    ],
                    [
                        27.75239342986402,
                        47.23892647612734
                    ],
                    [
                        27.760001876844665,
                        47.22991463603945
                    ],
                    [
                        27.763038788966984,
                        47.22631750650213
                    ],
                    [
                        27.780996264329072,
                        47.21065513615143
                    ],
                    [
                        27.785085199031865,
                        47.20708882261764
                    ],
                    [
                        27.78830855106368,
                        47.20427743496701
                    ],
                    [
                        27.788482595241696,
                        47.20388277263972
                    ],
                    [
                        27.795552354681153,
                        47.18784686323397
                    ],
                    [
                        27.798666093036385,
                        47.18078397331266
                    ],
                    [
                        27.800349169288413,
                        47.176966493544555
                    ],
                    [
                        27.802106161390416,
                        47.17634634192486
                    ],
                    [
                        27.8047933411925,
                        47.16849155230111
                    ],
                    [
                        27.806243621212836,
                        47.165474362749215
                    ],
                    [
                        27.80768721130662,
                        47.16247119094289
                    ],
                    [
                        27.806772955631804,
                        47.160329204096676
                    ],
                    [
                        27.805878551505188,
                        47.15823380960528
                    ],
                    [
                        27.80273752481025,
                        47.15756066073371
                    ],
                    [
                        27.802031488629293,
                        47.15674793414893
                    ],
                    [
                        27.80140051106108,
                        47.15602206208747
                    ],
                    [
                        27.801262000760342,
                        47.15336500333674
                    ],
                    [
                        27.797816077408505,
                        47.15285757452432
                    ],
                    [
                        27.806550347413232,
                        47.14461708151529
                    ],
                    [
                        27.83682955901871,
                        47.133361610940376
                    ],
                    [
                        27.849855180999118,
                        47.12851977889935
                    ],
                    [
                        27.849855174374625,
                        47.12405367715379
                    ],
                    [
                        27.849855172097147,
                        47.12172427715823
                    ],
                    [
                        27.843757376462204,
                        47.11438635635831
                    ],
                    [
                        27.84450501732896,
                        47.11388636764
                    ],
                    [
                        27.84820153331236,
                        47.1114148702719
                    ],
                    [
                        27.85523112851218,
                        47.109867581314255
                    ],
                    [
                        27.857709992275183,
                        47.109321951266914
                    ],
                    [
                        27.86516533920608,
                        47.105573575046634
                    ],
                    [
                        27.867011752611383,
                        47.1046452485909
                    ],
                    [
                        27.88026394668589,
                        47.09458307091698
                    ],
                    [
                        27.88609910508173,
                        47.09015248784789
                    ],
                    [
                        27.89592138852042,
                        47.08269449959673
                    ],
                    [
                        27.89760421264072,
                        47.08141676013343
                    ],
                    [
                        27.925922888567502,
                        47.068755982457574
                    ],
                    [
                        27.935365225266885,
                        47.06294236399525
                    ],
                    [
                        27.938428577683442,
                        47.06105614958624
                    ],
                    [
                        27.938738652250425,
                        47.0466385188972
                    ],
                    [
                        27.96312993222994,
                        47.04338292082751
                    ],
                    [
                        27.978436709502866,
                        47.03675780593654
                    ],
                    [
                        27.983534701022634,
                        47.034551360002254
                    ],
                    [
                        27.986591028956788,
                        47.03322848318824
                    ],
                    [
                        27.997080676790336,
                        47.029881747611114
                    ],
                    [
                        28.008295121136204,
                        47.026303791038984
                    ],
                    [
                        28.028035513408962,
                        47.03297002421535
                    ],
                    [
                        28.029555762789055,
                        47.030178619158235
                    ],
                    [
                        28.036698150390468,
                        47.017063674725506
                    ],
                    [
                        28.037027231647215,
                        47.01645950779063
                    ],
                    [
                        28.038146328431612,
                        47.01548288633629
                    ],
                    [
                        28.054924299788247,
                        47.00084283327249
                    ],
                    [
                        28.06906661091988,
                        46.988502513899924
                    ],
                    [
                        28.08270918608793,
                        46.97152678414306
                    ],
                    [
                        28.08462584303523,
                        46.96796407342102
                    ],
                    [
                        28.09330358273059,
                        46.95183343018283
                    ],
                    [
                        28.097388630625687,
                        46.94424009881642
                    ],
                    [
                        28.102294561524964,
                        46.935120779381144
                    ],
                    [
                        28.102758682548316,
                        46.93255296416372
                    ],
                    [
                        28.103623063526403,
                        46.9277705472604
                    ],
                    [
                        28.104103001578302,
                        46.925114925536114
                    ],
                    [
                        28.104994091110612,
                        46.92018469450754
                    ],
                    [
                        28.10544682217376,
                        46.917679976715554
                    ],
                    [
                        28.101551328811254,
                        46.91083933585743
                    ],
                    [
                        28.0968685337661,
                        46.902616288728844
                    ],
                    [
                        28.113560020016774,
                        46.89476146546344
                    ],
                    [
                        28.113718853568077,
                        46.89243188859645
                    ],
                    [
                        28.113942421251373,
                        46.889152661614006
                    ],
                    [
                        28.11433516899099,
                        46.883392668378484
                    ],
                    [
                        28.114057264753416,
                        46.88071206858245
                    ],
                    [
                        28.113568755030446,
                        46.87599999245454
                    ],
                    [
                        28.113094937685343,
                        46.87142958971611
                    ],
                    [
                        28.12425704163904,
                        46.861636876009456
                    ],
                    [
                        28.124257028852238,
                        46.85419539727029
                    ],
                    [
                        28.124153392149974,
                        46.85344256635615
                    ],
                    [
                        28.123907516057557,
                        46.85165648121573
                    ],
                    [
                        28.122615280607807,
                        46.84226948262086
                    ],
                    [
                        28.122294134599166,
                        46.84215399737933
                    ],
                    [
                        28.11474938322328,
                        46.83944102741186
                    ],
                    [
                        28.11313978551497,
                        46.83929544356486
                    ],
                    [
                        28.06446822497778,
                        46.834893559323866
                    ],
                    [
                        28.047414981499827,
                        46.82758122488666
                    ],
                    [
                        28.04043867467043,
                        46.82313711578494
                    ],
                    [
                        28.03129193160564,
                        46.81941633431199
                    ],
                    [
                        28.019509711820803,
                        46.81889960511875
                    ],
                    [
                        28.00741742858582,
                        46.822956220021204
                    ],
                    [
                        27.99837405323139,
                        46.82866646280302
                    ],
                    [
                        27.989072305005156,
                        46.832878147664005
                    ],
                    [
                        27.98054567728537,
                        46.83365319820408
                    ],
                    [
                        27.968298379152646,
                        46.82822726887121
                    ],
                    [
                        27.96473270040822,
                        46.82184520282345
                    ],
                    [
                        27.95574098948312,
                        46.81714257842293
                    ],
                    [
                        27.941426615701058,
                        46.81724592363971
                    ],
                    [
                        27.90468468887334,
                        46.8259276529602
                    ],
                    [
                        27.873007039967916,
                        46.83962193232506
                    ],
                    [
                        27.861999945349122,
                        46.84174058512186
                    ],
                    [
                        27.846186970792026,
                        46.84034539941294
                    ],
                    [
                        27.832957803808803,
                        46.8412755737448
                    ],
                    [
                        27.8227258513402,
                        46.84685652197286
                    ],
                    [
                        27.82133060914657,
                        46.853936313892866
                    ],
                    [
                        27.823966094624346,
                        46.86158435166358
                    ],
                    [
                        27.828927036948357,
                        46.870162672811944
                    ],
                    [
                        27.837815393784997,
                        46.89047156732504
                    ],
                    [
                        27.838745557098925,
                        46.90147858014195
                    ],
                    [
                        27.835128214182166,
                        46.91124546318661
                    ],
                    [
                        27.826446574752982,
                        46.91708490556411
                    ],
                    [
                        27.814044217311586,
                        46.91837673668895
                    ],
                    [
                        27.80086673410392,
                        46.911633004982676
                    ],
                    [
                        27.796060823077024,
                        46.90266713012668
                    ],
                    [
                        27.79528567956649,
                        46.89282278695396
                    ],
                    [
                        27.79606081701782,
                        46.88370184572687
                    ],
                    [
                        27.793115266383793,
                        46.878275849101264
                    ],
                    [
                        27.78644901087517,
                        46.87781078545199
                    ],
                    [
                        27.77492516719113,
                        46.883546873040004
                    ],
                    [
                        27.73678794805919,
                        46.917524066124685
                    ],
                    [
                        27.709606164448445,
                        46.937316249945496
                    ],
                    [
                        27.650023240638838,
                        46.96922645760865
                    ],
                    [
                        27.636690720232572,
                        46.97361895409574
                    ],
                    [
                        27.62552859429411,
                        46.973851401193855
                    ],
                    [
                        27.617312058174612,
                        46.96726275101311
                    ],
                    [
                        27.61602014236856,
                        46.960079699808844
                    ],
                    [
                        27.61855228547885,
                        46.952483255235165
                    ],
                    [
                        27.62335818958159,
                        46.94545522873638
                    ],
                    [
                        27.624908492616516,
                        46.937703823021856
                    ],
                    [
                        27.624288362700415,
                        46.92907378839956
                    ],
                    [
                        27.619327430232314,
                        46.91465609269942
                    ],
                    [
                        27.62118778757408,
                        46.90954016191827
                    ],
                    [
                        27.62800907544235,
                        46.90667210569385
                    ],
                    [
                        27.639171164321223,
                        46.905922685808925
                    ],
                    [
                        27.657774700095324,
                        46.90762812161031
                    ],
                    [
                        27.663975853487294,
                        46.90674952075936
                    ],
                    [
                        27.667076452095785,
                        46.903597329437126
                    ],
                    [
                        27.66728314930457,
                        46.89762864817568
                    ],
                    [
                        27.6653711155041,
                        46.89160831568301
                    ],
                    [
                        27.660720245797982,
                        46.88504545741918
                    ],
                    [
                        27.648472924873214,
                        46.88054957146709
                    ],
                    [
                        27.62862919040163,
                        46.87868930783272
                    ],
                    [
                        27.590750352817654,
                        46.88313340811684
                    ],
                    [
                        27.572766966859515,
                        46.88819777538559
                    ],
                    [
                        27.55927940995395,
                        46.888352750295624
                    ],
                    [
                        27.5525614703815,
                        46.88199653588574
                    ],
                    [
                        27.548220647513205,
                        46.874400083079614
                    ],
                    [
                        27.54124433553628,
                        46.86667449169249
                    ],
                    [
                        27.53023725926007,
                        46.860266638396055
                    ],
                    [
                        27.49328860313729,
                        46.85166247065079
                    ],
                    [
                        27.47577029483393,
                        46.85080982192676
                    ],
                    [
                        27.45127565612916,
                        46.85476301634567
                    ],
                    [
                        27.43324058340131,
                        46.859672286957284
                    ],
                    [
                        27.41432703228899,
                        46.86313474491958
                    ],
                    [
                        27.39541343494007,
                        46.863341310998514
                    ],
                    [
                        27.32027591535503,
                        46.85406547161479
                    ],
                    [
                        27.204830751240383,
                        46.85956892827793
                    ],
                    [
                        27.199559756946375,
                        46.87274642675807
                    ],
                    [
                        27.19382368923216,
                        46.88160902954984
                    ],
                    [
                        27.176460392985092,
                        46.90246038539864
                    ],
                    [
                        27.15501469346853,
                        46.92225256826416
                    ],
                    [
                        27.144317664295574,
                        46.93413810683463
                    ],
                    [
                        27.14292238982331,
                        46.944576678592256
                    ],
                    [
                        27.14943362007367,
                        46.95457606950798
                    ],
                    [
                        27.16323122941431,
                        46.963593623017594
                    ],
                    [
                        27.179716017962754,
                        46.97013073147452
                    ],
                    [
                        27.19769941762943,
                        46.97496247913586
                    ],
                    [
                        27.227206646305664,
                        46.98023339181358
                    ],
                    [
                        27.236198370638803,
                        46.984626038737545
                    ],
                    [
                        27.239453970886743,
                        46.99170562298284
                    ],
                    [
                        27.23371789728624,
                        47.00064570523856
                    ],
                    [
                        27.220488712019936,
                        47.01113591215225
                    ],
                    [
                        27.197544390550394,
                        47.024623540511705
                    ],
                    [
                        27.18529706398708,
                        47.03439032185375
                    ],
                    [
                        27.175995326582346,
                        47.044467348160175
                    ],
                    [
                        27.172739701549666,
                        47.05384656127666
                    ],
                    [
                        27.16819217519078,
                        47.0627349013786
                    ],
                    [
                        27.16044071412425,
                        47.07051222937784
                    ],
                    [
                        27.148038351659025,
                        47.075059644553015
                    ],
                    [
                        27.12540407647076,
                        47.07666162878749
                    ],
                    [
                        27.109281051041098,
                        47.07387122457982
                    ],
                    [
                        27.09605187732024,
                        47.06854851605616
                    ],
                    [
                        27.061480344126036,
                        47.04131503552277
                    ],
                    [
                        27.050886662140964,
                        47.034752043152075
                    ],
                    [
                        27.038794382166554,
                        47.03144478247467
                    ],
                    [
                        27.02112105718796,
                        47.03237504692216
                    ],
                    [
                        26.973785429028283,
                        47.039971385931956
                    ],
                    [
                        26.959522741685127,
                        47.03780102883578
                    ],
                    [
                        26.95037602171628,
                        47.03185828422642
                    ],
                    [
                        26.94226279950958,
                        47.01516666813371
                    ],
                    [
                        26.936526723541007,
                        47.0088621905023
                    ],
                    [
                        26.927690060632706,
                        47.005503264153745
                    ],
                    [
                        26.913117310179597,
                        47.00501235773472
                    ],
                    [
                        26.872447941533117,
                        47.01129094620016
                    ],
                    [
                        26.846558061790187,
                        47.02079948608289
                    ],
                    [
                        26.787595260643876,
                        47.05211545450621
                    ],
                    [
                        26.749096318873367,
                        47.06653317909517
                    ],
                    [
                        26.72057092063689,
                        47.07211419073586
                    ],
                    [
                        26.69726483444633,
                        47.07263086494908
                    ],
                    [
                        26.67866132693002,
                        47.07097726452921
                    ],
                    [
                        26.661246380434555,
                        47.071287390794026
                    ],
                    [
                        26.648378944813444,
                        47.07635165097116
                    ],
                    [
                        26.63954226164367,
                        47.090045827562506
                    ],
                    [
                        26.63241091919565,
                        47.10583301511097
                    ],
                    [
                        26.60264529154074,
                        47.15637254648328
                    ],
                    [
                        26.551588992207872,
                        47.20729976226501
                    ],
                    [
                        26.48234256992957,
                        47.25360183042539
                    ],
                    [
                        26.559030401430288,
                        47.26559080142801
                    ],
                    [
                        26.569417358918393,
                        47.27101678990957
                    ],
                    [
                        26.57794396030697,
                        47.27869068395687
                    ],
                    [
                        26.57267297045305,
                        47.285744552426394
                    ],
                    [
                        26.511384729855145,
                        47.32439856752051
                    ],
                    [
                        26.50053265827762,
                        47.340934907732425
                    ],
                    [
                        26.50456341725376,
                        47.35008162171957
                    ],
                    [
                        26.521151567579043,
                        47.35344068344621
                    ],
                    [
                        26.626054721790894,
                        47.34491404743142
                    ],
                    [
                        26.647293729709894,
                        47.347652869545534
                    ],
                    [
                        26.656130397892422,
                        47.35292385502313
                    ],
                    [
                        26.66031620310675,
                        47.36240656312307
                    ],
                    [
                        26.66207319833663,
                        47.37467969291761
                    ],
                    [
                        26.672460164717798,
                        47.39274062698375
                    ],
                    [
                        26.67556075494712,
                        47.403670215154094
                    ],
                    [
                        26.673390337796707,
                        47.41271355150585
                    ],
                    [
                        26.658455842534458,
                        47.42666615098772
                    ]
                ]
            ]
        },
        "type": "Feature",
        "properties": {
            "source": "https://simplemaps.com",
            "id": "ROIS",
            "name": "Iasi"
        },
        "id": 14
    },
    {
        "geometry": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        27.204830751240383,
                        46.85956892827793
                    ],
                    [
                        27.32027591535503,
                        46.85406547161479
                    ],
                    [
                        27.39541343494007,
                        46.863341310998514
                    ],
                    [
                        27.41432703228899,
                        46.86313474491958
                    ],
                    [
                        27.43324058340131,
                        46.859672286957284
                    ],
                    [
                        27.45127565612916,
                        46.85476301634567
                    ],
                    [
                        27.47577029483393,
                        46.85080982192676
                    ],
                    [
                        27.49328860313729,
                        46.85166247065079
                    ],
                    [
                        27.53023725926007,
                        46.860266638396055
                    ],
                    [
                        27.54124433553628,
                        46.86667449169249
                    ],
                    [
                        27.548220647513205,
                        46.874400083079614
                    ],
                    [
                        27.5525614703815,
                        46.88199653588574
                    ],
                    [
                        27.55927940995395,
                        46.888352750295624
                    ],
                    [
                        27.572766966859515,
                        46.88819777538559
                    ],
                    [
                        27.590750352817654,
                        46.88313340811684
                    ],
                    [
                        27.62862919040163,
                        46.87868930783272
                    ],
                    [
                        27.648472924873214,
                        46.88054957146709
                    ],
                    [
                        27.660720245797982,
                        46.88504545741918
                    ],
                    [
                        27.6653711155041,
                        46.89160831568301
                    ],
                    [
                        27.66728314930457,
                        46.89762864817568
                    ],
                    [
                        27.667076452095785,
                        46.903597329437126
                    ],
                    [
                        27.663975853487294,
                        46.90674952075936
                    ],
                    [
                        27.657774700095324,
                        46.90762812161031
                    ],
                    [
                        27.639171164321223,
                        46.905922685808925
                    ],
                    [
                        27.62800907544235,
                        46.90667210569385
                    ],
                    [
                        27.62118778757408,
                        46.90954016191827
                    ],
                    [
                        27.619327430232314,
                        46.91465609269942
                    ],
                    [
                        27.624288362700415,
                        46.92907378839956
                    ],
                    [
                        27.624908492616516,
                        46.937703823021856
                    ],
                    [
                        27.62335818958159,
                        46.94545522873638
                    ],
                    [
                        27.61855228547885,
                        46.952483255235165
                    ],
                    [
                        27.61602014236856,
                        46.960079699808844
                    ],
                    [
                        27.617312058174612,
                        46.96726275101311
                    ],
                    [
                        27.62552859429411,
                        46.973851401193855
                    ],
                    [
                        27.636690720232572,
                        46.97361895409574
                    ],
                    [
                        27.650023240638838,
                        46.96922645760865
                    ],
                    [
                        27.709606164448445,
                        46.937316249945496
                    ],
                    [
                        27.73678794805919,
                        46.917524066124685
                    ],
                    [
                        27.77492516719113,
                        46.883546873040004
                    ],
                    [
                        27.78644901087517,
                        46.87781078545199
                    ],
                    [
                        27.793115266383793,
                        46.878275849101264
                    ],
                    [
                        27.79606081701782,
                        46.88370184572687
                    ],
                    [
                        27.79528567956649,
                        46.89282278695396
                    ],
                    [
                        27.796060823077024,
                        46.90266713012668
                    ],
                    [
                        27.80086673410392,
                        46.911633004982676
                    ],
                    [
                        27.814044217311586,
                        46.91837673668895
                    ],
                    [
                        27.826446574752982,
                        46.91708490556411
                    ],
                    [
                        27.835128214182166,
                        46.91124546318661
                    ],
                    [
                        27.838745557098925,
                        46.90147858014195
                    ],
                    [
                        27.837815393784997,
                        46.89047156732504
                    ],
                    [
                        27.828927036948357,
                        46.870162672811944
                    ],
                    [
                        27.823966094624346,
                        46.86158435166358
                    ],
                    [
                        27.82133060914657,
                        46.853936313892866
                    ],
                    [
                        27.8227258513402,
                        46.84685652197286
                    ],
                    [
                        27.832957803808803,
                        46.8412755737448
                    ],
                    [
                        27.846186970792026,
                        46.84034539941294
                    ],
                    [
                        27.861999945349122,
                        46.84174058512186
                    ],
                    [
                        27.873007039967916,
                        46.83962193232506
                    ],
                    [
                        27.90468468887334,
                        46.8259276529602
                    ],
                    [
                        27.941426615701058,
                        46.81724592363971
                    ],
                    [
                        27.95574098948312,
                        46.81714257842293
                    ],
                    [
                        27.96473270040822,
                        46.82184520282345
                    ],
                    [
                        27.968298379152646,
                        46.82822726887121
                    ],
                    [
                        27.98054567728537,
                        46.83365319820408
                    ],
                    [
                        27.989072305005156,
                        46.832878147664005
                    ],
                    [
                        27.99837405323139,
                        46.82866646280302
                    ],
                    [
                        28.00741742858582,
                        46.822956220021204
                    ],
                    [
                        28.019509711820803,
                        46.81889960511875
                    ],
                    [
                        28.03129193160564,
                        46.81941633431199
                    ],
                    [
                        28.04043867467043,
                        46.82313711578494
                    ],
                    [
                        28.047414981499827,
                        46.82758122488666
                    ],
                    [
                        28.06446822497778,
                        46.834893559323866
                    ],
                    [
                        28.11313978551497,
                        46.83929544356486
                    ],
                    [
                        28.11474938322328,
                        46.83944102741186
                    ],
                    [
                        28.122294134599166,
                        46.84215399737933
                    ],
                    [
                        28.122615280607807,
                        46.84226948262086
                    ],
                    [
                        28.12151818678081,
                        46.83430002205925
                    ],
                    [
                        28.137796270856903,
                        46.806239765042484
                    ],
                    [
                        28.142055083595075,
                        46.80121751742771
                    ],
                    [
                        28.161713644266182,
                        46.778034979314256
                    ],
                    [
                        28.16543164667843,
                        46.773650502519715
                    ],
                    [
                        28.178155547936218,
                        46.75864567470129
                    ],
                    [
                        28.178152730580358,
                        46.757617936124625
                    ],
                    [
                        28.178110887161456,
                        46.74238309454952
                    ],
                    [
                        28.17810388498869,
                        46.73983552802459
                    ],
                    [
                        28.18756749349125,
                        46.72675749121081
                    ],
                    [
                        28.190853793060544,
                        46.722216192772784
                    ],
                    [
                        28.2240357140139,
                        46.67636151618118
                    ],
                    [
                        28.224853046604782,
                        46.6752319615005
                    ],
                    [
                        28.234121125168706,
                        46.662424164682534
                    ],
                    [
                        28.237003040677333,
                        46.65472689305874
                    ],
                    [
                        28.238883317071185,
                        46.649704807434155
                    ],
                    [
                        28.240813502718854,
                        46.647729514493285
                    ],
                    [
                        28.242276495675807,
                        46.64623247435828
                    ],
                    [
                        28.242806487118912,
                        46.6456899255972
                    ],
                    [
                        28.243389489520187,
                        46.643179939277836
                    ],
                    [
                        28.243688512376405,
                        46.641892569531535
                    ],
                    [
                        28.244393005619724,
                        46.638858031027894
                    ],
                    [
                        28.244430489722944,
                        46.63854494042772
                    ],
                    [
                        28.244569512713856,
                        46.63737607146141
                    ],
                    [
                        28.244512988585367,
                        46.63660593394129
                    ],
                    [
                        28.24450948892956,
                        46.636557435902894
                    ],
                    [
                        28.244472495666493,
                        46.63604897430037
                    ],
                    [
                        28.245274500335594,
                        46.634086500912545
                    ],
                    [
                        28.246379012221915,
                        46.631385068664876
                    ],
                    [
                        28.24772401110425,
                        46.62809356229682
                    ],
                    [
                        28.24879900389634,
                        46.62658602120983
                    ],
                    [
                        28.250099507016834,
                        46.624415038998414
                    ],
                    [
                        28.251220491571246,
                        46.62190245095149
                    ],
                    [
                        28.2514259889487,
                        46.620972436000436
                    ],
                    [
                        28.251512489717967,
                        46.62058094038519
                    ],
                    [
                        28.251518510700414,
                        46.61938006000149
                    ],
                    [
                        28.251484995421784,
                        46.61845097289923
                    ],
                    [
                        28.25130949381958,
                        46.61361896376013
                    ],
                    [
                        28.25102548737037,
                        46.61326292698663
                    ],
                    [
                        28.248982501592895,
                        46.61070100808353
                    ],
                    [
                        28.248795503140606,
                        46.610466516910186
                    ],
                    [
                        28.247181349609807,
                        46.6096522445234
                    ],
                    [
                        28.24714360757375,
                        46.60715634171599
                    ],
                    [
                        28.240529005156798,
                        46.596381695947414
                    ],
                    [
                        28.239693523133422,
                        46.595341724423356
                    ],
                    [
                        28.230503796027207,
                        46.58390194468295
                    ],
                    [
                        28.229299143237768,
                        46.580490756775404
                    ],
                    [
                        28.22560672822487,
                        46.57003521478202
                    ],
                    [
                        28.22703999154778,
                        46.56658995070318
                    ],
                    [
                        28.227153415580585,
                        46.56631743678534
                    ],
                    [
                        28.228535570839632,
                        46.563701253092
                    ],
                    [
                        28.233932312131753,
                        46.55348590372293
                    ],
                    [
                        28.234121132272257,
                        46.55312855012609
                    ],
                    [
                        28.224767689031374,
                        46.54873600128845
                    ],
                    [
                        28.221098665499053,
                        46.54119125638049
                    ],
                    [
                        28.220739776017588,
                        46.53468615411758
                    ],
                    [
                        28.21955939955016,
                        46.51329191852578
                    ],
                    [
                        28.219031602897996,
                        46.50372581598519
                    ],
                    [
                        28.219731511152354,
                        46.50103126608682
                    ],
                    [
                        28.22109867391418,
                        46.49576772050795
                    ],
                    [
                        28.228137028717203,
                        46.48620165555732
                    ],
                    [
                        28.234121123474672,
                        46.478068481728386
                    ],
                    [
                        28.23523076363778,
                        46.4773767920912
                    ],
                    [
                        28.238100230006168,
                        46.475588131293996
                    ],
                    [
                        28.242337678798204,
                        46.47651820304528
                    ],
                    [
                        28.245799999506403,
                        46.47551051037964
                    ],
                    [
                        28.24633604630087,
                        46.47219138928375
                    ],
                    [
                        28.247143586076465,
                        46.46719060290931
                    ],
                    [
                        28.24715313918472,
                        46.46432806952174
                    ],
                    [
                        28.247179688425632,
                        46.4563615462955
                    ],
                    [
                        28.247210608949747,
                        46.447087114467024
                    ],
                    [
                        28.247246943904045,
                        46.43618477052988
                    ],
                    [
                        28.246058393608788,
                        46.42786490968326
                    ],
                    [
                        28.24021894703981,
                        46.42026841982441
                    ],
                    [
                        28.226059611942464,
                        46.41535919740703
                    ],
                    [
                        28.22949340802964,
                        46.40890851218926
                    ],
                    [
                        28.23329430582357,
                        46.40176825455892
                    ],
                    [
                        28.231246752571604,
                        46.39927711352326
                    ],
                    [
                        28.22864342065334,
                        46.39610965013135
                    ],
                    [
                        28.226796335770256,
                        46.39554818109872
                    ],
                    [
                        28.221711085521132,
                        46.39400242068944
                    ],
                    [
                        28.219548392318536,
                        46.39334510273425
                    ],
                    [
                        28.21835206288874,
                        46.392503903236495
                    ],
                    [
                        28.21293380925354,
                        46.388694223386246
                    ],
                    [
                        28.211037911346665,
                        46.37868997172687
                    ],
                    [
                        28.20763997077816,
                        46.36075976368704
                    ],
                    [
                        28.207175315228056,
                        46.35830787278492
                    ],
                    [
                        28.207146049230676,
                        46.35815345132535
                    ],
                    [
                        28.202391795487234,
                        46.35391585928649
                    ],
                    [
                        28.19405506682552,
                        46.35194797462186
                    ],
                    [
                        28.190351204600027,
                        46.35107375473362
                    ],
                    [
                        28.189922622771554,
                        46.349787960907655
                    ],
                    [
                        28.188284030073007,
                        46.34487224011371
                    ],
                    [
                        28.18792240642719,
                        46.3437873469704
                    ],
                    [
                        28.18919804501197,
                        46.3373683768175
                    ],
                    [
                        28.191270604816935,
                        46.326938899522304
                    ],
                    [
                        28.19195317446838,
                        46.32350438852066
                    ],
                    [
                        28.192883328903623,
                        46.31123111132564
                    ],
                    [
                        28.19133304767787,
                        46.307768852383504
                    ],
                    [
                        28.187894491159767,
                        46.302505997410286
                    ],
                    [
                        28.181748950561193,
                        46.293100061966065
                    ],
                    [
                        28.177793826573815,
                        46.28704662584184
                    ],
                    [
                        28.177326819975004,
                        46.2867278816448
                    ],
                    [
                        28.165753212566802,
                        46.27883004972965
                    ],
                    [
                        28.156296427267183,
                        46.275367733769116
                    ],
                    [
                        28.144927606477076,
                        46.27293891310247
                    ],
                    [
                        28.136849757741047,
                        46.2699312159386
                    ],
                    [
                        28.13521244126552,
                        46.26932158497797
                    ],
                    [
                        28.13128751201271,
                        46.26274732819672
                    ],
                    [
                        28.131078328473283,
                        46.26239694895538
                    ],
                    [
                        28.13236383042506,
                        46.25596938118599
                    ],
                    [
                        28.13382706422756,
                        46.24865333369418
                    ],
                    [
                        28.134488967543675,
                        46.24534369845337
                    ],
                    [
                        28.13211185534924,
                        46.23991769445372
                    ],
                    [
                        28.120846397580596,
                        46.23785066771502
                    ],
                    [
                        28.111063916298214,
                        46.23478832071937
                    ],
                    [
                        28.11143550650954,
                        46.23397203667705
                    ],
                    [
                        28.111771495634628,
                        46.233233473732994
                    ],
                    [
                        28.11190049987863,
                        46.231588498297235
                    ],
                    [
                        28.111195503456965,
                        46.22898101901125
                    ],
                    [
                        28.11055882713344,
                        46.227369174357776
                    ],
                    [
                        28.110976200402305,
                        46.225603358485664
                    ],
                    [
                        28.12418951995011,
                        46.21052895048128
                    ],
                    [
                        28.12564783419792,
                        46.208865305887876
                    ],
                    [
                        28.129321330290757,
                        46.20467438547122
                    ],
                    [
                        28.135625854896848,
                        46.198834940402556
                    ],
                    [
                        28.141185976893585,
                        46.19234808613039
                    ],
                    [
                        28.141516970359596,
                        46.19196198865663
                    ],
                    [
                        28.142046784583954,
                        46.19051776719445
                    ],
                    [
                        28.144720899489307,
                        46.18322862131231
                    ],
                    [
                        28.14298878649451,
                        46.179717602622844
                    ],
                    [
                        28.141190309013133,
                        46.17607205090591
                    ],
                    [
                        28.138421735467812,
                        46.17046007107971
                    ],
                    [
                        28.13324873691133,
                        46.15997425189736
                    ],
                    [
                        28.132855368116576,
                        46.15832832074355
                    ],
                    [
                        28.12908258982177,
                        46.14254221322233
                    ],
                    [
                        28.129075593021042,
                        46.142512942039204
                    ],
                    [
                        28.12735763139298,
                        46.135324642072746
                    ],
                    [
                        28.126708931056086,
                        46.13402218033515
                    ],
                    [
                        28.12758100289281,
                        46.13256601577618
                    ],
                    [
                        28.128310500794253,
                        46.13134800360593
                    ],
                    [
                        28.129558002611198,
                        46.131020514142655
                    ],
                    [
                        28.129438004858866,
                        46.12944352717845
                    ],
                    [
                        28.129142499266518,
                        46.12555499474545
                    ],
                    [
                        28.125439998721966,
                        46.1200094915852
                    ],
                    [
                        28.122383499756474,
                        46.11310399758635
                    ],
                    [
                        28.12196349988443,
                        46.11209399832903
                    ],
                    [
                        28.121561497653783,
                        46.111126985383116
                    ],
                    [
                        28.121083501702266,
                        46.109977008879596
                    ],
                    [
                        28.12053749566654,
                        46.107613473846534
                    ],
                    [
                        28.12045950187219,
                        46.1072755098669
                    ],
                    [
                        28.120281998743497,
                        46.10650649170635
                    ],
                    [
                        28.120208996368287,
                        46.10619097791884
                    ],
                    [
                        28.118333001321233,
                        46.104117006669895
                    ],
                    [
                        28.113967000650803,
                        46.10231450277857
                    ],
                    [
                        28.112075993635294,
                        46.10202596204013
                    ],
                    [
                        28.110665673669757,
                        46.10181082082621
                    ],
                    [
                        28.110506472629957,
                        46.101491173938754
                    ],
                    [
                        28.107822812797508,
                        46.09610296115557
                    ],
                    [
                        28.107256294563953,
                        46.09589464239192
                    ],
                    [
                        28.10623452975202,
                        46.095518994709586
                    ],
                    [
                        28.103742298763052,
                        46.09460274703205
                    ],
                    [
                        28.07072105835973,
                        46.08928006878737
                    ],
                    [
                        28.05563154953073,
                        46.08971937650069
                    ],
                    [
                        28.03020673764528,
                        46.09395680113572
                    ],
                    [
                        27.993413122720106,
                        46.107883630732985
                    ],
                    [
                        27.9181722352312,
                        46.12488516225597
                    ],
                    [
                        27.903909534068507,
                        46.12506599085014
                    ],
                    [
                        27.888199897944673,
                        46.12007921688249
                    ],
                    [
                        27.878278029447266,
                        46.11434316997584
                    ],
                    [
                        27.870681595842044,
                        46.106229976572195
                    ],
                    [
                        27.860604686461876,
                        46.09217396292016
                    ],
                    [
                        27.85455855089115,
                        46.08581780081024
                    ],
                    [
                        27.846031939003154,
                        46.081967905540836
                    ],
                    [
                        27.835748326457175,
                        46.08178702256163
                    ],
                    [
                        27.828772009144213,
                        46.08757478779294
                    ],
                    [
                        27.827066688689982,
                        46.095067880912374
                    ],
                    [
                        27.826601591768995,
                        46.102767617949
                    ],
                    [
                        27.81854007163569,
                        46.10881378110689
                    ],
                    [
                        27.802882117707526,
                        46.1129479233188
                    ],
                    [
                        27.63141971194091,
                        46.12754649354051
                    ],
                    [
                        27.617622105672613,
                        46.12178457938527
                    ],
                    [
                        27.61374636953013,
                        46.11540251911839
                    ],
                    [
                        27.615400014845807,
                        46.10749601772689
                    ],
                    [
                        27.635915567673393,
                        46.080546815976795
                    ],
                    [
                        27.641496614868636,
                        46.07134837065385
                    ],
                    [
                        27.644752226676353,
                        46.06233080891644
                    ],
                    [
                        27.64444216982222,
                        46.053003221335665
                    ],
                    [
                        27.638706084054732,
                        46.02607979334211
                    ],
                    [
                        27.63855105505693,
                        46.0107060531492
                    ],
                    [
                        27.63638064641015,
                        46.00478910601469
                    ],
                    [
                        27.632970003601983,
                        46.000422464258676
                    ],
                    [
                        27.627543982986627,
                        45.997554445790875
                    ],
                    [
                        27.62041263317703,
                        45.996262527629554
                    ],
                    [
                        27.610335730728163,
                        46.00148185383313
                    ],
                    [
                        27.601447385478615,
                        46.0126439728772
                    ],
                    [
                        27.589355095097016,
                        46.03775868800449
                    ],
                    [
                        27.57974327523135,
                        46.06638741138734
                    ],
                    [
                        27.56780601942734,
                        46.083854043264076
                    ],
                    [
                        27.53318281659869,
                        46.11651359025432
                    ],
                    [
                        27.51985029470451,
                        46.16260895334737
                    ],
                    [
                        27.513029010220617,
                        46.289061206386776
                    ],
                    [
                        27.501711875602066,
                        46.33557002565126
                    ],
                    [
                        27.479025903709683,
                        46.39747828270681
                    ],
                    [
                        27.44176720110953,
                        46.45912829462388
                    ],
                    [
                        27.337690860356126,
                        46.58485702216062
                    ],
                    [
                        27.33303999517883,
                        46.60733635178835
                    ],
                    [
                        27.33645063641505,
                        46.63007395649705
                    ],
                    [
                        27.33583051836913,
                        46.65474945508928
                    ],
                    [
                        27.323841578897046,
                        46.67250026325582
                    ],
                    [
                        27.304928011771825,
                        46.68707306050094
                    ],
                    [
                        27.259297726248814,
                        46.713428063078545
                    ],
                    [
                        27.245810167852344,
                        46.72360826556549
                    ],
                    [
                        27.23960900391071,
                        46.73027457661121
                    ],
                    [
                        27.225501346410336,
                        46.74283199888023
                    ],
                    [
                        27.236663433889994,
                        46.75885156057238
                    ],
                    [
                        27.23635338399907,
                        46.77006539646605
                    ],
                    [
                        27.232942737094646,
                        46.78598172437725
                    ],
                    [
                        27.21056685892058,
                        46.828098121397545
                    ],
                    [
                        27.204830751240383,
                        46.85956892827793
                    ]
                ]
            ]
        },
        "type": "Feature",
        "properties": {
            "source": "https://simplemaps.com",
            "id": "ROVS",
            "name": "Vaslui"
        },
        "id": 15
    },
    {
        "geometry": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        27.53318281659869,
                        46.11651359025432
                    ],
                    [
                        27.56780601942734,
                        46.083854043264076
                    ],
                    [
                        27.57974327523135,
                        46.06638741138734
                    ],
                    [
                        27.589355095097016,
                        46.03775868800449
                    ],
                    [
                        27.601447385478615,
                        46.0126439728772
                    ],
                    [
                        27.610335730728163,
                        46.00148185383313
                    ],
                    [
                        27.62041263317703,
                        45.996262527629554
                    ],
                    [
                        27.627543982986627,
                        45.997554445790875
                    ],
                    [
                        27.632970003601983,
                        46.000422464258676
                    ],
                    [
                        27.63638064641015,
                        46.00478910601469
                    ],
                    [
                        27.63855105505693,
                        46.0107060531492
                    ],
                    [
                        27.638706084054732,
                        46.02607979334211
                    ],
                    [
                        27.64444216982222,
                        46.053003221335665
                    ],
                    [
                        27.644752226676353,
                        46.06233080891644
                    ],
                    [
                        27.641496614868636,
                        46.07134837065385
                    ],
                    [
                        27.635915567673393,
                        46.080546815976795
                    ],
                    [
                        27.615400014845807,
                        46.10749601772689
                    ],
                    [
                        27.61374636953013,
                        46.11540251911839
                    ],
                    [
                        27.617622105672613,
                        46.12178457938527
                    ],
                    [
                        27.63141971194091,
                        46.12754649354051
                    ],
                    [
                        27.802882117707526,
                        46.1129479233188
                    ],
                    [
                        27.81854007163569,
                        46.10881378110689
                    ],
                    [
                        27.826601591768995,
                        46.102767617949
                    ],
                    [
                        27.827066688689982,
                        46.095067880912374
                    ],
                    [
                        27.828772009144213,
                        46.08757478779294
                    ],
                    [
                        27.835748326457175,
                        46.08178702256163
                    ],
                    [
                        27.846031939003154,
                        46.081967905540836
                    ],
                    [
                        27.85455855089115,
                        46.08581780081024
                    ],
                    [
                        27.860604686461876,
                        46.09217396292016
                    ],
                    [
                        27.870681595842044,
                        46.106229976572195
                    ],
                    [
                        27.878278029447266,
                        46.11434316997584
                    ],
                    [
                        27.888199897944673,
                        46.12007921688249
                    ],
                    [
                        27.903909534068507,
                        46.12506599085014
                    ],
                    [
                        27.9181722352312,
                        46.12488516225597
                    ],
                    [
                        27.993413122720106,
                        46.107883630732985
                    ],
                    [
                        28.03020673764528,
                        46.09395680113572
                    ],
                    [
                        28.05563154953073,
                        46.08971937650069
                    ],
                    [
                        28.07072105835973,
                        46.08928006878737
                    ],
                    [
                        28.103742298763052,
                        46.09460274703205
                    ],
                    [
                        28.10623452975202,
                        46.095518994709586
                    ],
                    [
                        28.107256294563953,
                        46.09589464239192
                    ],
                    [
                        28.107822812797508,
                        46.09610296115557
                    ],
                    [
                        28.106632840458584,
                        46.09371377684583
                    ],
                    [
                        28.100795932670884,
                        46.081994490213575
                    ],
                    [
                        28.09449521332066,
                        46.07913055873222
                    ],
                    [
                        28.093707960532573,
                        46.07877270300933
                    ],
                    [
                        28.093377506321225,
                        46.07816953575293
                    ],
                    [
                        28.091199994143594,
                        46.074194464943254
                    ],
                    [
                        28.090940994627733,
                        46.07372146775815
                    ],
                    [
                        28.090207308581867,
                        46.07238154235412
                    ],
                    [
                        28.0904606562707,
                        46.06799023883931
                    ],
                    [
                        28.093536727064684,
                        46.0665043174923
                    ],
                    [
                        28.09655847467541,
                        46.06504467937368
                    ],
                    [
                        28.096847369274137,
                        46.06003715461347
                    ],
                    [
                        28.096868525766773,
                        46.0596702785626
                    ],
                    [
                        28.094562017897633,
                        46.05314479032609
                    ],
                    [
                        28.084466187940077,
                        46.02458202229781
                    ],
                    [
                        28.08270918832059,
                        46.01471181386701
                    ],
                    [
                        28.086119828762612,
                        46.00055244630986
                    ],
                    [
                        28.110511109518196,
                        45.950426334020065
                    ],
                    [
                        28.112371462933616,
                        45.939212562101865
                    ],
                    [
                        28.114851928177245,
                        45.93321808003303
                    ],
                    [
                        28.120846389884854,
                        45.92629341300916
                    ],
                    [
                        28.122922729125587,
                        45.92232241935004
                    ],
                    [
                        28.124980506950294,
                        45.91838692521966
                    ],
                    [
                        28.12281010017735,
                        45.91079051486515
                    ],
                    [
                        28.118779343149086,
                        45.903142425035895
                    ],
                    [
                        28.117435753039363,
                        45.895235912898684
                    ],
                    [
                        28.12022628269176,
                        45.887846199376625
                    ],
                    [
                        28.12317027017673,
                        45.88363558488079
                    ],
                    [
                        28.12909826312984,
                        45.875157154466436
                    ],
                    [
                        28.129114629507946,
                        45.875133801138475
                    ],
                    [
                        28.13107832695557,
                        45.87136137807007
                    ],
                    [
                        28.128184449007538,
                        45.86640045204357
                    ],
                    [
                        28.124637876877618,
                        45.86461331956978
                    ],
                    [
                        28.119347833646867,
                        45.861947606067474
                    ],
                    [
                        28.1149552802068,
                        45.85973418152711
                    ],
                    [
                        28.1105111040548,
                        45.8543081371112
                    ],
                    [
                        28.11077314212115,
                        45.85159074319733
                    ],
                    [
                        28.11153826436729,
                        45.84365627246853
                    ],
                    [
                        28.113301640298793,
                        45.8253693891259
                    ],
                    [
                        28.128907915590528,
                        45.79503528491432
                    ],
                    [
                        28.140363608443206,
                        45.77946899295071
                    ],
                    [
                        28.14647790797891,
                        45.771160798566676
                    ],
                    [
                        28.148726345699366,
                        45.768679254477455
                    ],
                    [
                        28.15495283968483,
                        45.76180735115719
                    ],
                    [
                        28.156748318944153,
                        45.74130723030082
                    ],
                    [
                        28.163737829675902,
                        45.661503372676805
                    ],
                    [
                        28.162847344837957,
                        45.654215446120894
                    ],
                    [
                        28.16221909921091,
                        45.64907375657007
                    ],
                    [
                        28.161774124852563,
                        45.64543200270131
                    ],
                    [
                        28.164966942314717,
                        45.6387537493401
                    ],
                    [
                        28.16797529899759,
                        45.63246122540857
                    ],
                    [
                        28.15371260549115,
                        45.62750030301625
                    ],
                    [
                        28.150226365204944,
                        45.62752222490576
                    ],
                    [
                        28.12084639409642,
                        45.627707011565406
                    ],
                    [
                        28.117879753325965,
                        45.62695952522964
                    ],
                    [
                        28.11148207805846,
                        45.62534748799535
                    ],
                    [
                        28.107720582352194,
                        45.62439972694022
                    ],
                    [
                        28.091184122138262,
                        45.61597645593483
                    ],
                    [
                        28.0747510148986,
                        45.60486601563926
                    ],
                    [
                        28.062141966534643,
                        45.59360055737465
                    ],
                    [
                        28.11800419068251,
                        45.572723285133655
                    ],
                    [
                        28.140948526955007,
                        45.56021759073545
                    ],
                    [
                        28.157743365053037,
                        45.53892688856501
                    ],
                    [
                        28.161567420486204,
                        45.53272571423632
                    ],
                    [
                        28.164047891682387,
                        45.53060699313458
                    ],
                    [
                        28.16539147871867,
                        45.52828155434749
                    ],
                    [
                        28.1655566418531,
                        45.51751298710175
                    ],
                    [
                        28.165823362397457,
                        45.500122593013856
                    ],
                    [
                        28.165908241926203,
                        45.49458850981268
                    ],
                    [
                        28.172936238982267,
                        45.484356587895086
                    ],
                    [
                        28.199497925348997,
                        45.4617739890496
                    ],
                    [
                        28.212933800061936,
                        45.45019848398041
                    ],
                    [
                        28.215146089244747,
                        45.45036509518032
                    ],
                    [
                        28.213761426671073,
                        45.44880238674463
                    ],
                    [
                        28.199808792128668,
                        45.4369168222393
                    ],
                    [
                        28.19608808837142,
                        45.42872610314253
                    ],
                    [
                        28.19438276410866,
                        45.42342926296006
                    ],
                    [
                        28.190817090752287,
                        45.41702138070549
                    ],
                    [
                        28.18709638980072,
                        45.414385899995864
                    ],
                    [
                        28.181670363727047,
                        45.41301647132081
                    ],
                    [
                        28.17123172567692,
                        45.414385899995864
                    ],
                    [
                        28.142241245826764,
                        45.42423025589667
                    ],
                    [
                        28.12487796231251,
                        45.428028456950905
                    ],
                    [
                        28.115834588630992,
                        45.42797679791733
                    ],
                    [
                        28.104982538053047,
                        45.42663320667917
                    ],
                    [
                        28.061367628900257,
                        45.41611705001431
                    ],
                    [
                        28.051135697956344,
                        45.41503186369255
                    ],
                    [
                        28.043694287793777,
                        45.41128529728531
                    ],
                    [
                        28.030206737056787,
                        45.39542062443479
                    ],
                    [
                        27.969693639924838,
                        45.401156734636444
                    ],
                    [
                        27.94483727296381,
                        45.40663442183675
                    ],
                    [
                        27.921272820440528,
                        45.40947662731538
                    ],
                    [
                        27.85548872134782,
                        45.40740957014056
                    ],
                    [
                        27.820245396222585,
                        45.412370511072815
                    ],
                    [
                        27.765158316127202,
                        45.43314441881136
                    ],
                    [
                        27.731361933362678,
                        45.4543317789977
                    ],
                    [
                        27.711311479008447,
                        45.47154004137492
                    ],
                    [
                        27.702629834664997,
                        45.47701772031248
                    ],
                    [
                        27.69069257974852,
                        45.47916229571328
                    ],
                    [
                        27.67234744526584,
                        45.47681101904488
                    ],
                    [
                        27.6373108244353,
                        45.47551911002252
                    ],
                    [
                        27.580053338214856,
                        45.49334748084529
                    ],
                    [
                        27.55349165315549,
                        45.51360464827143
                    ],
                    [
                        27.54356977541061,
                        45.5253351804796
                    ],
                    [
                        27.525431349189574,
                        45.560061755619536
                    ],
                    [
                        27.522485795356765,
                        45.567709879059805
                    ],
                    [
                        27.52326093950697,
                        45.57719249643689
                    ],
                    [
                        27.522020703023884,
                        45.58853545542732
                    ],
                    [
                        27.514114209250437,
                        45.610652970038934
                    ],
                    [
                        27.506207715733023,
                        45.62450225778905
                    ],
                    [
                        27.495459016719142,
                        45.63633615437946
                    ],
                    [
                        27.474375032560562,
                        45.65132232343253
                    ],
                    [
                        27.467708773966592,
                        45.65902211432754
                    ],
                    [
                        27.463057901757658,
                        45.66543003173938
                    ],
                    [
                        27.457166787091783,
                        45.67147617246066
                    ],
                    [
                        27.446728145488077,
                        45.676488769460406
                    ],
                    [
                        27.420063103866887,
                        45.68620392269395
                    ],
                    [
                        27.41045129365719,
                        45.69266351337448
                    ],
                    [
                        27.3848197825902,
                        45.71845005421378
                    ],
                    [
                        27.378308551218304,
                        45.72801018620794
                    ],
                    [
                        27.37164228710896,
                        45.74030915063161
                    ],
                    [
                        27.36590620599826,
                        45.754881921253705
                    ],
                    [
                        27.25914269243766,
                        45.94257069850246
                    ],
                    [
                        27.250306028291295,
                        45.96933912589067
                    ],
                    [
                        27.251081170357246,
                        45.99104320167031
                    ],
                    [
                        27.25402672071492,
                        46.002463655198056
                    ],
                    [
                        27.261003047455755,
                        46.0123339050077
                    ],
                    [
                        27.269529662581583,
                        46.020240414161236
                    ],
                    [
                        27.283999056672847,
                        46.03042063058909
                    ],
                    [
                        27.308648710298172,
                        46.05202135615265
                    ],
                    [
                        27.33024946664259,
                        46.06530223959909
                    ],
                    [
                        27.349008009889495,
                        46.07289866561869
                    ],
                    [
                        27.377378375659006,
                        46.07687778220294
                    ],
                    [
                        27.41215660768282,
                        46.07822132550849
                    ],
                    [
                        27.42858971906103,
                        46.081967905540836
                    ],
                    [
                        27.44486778952015,
                        46.09258737831524
                    ],
                    [
                        27.454531278461623,
                        46.101682410392485
                    ],
                    [
                        27.466778597157987,
                        46.10938221606411
                    ],
                    [
                        27.476080363538113,
                        46.11372308520417
                    ],
                    [
                        27.53318281659869,
                        46.11651359025432
                    ]
                ]
            ]
        },
        "type": "Feature",
        "properties": {
            "source": "https://simplemaps.com",
            "id": "ROGL",
            "name": "Galati"
        },
        "id": 16
    },
    {
        "geometry": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        26.102530432051946,
                        47.97826699646761
                    ],
                    [
                        26.119418984150858,
                        47.91748894345707
                    ],
                    [
                        26.126705370232724,
                        47.90627521443057
                    ],
                    [
                        26.14158818915756,
                        47.89627586422103
                    ],
                    [
                        26.16830488636504,
                        47.885036129687045
                    ],
                    [
                        26.2086641796834,
                        47.86162670383323
                    ],
                    [
                        26.259668807558388,
                        47.842273814914485
                    ],
                    [
                        26.283284938289743,
                        47.82625413387277
                    ],
                    [
                        26.397024778839942,
                        47.72837904309792
                    ],
                    [
                        26.416093396673435,
                        47.70649415959159
                    ],
                    [
                        26.482187508699543,
                        47.65089005473573
                    ],
                    [
                        26.494641566902793,
                        47.636472553724445
                    ],
                    [
                        26.526732643582744,
                        47.61404505434813
                    ],
                    [
                        26.537119584594315,
                        47.60231437083217
                    ],
                    [
                        26.546318010101015,
                        47.580584555344764
                    ],
                    [
                        26.562130987723332,
                        47.52836545843287
                    ],
                    [
                        26.562751089452366,
                        47.51565296809576
                    ],
                    [
                        26.560580683195674,
                        47.500976879352514
                    ],
                    [
                        26.559960565202474,
                        47.489401357780906
                    ],
                    [
                        26.56228599729152,
                        47.47808417686626
                    ],
                    [
                        26.567557009272452,
                        47.46805903983622
                    ],
                    [
                        26.59220666719893,
                        47.44454626119158
                    ],
                    [
                        26.606469365328348,
                        47.43586463646196
                    ],
                    [
                        26.617218042135903,
                        47.430722706760136
                    ],
                    [
                        26.658455842534458,
                        47.42666615098772
                    ],
                    [
                        26.673390337796707,
                        47.41271355150585
                    ],
                    [
                        26.67556075494712,
                        47.403670215154094
                    ],
                    [
                        26.672460164717798,
                        47.39274062698375
                    ],
                    [
                        26.66207319833663,
                        47.37467969291761
                    ],
                    [
                        26.66031620310675,
                        47.36240656312307
                    ],
                    [
                        26.656130397892422,
                        47.35292385502313
                    ],
                    [
                        26.647293729709894,
                        47.347652869545534
                    ],
                    [
                        26.626054721790894,
                        47.34491404743142
                    ],
                    [
                        26.521151567579043,
                        47.35344068344621
                    ],
                    [
                        26.50456341725376,
                        47.35008162171957
                    ],
                    [
                        26.50053265827762,
                        47.340934907732425
                    ],
                    [
                        26.511384729855145,
                        47.32439856752051
                    ],
                    [
                        26.57267297045305,
                        47.285744552426394
                    ],
                    [
                        26.57794396030697,
                        47.27869068395687
                    ],
                    [
                        26.569417358918393,
                        47.27101678990957
                    ],
                    [
                        26.559030401430288,
                        47.26559080142801
                    ],
                    [
                        26.48234256992957,
                        47.25360183042539
                    ],
                    [
                        26.447305947372048,
                        47.2809903361426
                    ],
                    [
                        26.43273319866856,
                        47.288793501807405
                    ],
                    [
                        26.415473257128216,
                        47.2939093939224
                    ],
                    [
                        26.395784533417903,
                        47.29675157537567
                    ],
                    [
                        26.375734074855927,
                        47.29700994281132
                    ],
                    [
                        26.353099811644526,
                        47.29318597283403
                    ],
                    [
                        26.259358749310277,
                        47.259880428895876
                    ],
                    [
                        26.222926875651023,
                        47.25370516310289
                    ],
                    [
                        26.110427271601605,
                        47.25406682774271
                    ],
                    [
                        26.058750849541227,
                        47.244920162058264
                    ],
                    [
                        26.039630577729678,
                        47.24538530025151
                    ],
                    [
                        26.02319746183168,
                        47.24926096616214
                    ],
                    [
                        26.010795127710324,
                        47.255100465126375
                    ],
                    [
                        25.99668744150015,
                        47.25825260353688
                    ],
                    [
                        25.98206303503173,
                        47.25747759802837
                    ],
                    [
                        25.908992550526367,
                        47.23401644420063
                    ],
                    [
                        25.891319202459293,
                        47.23184598641942
                    ],
                    [
                        25.878451785443488,
                        47.23326717636789
                    ],
                    [
                        25.865687703154897,
                        47.23949416460685
                    ],
                    [
                        25.820264102492917,
                        47.268536216507954
                    ],
                    [
                        25.806569864122547,
                        47.274530777036894
                    ],
                    [
                        25.79416752646174,
                        47.277941462961415
                    ],
                    [
                        25.783470485249982,
                        47.27763128722552
                    ],
                    [
                        25.77571903895502,
                        47.274220758466015
                    ],
                    [
                        25.771533225884507,
                        47.268536216507954
                    ],
                    [
                        25.774323758604112,
                        47.26161159801136
                    ],
                    [
                        25.791842087046735,
                        47.24463600524722
                    ],
                    [
                        25.81199587700803,
                        47.23189764916748
                    ],
                    [
                        25.81943728555548,
                        47.224611286829415
                    ],
                    [
                        25.8216077019359,
                        47.21631725705525
                    ],
                    [
                        25.819643999320633,
                        47.206937997781615
                    ],
                    [
                        25.812150900238777,
                        47.196964347116584
                    ],
                    [
                        25.79509768956294,
                        47.18660328994317
                    ],
                    [
                        25.755978634348057,
                        47.16926587721358
                    ],
                    [
                        25.740785760317465,
                        47.159679877811605
                    ],
                    [
                        25.69624066717099,
                        47.12301539744293
                    ],
                    [
                        25.683528272311488,
                        47.10580719405241
                    ],
                    [
                        25.672056098005093,
                        47.07991725934682
                    ],
                    [
                        25.6712809699808,
                        47.057903212058896
                    ],
                    [
                        25.618674350105263,
                        47.0525804628235
                    ],
                    [
                        25.604411643187763,
                        47.049350620631195
                    ],
                    [
                        25.583586046165227,
                        47.04730943500089
                    ],
                    [
                        25.56792810625478,
                        47.04880816770713
                    ],
                    [
                        25.552115103322684,
                        47.055939422741105
                    ],
                    [
                        25.539867796825497,
                        47.065215394738196
                    ],
                    [
                        25.53004925893648,
                        47.074439538659924
                    ],
                    [
                        25.51888715352949,
                        47.08239773285303
                    ],
                    [
                        25.406852658369885,
                        47.13484937477129
                    ],
                    [
                        25.389799437323436,
                        47.139732806174024
                    ],
                    [
                        25.372539505486127,
                        47.14032706204993
                    ],
                    [
                        25.34804486568375,
                        47.136606294672795
                    ],
                    [
                        25.328356141749463,
                        47.13050845638475
                    ],
                    [
                        25.31176801600061,
                        47.12296375253056
                    ],
                    [
                        25.301639441421774,
                        47.11164664918211
                    ],
                    [
                        25.2993139921723,
                        47.10242234810998
                    ],
                    [
                        25.298848903121364,
                        47.093068907442564
                    ],
                    [
                        25.297298627550678,
                        47.084774948285606
                    ],
                    [
                        25.291872595128872,
                        47.07676505724848
                    ],
                    [
                        25.282570835079138,
                        47.07035716658503
                    ],
                    [
                        25.26985843258645,
                        47.06642975395674
                    ],
                    [
                        25.25482058384083,
                        47.06570623995981
                    ],
                    [
                        25.24190147109559,
                        47.06632632885188
                    ],
                    [
                        25.20469444608031,
                        47.0764291069763
                    ],
                    [
                        25.158909137329328,
                        47.09144117438329
                    ],
                    [
                        25.06857873776609,
                        47.102965046086375
                    ],
                    [
                        25.0631526959824,
                        47.172779801993386
                    ],
                    [
                        25.068578736822705,
                        47.20249384807547
                    ],
                    [
                        25.07276450872477,
                        47.21319075494893
                    ],
                    [
                        25.076485222450145,
                        47.22833201696864
                    ],
                    [
                        25.074779891467493,
                        47.23432642296142
                    ],
                    [
                        25.06981896144218,
                        47.23654856142107
                    ],
                    [
                        25.06175744983796,
                        47.23505001544742
                    ],
                    [
                        25.050905387194828,
                        47.234739882211926
                    ],
                    [
                        25.039123161809272,
                        47.23716867801528
                    ],
                    [
                        25.027599311032645,
                        47.24727138504032
                    ],
                    [
                        25.029149619341855,
                        47.25758093198529
                    ],
                    [
                        25.036746058441977,
                        47.27075844398389
                    ],
                    [
                        25.04951012220056,
                        47.28615792584181
                    ],
                    [
                        25.057416610074625,
                        47.30403792676912
                    ],
                    [
                        25.056796511905663,
                        47.31530351689943
                    ],
                    [
                        25.0523006412385,
                        47.32491519467805
                    ],
                    [
                        25.040363390929112,
                        47.34289863064161
                    ],
                    [
                        25.032922002518813,
                        47.35132200001762
                    ],
                    [
                        25.01318159238022,
                        47.3686593594147
                    ],
                    [
                        25.004034864375246,
                        47.379175521807525
                    ],
                    [
                        25.002639589672548,
                        47.38656518444399
                    ],
                    [
                        25.00698042144939,
                        47.3925597139767
                    ],
                    [
                        25.014111764918898,
                        47.39607369118086
                    ],
                    [
                        25.02294842962582,
                        47.39710718529566
                    ],
                    [
                        25.030544876546898,
                        47.396797198234076
                    ],
                    [
                        25.03819299152705,
                        47.39568617023887
                    ],
                    [
                        25.044704227619256,
                        47.39643552141542
                    ],
                    [
                        25.04935508610273,
                        47.39994938885998
                    ],
                    [
                        25.051990594764042,
                        47.40868277105322
                    ],
                    [
                        25.050440306465035,
                        47.415142352925386
                    ],
                    [
                        25.04594445322318,
                        47.42105928063299
                    ],
                    [
                        25.04067346227271,
                        47.42552932181539
                    ],
                    [
                        25.037262821884,
                        47.43023190467358
                    ],
                    [
                        25.03943321744193,
                        47.43524443087164
                    ],
                    [
                        25.04718469753331,
                        47.43974037273535
                    ],
                    [
                        25.05912195283384,
                        47.443486912912434
                    ],
                    [
                        25.07260949048013,
                        47.449455468767425
                    ],
                    [
                        25.08377160692319,
                        47.457775420614446
                    ],
                    [
                        25.0904895471905,
                        47.47146970394922
                    ],
                    [
                        25.089352652263578,
                        47.48299345904394
                    ],
                    [
                        25.084236697621186,
                        47.493793910453476
                    ],
                    [
                        25.072144413999816,
                        47.50857338019887
                    ],
                    [
                        25.046099491490335,
                        47.52968320086885
                    ],
                    [
                        24.967086216948488,
                        47.573582270410505
                    ],
                    [
                        24.956234177220445,
                        47.58228981856878
                    ],
                    [
                        25.015817114657786,
                        47.596475061227835
                    ],
                    [
                        25.02465375889084,
                        47.60293445386503
                    ],
                    [
                        25.032301877327335,
                        47.612339612590276
                    ],
                    [
                        25.029924781981784,
                        47.623062594908255
                    ],
                    [
                        25.0218632289946,
                        47.63223497819186
                    ],
                    [
                        24.978765083585234,
                        47.66256904019803
                    ],
                    [
                        24.95483890210442,
                        47.68845897906256
                    ],
                    [
                        24.942380222169046,
                        47.715562822144065
                    ],
                    [
                        25.01741824480158,
                        47.724581552974136
                    ],
                    [
                        25.02918785310279,
                        47.72803468277592
                    ],
                    [
                        25.043751488857357,
                        47.73230748929909
                    ],
                    [
                        25.079946718968554,
                        47.74292662612398
                    ],
                    [
                        25.08005010610896,
                        47.74308187315067
                    ],
                    [
                        25.08025677423208,
                        47.74313331414747
                    ],
                    [
                        25.083982916050683,
                        47.74556522046287
                    ],
                    [
                        25.087103483981327,
                        47.74760162992013
                    ],
                    [
                        25.08878473693874,
                        47.748698850986045
                    ],
                    [
                        25.11610069610087,
                        47.76652540687531
                    ],
                    [
                        25.121907978146833,
                        47.770315111763644
                    ],
                    [
                        25.127081783792306,
                        47.7760813962006
                    ],
                    [
                        25.129121443433316,
                        47.7783546083948
                    ],
                    [
                        25.12973471187743,
                        47.779037900117565
                    ],
                    [
                        25.2189563166937,
                        47.87847388299692
                    ],
                    [
                        25.22210460824108,
                        47.87995310312341
                    ],
                    [
                        25.2530766171617,
                        47.89450409296799
                    ],
                    [
                        25.26174443273883,
                        47.89857619329016
                    ],
                    [
                        25.28485518418817,
                        47.900272173534276
                    ],
                    [
                        25.752515485987217,
                        47.93459452387157
                    ],
                    [
                        25.77107635971499,
                        47.93966462170914
                    ],
                    [
                        25.80460330564598,
                        47.948822705510686
                    ],
                    [
                        25.81835128428817,
                        47.95257806162771
                    ],
                    [
                        25.87095786982465,
                        47.957022100418605
                    ],
                    [
                        25.887300497609075,
                        47.961846903965785
                    ],
                    [
                        25.90124026639663,
                        47.96596216770581
                    ],
                    [
                        25.90855930835508,
                        47.96691623896198
                    ],
                    [
                        25.918086804076513,
                        47.96815853994789
                    ],
                    [
                        25.965732483975966,
                        47.96490298270034
                    ],
                    [
                        26.02929449754183,
                        47.97779626160871
                    ],
                    [
                        26.102530432051946,
                        47.97826699646761
                    ]
                ]
            ]
        },
        "type": "Feature",
        "properties": {
            "source": "https://simplemaps.com",
            "id": "ROSV",
            "name": "Suceava"
        },
        "id": 17
    },
    {
        "geometry": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        23.090456566963425,
                        47.404290203385465
                    ],
                    [
                        22.998420840900753,
                        47.416253297100255
                    ],
                    [
                        22.981677680322253,
                        47.42268703645449
                    ],
                    [
                        22.96757002192539,
                        47.43049022956144
                    ],
                    [
                        22.966019722127545,
                        47.437931587160755
                    ],
                    [
                        22.968810260164354,
                        47.44449456306452
                    ],
                    [
                        22.976716754189543,
                        47.450230646363345
                    ],
                    [
                        23.013303671886874,
                        47.46681880773792
                    ],
                    [
                        23.022967149587743,
                        47.47273565240311
                    ],
                    [
                        23.030873645490868,
                        47.47953111664182
                    ],
                    [
                        23.03614465187736,
                        47.486714212728806
                    ],
                    [
                        23.040330428301466,
                        47.49516321052987
                    ],
                    [
                        23.04420616336569,
                        47.50567938691496
                    ],
                    [
                        23.049787229310088,
                        47.51642815922754
                    ],
                    [
                        23.057848736874497,
                        47.52614322382594
                    ],
                    [
                        23.116811557790406,
                        47.576476138665036
                    ],
                    [
                        23.126578393882685,
                        47.58071355036861
                    ],
                    [
                        23.135311714312458,
                        47.580739410952766
                    ],
                    [
                        23.143528292379955,
                        47.57699303569305
                    ],
                    [
                        23.160426477929615,
                        47.562833638137626
                    ],
                    [
                        23.17174360636849,
                        47.555392168256496
                    ],
                    [
                        23.217218875668166,
                        47.53534177038477
                    ],
                    [
                        23.232721803877507,
                        47.53076839574074
                    ],
                    [
                        23.249671673624412,
                        47.53076839574074
                    ],
                    [
                        23.2679651282083,
                        47.53808059512527
                    ],
                    [
                        23.28393314118084,
                        47.55001781804498
                    ],
                    [
                        23.301813189901196,
                        47.56751031627591
                    ],
                    [
                        23.32367230231634,
                        47.58526104479613
                    ],
                    [
                        23.340570519550006,
                        47.61078935927655
                    ],
                    [
                        23.346926730032724,
                        47.6233467932837
                    ],
                    [
                        23.359535770674423,
                        47.64257036967624
                    ],
                    [
                        23.363256485086755,
                        47.65450770195108
                    ],
                    [
                        23.360931046131338,
                        47.66784022123179
                    ],
                    [
                        23.353334608665183,
                        47.67574670371518
                    ],
                    [
                        23.342585883856678,
                        47.68334296125979
                    ],
                    [
                        23.32677289757584,
                        47.689182410463964
                    ],
                    [
                        23.25881837263266,
                        47.701946379553846
                    ],
                    [
                        23.247346246470567,
                        47.7067525652517
                    ],
                    [
                        23.24099000432414,
                        47.71367693418337
                    ],
                    [
                        23.23954309975118,
                        47.72225546386971
                    ],
                    [
                        23.24409059376101,
                        47.73615620909574
                    ],
                    [
                        23.255562757935344,
                        47.74452776896834
                    ],
                    [
                        23.27184086447165,
                        47.749230521035095
                    ],
                    [
                        23.342895938420327,
                        47.74892032871901
                    ],
                    [
                        23.38185998346394,
                        47.74091057829693
                    ],
                    [
                        23.39767295787463,
                        47.735742842822724
                    ],
                    [
                        23.41446779559377,
                        47.732590558722556
                    ],
                    [
                        23.431831087751014,
                        47.73197051690637
                    ],
                    [
                        23.454465356038217,
                        47.73507104684029
                    ],
                    [
                        23.47916668858411,
                        47.743029200043296
                    ],
                    [
                        23.620656795620967,
                        47.81620325802242
                    ],
                    [
                        23.62918336881717,
                        47.826951708882234
                    ],
                    [
                        23.630010221544907,
                        47.83808817346999
                    ],
                    [
                        23.620346732059904,
                        47.85046470432047
                    ],
                    [
                        23.607014195981318,
                        47.85940462414132
                    ],
                    [
                        23.573476168052615,
                        47.87387386384669
                    ],
                    [
                        23.559678582246164,
                        47.88141877102989
                    ],
                    [
                        23.549446668894593,
                        47.889015336978204
                    ],
                    [
                        23.501956002848072,
                        47.93423204712428
                    ],
                    [
                        23.486761599407465,
                        47.971112648008436
                    ],
                    [
                        23.48715069490664,
                        47.97085092941799
                    ],
                    [
                        23.488329483562516,
                        47.97062034597703
                    ],
                    [
                        23.489036133944467,
                        47.96902969509177
                    ],
                    [
                        23.491282795399965,
                        47.96847451064064
                    ],
                    [
                        23.49216533682271,
                        47.96830989757385
                    ],
                    [
                        23.492695711760195,
                        47.96820632086008
                    ],
                    [
                        23.492921977829386,
                        47.9680965789056
                    ],
                    [
                        23.493309773980773,
                        47.96788079428336
                    ],
                    [
                        23.493618981565575,
                        47.96770631711914
                    ],
                    [
                        23.493872441586753,
                        47.96771803113046
                    ],
                    [
                        23.49414165704161,
                        47.96775964670074
                    ],
                    [
                        23.49447648515051,
                        47.96786877200194
                    ],
                    [
                        23.495063017590027,
                        47.96803677572297
                    ],
                    [
                        23.49582447977842,
                        47.96829602569044
                    ],
                    [
                        23.49607359158793,
                        47.96836908428386
                    ],
                    [
                        23.49625453996028,
                        47.96838912145402
                    ],
                    [
                        23.496521119838324,
                        47.96840669251204
                    ],
                    [
                        23.49693973195271,
                        47.96840823383299
                    ],
                    [
                        23.49736274849677,
                        47.96842457183533
                    ],
                    [
                        23.498528706398464,
                        47.968569456046964
                    ],
                    [
                        23.49920172554964,
                        47.968654228757195
                    ],
                    [
                        23.49957581427075,
                        47.968666559335226
                    ],
                    [
                        23.50011323976717,
                        47.968639740328605
                    ],
                    [
                        23.500698766715914,
                        47.96862186099222
                    ],
                    [
                        23.500968876439444,
                        47.96865885272389
                    ],
                    [
                        23.501229401012267,
                        47.96874732463441
                    ],
                    [
                        23.50146898727547,
                        47.968872171800925
                    ],
                    [
                        23.501823184440177,
                        47.969106761311835
                    ],
                    [
                        23.502694369920462,
                        47.969808681375994
                    ],
                    [
                        23.503236702869092,
                        47.970216517125344
                    ],
                    [
                        23.503379315591683,
                        47.970366642748054
                    ],
                    [
                        23.50347304570336,
                        47.97055098602022
                    ],
                    [
                        23.503642935998027,
                        47.97086079395427
                    ],
                    [
                        23.50380219236509,
                        47.97103619779533
                    ],
                    [
                        23.503982336735188,
                        47.97113700110469
                    ],
                    [
                        23.504415255984995,
                        47.97140673490103
                    ],
                    [
                        23.504708259283646,
                        47.971588612686574
                    ],
                    [
                        23.504756423869896,
                        47.97167369453682
                    ],
                    [
                        23.504785361730928,
                        47.971785595703516
                    ],
                    [
                        23.504778920886068,
                        47.971915376448976
                    ],
                    [
                        23.503691452921945,
                        47.9726102130557
                    ],
                    [
                        23.502761504257354,
                        47.973589275770905
                    ],
                    [
                        23.50274780889631,
                        47.97364538084921
                    ],
                    [
                        23.50274779617694,
                        47.97364538084921
                    ],
                    [
                        23.502747786609838,
                        47.97364538084921
                    ],
                    [
                        23.50266115796369,
                        47.97417159768283
                    ],
                    [
                        23.502672218753887,
                        47.974284116343306
                    ],
                    [
                        23.503144084822953,
                        47.97511274824659
                    ],
                    [
                        23.50323429141856,
                        47.97528692154488
                    ],
                    [
                        23.503267298843546,
                        47.975511343221626
                    ],
                    [
                        23.503345031863724,
                        47.975896683039714
                    ],
                    [
                        23.50343460628426,
                        47.97627616618752
                    ],
                    [
                        23.503939629427343,
                        47.977691756722905
                    ],
                    [
                        23.50451291667001,
                        47.979198603635965
                    ],
                    [
                        23.50480987713166,
                        47.97978124496488
                    ],
                    [
                        23.505073938843406,
                        47.980253832671224
                    ],
                    [
                        23.505320752421113,
                        47.98053189833134
                    ],
                    [
                        23.505520194394045,
                        47.980662916056424
                    ],
                    [
                        23.50595187422257,
                        47.980920635799485
                    ],
                    [
                        23.506348255579944,
                        47.98125419207134
                    ],
                    [
                        23.506804912092218,
                        47.98154983052613
                    ],
                    [
                        23.507111930776038,
                        47.98173263943832
                    ],
                    [
                        23.50752782717778,
                        47.98190342560771
                    ],
                    [
                        23.508045981926305,
                        47.98209671621191
                    ],
                    [
                        23.50850780551265,
                        47.982306962277015
                    ],
                    [
                        23.508940811861855,
                        47.982557593047325
                    ],
                    [
                        23.509554964622126,
                        47.98298055222573
                    ],
                    [
                        23.51025968582776,
                        47.98343279861155
                    ],
                    [
                        23.510791379773924,
                        47.98395625848994
                    ],
                    [
                        23.511607978073894,
                        47.984725419430745
                    ],
                    [
                        23.51208724882554,
                        47.98524456567199
                    ],
                    [
                        23.512336843856843,
                        47.98562282779409
                    ],
                    [
                        23.512603682118336,
                        47.986138584514435
                    ],
                    [
                        23.51279711999049,
                        47.98664848475877
                    ],
                    [
                        23.513075933334985,
                        47.98732948350681
                    ],
                    [
                        23.5132889074809,
                        47.98773364421863
                    ],
                    [
                        23.513584409562306,
                        47.988094337315644
                    ],
                    [
                        23.514141558750634,
                        47.98859961668313
                    ],
                    [
                        23.514669525929904,
                        47.98913634209106
                    ],
                    [
                        23.514930877790174,
                        47.98940177644435
                    ],
                    [
                        23.51571824913527,
                        47.99049372842825
                    ],
                    [
                        23.51631945201162,
                        47.991503679737484
                    ],
                    [
                        23.516586418089815,
                        47.99195223981522
                    ],
                    [
                        23.517066232465158,
                        47.99257190125915
                    ],
                    [
                        23.518137730785543,
                        47.99282315739242
                    ],
                    [
                        23.51873253048244,
                        47.99298716764728
                    ],
                    [
                        23.51908248594505,
                        47.99313083084072
                    ],
                    [
                        23.519391379364162,
                        47.99330439826933
                    ],
                    [
                        23.51967681230377,
                        47.9935448648591
                    ],
                    [
                        23.52004956358858,
                        47.99377885753801
                    ],
                    [
                        23.520344462131767,
                        47.99395119218661
                    ],
                    [
                        23.520669142224346,
                        47.994154664353076
                    ],
                    [
                        23.520846060836615,
                        47.99435073766552
                    ],
                    [
                        23.52092413110632,
                        47.994543111609104
                    ],
                    [
                        23.520952488176896,
                        47.99481255865934
                    ],
                    [
                        23.520960842385975,
                        47.99514859709007
                    ],
                    [
                        23.52138012528268,
                        47.99772254094753
                    ],
                    [
                        23.521154474225035,
                        47.999634901245116
                    ],
                    [
                        23.52158713791417,
                        48.00038560550342
                    ],
                    [
                        23.52562301710387,
                        48.00117978179697
                    ],
                    [
                        23.56074846973752,
                        48.005449749526775
                    ],
                    [
                        23.561348694988368,
                        48.00519108328193
                    ],
                    [
                        23.565289344674326,
                        48.00337210184697
                    ],
                    [
                        23.566460233529384,
                        48.002896702122925
                    ],
                    [
                        23.56750523098806,
                        48.00281654400952
                    ],
                    [
                        23.569077453744022,
                        48.00286340567314
                    ],
                    [
                        23.57018852052533,
                        48.003003065807334
                    ],
                    [
                        23.572111338586858,
                        48.003365010924526
                    ],
                    [
                        23.572776063757452,
                        48.00359623674495
                    ],
                    [
                        23.581743616966282,
                        48.0015673134806
                    ],
                    [
                        23.643725756397508,
                        47.9967917997427
                    ],
                    [
                        23.644061911874207,
                        47.99598592021592
                    ],
                    [
                        23.64461319850208,
                        47.99432669093145
                    ],
                    [
                        23.64515800500787,
                        47.992702616079484
                    ],
                    [
                        23.645496100433114,
                        47.991919869477336
                    ],
                    [
                        23.6458395543546,
                        47.99139978653916
                    ],
                    [
                        23.646570065047797,
                        47.9908997432337
                    ],
                    [
                        23.647364422841253,
                        47.99053565551954
                    ],
                    [
                        23.64860475431093,
                        47.990160778210615
                    ],
                    [
                        23.64971405571109,
                        47.989822895784165
                    ],
                    [
                        23.65100291045057,
                        47.98957102565234
                    ],
                    [
                        23.65237712130005,
                        47.989338269480776
                    ],
                    [
                        23.65380631460668,
                        47.98919337500381
                    ],
                    [
                        23.65535507548771,
                        47.98887953997822
                    ],
                    [
                        23.65740784660489,
                        47.98833264163111
                    ],
                    [
                        23.658562649126022,
                        47.987889636221446
                    ],
                    [
                        23.659373738559214,
                        47.98757826886756
                    ],
                    [
                        23.661063683364517,
                        47.98688031394206
                    ],
                    [
                        23.6625732229908,
                        47.986098199466504
                    ],
                    [
                        23.664172368728277,
                        47.98531177113151
                    ],
                    [
                        23.66469132350919,
                        47.984996707138016
                    ],
                    [
                        23.66519238089466,
                        47.984584843172115
                    ],
                    [
                        23.665724123192707,
                        47.984199183651086
                    ],
                    [
                        23.666319858195497,
                        47.983950092879326
                    ],
                    [
                        23.666896369541593,
                        47.983806742469326
                    ],
                    [
                        23.66774249178212,
                        47.98384034503225
                    ],
                    [
                        23.66906136718096,
                        47.984008049624165
                    ],
                    [
                        23.670629841588536,
                        47.98426762199428
                    ],
                    [
                        23.671563835502237,
                        47.984403573885594
                    ],
                    [
                        23.67220982420458,
                        47.98465913894952
                    ],
                    [
                        23.67256736608871,
                        47.98493875019763
                    ],
                    [
                        23.673230415759722,
                        47.985589225026736
                    ],
                    [
                        23.673770155285062,
                        47.98603870089458
                    ],
                    [
                        23.674330665372946,
                        47.986215346949116
                    ],
                    [
                        23.675587941981508,
                        47.98629488395086
                    ],
                    [
                        23.68188802919455,
                        47.98670335920312
                    ],
                    [
                        23.687178668343787,
                        47.98719599652922
                    ],
                    [
                        23.687480748741734,
                        47.98723299060468
                    ],
                    [
                        23.710521267086573,
                        47.985082409443216
                    ],
                    [
                        23.780077771355245,
                        47.98751137117233
                    ],
                    [
                        23.79651088305787,
                        47.98198203660362
                    ],
                    [
                        23.8323830387994,
                        47.95963331667202
                    ],
                    [
                        23.832465478526625,
                        47.95899615433736
                    ],
                    [
                        23.83260728776678,
                        47.95780382911562
                    ],
                    [
                        23.832753357274633,
                        47.957183624631824
                    ],
                    [
                        23.833020563547073,
                        47.956680865397594
                    ],
                    [
                        23.83351305294266,
                        47.95620800740594
                    ],
                    [
                        23.834069932346377,
                        47.95587139709604
                    ],
                    [
                        23.834605835942305,
                        47.955652230700515
                    ],
                    [
                        23.83553225441972,
                        47.9556315778981
                    ],
                    [
                        23.83652378279254,
                        47.95584242150131
                    ],
                    [
                        23.837709728170292,
                        47.95575888549425
                    ],
                    [
                        23.838187511885774,
                        47.955368331857414
                    ],
                    [
                        23.838186693093594,
                        47.95497500448913
                    ],
                    [
                        23.83788136025788,
                        47.95419944830587
                    ],
                    [
                        23.837556360196842,
                        47.953136298502535
                    ],
                    [
                        23.83758842062059,
                        47.952757461766694
                    ],
                    [
                        23.838016312820262,
                        47.95185029002246
                    ],
                    [
                        23.83896326915845,
                        47.95081797328954
                    ],
                    [
                        23.83976977543539,
                        47.95027515307619
                    ],
                    [
                        23.842253036642898,
                        47.94928291360805
                    ],
                    [
                        23.843060206107175,
                        47.94883534349971
                    ],
                    [
                        23.84368823832936,
                        47.94839702136826
                    ],
                    [
                        23.84397352042116,
                        47.94799106537804
                    ],
                    [
                        23.844018793431385,
                        47.94763689466457
                    ],
                    [
                        23.84392062963417,
                        47.94709284735889
                    ],
                    [
                        23.84355993699044,
                        47.946229463304924
                    ],
                    [
                        23.842545915985475,
                        47.943954654196915
                    ],
                    [
                        23.842460317508287,
                        47.94334002722213
                    ],
                    [
                        23.842664989562874,
                        47.94268902954042
                    ],
                    [
                        23.84302300284268,
                        47.942372161872086
                    ],
                    [
                        23.843546755255876,
                        47.94202077205546
                    ],
                    [
                        23.844143356253046,
                        47.94175907938587
                    ],
                    [
                        23.845253193671464,
                        47.94120456294372
                    ],
                    [
                        23.847026655089678,
                        47.940310064471745
                    ],
                    [
                        23.848809820161158,
                        47.93926176011051
                    ],
                    [
                        23.84925307873927,
                        47.938963390131406
                    ],
                    [
                        23.849587276541545,
                        47.93868043210435
                    ],
                    [
                        23.849841631852968,
                        47.93824798152786
                    ],
                    [
                        23.850444604066762,
                        47.93715221687597
                    ],
                    [
                        23.851919980348374,
                        47.93533982185169
                    ],
                    [
                        23.852637889731106,
                        47.93469438999264
                    ],
                    [
                        23.85324968751111,
                        47.934445341210626
                    ],
                    [
                        23.853670706109277,
                        47.934371982822434
                    ],
                    [
                        23.85436103472638,
                        47.93437968853462
                    ],
                    [
                        23.854866093611257,
                        47.93443239561137
                    ],
                    [
                        23.855099606603513,
                        47.93449465778438
                    ],
                    [
                        23.85544183173787,
                        47.93458589346763
                    ],
                    [
                        23.856069259980167,
                        47.93464815567312
                    ],
                    [
                        23.85694282121531,
                        47.93462288091485
                    ],
                    [
                        23.85751130185474,
                        47.93441821709859
                    ],
                    [
                        23.85778981565917,
                        47.93425763007733
                    ],
                    [
                        23.858183141622625,
                        47.93403108231728
                    ],
                    [
                        23.859382781088218,
                        47.93326945160262
                    ],
                    [
                        23.860360222414307,
                        47.93285920131405
                    ],
                    [
                        23.862367003088803,
                        47.93224552219776
                    ],
                    [
                        23.86349631043955,
                        47.9319785983807
                    ],
                    [
                        23.864513897400325,
                        47.93194099481392
                    ],
                    [
                        23.865510600260933,
                        47.932020825342576
                    ],
                    [
                        23.86658928388437,
                        47.932238432993955
                    ],
                    [
                        23.867653377399062,
                        47.93253833728701
                    ],
                    [
                        23.868335639109535,
                        47.93289094868638
                    ],
                    [
                        23.869333497613525,
                        47.93336438563519
                    ],
                    [
                        23.870020278724205,
                        47.933991629119774
                    ],
                    [
                        23.87053393423466,
                        47.93438092144861
                    ],
                    [
                        23.87660931683601,
                        47.93443948486804
                    ],
                    [
                        23.916865257110516,
                        47.94557815098568
                    ],
                    [
                        23.917021952200635,
                        47.945533147916116
                    ],
                    [
                        23.918048144263604,
                        47.94544807363902
                    ],
                    [
                        23.918996085490956,
                        47.94540461178958
                    ],
                    [
                        23.920458436960246,
                        47.94546163620328
                    ],
                    [
                        23.922348946118007,
                        47.945505098061155
                    ],
                    [
                        23.923714335393655,
                        47.945709153110954
                    ],
                    [
                        23.92446213664944,
                        47.94599520030744
                    ],
                    [
                        23.925119258993877,
                        47.94639344751425
                    ],
                    [
                        23.926038474545393,
                        47.94701486219022
                    ],
                    [
                        23.92640764885081,
                        47.94723494686962
                    ],
                    [
                        23.927010460977716,
                        47.947437770151446
                    ],
                    [
                        23.927926132675356,
                        47.94767758266216
                    ],
                    [
                        23.928831461112512,
                        47.947976269726105
                    ],
                    [
                        23.929554696860585,
                        47.94820067052698
                    ],
                    [
                        23.930355082882635,
                        47.94849103555374
                    ],
                    [
                        23.931195732259404,
                        47.94865317156402
                    ],
                    [
                        23.932111724916307,
                        47.9486904690239
                    ],
                    [
                        23.9329384127604,
                        47.94852987420967
                    ],
                    [
                        23.9336745914341,
                        47.948278347767165
                    ],
                    [
                        23.93449648789076,
                        47.94784341713492
                    ],
                    [
                        23.9354067074154,
                        47.947510515313965
                    ],
                    [
                        23.936347795510557,
                        47.94720412267491
                    ],
                    [
                        23.93745644058636,
                        47.94705400889285
                    ],
                    [
                        23.938641942643045,
                        47.94717206551584
                    ],
                    [
                        23.93932816178849,
                        47.94740540472474
                    ],
                    [
                        23.940428969777926,
                        47.94780272911435
                    ],
                    [
                        23.94131461890648,
                        47.948314412207104
                    ],
                    [
                        23.942102167696927,
                        47.94908008905303
                    ],
                    [
                        23.94278481511336,
                        47.949837753531476
                    ],
                    [
                        23.943581846803614,
                        47.95044931163847
                    ],
                    [
                        23.9444375945151,
                        47.95102973817616
                    ],
                    [
                        23.945510281356874,
                        47.95188974561601
                    ],
                    [
                        23.946174373231162,
                        47.95275314629814
                    ],
                    [
                        23.94677654177722,
                        47.95376635840289
                    ],
                    [
                        23.94683073707968,
                        47.95386931352483
                    ],
                    [
                        23.97727503553661,
                        47.96229326086888
                    ],
                    [
                        23.979553196097918,
                        47.96221465514957
                    ],
                    [
                        23.979549966017302,
                        47.96220818173833
                    ],
                    [
                        23.979123885315303,
                        47.96180498097662
                    ],
                    [
                        23.978909906099695,
                        47.96140671287795
                    ],
                    [
                        23.978665112166116,
                        47.960779410892464
                    ],
                    [
                        23.978715803683002,
                        47.9601875596337
                    ],
                    [
                        23.979195773646538,
                        47.95967739713625
                    ],
                    [
                        23.979867169149284,
                        47.959289612580044
                    ],
                    [
                        23.9805817031802,
                        47.95905996298496
                    ],
                    [
                        23.98135281680899,
                        47.959013724833156
                    ],
                    [
                        23.982361693124393,
                        47.95912932022628
                    ],
                    [
                        23.98312248431561,
                        47.95934479016052
                    ],
                    [
                        23.98402422397454,
                        47.95966629995581
                    ],
                    [
                        23.98495282205444,
                        47.95983522374773
                    ],
                    [
                        23.986428105785905,
                        47.96002356772515
                    ],
                    [
                        23.98753272685487,
                        47.96030161421056
                    ],
                    [
                        23.98868983998307,
                        47.96078650078456
                    ],
                    [
                        23.989841809385837,
                        47.96119925610248
                    ],
                    [
                        23.990603661370073,
                        47.96130714593768
                    ],
                    [
                        23.99178868780388,
                        47.96132934042298
                    ],
                    [
                        23.992894447801977,
                        47.96129758997925
                    ],
                    [
                        23.994834158213994,
                        47.961367564262716
                    ],
                    [
                        23.996376313625248,
                        47.96163574779437
                    ],
                    [
                        24.008797632344574,
                        47.96120788728781
                    ],
                    [
                        24.025230739913024,
                        47.953249733844736
                    ],
                    [
                        24.029591513842778,
                        47.95245414613176
                    ],
                    [
                        24.030278761235785,
                        47.95105378136074
                    ],
                    [
                        24.030622128128055,
                        47.95030628583814
                    ],
                    [
                        24.030966664094407,
                        47.94985655645835
                    ],
                    [
                        24.03148938067409,
                        47.94950454120739
                    ],
                    [
                        24.032287955349354,
                        47.94919783824573
                    ],
                    [
                        24.03303104103643,
                        47.94900611052674
                    ],
                    [
                        24.03431472647826,
                        47.94907145822399
                    ],
                    [
                        24.03511359688845,
                        47.94917009628507
                    ],
                    [
                        24.036270828400806,
                        47.949451831429386
                    ],
                    [
                        24.037205756968138,
                        47.94978750965085
                    ],
                    [
                        24.03867522303187,
                        47.95041571289894
                    ],
                    [
                        24.039315732048085,
                        47.950680187484544
                    ],
                    [
                        24.074943480305464,
                        47.944180593121935
                    ],
                    [
                        24.089999954247837,
                        47.93943622038312
                    ],
                    [
                        24.091338342320395,
                        47.93869491905557
                    ],
                    [
                        24.093021655332137,
                        47.93788488381556
                    ],
                    [
                        24.09389993543545,
                        47.93752456063746
                    ],
                    [
                        24.094641459575346,
                        47.93723698052197
                    ],
                    [
                        24.09560354400891,
                        47.93710968094646
                    ],
                    [
                        24.09619271550894,
                        47.93702430087459
                    ],
                    [
                        24.098858984247613,
                        47.93531054005093
                    ],
                    [
                        24.098923493209632,
                        47.9349375826329
                    ],
                    [
                        24.09900893902142,
                        47.93393121642129
                    ],
                    [
                        24.09893484552544,
                        47.93265916212454
                    ],
                    [
                        24.098907555084132,
                        47.93244648578555
                    ],
                    [
                        24.0989104357421,
                        47.9320596618238
                    ],
                    [
                        24.098926878504837,
                        47.931503006082494
                    ],
                    [
                        24.098998289706746,
                        47.93109029245552
                    ],
                    [
                        24.09904531701588,
                        47.93092446742705
                    ],
                    [
                        24.09912754922892,
                        47.930396170468406
                    ],
                    [
                        24.09949714851236,
                        47.92936670303927
                    ],
                    [
                        24.100051777720196,
                        47.92825155346035
                    ],
                    [
                        24.100406230053203,
                        47.92767856918048
                    ],
                    [
                        24.10103702131305,
                        47.926984147015645
                    ],
                    [
                        24.101919230215994,
                        47.926066267057415
                    ],
                    [
                        24.103123155812455,
                        47.924887636947524
                    ],
                    [
                        24.104263017986774,
                        47.92383229850816
                    ],
                    [
                        24.104929885245912,
                        47.92329815815156
                    ],
                    [
                        24.10522422396234,
                        47.92294925683742
                    ],
                    [
                        24.105404780418997,
                        47.92251991152942
                    ],
                    [
                        24.105794241783936,
                        47.92162084660494
                    ],
                    [
                        24.106397498660392,
                        47.92083828941304
                    ],
                    [
                        24.107647467425178,
                        47.919391226744565
                    ],
                    [
                        24.1080549944161,
                        47.91887959393386
                    ],
                    [
                        24.108388313154716,
                        47.91830508682439
                    ],
                    [
                        24.108691805081694,
                        47.917656610187954
                    ],
                    [
                        24.109172954738337,
                        47.91696467732754
                    ],
                    [
                        24.109882595963697,
                        47.916305108095266
                    ],
                    [
                        24.11163030720512,
                        47.91505408807765
                    ],
                    [
                        24.112430786036846,
                        47.91473046957306
                    ],
                    [
                        24.113484634609748,
                        47.91454092175675
                    ],
                    [
                        24.115048664783714,
                        47.914477122763074
                    ],
                    [
                        24.11601666583467,
                        47.91453814788718
                    ],
                    [
                        24.117229305936135,
                        47.914661431004696
                    ],
                    [
                        24.11973273927111,
                        47.91507103953294
                    ],
                    [
                        24.12212397655848,
                        47.91551485979961
                    ],
                    [
                        24.123528035398415,
                        47.915638759743395
                    ],
                    [
                        24.125266388803464,
                        47.91567389555779
                    ],
                    [
                        24.12727948660146,
                        47.915473251621215
                    ],
                    [
                        24.127816467881154,
                        47.915443663586835
                    ],
                    [
                        24.12837109118413,
                        47.91555831723665
                    ],
                    [
                        24.12902581238423,
                        47.91570933958535
                    ],
                    [
                        24.129297449635228,
                        47.91574601645314
                    ],
                    [
                        24.129774231119857,
                        47.91581043213956
                    ],
                    [
                        24.130544589061873,
                        47.91578485078874
                    ],
                    [
                        24.131140526268126,
                        47.91565940973908
                    ],
                    [
                        24.13203860858513,
                        47.91538633677867
                    ],
                    [
                        24.13300778020875,
                        47.91494683161963
                    ],
                    [
                        24.134673041717054,
                        47.91405950167195
                    ],
                    [
                        24.135513974926905,
                        47.91361167690831
                    ],
                    [
                        24.13623274426109,
                        47.91326710195101
                    ],
                    [
                        24.13708718889474,
                        47.91287598828794
                    ],
                    [
                        24.138267926066252,
                        47.91219547024322
                    ],
                    [
                        24.139056058159287,
                        47.91194212561146
                    ],
                    [
                        24.13997167811509,
                        47.9118129877381
                    ],
                    [
                        24.14156220514779,
                        47.911909764086566
                    ],
                    [
                        24.14195042874359,
                        47.911974178934834
                    ],
                    [
                        24.142867092635967,
                        47.912209647686446
                    ],
                    [
                        24.143651014711327,
                        47.91241367966257
                    ],
                    [
                        24.144463389064633,
                        47.91263774515248
                    ],
                    [
                        24.144599291659326,
                        47.912687366281254
                    ],
                    [
                        24.148737420738062,
                        47.91211533688115
                    ],
                    [
                        24.150184367199245,
                        47.91291636327563
                    ],
                    [
                        24.209302204722228,
                        47.897594298223524
                    ],
                    [
                        24.219866322299595,
                        47.897317543706784
                    ],
                    [
                        24.22110280475589,
                        47.897064520038164
                    ],
                    [
                        24.221903874108612,
                        47.89726422688645
                    ],
                    [
                        24.22427063956174,
                        47.89720228076628
                    ],
                    [
                        24.225371314209642,
                        47.89655908972928
                    ],
                    [
                        24.22681564996676,
                        47.8966512382394
                    ],
                    [
                        24.228023151076943,
                        47.896553542328235
                    ],
                    [
                        24.228727698545836,
                        47.89703678298657
                    ],
                    [
                        24.228883717413762,
                        47.897081470459845
                    ],
                    [
                        24.23100632850149,
                        47.89702599635611
                    ],
                    [
                        24.2359005273367,
                        47.898692073149356
                    ],
                    [
                        24.236219374710718,
                        47.89866587690061
                    ],
                    [
                        24.237718415063075,
                        47.89927301408657
                    ],
                    [
                        24.24005053079471,
                        47.89952388230359
                    ],
                    [
                        24.24133404641425,
                        47.90054153418621
                    ],
                    [
                        24.24385936408444,
                        47.90140139420505
                    ],
                    [
                        24.245001981855808,
                        47.90133944721674
                    ],
                    [
                        24.246124456440512,
                        47.902159860623556
                    ],
                    [
                        24.24771075082198,
                        47.90271245441018
                    ],
                    [
                        24.261037882608264,
                        47.907249125176094
                    ],
                    [
                        24.2616299070479,
                        47.907292273194884
                    ],
                    [
                        24.26402898952373,
                        47.907109202358555
                    ],
                    [
                        24.264694387480834,
                        47.90740815647661
                    ],
                    [
                        24.265512798742844,
                        47.90738966446054
                    ],
                    [
                        24.26664108457292,
                        47.90713293375687
                    ],
                    [
                        24.267288584123015,
                        47.90704663777219
                    ],
                    [
                        24.26751416782042,
                        47.90701674238337
                    ],
                    [
                        24.269419206891158,
                        47.90634486743412
                    ],
                    [
                        24.27349119778508,
                        47.90627552262968
                    ],
                    [
                        24.274001528012114,
                        47.90641452045409
                    ],
                    [
                        24.275035341754045,
                        47.906422225435186
                    ],
                    [
                        24.27618650707341,
                        47.906071803098456
                    ],
                    [
                        24.279713843814445,
                        47.90579843081694
                    ],
                    [
                        24.280532291297973,
                        47.90636644137658
                    ],
                    [
                        24.281928210863164,
                        47.907459934127864
                    ],
                    [
                        24.28660980198131,
                        47.90887149502563
                    ],
                    [
                        24.287387168037764,
                        47.90943149824022
                    ],
                    [
                        24.292541143168147,
                        47.91090286012966
                    ],
                    [
                        24.29429158298912,
                        47.91132725724606
                    ],
                    [
                        24.295844780480667,
                        47.911180243796736
                    ],
                    [
                        24.297894188473162,
                        47.91119719502929
                    ],
                    [
                        24.29897806341346,
                        47.91246237613698
                    ],
                    [
                        24.29932476474465,
                        47.91270462580626
                    ],
                    [
                        24.30144412483424,
                        47.91427617143357
                    ],
                    [
                        24.30194356920735,
                        47.9145612634678
                    ],
                    [
                        24.30376826373558,
                        47.91709905703438
                    ],
                    [
                        24.307031735986314,
                        47.917510210004046
                    ],
                    [
                        24.309294478546825,
                        47.918178411856
                    ],
                    [
                        24.31014203336073,
                        47.91903924793247
                    ],
                    [
                        24.311287742354,
                        47.92008470636986
                    ],
                    [
                        24.330872402157045,
                        47.920515589199105
                    ],
                    [
                        24.334882227242776,
                        47.9177934558993
                    ],
                    [
                        24.338638745230295,
                        47.91821878756994
                    ],
                    [
                        24.341986228310468,
                        47.91602987707166
                    ],
                    [
                        24.34207669449636,
                        47.91598210463573
                    ],
                    [
                        24.344490029874716,
                        47.91454092175675
                    ],
                    [
                        24.344996280177526,
                        47.91465095193771
                    ],
                    [
                        24.350183569611715,
                        47.91534503682698
                    ],
                    [
                        24.350648174887255,
                        47.91561872616685
                    ],
                    [
                        24.351007994189047,
                        47.915798720195525
                    ],
                    [
                        24.35180412047641,
                        47.91604004797837
                    ],
                    [
                        24.353486451375222,
                        47.91661116036391
                    ],
                    [
                        24.35674331604704,
                        47.918572922885744
                    ],
                    [
                        24.35965766405072,
                        47.919324344573674
                    ],
                    [
                        24.360859014823856,
                        47.919719473563774
                    ],
                    [
                        24.3622590150105,
                        47.92040925539511
                    ],
                    [
                        24.36330697424736,
                        47.92081733084017
                    ],
                    [
                        24.365394999316635,
                        47.92187080918652
                    ],
                    [
                        24.36854660343352,
                        47.92323559012931
                    ],
                    [
                        24.37200603326075,
                        47.92398764014394
                    ],
                    [
                        24.377145304339038,
                        47.92523499946305
                    ],
                    [
                        24.381102697415535,
                        47.92639637063509
                    ],
                    [
                        24.3814374053511,
                        47.926415172063805
                    ],
                    [
                        24.381574120251766,
                        47.926933290596565
                    ],
                    [
                        24.38161050726835,
                        47.92748778014916
                    ],
                    [
                        24.38102729812812,
                        47.93014527597877
                    ],
                    [
                        24.381214929977492,
                        47.93079901993036
                    ],
                    [
                        24.38046619000887,
                        47.931521807837335
                    ],
                    [
                        24.380715403559122,
                        47.93209819008406
                    ],
                    [
                        24.380381585589024,
                        47.93390994868858
                    ],
                    [
                        24.381267733615122,
                        47.93590573175246
                    ],
                    [
                        24.382420886008916,
                        47.93775665926362
                    ],
                    [
                        24.38320866062771,
                        47.93988408441887
                    ],
                    [
                        24.38563771034845,
                        47.94078844512182
                    ],
                    [
                        24.386668627543582,
                        47.94209998884587
                    ],
                    [
                        24.38809304737148,
                        47.94423946673117
                    ],
                    [
                        24.388350658763073,
                        47.944458932854836
                    ],
                    [
                        24.409186625763557,
                        47.952061130911964
                    ],
                    [
                        24.428513619780198,
                        47.952526276040956
                    ],
                    [
                        24.485564428367574,
                        47.94319885430703
                    ],
                    [
                        24.542098405662106,
                        47.943818721039165
                    ],
                    [
                        24.561632141145687,
                        47.94053754177149
                    ],
                    [
                        24.56980843893665,
                        47.93728845518437
                    ],
                    [
                        24.60845098285321,
                        47.92193399334987
                    ],
                    [
                        24.633669089096443,
                        47.90829145979549
                    ],
                    [
                        24.64927535861346,
                        47.895217238094276
                    ],
                    [
                        24.655993263953015,
                        47.87930070450146
                    ],
                    [
                        24.656923476095994,
                        47.866200955586216
                    ],
                    [
                        24.66147100618593,
                        47.853876152316744
                    ],
                    [
                        24.679144334098307,
                        47.84013014532445
                    ],
                    [
                        24.712837381776843,
                        47.82591921217758
                    ],
                    [
                        24.793659291113492,
                        47.80447330081664
                    ],
                    [
                        24.80823203326458,
                        47.795739909647146
                    ],
                    [
                        24.82073777503778,
                        47.78408716022882
                    ],
                    [
                        24.85443076541901,
                        47.74313331414747
                    ],
                    [
                        24.87778851137886,
                        47.718742031651395
                    ],
                    [
                        24.896598738496518,
                        47.71006042373583
                    ],
                    [
                        24.92885797328919,
                        47.713937810025016
                    ],
                    [
                        24.942380222169046,
                        47.715562822144065
                    ],
                    [
                        24.95483890210442,
                        47.68845897906256
                    ],
                    [
                        24.978765083585234,
                        47.66256904019803
                    ],
                    [
                        25.0218632289946,
                        47.63223497819186
                    ],
                    [
                        25.029924781981784,
                        47.623062594908255
                    ],
                    [
                        25.032301877327335,
                        47.612339612590276
                    ],
                    [
                        25.02465375889084,
                        47.60293445386503
                    ],
                    [
                        25.015817114657786,
                        47.596475061227835
                    ],
                    [
                        24.956234177220445,
                        47.58228981856878
                    ],
                    [
                        24.87076133540129,
                        47.582832278384245
                    ],
                    [
                        24.837068311971702,
                        47.57466746777711
                    ],
                    [
                        24.79577885243369,
                        47.548467574895625
                    ],
                    [
                        24.780120878135676,
                        47.54071601570697
                    ],
                    [
                        24.759191926172583,
                        47.53650440194599
                    ],
                    [
                        24.57093468031358,
                        47.53216356401361
                    ],
                    [
                        24.38334922927568,
                        47.562110047023765
                    ],
                    [
                        24.365675897287815,
                        47.559087021711036
                    ],
                    [
                        24.29627443762969,
                        47.537718751795346
                    ],
                    [
                        24.282321799851747,
                        47.52991559938923
                    ],
                    [
                        24.27441532709342,
                        47.52113075056335
                    ],
                    [
                        24.255191692131167,
                        47.4900215188745
                    ],
                    [
                        24.245063112268376,
                        47.48170161604986
                    ],
                    [
                        24.22490929959313,
                        47.47320082475912
                    ],
                    [
                        24.140366644509914,
                        47.46118597049043
                    ],
                    [
                        24.125897253939165,
                        47.456716026747614
                    ],
                    [
                        24.120936312958445,
                        47.45154836044209
                    ],
                    [
                        24.11907596235367,
                        47.44552806566471
                    ],
                    [
                        24.11737063510804,
                        47.42997342614615
                    ],
                    [
                        24.11411503180481,
                        47.42072342244395
                    ],
                    [
                        24.107138716497317,
                        47.41090492457318
                    ],
                    [
                        24.046005498956116,
                        47.350030093214535
                    ],
                    [
                        24.007506555153213,
                        47.324605279802064
                    ],
                    [
                        23.84147016839891,
                        47.33323517877108
                    ],
                    [
                        23.812944787409076,
                        47.31651791802219
                    ],
                    [
                        23.787623323374206,
                        47.30762949107542
                    ],
                    [
                        23.77661625194862,
                        47.305329950080626
                    ],
                    [
                        23.76204350027493,
                        47.304864876437165
                    ],
                    [
                        23.7496411499312,
                        47.306699337617566
                    ],
                    [
                        23.736256962572387,
                        47.31256467218292
                    ],
                    [
                        23.72835044723629,
                        47.31871403360437
                    ],
                    [
                        23.719048709347966,
                        47.32445024557799
                    ],
                    [
                        23.70742149364851,
                        47.32928187428305
                    ],
                    [
                        23.68706098776726,
                        47.33556061215673
                    ],
                    [
                        23.67822432174967,
                        47.34357048605559
                    ],
                    [
                        23.672488226027095,
                        47.351528576398906
                    ],
                    [
                        23.670007769438214,
                        47.35922845152187
                    ],
                    [
                        23.656985315133934,
                        47.36457700703259
                    ],
                    [
                        23.633524194093567,
                        47.36744490818307
                    ],
                    [
                        23.47994183616511,
                        47.36263898909708
                    ],
                    [
                        23.457100866997546,
                        47.36517122830993
                    ],
                    [
                        23.332198938304682,
                        47.39405840298366
                    ],
                    [
                        23.29173627239106,
                        47.40847600266655
                    ],
                    [
                        23.27184085594424,
                        47.41315278667976
                    ],
                    [
                        23.245330844224544,
                        47.416434223992106
                    ],
                    [
                        23.14058271877381,
                        47.41695100470398
                    ],
                    [
                        23.090456566963425,
                        47.404290203385465
                    ]
                ]
            ]
        },
        "type": "Feature",
        "properties": {
            "source": "https://simplemaps.com",
            "id": "ROMM",
            "name": "Maramures"
        },
        "id": 18
    },
    {
        "geometry": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        28.785410992660005,
                        44.67967350375752
                    ],
                    [
                        28.72854475400197,
                        44.68892867325305
                    ],
                    [
                        28.670932348011934,
                        44.71053334049254
                    ],
                    [
                        28.606118416568847,
                        44.696130405995206
                    ],
                    [
                        28.526901355300804,
                        44.696130405995206
                    ],
                    [
                        28.454885808765937,
                        44.71773484770103
                    ],
                    [
                        28.4044749511195,
                        44.76094414910091
                    ],
                    [
                        28.34686254267157,
                        44.76094414910091
                    ],
                    [
                        28.32525788975503,
                        44.71773484770103
                    ],
                    [
                        28.282048590876524,
                        44.71053334049254
                    ],
                    [
                        28.23883928203538,
                        44.73933952994485
                    ],
                    [
                        28.19563001135421,
                        44.76814594654664
                    ],
                    [
                        28.14521914823931,
                        44.78254901226742
                    ],
                    [
                        28.054804741122442,
                        44.777008887673226
                    ],
                    [
                        28.070100964454515,
                        44.79592246291242
                    ],
                    [
                        28.076147106792774,
                        44.816903095323006
                    ],
                    [
                        28.080074519776915,
                        44.84077762782023
                    ],
                    [
                        28.09020307313595,
                        44.85607369083772
                    ],
                    [
                        28.11707480732977,
                        44.881446751680556
                    ],
                    [
                        28.125033001693765,
                        44.891601315387
                    ],
                    [
                        28.12663498229601,
                        44.895761333768284
                    ],
                    [
                        28.125188041742863,
                        44.900515562742086
                    ],
                    [
                        28.124102835969605,
                        44.94485393369287
                    ],
                    [
                        28.127358431824174,
                        44.949711404989806
                    ],
                    [
                        28.141362738974944,
                        44.95978827346804
                    ],
                    [
                        28.1410010176733,
                        44.98237095769579
                    ],
                    [
                        28.130769076852538,
                        45.01859609605846
                    ],
                    [
                        28.133094516943427,
                        45.02562409173961
                    ],
                    [
                        28.142396274854192,
                        45.03645030405513
                    ],
                    [
                        28.14441165472465,
                        45.04283234333808
                    ],
                    [
                        28.14332644991138,
                        45.04872345615955
                    ],
                    [
                        28.141001010719133,
                        45.051824040844565
                    ],
                    [
                        28.138675571290168,
                        45.053839425642145
                    ],
                    [
                        28.137590366580294,
                        45.05647492312318
                    ],
                    [
                        28.131440871510797,
                        45.08903107538006
                    ],
                    [
                        28.13417972301203,
                        45.09370779511432
                    ],
                    [
                        28.147770623036976,
                        45.09791941790156
                    ],
                    [
                        28.162705111162207,
                        45.10830638062668
                    ],
                    [
                        28.17428063343817,
                        45.1216389065163
                    ],
                    [
                        28.177949659090686,
                        45.134661359045126
                    ],
                    [
                        28.16962975388777,
                        45.14789053127488
                    ],
                    [
                        28.1525765333731,
                        45.16124889577177
                    ],
                    [
                        28.132060988776,
                        45.17153250257886
                    ],
                    [
                        28.113664177909335,
                        45.17564077123743
                    ],
                    [
                        28.097696161758797,
                        45.18416738655552
                    ],
                    [
                        28.10296715737605,
                        45.203546049104084
                    ],
                    [
                        28.117901646723386,
                        45.22447500615633
                    ],
                    [
                        28.130769075420186,
                        45.237704160764885
                    ],
                    [
                        28.126893346007236,
                        45.244525464134156
                    ],
                    [
                        28.122397493449263,
                        45.24977060813573
                    ],
                    [
                        28.116971470803044,
                        45.2540856013015
                    ],
                    [
                        28.110253532581993,
                        45.25821970671018
                    ],
                    [
                        28.075526971073675,
                        45.24822032358817
                    ],
                    [
                        28.041317173816566,
                        45.25842642270356
                    ],
                    [
                        27.986746860465242,
                        45.29232616110991
                    ],
                    [
                        27.9997693210005,
                        45.30674388274917
                    ],
                    [
                        28.004316847972856,
                        45.3128417060098
                    ],
                    [
                        28.00938113643671,
                        45.32806039944651
                    ],
                    [
                        28.010828078799296,
                        45.330308338606265
                    ],
                    [
                        28.019199661468917,
                        45.341108716020514
                    ],
                    [
                        28.020904980725394,
                        45.34446767090336
                    ],
                    [
                        28.02168012781982,
                        45.34813669705518
                    ],
                    [
                        28.024005571421352,
                        45.37769564361235
                    ],
                    [
                        28.026020949105636,
                        45.38632559022646
                    ],
                    [
                        28.030206737056787,
                        45.39542062443479
                    ],
                    [
                        28.043694287793777,
                        45.41128529728531
                    ],
                    [
                        28.051135697956344,
                        45.41503186369255
                    ],
                    [
                        28.061367628900257,
                        45.41611705001431
                    ],
                    [
                        28.104982538053047,
                        45.42663320667917
                    ],
                    [
                        28.115834588630992,
                        45.42797679791733
                    ],
                    [
                        28.12487796231251,
                        45.428028456950905
                    ],
                    [
                        28.142241245826764,
                        45.42423025589667
                    ],
                    [
                        28.17123172567692,
                        45.414385899995864
                    ],
                    [
                        28.181670363727047,
                        45.41301647132081
                    ],
                    [
                        28.18709638980072,
                        45.414385899995864
                    ],
                    [
                        28.190817090752287,
                        45.41702138070549
                    ],
                    [
                        28.19438276410866,
                        45.42342926296006
                    ],
                    [
                        28.19608808837142,
                        45.42872610314253
                    ],
                    [
                        28.199808792128668,
                        45.4369168222393
                    ],
                    [
                        28.213761426671073,
                        45.44880238674463
                    ],
                    [
                        28.215146089244747,
                        45.45036509518032
                    ],
                    [
                        28.237635132438125,
                        45.45205882057043
                    ],
                    [
                        28.26688399500017,
                        45.44048330872532
                    ],
                    [
                        28.285241974685047,
                        45.42285379409934
                    ],
                    [
                        28.284835284901618,
                        45.42126821942323
                    ],
                    [
                        28.283982506301793,
                        45.418315344768864
                    ],
                    [
                        28.283442141829802,
                        45.41668532014019
                    ],
                    [
                        28.283164462624587,
                        45.41494709379911
                    ],
                    [
                        28.283362491786306,
                        45.412573582747065
                    ],
                    [
                        28.283387869970344,
                        45.41017546274788
                    ],
                    [
                        28.283411619781077,
                        45.40793129444189
                    ],
                    [
                        28.282608560275104,
                        45.4043850363397
                    ],
                    [
                        28.282061323533824,
                        45.401792122857735
                    ],
                    [
                        28.281878759234353,
                        45.40058848787323
                    ],
                    [
                        28.281799574225847,
                        45.40006642959597
                    ],
                    [
                        28.28220761581088,
                        45.397606334297485
                    ],
                    [
                        28.28339643618436,
                        45.39551200448778
                    ],
                    [
                        28.285770102414645,
                        45.39299034370294
                    ],
                    [
                        28.286225719677446,
                        45.39266076606345
                    ],
                    [
                        28.310808960727375,
                        45.347827458265115
                    ],
                    [
                        28.330239296257986,
                        45.32291940278584
                    ],
                    [
                        28.353286986416332,
                        45.31242909457966
                    ],
                    [
                        28.370236857076,
                        45.309225159444935
                    ],
                    [
                        28.40517012490744,
                        45.295065816458234
                    ],
                    [
                        28.465607637497953,
                        45.28408036541342
                    ],
                    [
                        28.469393003217178,
                        45.282461007107216
                    ],
                    [
                        28.473992000589945,
                        45.28086801028256
                    ],
                    [
                        28.48029100167633,
                        45.27880700294766
                    ],
                    [
                        28.48897699910577,
                        45.27591300745305
                    ],
                    [
                        28.497813001467648,
                        45.27341900856268
                    ],
                    [
                        28.49833800021281,
                        45.27327300024143
                    ],
                    [
                        28.514458998659006,
                        45.26772399901106
                    ],
                    [
                        28.521618000087877,
                        45.26526200634273
                    ],
                    [
                        28.527876000697532,
                        45.26393200406604
                    ],
                    [
                        28.532847999892926,
                        45.26236799837563
                    ],
                    [
                        28.53961700141092,
                        45.25944200239437
                    ],
                    [
                        28.54621000053053,
                        45.25639299726421
                    ],
                    [
                        28.54821999971736,
                        45.25524099835289
                    ],
                    [
                        28.551734999783424,
                        45.25322199873795
                    ],
                    [
                        28.555447001121006,
                        45.25103000752978
                    ],
                    [
                        28.559079999674328,
                        45.24900999810279
                    ],
                    [
                        28.562703000552723,
                        45.24827700321883
                    ],
                    [
                        28.569133000978802,
                        45.24773900569909
                    ],
                    [
                        28.575892999454176,
                        45.24737599682212
                    ],
                    [
                        28.587961314927657,
                        45.246357525230266
                    ],
                    [
                        28.68213787968595,
                        45.23139318690335
                    ],
                    [
                        28.68630899861024,
                        45.22970999773865
                    ],
                    [
                        28.68944099749296,
                        45.228619991257894
                    ],
                    [
                        28.69187000144422,
                        45.22764800357636
                    ],
                    [
                        28.698766997638113,
                        45.22575899210211
                    ],
                    [
                        28.703801000460533,
                        45.22464100267
                    ],
                    [
                        28.709767998590202,
                        45.22405599282715
                    ],
                    [
                        28.714285999641547,
                        45.22400300471832
                    ],
                    [
                        28.718866999501156,
                        45.224316997108936
                    ],
                    [
                        28.723041000140455,
                        45.225531006607895
                    ],
                    [
                        28.728143001848938,
                        45.227488005917685
                    ],
                    [
                        28.732200151652528,
                        45.22904139815225
                    ],
                    [
                        28.734346000426797,
                        45.22986300247142
                    ],
                    [
                        28.739041000462045,
                        45.231407002675176
                    ],
                    [
                        28.743333999916253,
                        45.23270499951489
                    ],
                    [
                        28.746347000313552,
                        45.233580996026184
                    ],
                    [
                        28.748317997856056,
                        45.233671993378444
                    ],
                    [
                        28.751910999634774,
                        45.233945004673316
                    ],
                    [
                        28.757128001449484,
                        45.234630008387086
                    ],
                    [
                        28.762221998867144,
                        45.23527599244588
                    ],
                    [
                        28.766742998495026,
                        45.235668991294425
                    ],
                    [
                        28.7708579984573,
                        45.235937991077826
                    ],
                    [
                        28.7739900006048,
                        45.23632200927994
                    ],
                    [
                        28.77735299905702,
                        45.236544994547266
                    ],
                    [
                        28.781639001201608,
                        45.23718400694645
                    ],
                    [
                        28.78465700146683,
                        45.23818500747865
                    ],
                    [
                        28.787149999589847,
                        45.239306991849496
                    ],
                    [
                        28.790050999493538,
                        45.241046997072836
                    ],
                    [
                        28.791386999684462,
                        45.24220099817651
                    ],
                    [
                        28.792079998734156,
                        45.243601993685424
                    ],
                    [
                        28.792258000680956,
                        45.24540800393426
                    ],
                    [
                        28.791915000623533,
                        45.247047003602326
                    ],
                    [
                        28.79145718167845,
                        45.24779847528456
                    ],
                    [
                        28.790818999414018,
                        45.24884599761399
                    ],
                    [
                        28.78838799965296,
                        45.250925992216324
                    ],
                    [
                        28.78526200054429,
                        45.25362099736655
                    ],
                    [
                        28.78086400063756,
                        45.25618200168418
                    ],
                    [
                        28.775590001564314,
                        45.25824800904124
                    ],
                    [
                        28.77019999942924,
                        45.26027099091967
                    ],
                    [
                        28.766785001462225,
                        45.26251000845336
                    ],
                    [
                        28.764641997493285,
                        45.264468992288876
                    ],
                    [
                        28.762675998447992,
                        45.26622199202664
                    ],
                    [
                        28.761972016379982,
                        45.266996147421104
                    ],
                    [
                        28.759670450392978,
                        45.274188534489774
                    ],
                    [
                        28.761530803744975,
                        45.281836654305785
                    ],
                    [
                        28.787182715035847,
                        45.29100466527295
                    ],
                    [
                        28.787474000736008,
                        45.29101200424944
                    ],
                    [
                        28.789741999843542,
                        45.29158499909651
                    ],
                    [
                        28.791602999976824,
                        45.2926080056386
                    ],
                    [
                        28.79323500011695,
                        45.293819994902634
                    ],
                    [
                        28.795419999898442,
                        45.295404999413705
                    ],
                    [
                        28.797808998528353,
                        45.29735599050701
                    ],
                    [
                        28.799675002646204,
                        45.29891000949924
                    ],
                    [
                        28.80165999870955,
                        45.30079999255421
                    ],
                    [
                        28.802694999267693,
                        45.30189899577483
                    ],
                    [
                        28.80373200251454,
                        45.30322400773732
                    ],
                    [
                        28.804410000860376,
                        45.304689004963
                    ],
                    [
                        28.805246001122757,
                        45.30716300547618
                    ],
                    [
                        28.805327999085357,
                        45.30893399472411
                    ],
                    [
                        28.805055001899035,
                        45.31039199941727
                    ],
                    [
                        28.804462999152616,
                        45.31142700187996
                    ],
                    [
                        28.803193001575945,
                        45.31259900908994
                    ],
                    [
                        28.801413001370577,
                        45.313770006905926
                    ],
                    [
                        28.79950999885757,
                        45.31465899440943
                    ],
                    [
                        28.79677000133223,
                        45.315741007685624
                    ],
                    [
                        28.793556000290433,
                        45.316930000675605
                    ],
                    [
                        28.790382999252007,
                        45.31784399568355
                    ],
                    [
                        28.78948676101201,
                        45.31815504500681
                    ],
                    [
                        28.789746133048727,
                        45.321420791511144
                    ],
                    [
                        28.81630782296416,
                        45.32607169308476
                    ],
                    [
                        28.831810747817418,
                        45.32229928442505
                    ],
                    [
                        28.858114054924634,
                        45.309070135323154
                    ],
                    [
                        28.880851685035925,
                        45.30617625495972
                    ],
                    [
                        28.893615762018396,
                        45.29982004335401
                    ],
                    [
                        28.91004886793511,
                        45.28736602187698
                    ],
                    [
                        28.929892618302322,
                        45.279097800736764
                    ],
                    [
                        28.93178424891869,
                        45.2795920007716
                    ],
                    [
                        28.93254376076882,
                        45.27946582767145
                    ],
                    [
                        28.935491654885485,
                        45.27928514908749
                    ],
                    [
                        28.937493488583794,
                        45.27931360586326
                    ],
                    [
                        28.94007778007437,
                        45.27940566517178
                    ],
                    [
                        28.94311306274814,
                        45.27998527429699
                    ],
                    [
                        28.94563130170939,
                        45.28100370133079
                    ],
                    [
                        28.948122193251645,
                        45.28240694070206
                    ],
                    [
                        28.949980158754812,
                        45.283887682591725
                    ],
                    [
                        28.950559220561427,
                        45.284497189028336
                    ],
                    [
                        28.952836954376263,
                        45.28509226715961
                    ],
                    [
                        28.957384481561988,
                        45.29201691022526
                    ],
                    [
                        28.960433390254384,
                        45.3112922174589
                    ],
                    [
                        28.966479532928755,
                        45.31987050359129
                    ],
                    [
                        28.973662558965643,
                        45.32369457126849
                    ],
                    [
                        28.982447553121148,
                        45.325503252887
                    ],
                    [
                        29.0046167429835,
                        45.32607169308476
                    ],
                    [
                        29.018155966830943,
                        45.330877588755435
                    ],
                    [
                        29.069522338051982,
                        45.36079823258675
                    ],
                    [
                        29.110295042819633,
                        45.36906646697116
                    ],
                    [
                        29.127503298965117,
                        45.37454418689124
                    ],
                    [
                        29.141869347312486,
                        45.38508617985691
                    ],
                    [
                        29.150137572217435,
                        45.387876684546306
                    ],
                    [
                        29.174322145393596,
                        45.38896190760986
                    ],
                    [
                        29.179386436334006,
                        45.39185578726772
                    ],
                    [
                        29.183107140042264,
                        45.39898713928976
                    ],
                    [
                        29.191582068992446,
                        45.40617012891452
                    ],
                    [
                        29.20667159054796,
                        45.41542023011006
                    ],
                    [
                        29.212106648710243,
                        45.41752369411432
                    ],
                    [
                        29.21235557054292,
                        45.41754399773044
                    ],
                    [
                        29.21403208628779,
                        45.41790196863303
                    ],
                    [
                        29.21561518443074,
                        45.4185022837695
                    ],
                    [
                        29.219040320142508,
                        45.41987815613436
                    ],
                    [
                        29.222071699821726,
                        45.42138036839568
                    ],
                    [
                        29.228168985686473,
                        45.42374013122159
                    ],
                    [
                        29.24460208914816,
                        45.424205210502684
                    ],
                    [
                        29.260828488255115,
                        45.42203479444897
                    ],
                    [
                        29.28180912329453,
                        45.422293200328035
                    ],
                    [
                        29.290490762785222,
                        45.42461863178402
                    ],
                    [
                        29.299275755850964,
                        45.42890777049924
                    ],
                    [
                        29.30702722328572,
                        45.43412710227023
                    ],
                    [
                        29.312814984634333,
                        45.43934642989205
                    ],
                    [
                        29.322116740244596,
                        45.443842266381914
                    ],
                    [
                        29.332968792826637,
                        45.44213695331866
                    ],
                    [
                        29.3439241975501,
                        45.4381061954011
                    ],
                    [
                        29.353742717842014,
                        45.43593577575368
                    ],
                    [
                        29.430637246959797,
                        45.4304063861417
                    ],
                    [
                        29.56969852437673,
                        45.394956345284804
                    ],
                    [
                        29.616362348561033,
                        45.36534577935097
                    ],
                    [
                        29.620241292117804,
                        45.36384864489181
                    ],
                    [
                        29.621033002192124,
                        45.36307301228265
                    ],
                    [
                        29.626706999601904,
                        45.35784999676926
                    ],
                    [
                        29.629040997993943,
                        45.35589798876082
                    ],
                    [
                        29.630423999536458,
                        45.35462400300507
                    ],
                    [
                        29.63301199965841,
                        45.35249099248396
                    ],
                    [
                        29.635097001937215,
                        45.35108401645388
                    ],
                    [
                        29.63939499704009,
                        45.34826698342006
                    ],
                    [
                        29.6423640010929,
                        45.34612900052024
                    ],
                    [
                        29.646091998406337,
                        45.34358599207404
                    ],
                    [
                        29.646407955744404,
                        45.34338349256814
                    ],
                    [
                        29.65008551690311,
                        45.34085082425655
                    ],
                    [
                        29.65088287451891,
                        45.340190804106044
                    ],
                    [
                        29.651321099987367,
                        45.33963205292888
                    ],
                    [
                        29.651315424262442,
                        45.33881258326897
                    ],
                    [
                        29.65138055378429,
                        45.338166672990795
                    ],
                    [
                        29.65184124677489,
                        45.33768484054007
                    ],
                    [
                        29.652816576238767,
                        45.33717995693721
                    ],
                    [
                        29.653600863491665,
                        45.33670756815301
                    ],
                    [
                        29.65490644963809,
                        45.33564076757296
                    ],
                    [
                        29.655552430739856,
                        45.334764193543045
                    ],
                    [
                        29.65623432224447,
                        45.33373623816906
                    ],
                    [
                        29.65700933473492,
                        45.33204415091543
                    ],
                    [
                        29.657708914914117,
                        45.32979731011885
                    ],
                    [
                        29.65840395204704,
                        45.32762651706288
                    ],
                    [
                        29.659140551767255,
                        45.32566655989672
                    ],
                    [
                        29.66053068136812,
                        45.32269680686074
                    ],
                    [
                        29.66203285302712,
                        45.31919685375212
                    ],
                    [
                        29.664029024263666,
                        45.3155588784764
                    ],
                    [
                        29.66655642629664,
                        45.31252704866103
                    ],
                    [
                        29.66711824603022,
                        45.311788045465825
                    ],
                    [
                        29.672276245165136,
                        45.272948303925226
                    ],
                    [
                        29.66763502081709,
                        45.2626897236102
                    ],
                    [
                        29.66440063565733,
                        45.260467159078694
                    ],
                    [
                        29.663594547531954,
                        45.25949090576887
                    ],
                    [
                        29.662526663329082,
                        45.25745906084496
                    ],
                    [
                        29.66135320920493,
                        45.254928719756656
                    ],
                    [
                        29.660736937430674,
                        45.253336563415075
                    ],
                    [
                        29.660382082573456,
                        45.25257019421572
                    ],
                    [
                        29.660280406042506,
                        45.25235060123828
                    ],
                    [
                        29.660255888823457,
                        45.25227307200972
                    ],
                    [
                        29.660244160023804,
                        45.2522359795251
                    ],
                    [
                        29.659761686283726,
                        45.24987104959116
                    ],
                    [
                        29.659694016859216,
                        45.24872585421012
                    ],
                    [
                        29.65989449949484,
                        45.247607568775145
                    ],
                    [
                        29.660272041061866,
                        45.24641519829062
                    ],
                    [
                        29.6603248875965,
                        45.246248313345426
                    ],
                    [
                        29.661109588946882,
                        45.24436591809316
                    ],
                    [
                        29.66133025825,
                        45.24336255101112
                    ],
                    [
                        29.661454370376468,
                        45.24216579850234
                    ],
                    [
                        29.661507584049822,
                        45.24168737371722
                    ],
                    [
                        29.66156844237494,
                        45.241140251102934
                    ],
                    [
                        29.66187877289005,
                        45.23998705577378
                    ],
                    [
                        29.662704911108772,
                        45.23831546660995
                    ],
                    [
                        29.664774211301197,
                        45.23475580368915
                    ],
                    [
                        29.66604162405844,
                        45.232782563019
                    ],
                    [
                        29.66648848535153,
                        45.23062531358094
                    ],
                    [
                        29.664214720643503,
                        45.22318389699918
                    ],
                    [
                        29.659027541378244,
                        45.21588776973493
                    ],
                    [
                        29.650157098119415,
                        45.21723054228383
                    ],
                    [
                        29.62387128834145,
                        45.216498104680376
                    ],
                    [
                        29.623871289848353,
                        45.210272527147566
                    ],
                    [
                        29.63884524829596,
                        45.19562409266267
                    ],
                    [
                        29.649750195400284,
                        45.17780182163031
                    ],
                    [
                        29.667002799524976,
                        45.16421132733192
                    ],
                    [
                        29.699554884459225,
                        45.16181061657625
                    ],
                    [
                        29.67652428448554,
                        45.144598697110006
                    ],
                    [
                        29.664398633233265,
                        45.11692942468909
                    ],
                    [
                        29.65626061297753,
                        45.02895742387297
                    ],
                    [
                        29.650726758977,
                        45.01211172087007
                    ],
                    [
                        29.637543191065067,
                        44.983710175029145
                    ],
                    [
                        29.6349389812224,
                        44.969549777327
                    ],
                    [
                        29.63363689234746,
                        44.95335508213219
                    ],
                    [
                        29.63086997443945,
                        44.93866600642613
                    ],
                    [
                        29.623871278151647,
                        44.92910384106708
                    ],
                    [
                        29.630381720877345,
                        44.907660301408065
                    ],
                    [
                        29.605153818772777,
                        44.88003151158393
                    ],
                    [
                        29.617849135239364,
                        44.86147684320636
                    ],
                    [
                        29.61117600387278,
                        44.84931076609829
                    ],
                    [
                        29.603200731027005,
                        44.845404443419234
                    ],
                    [
                        29.59376061960436,
                        44.844305768405476
                    ],
                    [
                        29.58350669079406,
                        44.84027731917328
                    ],
                    [
                        29.56934656657402,
                        44.82489664598419
                    ],
                    [
                        29.561778185797344,
                        44.820257850487295
                    ],
                    [
                        29.542002812622744,
                        44.82782631064041
                    ],
                    [
                        29.531097848386327,
                        44.826239304482
                    ],
                    [
                        29.520518400008722,
                        44.82249569304386
                    ],
                    [
                        29.510996917022887,
                        44.82050188375515
                    ],
                    [
                        29.315928568238586,
                        44.79877342625055
                    ],
                    [
                        29.192067883009052,
                        44.7928733136094
                    ],
                    [
                        29.156097832480626,
                        44.78440978565762
                    ],
                    [
                        29.05583741010707,
                        44.735174722318455
                    ],
                    [
                        29.026377799143987,
                        44.71466705404446
                    ],
                    [
                        29.00074305756946,
                        44.68891035383529
                    ],
                    [
                        28.993907121649,
                        44.69635665490308
                    ],
                    [
                        28.994883643058564,
                        44.71112692181274
                    ],
                    [
                        28.981293185451364,
                        44.72943768554186
                    ],
                    [
                        28.974945512005142,
                        44.74494051441694
                    ],
                    [
                        28.997325076221017,
                        44.751613733185316
                    ],
                    [
                        29.021495008037164,
                        44.75470623792299
                    ],
                    [
                        29.05827882186698,
                        44.76829650069975
                    ],
                    [
                        29.098155123983833,
                        44.77537657954882
                    ],
                    [
                        29.120616086313017,
                        44.786566497851936
                    ],
                    [
                        29.138682481238792,
                        44.80402248907749
                    ],
                    [
                        29.144704607105854,
                        44.82664613456055
                    ],
                    [
                        29.138845227182532,
                        44.839178658241075
                    ],
                    [
                        29.12598716019929,
                        44.85248435683816
                    ],
                    [
                        29.096364765542567,
                        44.875067366763936
                    ],
                    [
                        29.101817250153545,
                        44.85911690685194
                    ],
                    [
                        29.103363474303162,
                        44.85130441346986
                    ],
                    [
                        29.103770363056867,
                        44.84027731917328
                    ],
                    [
                        29.0879012171584,
                        44.84271869690004
                    ],
                    [
                        29.07349693098341,
                        44.835435231242485
                    ],
                    [
                        29.060313325221852,
                        44.832342715359324
                    ],
                    [
                        29.048594593992664,
                        44.84715402164787
                    ],
                    [
                        29.044118661822647,
                        44.86554582652807
                    ],
                    [
                        29.04175864406589,
                        44.92568584817603
                    ],
                    [
                        29.05209392431349,
                        44.94464740311482
                    ],
                    [
                        29.098806161501127,
                        44.956976489177805
                    ],
                    [
                        29.110606294043635,
                        44.97003802687349
                    ],
                    [
                        29.101735865754858,
                        44.98029201737588
                    ],
                    [
                        29.058278842004597,
                        45.00096263202622
                    ],
                    [
                        29.04517662901582,
                        45.004828192090564
                    ],
                    [
                        29.0144149100158,
                        45.004828192090564
                    ],
                    [
                        28.98324628993922,
                        45.01227448064926
                    ],
                    [
                        28.97282962305637,
                        45.0109723983248
                    ],
                    [
                        28.969248894025316,
                        45.00584544514556
                    ],
                    [
                        28.966075078865366,
                        44.99656817523634
                    ],
                    [
                        28.96021568174587,
                        44.98769760458127
                    ],
                    [
                        28.94922938845974,
                        44.983710175029145
                    ],
                    [
                        28.927012570969143,
                        44.98261142371896
                    ],
                    [
                        28.916840063265642,
                        44.979681842518715
                    ],
                    [
                        28.88005619969154,
                        44.95477944329944
                    ],
                    [
                        28.86939540415947,
                        44.943345590804284
                    ],
                    [
                        28.863535979052802,
                        44.922308516339555
                    ],
                    [
                        28.865082207381153,
                        44.91657124223089
                    ],
                    [
                        28.874359596810795,
                        44.91156662264101
                    ],
                    [
                        28.876638207631316,
                        44.90485255168118
                    ],
                    [
                        28.874685078488326,
                        44.89911522364692
                    ],
                    [
                        28.870127795125992,
                        44.896429726730034
                    ],
                    [
                        28.865489103581098,
                        44.89467993253871
                    ],
                    [
                        28.863536003714376,
                        44.891546940342394
                    ],
                    [
                        28.86646571499809,
                        44.882635948244584
                    ],
                    [
                        28.87354577641953,
                        44.87498611304574
                    ],
                    [
                        28.881521039204546,
                        44.86969640939279
                    ],
                    [
                        28.90406335136036,
                        44.86273837327632
                    ],
                    [
                        28.952403175210755,
                        44.82664613456055
                    ],
                    [
                        28.9397078605683,
                        44.81688049419083
                    ],
                    [
                        28.93409262416023,
                        44.814194939003016
                    ],
                    [
                        28.924978060664923,
                        44.81305572905697
                    ],
                    [
                        28.934418169391357,
                        44.80752190245608
                    ],
                    [
                        28.938731338865882,
                        44.806219926535164
                    ],
                    [
                        28.938731302415665,
                        44.79877342625055
                    ],
                    [
                        28.926280150217607,
                        44.792954856062785
                    ],
                    [
                        28.92546633696117,
                        44.78367744676755
                    ],
                    [
                        28.932953304456838,
                        44.773504854032545
                    ],
                    [
                        28.94613691980906,
                        44.76520419688885
                    ],
                    [
                        28.936371270261464,
                        44.75995503047962
                    ],
                    [
                        28.923838719229632,
                        44.75779846104492
                    ],
                    [
                        28.879405145541487,
                        44.756577875961234
                    ],
                    [
                        28.86882573287107,
                        44.75356689130825
                    ],
                    [
                        28.80844157598042,
                        44.726873939269886
                    ],
                    [
                        28.79835044170261,
                        44.720200824751984
                    ],
                    [
                        28.788828979681252,
                        44.706244252840385
                    ],
                    [
                        28.787120012935432,
                        44.6933049006109
                    ],
                    [
                        28.793711792845052,
                        44.68789301680544
                    ],
                    [
                        28.808360246491258,
                        44.69635665490308
                    ],
                    [
                        28.804209854283354,
                        44.68423099107014
                    ],
                    [
                        28.785410992660005,
                        44.67967350375752
                    ]
                ]
            ]
        },
        "type": "Feature",
        "properties": {
            "source": "https://simplemaps.com",
            "id": "ROTL",
            "name": "Tulcea"
        },
        "id": 19
    },
    {
        "geometry": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        22.802773887451266,
                        46.5569001918347
                    ],
                    [
                        22.80354902588782,
                        46.5943138791118
                    ],
                    [
                        22.807889852657162,
                        46.61937699066421
                    ],
                    [
                        22.80339398811175,
                        46.62736089309847
                    ],
                    [
                        22.79388552238946,
                        46.63379459415408
                    ],
                    [
                        22.78272341381846,
                        46.63896224115097
                    ],
                    [
                        22.77342166727075,
                        46.64464673037239
                    ],
                    [
                        22.764274935977312,
                        46.65699737774687
                    ],
                    [
                        22.74691164752506,
                        46.70355779608094
                    ],
                    [
                        22.733837510888616,
                        46.72428004871789
                    ],
                    [
                        22.72081505370234,
                        46.73885283031505
                    ],
                    [
                        22.68081750651096,
                        46.7636575968394
                    ],
                    [
                        22.668828564746395,
                        46.77531056576549
                    ],
                    [
                        22.66619307524333,
                        46.784354004746355
                    ],
                    [
                        22.66805342473754,
                        46.79257053239159
                    ],
                    [
                        22.673634480588802,
                        46.799934443581755
                    ],
                    [
                        22.68221276706421,
                        46.806652364533775
                    ],
                    [
                        22.693529892488765,
                        46.81233667808358
                    ],
                    [
                        22.730271848187375,
                        46.823421358821776
                    ],
                    [
                        22.739160199784052,
                        46.82840816755888
                    ],
                    [
                        22.74598147093333,
                        46.835177659044
                    ],
                    [
                        22.751252465689912,
                        46.84331668377504
                    ],
                    [
                        22.7566784981988,
                        46.85419462938804
                    ],
                    [
                        22.761329385392727,
                        46.86587356071212
                    ],
                    [
                        22.76567019500299,
                        46.8843736508771
                    ],
                    [
                        22.76024417253651,
                        46.89481230562803
                    ],
                    [
                        22.747686791352205,
                        46.90212446389699
                    ],
                    [
                        22.696785505191794,
                        46.91558617287944
                    ],
                    [
                        22.688258910264516,
                        46.92028884055913
                    ],
                    [
                        22.686553589852153,
                        46.92687760584371
                    ],
                    [
                        22.689964227085976,
                        46.936075957783764
                    ],
                    [
                        22.71182335283442,
                        46.965402295253135
                    ],
                    [
                        22.719419783226634,
                        46.97935490036344
                    ],
                    [
                        22.731253691182186,
                        46.97615099264579
                    ],
                    [
                        22.85057458199611,
                        46.974807462638275
                    ],
                    [
                        22.868247908133444,
                        46.97232690157742
                    ],
                    [
                        22.8792549971505,
                        46.96845123606374
                    ],
                    [
                        22.889176870819153,
                        46.96261178541135
                    ],
                    [
                        22.89692833612169,
                        46.95346506195549
                    ],
                    [
                        22.91356815544178,
                        46.92338942828308
                    ],
                    [
                        22.92426517756023,
                        46.91039281142861
                    ],
                    [
                        22.934497106274613,
                        46.90194367775529
                    ],
                    [
                        22.9472095026046,
                        46.89855883300991
                    ],
                    [
                        22.984313180231997,
                        46.89610420142987
                    ],
                    [
                        22.993769966976245,
                        46.893778761977124
                    ],
                    [
                        23.00074627993698,
                        46.88954125211822
                    ],
                    [
                        23.005552196853163,
                        46.88390857848495
                    ],
                    [
                        23.010823184377934,
                        46.87910261350284
                    ],
                    [
                        23.01847130776799,
                        46.87569205113923
                    ],
                    [
                        23.027928100175046,
                        46.87533035485523
                    ],
                    [
                        23.049632193771274,
                        46.878275849101264
                    ],
                    [
                        23.061879510924935,
                        46.878482578401126
                    ],
                    [
                        23.07324831934042,
                        46.87706143231507
                    ],
                    [
                        23.08425539489894,
                        46.87419335638046
                    ],
                    [
                        23.0989831809945,
                        46.8719712830567
                    ],
                    [
                        23.116036415525212,
                        46.87367669379427
                    ],
                    [
                        23.13562176993237,
                        46.87853418395268
                    ],
                    [
                        23.14988446547986,
                        46.88054957146709
                    ],
                    [
                        23.161356636585467,
                        46.87974860625144
                    ],
                    [
                        23.184042588256638,
                        46.87362493542948
                    ],
                    [
                        23.196444929768624,
                        46.87419335638046
                    ],
                    [
                        23.205591662552724,
                        46.87806911993313
                    ],
                    [
                        23.208537216262208,
                        46.88644068148887
                    ],
                    [
                        23.206676875548812,
                        46.89455395780506
                    ],
                    [
                        23.207141969237757,
                        46.902615520731956
                    ],
                    [
                        23.209932480956606,
                        46.90974675756701
                    ],
                    [
                        23.223420049089917,
                        46.92824704995231
                    ],
                    [
                        23.230241336673675,
                        46.9353783915474
                    ],
                    [
                        23.242333620886647,
                        46.936541105189555
                    ],
                    [
                        23.25075686160043,
                        46.93279444483933
                    ],
                    [
                        23.257268105367093,
                        46.925017229549475
                    ],
                    [
                        23.263624294064435,
                        46.90974675756701
                    ],
                    [
                        23.269050319846723,
                        46.905070048079196
                    ],
                    [
                        23.277731960083567,
                        46.90364893898837
                    ],
                    [
                        23.298867621683183,
                        46.90829982278625
                    ],
                    [
                        23.309409631221317,
                        46.9086875146554
                    ],
                    [
                        23.317626181382217,
                        46.9065429270246
                    ],
                    [
                        23.32444745554795,
                        46.901633561405866
                    ],
                    [
                        23.330803663583357,
                        46.89584585257652
                    ],
                    [
                        23.337779976902578,
                        46.89134997041485
                    ],
                    [
                        23.34723677398758,
                        46.89176344581812
                    ],
                    [
                        23.3561251090903,
                        46.89623337593382
                    ],
                    [
                        23.364651725404922,
                        46.91031524188824
                    ],
                    [
                        23.364961776371988,
                        46.9193843992722
                    ],
                    [
                        23.360775995877734,
                        46.92855703821905
                    ],
                    [
                        23.350233993700343,
                        46.935740001339425
                    ],
                    [
                        23.34134565019925,
                        46.94351732143455
                    ],
                    [
                        23.337779976228134,
                        46.95227647861061
                    ],
                    [
                        23.34212081315459,
                        46.95909787292143
                    ],
                    [
                        23.35674523399275,
                        46.963697014947336
                    ],
                    [
                        23.366977159913798,
                        46.963464421559166
                    ],
                    [
                        23.38387537114534,
                        46.95922707262709
                    ],
                    [
                        23.389611449526498,
                        46.960906519892205
                    ],
                    [
                        23.393332149094377,
                        46.9736705748512
                    ],
                    [
                        23.397827990754305,
                        46.97976833491775
                    ],
                    [
                        23.409661890773357,
                        46.98431584285422
                    ],
                    [
                        23.421444129740543,
                        46.98555616726856
                    ],
                    [
                        23.44392336249512,
                        46.985065137731475
                    ],
                    [
                        23.457100873033713,
                        46.985969609804556
                    ],
                    [
                        23.471725285919753,
                        46.988760015156245
                    ],
                    [
                        23.481802200975306,
                        46.994857908082274
                    ],
                    [
                        23.485677925249274,
                        47.004469672702974
                    ],
                    [
                        23.48412763370198,
                        47.01222115206343
                    ],
                    [
                        23.475135929675165,
                        47.0342352766137
                    ],
                    [
                        23.470485067783105,
                        47.04092749099631
                    ],
                    [
                        23.45679081473566,
                        47.05268388346997
                    ],
                    [
                        23.45338016169032,
                        47.059117543423476
                    ],
                    [
                        23.45446536997531,
                        47.06580966486342
                    ],
                    [
                        23.45989139661257,
                        47.07071892865905
                    ],
                    [
                        23.480251915077748,
                        47.07487891468102
                    ],
                    [
                        23.486763142341694,
                        47.07774693772956
                    ],
                    [
                        23.488778522826934,
                        47.08312128477765
                    ],
                    [
                        23.495289757233053,
                        47.094438447398964
                    ],
                    [
                        23.502731147541976,
                        47.103791774692816
                    ],
                    [
                        23.50397139761356,
                        47.11252519730472
                    ],
                    [
                        23.505986777033254,
                        47.12058671232236
                    ],
                    [
                        23.509552453176198,
                        47.12689124916797
                    ],
                    [
                        23.555337767524485,
                        47.13944859055334
                    ],
                    [
                        23.577817005774776,
                        47.14978381231435
                    ],
                    [
                        23.5908911491975,
                        47.15236767053348
                    ],
                    [
                        23.60205324845135,
                        47.15190251608207
                    ],
                    [
                        23.61244021187784,
                        47.148956963698275
                    ],
                    [
                        23.62189699867587,
                        47.148956963698275
                    ],
                    [
                        23.63032025622047,
                        47.1530910746855
                    ],
                    [
                        23.63745161770879,
                        47.16564853406257
                    ],
                    [
                        23.646288278687486,
                        47.177559897079014
                    ],
                    [
                        23.66194623275249,
                        47.18978133741493
                    ],
                    [
                        23.696724476592898,
                        47.20270047981186
                    ],
                    [
                        23.729435656967528,
                        47.209831817808436
                    ],
                    [
                        23.788708536355177,
                        47.21427607123553
                    ],
                    [
                        23.80410810059308,
                        47.218461777201625
                    ],
                    [
                        23.811859564712215,
                        47.227401791859876
                    ],
                    [
                        23.81108443693338,
                        47.246728900008236
                    ],
                    [
                        23.8158903451398,
                        47.26559080142801
                    ],
                    [
                        23.82069623853201,
                        47.27745044122713
                    ],
                    [
                        23.827052438464985,
                        47.286261269281184
                    ],
                    [
                        23.828757760874588,
                        47.29409024945665
                    ],
                    [
                        23.8284477160834,
                        47.30083411347577
                    ],
                    [
                        23.812944787409076,
                        47.31651791802219
                    ],
                    [
                        23.84147016839891,
                        47.33323517877108
                    ],
                    [
                        24.007506555153213,
                        47.324605279802064
                    ],
                    [
                        23.998204787687605,
                        47.295976474353154
                    ],
                    [
                        23.987662793166532,
                        47.28445261024748
                    ],
                    [
                        23.97464032308672,
                        47.27411726523181
                    ],
                    [
                        23.942187524929494,
                        47.25572046467092
                    ],
                    [
                        23.93629641884015,
                        47.245721122768046
                    ],
                    [
                        23.935986372754435,
                        47.23380979186365
                    ],
                    [
                        23.940017113694996,
                        47.223164305420006
                    ],
                    [
                        23.95071414058919,
                        47.16774136440232
                    ],
                    [
                        23.95536503404617,
                        47.15557165946542
                    ],
                    [
                        23.962341350221042,
                        47.145598095966854
                    ],
                    [
                        23.973090031829596,
                        47.13743311100855
                    ],
                    [
                        23.98580245358344,
                        47.1323689524852
                    ],
                    [
                        24.042749870178405,
                        47.12169768628384
                    ],
                    [
                        24.057787717485073,
                        47.11547071824483
                    ],
                    [
                        24.078561631141433,
                        47.1017505473966
                    ],
                    [
                        24.089465368316333,
                        47.09694470082195
                    ],
                    [
                        24.11240969180006,
                        47.08963240402788
                    ],
                    [
                        24.126982458720416,
                        47.082320275395325
                    ],
                    [
                        24.140831730955416,
                        47.06787663320051
                    ],
                    [
                        24.14517255997807,
                        47.0557327330435
                    ],
                    [
                        24.14377730064223,
                        47.043097869334126
                    ],
                    [
                        24.13891972316358,
                        47.03064390286222
                    ],
                    [
                        24.13612917947031,
                        47.017905546066174
                    ],
                    [
                        24.13571576573494,
                        47.00307439867228
                    ],
                    [
                        24.14362226014693,
                        46.996433985423714
                    ],
                    [
                        24.1611405824519,
                        46.98777825431383
                    ],
                    [
                        24.163155965517866,
                        46.98157709814342
                    ],
                    [
                        24.16083052783274,
                        46.97434241359403
                    ],
                    [
                        24.15943524679971,
                        46.966539153811446
                    ],
                    [
                        24.160830514535743,
                        46.95496366333759
                    ],
                    [
                        24.167806832939917,
                        46.94654040046584
                    ],
                    [
                        24.17989911952317,
                        46.940106694318644
                    ],
                    [
                        24.2149874097575,
                        46.926851645602056
                    ],
                    [
                        24.233590945776736,
                        46.9127957867615
                    ],
                    [
                        24.23870689940592,
                        46.89925647338907
                    ],
                    [
                        24.23669151992916,
                        46.88334014051251
                    ],
                    [
                        24.231110476699353,
                        46.869025846019156
                    ],
                    [
                        24.22475425481369,
                        46.82789127055641
                    ],
                    [
                        24.218708130591896,
                        46.81559240409776
                    ],
                    [
                        24.196849001886843,
                        46.784534879143884
                    ],
                    [
                        24.166411577337726,
                        46.78215772461793
                    ],
                    [
                        24.157264854953162,
                        46.7759049171276
                    ],
                    [
                        24.146412805824752,
                        46.76624142890578
                    ],
                    [
                        24.10930912336328,
                        46.71652868166045
                    ],
                    [
                        24.10481326481562,
                        46.70531482875426
                    ],
                    [
                        24.10465823885549,
                        46.69663321967441
                    ],
                    [
                        24.110704382196538,
                        46.689579388478975
                    ],
                    [
                        24.119541050967044,
                        46.68175040004924
                    ],
                    [
                        24.126362349502028,
                        46.67182858544136
                    ],
                    [
                        24.127447543809073,
                        46.65474945508928
                    ],
                    [
                        24.120781285030816,
                        46.643768220414806
                    ],
                    [
                        24.11116947685439,
                        46.637515426946784
                    ],
                    [
                        24.075150998757632,
                        46.63309705774918
                    ],
                    [
                        24.06212853423051,
                        46.62898875917497
                    ],
                    [
                        24.045540390530473,
                        46.617723235854015
                    ],
                    [
                        24.03592858139919,
                        46.60351227125622
                    ],
                    [
                        24.025334917494636,
                        46.58258334686388
                    ],
                    [
                        24.02316451154883,
                        46.57116287784832
                    ],
                    [
                        24.02554162498994,
                        46.5619644559895
                    ],
                    [
                        24.030967638704304,
                        46.5540062075591
                    ],
                    [
                        24.034068240861806,
                        46.54566057625716
                    ],
                    [
                        24.032828000523747,
                        46.53447258244716
                    ],
                    [
                        24.02626508055346,
                        46.528865607577195
                    ],
                    [
                        24.00487105331656,
                        46.519279730845675
                    ],
                    [
                        23.991693561676232,
                        46.510029649703036
                    ],
                    [
                        23.971694776135447,
                        46.488713072245794
                    ],
                    [
                        23.967457319332677,
                        46.47649166459429
                    ],
                    [
                        23.972624942500076,
                        46.465277744996754
                    ],
                    [
                        23.99541426318385,
                        46.449671560445346
                    ],
                    [
                        23.987817821635854,
                        46.44223011509035
                    ],
                    [
                        23.97107465573422,
                        46.43659737149132
                    ],
                    [
                        23.958000520650597,
                        46.43664906168435
                    ],
                    [
                        23.895937120743945,
                        46.450446637324795
                    ],
                    [
                        23.87562829459121,
                        46.45220372002276
                    ],
                    [
                        23.83914472564238,
                        46.44595081732263
                    ],
                    [
                        23.823951849080892,
                        46.444762219004716
                    ],
                    [
                        23.778941687226045,
                        46.445537438030584
                    ],
                    [
                        23.769174829473826,
                        46.443677007382114
                    ],
                    [
                        23.74979616872548,
                        46.4376308700824
                    ],
                    [
                        23.73796227293284,
                        46.43579640458202
                    ],
                    [
                        23.691091750544476,
                        46.43556387605213
                    ],
                    [
                        23.680084674380673,
                        46.43329013582635
                    ],
                    [
                        23.67403852587676,
                        46.42884592574237
                    ],
                    [
                        23.673573441329218,
                        46.42238639514417
                    ],
                    [
                        23.67605390902544,
                        46.41592683412304
                    ],
                    [
                        23.677914269635515,
                        46.40915727977587
                    ],
                    [
                        23.675898881430268,
                        46.40367952713979
                    ],
                    [
                        23.669387638264137,
                        46.40037215203145
                    ],
                    [
                        23.654969926087198,
                        46.40088899916271
                    ],
                    [
                        23.63869184989149,
                        46.40460970822143
                    ],
                    [
                        23.618176312666634,
                        46.414299079714986
                    ],
                    [
                        23.610734894322125,
                        46.424246708941475
                    ],
                    [
                        23.609184603864726,
                        46.43285085048185
                    ],
                    [
                        23.61445560850661,
                        46.44083491981145
                    ],
                    [
                        23.62267215383447,
                        46.44910310028034
                    ],
                    [
                        23.63011355339166,
                        46.45907660099801
                    ],
                    [
                        23.630010217382996,
                        46.46698320993217
                    ],
                    [
                        23.623912378913055,
                        46.47251245457053
                    ],
                    [
                        23.61275028795494,
                        46.47530311229289
                    ],
                    [
                        23.580194130761956,
                        46.47318434564741
                    ],
                    [
                        23.56169395377933,
                        46.473752692910374
                    ],
                    [
                        23.54014489163552,
                        46.47674999272613
                    ],
                    [
                        23.490793887127325,
                        46.490547518176534
                    ],
                    [
                        23.4350867041964,
                        46.51904714478954
                    ],
                    [
                        23.420513954395503,
                        46.52429233700259
                    ],
                    [
                        23.403719107371497,
                        46.527082810178634
                    ],
                    [
                        23.303208453472976,
                        46.51393121278063
                    ],
                    [
                        23.267034949397548,
                        46.49468173135162
                    ],
                    [
                        23.25726809062111,
                        46.48801537791911
                    ],
                    [
                        23.247966335858756,
                        46.4841655057238
                    ],
                    [
                        23.234892199219036,
                        46.48284775991638
                    ],
                    [
                        23.21799400102375,
                        46.48447553723758
                    ],
                    [
                        23.17236371848394,
                        46.494578333216374
                    ],
                    [
                        23.153915241747345,
                        46.4943716904507
                    ],
                    [
                        23.144303425205365,
                        46.491891220105046
                    ],
                    [
                        23.103168977211656,
                        46.47468291300531
                    ],
                    [
                        23.09557254168584,
                        46.46930856495879
                    ],
                    [
                        23.085030555371276,
                        46.45835319785201
                    ],
                    [
                        23.07727907951532,
                        46.45530421478788
                    ],
                    [
                        23.070251086078866,
                        46.4562860772897
                    ],
                    [
                        23.063274772747313,
                        46.4632624297458
                    ],
                    [
                        23.061569457029293,
                        46.46987705909717
                    ],
                    [
                        23.05970909358854,
                        46.481710882309265
                    ],
                    [
                        23.05505821447101,
                        46.487162744640386
                    ],
                    [
                        23.046531603517426,
                        46.492588769045845
                    ],
                    [
                        23.034129266301004,
                        46.49894501444067
                    ],
                    [
                        23.025292586326074,
                        46.50496524867904
                    ],
                    [
                        23.01971154535512,
                        46.5112698727039
                    ],
                    [
                        23.01066815990745,
                        46.52501572827919
                    ],
                    [
                        22.996715522662505,
                        46.53101019344482
                    ],
                    [
                        22.97392621867208,
                        46.53576444764414
                    ],
                    [
                        22.833004586686403,
                        46.53819322905228
                    ],
                    [
                        22.802773887451266,
                        46.5569001918347
                    ]
                ]
            ]
        },
        "type": "Feature",
        "properties": {
            "source": "https://simplemaps.com",
            "id": "ROCJ",
            "name": "Cluj"
        },
        "id": 20
    },
    {
        "geometry": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        24.956234177220445,
                        47.58228981856878
                    ],
                    [
                        24.967086216948488,
                        47.573582270410505
                    ],
                    [
                        25.046099491490335,
                        47.52968320086885
                    ],
                    [
                        25.072144413999816,
                        47.50857338019887
                    ],
                    [
                        25.084236697621186,
                        47.493793910453476
                    ],
                    [
                        25.089352652263578,
                        47.48299345904394
                    ],
                    [
                        25.0904895471905,
                        47.47146970394922
                    ],
                    [
                        25.08377160692319,
                        47.457775420614446
                    ],
                    [
                        25.07260949048013,
                        47.449455468767425
                    ],
                    [
                        25.05912195283384,
                        47.443486912912434
                    ],
                    [
                        25.04718469753331,
                        47.43974037273535
                    ],
                    [
                        25.03943321744193,
                        47.43524443087164
                    ],
                    [
                        25.037262821884,
                        47.43023190467358
                    ],
                    [
                        25.04067346227271,
                        47.42552932181539
                    ],
                    [
                        25.04594445322318,
                        47.42105928063299
                    ],
                    [
                        25.050440306465035,
                        47.415142352925386
                    ],
                    [
                        25.051990594764042,
                        47.40868277105322
                    ],
                    [
                        25.04935508610273,
                        47.39994938885998
                    ],
                    [
                        25.044704227619256,
                        47.39643552141542
                    ],
                    [
                        25.03819299152705,
                        47.39568617023887
                    ],
                    [
                        25.030544876546898,
                        47.396797198234076
                    ],
                    [
                        25.02294842962582,
                        47.39710718529566
                    ],
                    [
                        25.014111764918898,
                        47.39607369118086
                    ],
                    [
                        25.00698042144939,
                        47.3925597139767
                    ],
                    [
                        25.002639589672548,
                        47.38656518444399
                    ],
                    [
                        25.004034864375246,
                        47.379175521807525
                    ],
                    [
                        25.01318159238022,
                        47.3686593594147
                    ],
                    [
                        25.032922002518813,
                        47.35132200001762
                    ],
                    [
                        25.040363390929112,
                        47.34289863064161
                    ],
                    [
                        25.0523006412385,
                        47.32491519467805
                    ],
                    [
                        25.056796511905663,
                        47.31530351689943
                    ],
                    [
                        25.057416610074625,
                        47.30403792676912
                    ],
                    [
                        25.04951012220056,
                        47.28615792584181
                    ],
                    [
                        25.036746058441977,
                        47.27075844398389
                    ],
                    [
                        25.029149619341855,
                        47.25758093198529
                    ],
                    [
                        25.027599311032645,
                        47.24727138504032
                    ],
                    [
                        25.039123161809272,
                        47.23716867801528
                    ],
                    [
                        25.050905387194828,
                        47.234739882211926
                    ],
                    [
                        25.06175744983796,
                        47.23505001544742
                    ],
                    [
                        25.06981896144218,
                        47.23654856142107
                    ],
                    [
                        25.074779891467493,
                        47.23432642296142
                    ],
                    [
                        25.076485222450145,
                        47.22833201696864
                    ],
                    [
                        25.07276450872477,
                        47.21319075494893
                    ],
                    [
                        25.068578736822705,
                        47.20249384807547
                    ],
                    [
                        25.0631526959824,
                        47.172779801993386
                    ],
                    [
                        25.06857873776609,
                        47.102965046086375
                    ],
                    [
                        24.991477491727764,
                        47.0819326810191
                    ],
                    [
                        24.925693394537575,
                        47.073147693681506
                    ],
                    [
                        24.89897668653111,
                        47.06694657262859
                    ],
                    [
                        24.866523889933895,
                        47.05211545450621
                    ],
                    [
                        24.815984332608707,
                        47.02178134807037
                    ],
                    [
                        24.808336210480796,
                        47.01464993322986
                    ],
                    [
                        24.794538609111463,
                        46.98974193264197
                    ],
                    [
                        24.789422640002726,
                        46.982507217844976
                    ],
                    [
                        24.764307902251254,
                        46.95666905100466
                    ],
                    [
                        24.756349724973667,
                        46.94413748122759
                    ],
                    [
                        24.75066530596146,
                        46.93026228623099
                    ],
                    [
                        24.74286216988246,
                        46.90209865924187
                    ],
                    [
                        24.735730818075407,
                        46.894037109181895
                    ],
                    [
                        24.724103638634997,
                        46.89013565825729
                    ],
                    [
                        24.706120242854755,
                        46.891970183717625
                    ],
                    [
                        24.68979048329091,
                        46.89687940282298
                    ],
                    [
                        24.66033491565746,
                        46.909695147043145
                    ],
                    [
                        24.648087592976992,
                        46.91336412283775
                    ],
                    [
                        24.636718780962166,
                        46.914811080276074
                    ],
                    [
                        24.624471460483374,
                        46.91362248567617
                    ],
                    [
                        24.606488068991045,
                        46.90791228498357
                    ],
                    [
                        24.58199344948329,
                        46.89452815375317
                    ],
                    [
                        24.561167831965548,
                        46.87584702007385
                    ],
                    [
                        24.55155601685631,
                        46.86365139073454
                    ],
                    [
                        24.542254262363823,
                        46.84504789788089
                    ],
                    [
                        24.536053090096413,
                        46.83781319485213
                    ],
                    [
                        24.517087840230975,
                        46.82166430777609
                    ],
                    [
                        24.51088666387393,
                        46.81311183337489
                    ],
                    [
                        24.507941124665205,
                        46.802311573721695
                    ],
                    [
                        24.506235784026778,
                        46.791872813552324
                    ],
                    [
                        24.50313519797739,
                        46.78156336191153
                    ],
                    [
                        24.49786421073428,
                        46.773579414168545
                    ],
                    [
                        24.48375654257417,
                        46.767274875309894
                    ],
                    [
                        24.464481227146525,
                        46.76283066433201
                    ],
                    [
                        24.42897952864396,
                        46.7594200887454
                    ],
                    [
                        24.38350425813634,
                        46.746604262604635
                    ],
                    [
                        24.36753624599498,
                        46.7445114039313
                    ],
                    [
                        24.345625441439793,
                        46.7453640825655
                    ],
                    [
                        24.279376264316177,
                        46.75683631038897
                    ],
                    [
                        24.196849001886843,
                        46.784534879143884
                    ],
                    [
                        24.218708130591896,
                        46.81559240409776
                    ],
                    [
                        24.22475425481369,
                        46.82789127055641
                    ],
                    [
                        24.231110476699353,
                        46.869025846019156
                    ],
                    [
                        24.23669151992916,
                        46.88334014051251
                    ],
                    [
                        24.23870689940592,
                        46.89925647338907
                    ],
                    [
                        24.233590945776736,
                        46.9127957867615
                    ],
                    [
                        24.2149874097575,
                        46.926851645602056
                    ],
                    [
                        24.17989911952317,
                        46.940106694318644
                    ],
                    [
                        24.167806832939917,
                        46.94654040046584
                    ],
                    [
                        24.160830514535743,
                        46.95496366333759
                    ],
                    [
                        24.15943524679971,
                        46.966539153811446
                    ],
                    [
                        24.16083052783274,
                        46.97434241359403
                    ],
                    [
                        24.163155965517866,
                        46.98157709814342
                    ],
                    [
                        24.1611405824519,
                        46.98777825431383
                    ],
                    [
                        24.14362226014693,
                        46.996433985423714
                    ],
                    [
                        24.13571576573494,
                        47.00307439867228
                    ],
                    [
                        24.13612917947031,
                        47.017905546066174
                    ],
                    [
                        24.13891972316358,
                        47.03064390286222
                    ],
                    [
                        24.14377730064223,
                        47.043097869334126
                    ],
                    [
                        24.14517255997807,
                        47.0557327330435
                    ],
                    [
                        24.140831730955416,
                        47.06787663320051
                    ],
                    [
                        24.126982458720416,
                        47.082320275395325
                    ],
                    [
                        24.11240969180006,
                        47.08963240402788
                    ],
                    [
                        24.089465368316333,
                        47.09694470082195
                    ],
                    [
                        24.078561631141433,
                        47.1017505473966
                    ],
                    [
                        24.057787717485073,
                        47.11547071824483
                    ],
                    [
                        24.042749870178405,
                        47.12169768628384
                    ],
                    [
                        23.98580245358344,
                        47.1323689524852
                    ],
                    [
                        23.973090031829596,
                        47.13743311100855
                    ],
                    [
                        23.962341350221042,
                        47.145598095966854
                    ],
                    [
                        23.95536503404617,
                        47.15557165946542
                    ],
                    [
                        23.95071414058919,
                        47.16774136440232
                    ],
                    [
                        23.940017113694996,
                        47.223164305420006
                    ],
                    [
                        23.935986372754435,
                        47.23380979186365
                    ],
                    [
                        23.93629641884015,
                        47.245721122768046
                    ],
                    [
                        23.942187524929494,
                        47.25572046467092
                    ],
                    [
                        23.97464032308672,
                        47.27411726523181
                    ],
                    [
                        23.987662793166532,
                        47.28445261024748
                    ],
                    [
                        23.998204787687605,
                        47.295976474353154
                    ],
                    [
                        24.007506555153213,
                        47.324605279802064
                    ],
                    [
                        24.046005498956116,
                        47.350030093214535
                    ],
                    [
                        24.107138716497317,
                        47.41090492457318
                    ],
                    [
                        24.11411503180481,
                        47.42072342244395
                    ],
                    [
                        24.11737063510804,
                        47.42997342614615
                    ],
                    [
                        24.11907596235367,
                        47.44552806566471
                    ],
                    [
                        24.120936312958445,
                        47.45154836044209
                    ],
                    [
                        24.125897253939165,
                        47.456716026747614
                    ],
                    [
                        24.140366644509914,
                        47.46118597049043
                    ],
                    [
                        24.22490929959313,
                        47.47320082475912
                    ],
                    [
                        24.245063112268376,
                        47.48170161604986
                    ],
                    [
                        24.255191692131167,
                        47.4900215188745
                    ],
                    [
                        24.27441532709342,
                        47.52113075056335
                    ],
                    [
                        24.282321799851747,
                        47.52991559938923
                    ],
                    [
                        24.29627443762969,
                        47.537718751795346
                    ],
                    [
                        24.365675897287815,
                        47.559087021711036
                    ],
                    [
                        24.38334922927568,
                        47.562110047023765
                    ],
                    [
                        24.57093468031358,
                        47.53216356401361
                    ],
                    [
                        24.759191926172583,
                        47.53650440194599
                    ],
                    [
                        24.780120878135676,
                        47.54071601570697
                    ],
                    [
                        24.79577885243369,
                        47.548467574895625
                    ],
                    [
                        24.837068311971702,
                        47.57466746777711
                    ],
                    [
                        24.87076133540129,
                        47.582832278384245
                    ],
                    [
                        24.956234177220445,
                        47.58228981856878
                    ]
                ]
            ]
        },
        "type": "Feature",
        "properties": {
            "source": "https://simplemaps.com",
            "id": "ROBN",
            "name": "Bistrita-Nasaud"
        },
        "id": 21
    },
    {
        "geometry": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        22.580720246895762,
                        47.321401254874694
                    ],
                    [
                        22.62356000771036,
                        47.34470732163915
                    ],
                    [
                        22.7546631120713,
                        47.38793462275729
                    ],
                    [
                        22.782413353041974,
                        47.39289554152208
                    ],
                    [
                        22.801843709957172,
                        47.39276647170768
                    ],
                    [
                        22.91186282418903,
                        47.372044157806826
                    ],
                    [
                        22.925815463356887,
                        47.36597219055619
                    ],
                    [
                        22.949534957440253,
                        47.350030093214535
                    ],
                    [
                        22.964469445102164,
                        47.344035617578506
                    ],
                    [
                        23.00555218972025,
                        47.336852458753455
                    ],
                    [
                        23.01609418967742,
                        47.33302846075158
                    ],
                    [
                        23.033354112749894,
                        47.31974757750038
                    ],
                    [
                        23.045446414176627,
                        47.31426998776071
                    ],
                    [
                        23.051027468900788,
                        47.3160528276707
                    ],
                    [
                        23.055368275073135,
                        47.320677769941945
                    ],
                    [
                        23.05986413097779,
                        47.32726655889443
                    ],
                    [
                        23.066375359922816,
                        47.333131819744146
                    ],
                    [
                        23.10502932620185,
                        47.355430173276915
                    ],
                    [
                        23.110300318871708,
                        47.36176050904806
                    ],
                    [
                        23.111850627159473,
                        47.3689953148457
                    ],
                    [
                        23.110300325058986,
                        47.37685006900477
                    ],
                    [
                        23.10208377431522,
                        47.390079247337674
                    ],
                    [
                        23.090456566963425,
                        47.404290203385465
                    ],
                    [
                        23.14058271877381,
                        47.41695100470398
                    ],
                    [
                        23.245330844224544,
                        47.416434223992106
                    ],
                    [
                        23.27184085594424,
                        47.41315278667976
                    ],
                    [
                        23.29173627239106,
                        47.40847600266655
                    ],
                    [
                        23.332198938304682,
                        47.39405840298366
                    ],
                    [
                        23.457100866997546,
                        47.36517122830993
                    ],
                    [
                        23.47994183616511,
                        47.36263898909708
                    ],
                    [
                        23.633524194093567,
                        47.36744490818307
                    ],
                    [
                        23.656985315133934,
                        47.36457700703259
                    ],
                    [
                        23.670007769438214,
                        47.35922845152187
                    ],
                    [
                        23.672488226027095,
                        47.351528576398906
                    ],
                    [
                        23.67822432174967,
                        47.34357048605559
                    ],
                    [
                        23.68706098776726,
                        47.33556061215673
                    ],
                    [
                        23.70742149364851,
                        47.32928187428305
                    ],
                    [
                        23.719048709347966,
                        47.32445024557799
                    ],
                    [
                        23.72835044723629,
                        47.31871403360437
                    ],
                    [
                        23.736256962572387,
                        47.31256467218292
                    ],
                    [
                        23.7496411499312,
                        47.306699337617566
                    ],
                    [
                        23.76204350027493,
                        47.304864876437165
                    ],
                    [
                        23.77661625194862,
                        47.305329950080626
                    ],
                    [
                        23.787623323374206,
                        47.30762949107542
                    ],
                    [
                        23.812944787409076,
                        47.31651791802219
                    ],
                    [
                        23.8284477160834,
                        47.30083411347577
                    ],
                    [
                        23.828757760874588,
                        47.29409024945665
                    ],
                    [
                        23.827052438464985,
                        47.286261269281184
                    ],
                    [
                        23.82069623853201,
                        47.27745044122713
                    ],
                    [
                        23.8158903451398,
                        47.26559080142801
                    ],
                    [
                        23.81108443693338,
                        47.246728900008236
                    ],
                    [
                        23.811859564712215,
                        47.227401791859876
                    ],
                    [
                        23.80410810059308,
                        47.218461777201625
                    ],
                    [
                        23.788708536355177,
                        47.21427607123553
                    ],
                    [
                        23.729435656967528,
                        47.209831817808436
                    ],
                    [
                        23.696724476592898,
                        47.20270047981186
                    ],
                    [
                        23.66194623275249,
                        47.18978133741493
                    ],
                    [
                        23.646288278687486,
                        47.177559897079014
                    ],
                    [
                        23.63745161770879,
                        47.16564853406257
                    ],
                    [
                        23.63032025622047,
                        47.1530910746855
                    ],
                    [
                        23.62189699867587,
                        47.148956963698275
                    ],
                    [
                        23.61244021187784,
                        47.148956963698275
                    ],
                    [
                        23.60205324845135,
                        47.15190251608207
                    ],
                    [
                        23.5908911491975,
                        47.15236767053348
                    ],
                    [
                        23.577817005774776,
                        47.14978381231435
                    ],
                    [
                        23.555337767524485,
                        47.13944859055334
                    ],
                    [
                        23.509552453176198,
                        47.12689124916797
                    ],
                    [
                        23.505986777033254,
                        47.12058671232236
                    ],
                    [
                        23.50397139761356,
                        47.11252519730472
                    ],
                    [
                        23.502731147541976,
                        47.103791774692816
                    ],
                    [
                        23.495289757233053,
                        47.094438447398964
                    ],
                    [
                        23.488778522826934,
                        47.08312128477765
                    ],
                    [
                        23.486763142341694,
                        47.07774693772956
                    ],
                    [
                        23.480251915077748,
                        47.07487891468102
                    ],
                    [
                        23.45989139661257,
                        47.07071892865905
                    ],
                    [
                        23.45446536997531,
                        47.06580966486342
                    ],
                    [
                        23.45338016169032,
                        47.059117543423476
                    ],
                    [
                        23.45679081473566,
                        47.05268388346997
                    ],
                    [
                        23.470485067783105,
                        47.04092749099631
                    ],
                    [
                        23.475135929675165,
                        47.0342352766137
                    ],
                    [
                        23.48412763370198,
                        47.01222115206343
                    ],
                    [
                        23.485677925249274,
                        47.004469672702974
                    ],
                    [
                        23.481802200975306,
                        46.994857908082274
                    ],
                    [
                        23.471725285919753,
                        46.988760015156245
                    ],
                    [
                        23.457100873033713,
                        46.985969609804556
                    ],
                    [
                        23.44392336249512,
                        46.985065137731475
                    ],
                    [
                        23.421444129740543,
                        46.98555616726856
                    ],
                    [
                        23.409661890773357,
                        46.98431584285422
                    ],
                    [
                        23.397827990754305,
                        46.97976833491775
                    ],
                    [
                        23.393332149094377,
                        46.9736705748512
                    ],
                    [
                        23.389611449526498,
                        46.960906519892205
                    ],
                    [
                        23.38387537114534,
                        46.95922707262709
                    ],
                    [
                        23.366977159913798,
                        46.963464421559166
                    ],
                    [
                        23.35674523399275,
                        46.963697014947336
                    ],
                    [
                        23.34212081315459,
                        46.95909787292143
                    ],
                    [
                        23.337779976228134,
                        46.95227647861061
                    ],
                    [
                        23.34134565019925,
                        46.94351732143455
                    ],
                    [
                        23.350233993700343,
                        46.935740001339425
                    ],
                    [
                        23.360775995877734,
                        46.92855703821905
                    ],
                    [
                        23.364961776371988,
                        46.9193843992722
                    ],
                    [
                        23.364651725404922,
                        46.91031524188824
                    ],
                    [
                        23.3561251090903,
                        46.89623337593382
                    ],
                    [
                        23.34723677398758,
                        46.89176344581812
                    ],
                    [
                        23.337779976902578,
                        46.89134997041485
                    ],
                    [
                        23.330803663583357,
                        46.89584585257652
                    ],
                    [
                        23.32444745554795,
                        46.901633561405866
                    ],
                    [
                        23.317626181382217,
                        46.9065429270246
                    ],
                    [
                        23.309409631221317,
                        46.9086875146554
                    ],
                    [
                        23.298867621683183,
                        46.90829982278625
                    ],
                    [
                        23.277731960083567,
                        46.90364893898837
                    ],
                    [
                        23.269050319846723,
                        46.905070048079196
                    ],
                    [
                        23.263624294064435,
                        46.90974675756701
                    ],
                    [
                        23.257268105367093,
                        46.925017229549475
                    ],
                    [
                        23.25075686160043,
                        46.93279444483933
                    ],
                    [
                        23.242333620886647,
                        46.936541105189555
                    ],
                    [
                        23.230241336673675,
                        46.9353783915474
                    ],
                    [
                        23.223420049089917,
                        46.92824704995231
                    ],
                    [
                        23.209932480956606,
                        46.90974675756701
                    ],
                    [
                        23.207141969237757,
                        46.902615520731956
                    ],
                    [
                        23.206676875548812,
                        46.89455395780506
                    ],
                    [
                        23.208537216262208,
                        46.88644068148887
                    ],
                    [
                        23.205591662552724,
                        46.87806911993313
                    ],
                    [
                        23.196444929768624,
                        46.87419335638046
                    ],
                    [
                        23.184042588256638,
                        46.87362493542948
                    ],
                    [
                        23.161356636585467,
                        46.87974860625144
                    ],
                    [
                        23.14988446547986,
                        46.88054957146709
                    ],
                    [
                        23.13562176993237,
                        46.87853418395268
                    ],
                    [
                        23.116036415525212,
                        46.87367669379427
                    ],
                    [
                        23.0989831809945,
                        46.8719712830567
                    ],
                    [
                        23.08425539489894,
                        46.87419335638046
                    ],
                    [
                        23.07324831934042,
                        46.87706143231507
                    ],
                    [
                        23.061879510924935,
                        46.878482578401126
                    ],
                    [
                        23.049632193771274,
                        46.878275849101264
                    ],
                    [
                        23.027928100175046,
                        46.87533035485523
                    ],
                    [
                        23.01847130776799,
                        46.87569205113923
                    ],
                    [
                        23.010823184377934,
                        46.87910261350284
                    ],
                    [
                        23.005552196853163,
                        46.88390857848495
                    ],
                    [
                        23.00074627993698,
                        46.88954125211822
                    ],
                    [
                        22.993769966976245,
                        46.893778761977124
                    ],
                    [
                        22.984313180231997,
                        46.89610420142987
                    ],
                    [
                        22.9472095026046,
                        46.89855883300991
                    ],
                    [
                        22.934497106274613,
                        46.90194367775529
                    ],
                    [
                        22.92426517756023,
                        46.91039281142861
                    ],
                    [
                        22.91356815544178,
                        46.92338942828308
                    ],
                    [
                        22.89692833612169,
                        46.95346506195549
                    ],
                    [
                        22.889176870819153,
                        46.96261178541135
                    ],
                    [
                        22.8792549971505,
                        46.96845123606374
                    ],
                    [
                        22.868247908133444,
                        46.97232690157742
                    ],
                    [
                        22.85057458199611,
                        46.974807462638275
                    ],
                    [
                        22.731253691182186,
                        46.97615099264579
                    ],
                    [
                        22.719419783226634,
                        46.97935490036344
                    ],
                    [
                        22.702676619531037,
                        46.99875939735813
                    ],
                    [
                        22.663867623334397,
                        47.02552781690498
                    ],
                    [
                        22.601649209819357,
                        47.05012588427175
                    ],
                    [
                        22.590487092851347,
                        47.0585749202187
                    ],
                    [
                        22.58366580303052,
                        47.06645557181876
                    ],
                    [
                        22.579945109717926,
                        47.07469803122991
                    ],
                    [
                        22.550437853064576,
                        47.11366196472109
                    ],
                    [
                        22.507184691297255,
                        47.15991246067646
                    ],
                    [
                        22.49488569890245,
                        47.18063469840853
                    ],
                    [
                        22.49426558715928,
                        47.19417395853047
                    ],
                    [
                        22.5026371525014,
                        47.199806571654655
                    ],
                    [
                        22.511318811728067,
                        47.20678302187866
                    ],
                    [
                        22.536795278659685,
                        47.23241443087451
                    ],
                    [
                        22.54268638419107,
                        47.23995914098531
                    ],
                    [
                        22.54547692772265,
                        47.24758153067484
                    ],
                    [
                        22.5462520717407,
                        47.256108118779906
                    ],
                    [
                        22.54842248706957,
                        47.26476395578937
                    ],
                    [
                        22.553228382916494,
                        47.27264452792968
                    ],
                    [
                        22.56475223925935,
                        47.28543452272411
                    ],
                    [
                        22.570488315867678,
                        47.293702702011664
                    ],
                    [
                        22.580720246895762,
                        47.321401254874694
                    ]
                ]
            ]
        },
        "type": "Feature",
        "properties": {
            "source": "https://simplemaps.com",
            "id": "ROSJ",
            "name": "Salaj"
        },
        "id": 22
    },
    {
        "geometry": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        25.513616153815107,
                        44.50586246588314
                    ],
                    [
                        25.48834637127344,
                        44.50746439216697
                    ],
                    [
                        25.432329128620193,
                        44.52655889599638
                    ],
                    [
                        25.40979821293141,
                        44.52953035129544
                    ],
                    [
                        25.395845585871157,
                        44.527954280903614
                    ],
                    [
                        25.39041954270768,
                        44.52420762825725
                    ],
                    [
                        25.39088464313633,
                        44.51829075816855
                    ],
                    [
                        25.39817099959303,
                        44.5078519805305
                    ],
                    [
                        25.398171017240546,
                        44.50203849875784
                    ],
                    [
                        25.3936751817428,
                        44.49635419025692
                    ],
                    [
                        25.380342651145487,
                        44.48539870595143
                    ],
                    [
                        25.37414146872138,
                        44.47930082194424
                    ],
                    [
                        25.35905196436618,
                        44.46038733764408
                    ],
                    [
                        25.348044879712297,
                        44.449354390582535
                    ],
                    [
                        25.328356159939712,
                        44.435685981595334
                    ],
                    [
                        25.31114788686964,
                        44.431629242169805
                    ],
                    [
                        25.299934135899868,
                        44.43072513938421
                    ],
                    [
                        25.2785400775796,
                        44.43728793934651
                    ],
                    [
                        25.299779106302882,
                        44.46521915129393
                    ],
                    [
                        25.30318971132634,
                        44.48395158705438
                    ],
                    [
                        25.300709276635946,
                        44.49139322604442
                    ],
                    [
                        25.2968335101804,
                        44.49976458278964
                    ],
                    [
                        25.293732951268062,
                        44.50896317093451
                    ],
                    [
                        25.292492697452122,
                        44.5222955545753
                    ],
                    [
                        25.297763686409436,
                        44.53229489842155
                    ],
                    [
                        25.315902129368972,
                        44.55671211237586
                    ],
                    [
                        25.31714234943378,
                        44.56575539803062
                    ],
                    [
                        25.31300827687071,
                        44.573067884094236
                    ],
                    [
                        25.305515147692045,
                        44.57756343253686
                    ],
                    [
                        25.2963684281958,
                        44.580224827903365
                    ],
                    [
                        25.273114066711223,
                        44.58306725031384
                    ],
                    [
                        25.262727083144338,
                        44.58559925733585
                    ],
                    [
                        25.254303840808127,
                        44.58994018266552
                    ],
                    [
                        25.226708589765803,
                        44.60942195618269
                    ],
                    [
                        25.21616660525788,
                        44.61908550134293
                    ],
                    [
                        25.190690126326587,
                        44.65484560962021
                    ],
                    [
                        25.187744567073928,
                        44.66704122444533
                    ],
                    [
                        25.192240419303005,
                        44.675412832324305
                    ],
                    [
                        25.214771369472924,
                        44.685438228507145
                    ],
                    [
                        25.21864707173228,
                        44.690088904734736
                    ],
                    [
                        25.209655410136225,
                        44.6971688315131
                    ],
                    [
                        25.19859665283188,
                        44.7038867549212
                    ],
                    [
                        25.18464401412332,
                        44.7158240006603
                    ],
                    [
                        25.18231856380172,
                        44.72739945096405
                    ],
                    [
                        25.185419142522928,
                        44.738639030658966
                    ],
                    [
                        25.20014691835634,
                        44.75819850349654
                    ],
                    [
                        25.205004508419627,
                        44.766957700634435
                    ],
                    [
                        25.2074849698174,
                        44.77762883056895
                    ],
                    [
                        25.21585655152652,
                        44.85940678179347
                    ],
                    [
                        25.21322107577936,
                        44.875245758443924
                    ],
                    [
                        25.196891312062803,
                        44.92927339725337
                    ],
                    [
                        25.19441082060415,
                        44.94914282816706
                    ],
                    [
                        25.19642621127046,
                        44.96534346211158
                    ],
                    [
                        25.202834087866805,
                        44.97451601822307
                    ],
                    [
                        25.2310494346373,
                        44.99782218948324
                    ],
                    [
                        25.235700310945024,
                        45.006658841494165
                    ],
                    [
                        25.23523522298795,
                        45.01596059890502
                    ],
                    [
                        25.23042931502329,
                        45.0284146179296
                    ],
                    [
                        25.219112176657248,
                        45.047793283132194
                    ],
                    [
                        25.18774458275427,
                        45.07342479356036
                    ],
                    [
                        25.174102003865674,
                        45.09027130954243
                    ],
                    [
                        25.163094924234013,
                        45.1298554551477
                    ],
                    [
                        25.164025098570654,
                        45.148872377463796
                    ],
                    [
                        25.168986037798724,
                        45.162359938697016
                    ],
                    [
                        25.174412062291474,
                        45.16858694291977
                    ],
                    [
                        25.184023878097495,
                        45.186596169766666
                    ],
                    [
                        25.188829788100225,
                        45.19124706358952
                    ],
                    [
                        25.194875928563924,
                        45.193985903785475
                    ],
                    [
                        25.201697218116838,
                        45.19290069847135
                    ],
                    [
                        25.20841515631327,
                        45.18830150693672
                    ],
                    [
                        25.21973229346654,
                        45.17509817479231
                    ],
                    [
                        25.226708612355065,
                        45.170266426955514
                    ],
                    [
                        25.235545283443795,
                        45.16835440572198
                    ],
                    [
                        25.24484704002638,
                        45.16990469455144
                    ],
                    [
                        25.25352867957723,
                        45.17445221489591
                    ],
                    [
                        25.262572057543302,
                        45.181971144691566
                    ],
                    [
                        25.270943637351493,
                        45.192022195701306
                    ],
                    [
                        25.2796252783366,
                        45.20835195819899
                    ],
                    [
                        25.287686802086263,
                        45.22907420802231
                    ],
                    [
                        25.289702183035796,
                        45.2524577891967
                    ],
                    [
                        25.29435306199516,
                        45.26832245282431
                    ],
                    [
                        25.300244175229583,
                        45.2814741100777
                    ],
                    [
                        25.30722049337055,
                        45.29232616110991
                    ],
                    [
                        25.322930130611073,
                        45.31051627142916
                    ],
                    [
                        25.329131299936474,
                        45.321058247964764
                    ],
                    [
                        25.333782180706056,
                        45.33774975255634
                    ],
                    [
                        25.3339372107164,
                        45.349428629021304
                    ],
                    [
                        25.330526565869317,
                        45.3596605611189
                    ],
                    [
                        25.325100541201106,
                        45.368962323923675
                    ],
                    [
                        25.309235872560617,
                        45.38849599233826
                    ],
                    [
                        25.370265741569863,
                        45.39939973003036
                    ],
                    [
                        25.388714224789503,
                        45.41588449616966
                    ],
                    [
                        25.3939852207464,
                        45.42668486552861
                    ],
                    [
                        25.40266686614367,
                        45.439164757500386
                    ],
                    [
                        25.409643179958955,
                        45.445340061962355
                    ],
                    [
                        25.42979699261667,
                        45.45231640577406
                    ],
                    [
                        25.447987094457527,
                        45.3897879088166
                    ],
                    [
                        25.454808381303234,
                        45.34503610118124
                    ],
                    [
                        25.459304236296852,
                        45.33294384664532
                    ],
                    [
                        25.466280551407582,
                        45.32415883976257
                    ],
                    [
                        25.475737337989994,
                        45.31878448392399
                    ],
                    [
                        25.486175978097865,
                        45.31413361385955
                    ],
                    [
                        25.49594282518951,
                        45.30860424148494
                    ],
                    [
                        25.506484814980585,
                        45.30033600092534
                    ],
                    [
                        25.518267042841526,
                        45.28674510118597
                    ],
                    [
                        25.52431318550156,
                        45.27496287796281
                    ],
                    [
                        25.527103714544168,
                        45.26509268616186
                    ],
                    [
                        25.52694868227036,
                        45.256876122350484
                    ],
                    [
                        25.52446821372811,
                        45.2374974559102
                    ],
                    [
                        25.52570844983321,
                        45.22375153582647
                    ],
                    [
                        25.540901319088853,
                        45.20494130564444
                    ],
                    [
                        25.549944695513286,
                        45.19703481659531
                    ],
                    [
                        25.56079674870411,
                        45.18949006755035
                    ],
                    [
                        25.572268915025347,
                        45.177552809286
                    ],
                    [
                        25.62689090307647,
                        45.10236359325039
                    ],
                    [
                        25.668800490371535,
                        45.0694457068421
                    ],
                    [
                        25.677017042729208,
                        45.05880036102258
                    ],
                    [
                        25.681357863608167,
                        45.04799998752876
                    ],
                    [
                        25.68709394716726,
                        45.005263577607955
                    ],
                    [
                        25.695155471757502,
                        44.98058809154357
                    ],
                    [
                        25.702441827141417,
                        44.967539649889055
                    ],
                    [
                        25.711485221782667,
                        44.95673939950855
                    ],
                    [
                        25.721252069178906,
                        44.95043488274749
                    ],
                    [
                        25.731328955197526,
                        44.94655903713977
                    ],
                    [
                        25.7435762851258,
                        44.943561897271394
                    ],
                    [
                        25.754893436519257,
                        44.94345863230488
                    ],
                    [
                        25.765797175806348,
                        44.9451640352802
                    ],
                    [
                        25.77432375542658,
                        44.94777348098792
                    ],
                    [
                        25.78207522783977,
                        44.948987928550466
                    ],
                    [
                        25.790291798428,
                        44.946300872825596
                    ],
                    [
                        25.80005862221254,
                        44.93823920369954
                    ],
                    [
                        25.81385623564418,
                        44.921780304844596
                    ],
                    [
                        25.818507128238377,
                        44.908267005233995
                    ],
                    [
                        25.819127218181208,
                        44.89361655752418
                    ],
                    [
                        25.815716610277004,
                        44.87968999745821
                    ],
                    [
                        25.81370120847584,
                        44.865272136386345
                    ],
                    [
                        25.81747359105312,
                        44.84697869694816
                    ],
                    [
                        25.82522505425369,
                        44.83744438671227
                    ],
                    [
                        25.836077081673118,
                        44.83173398887437
                    ],
                    [
                        25.883567764569047,
                        44.826928350263245
                    ],
                    [
                        25.89922572094085,
                        44.822820054500816
                    ],
                    [
                        25.915813822477155,
                        44.81563682304377
                    ],
                    [
                        25.985008588217248,
                        44.75556311664951
                    ],
                    [
                        25.99699752619184,
                        44.74830260825216
                    ],
                    [
                        26.01715134012533,
                        44.74034447677504
                    ],
                    [
                        26.02893353312858,
                        44.73814801008947
                    ],
                    [
                        26.003663765146094,
                        44.717012401111944
                    ],
                    [
                        25.99157147131085,
                        44.71019105454148
                    ],
                    [
                        25.984905221055552,
                        44.70042427158625
                    ],
                    [
                        25.981597941496133,
                        44.6899857050628
                    ],
                    [
                        25.975396753812415,
                        44.68339685744439
                    ],
                    [
                        25.95400270690567,
                        44.672208885799634
                    ],
                    [
                        25.94997197643654,
                        44.66590456761693
                    ],
                    [
                        25.94966191147672,
                        44.65972918481306
                    ],
                    [
                        25.954002707103218,
                        44.65407045890349
                    ],
                    [
                        25.988005798214264,
                        44.645388811056705
                    ],
                    [
                        25.99203659133426,
                        44.63735333106697
                    ],
                    [
                        25.98717898761246,
                        44.628774919661154
                    ],
                    [
                        25.977877217076752,
                        44.61908550134293
                    ],
                    [
                        25.929921498335936,
                        44.57913969442215
                    ],
                    [
                        25.907132181845068,
                        44.56591045543884
                    ],
                    [
                        25.5991406741285,
                        44.55293986271674
                    ],
                    [
                        25.57087363085214,
                        44.54704852026057
                    ],
                    [
                        25.551339966850456,
                        44.53965897649362
                    ],
                    [
                        25.54028119763138,
                        44.53118394988084
                    ],
                    [
                        25.513616153815107,
                        44.50586246588314
                    ]
                ]
            ]
        },
        "type": "Feature",
        "properties": {
            "source": "https://simplemaps.com",
            "id": "RODB",
            "name": "Dambovita"
        },
        "id": 23
    },
    {
        "geometry": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        25.2785400775796,
                        44.43728793934651
                    ],
                    [
                        25.246397351561548,
                        44.4484243116579
                    ],
                    [
                        25.23027428516783,
                        44.45180897904928
                    ],
                    [
                        25.212755981487252,
                        44.45341099956065
                    ],
                    [
                        25.190070011141998,
                        44.453462569467455
                    ],
                    [
                        25.144749782065407,
                        44.44726141081593
                    ],
                    [
                        25.12382084331366,
                        44.438657389313796
                    ],
                    [
                        25.101496620231117,
                        44.423025242123565
                    ],
                    [
                        25.08800907901629,
                        44.418581122788865
                    ],
                    [
                        25.063307714696666,
                        44.414136746235144
                    ],
                    [
                        25.03178509257712,
                        44.41739237094188
                    ],
                    [
                        25.022018271568168,
                        44.41646236418597
                    ],
                    [
                        25.012096372680404,
                        44.410881147225716
                    ],
                    [
                        24.99922897694943,
                        44.39956425026002
                    ],
                    [
                        24.991632513264,
                        44.395068210794975
                    ],
                    [
                        24.981245540909633,
                        44.391089061426825
                    ],
                    [
                        24.966001016621234,
                        44.38840204365695
                    ],
                    [
                        24.9487927763659,
                        44.38767865398496
                    ],
                    [
                        24.8941707618158,
                        44.39770370899064
                    ],
                    [
                        24.851330988069897,
                        44.389926322286406
                    ],
                    [
                        24.83009200657837,
                        44.40070108232497
                    ],
                    [
                        24.781516142383893,
                        44.40312975175957
                    ],
                    [
                        24.772059357702094,
                        44.40788400507729
                    ],
                    [
                        24.765393109460014,
                        44.41646236418597
                    ],
                    [
                        24.760277153342624,
                        44.43144860453262
                    ],
                    [
                        24.75562623947465,
                        44.47568339317659
                    ],
                    [
                        24.74379234496282,
                        44.509014747821304
                    ],
                    [
                        24.743327249362757,
                        44.51764465956864
                    ],
                    [
                        24.745187604067254,
                        44.52617128992234
                    ],
                    [
                        24.750458612048927,
                        44.53919383434848
                    ],
                    [
                        24.75097536315803,
                        44.54586000670162
                    ],
                    [
                        24.741466933659026,
                        44.59097375767032
                    ],
                    [
                        24.73449059656522,
                        44.607148357878856
                    ],
                    [
                        24.73139002247543,
                        44.616760258487524
                    ],
                    [
                        24.729994739560855,
                        44.62869737897528
                    ],
                    [
                        24.724878786018294,
                        44.65107336588095
                    ],
                    [
                        24.716817256302992,
                        44.66636954932908
                    ],
                    [
                        24.692425991793296,
                        44.6958510299882
                    ],
                    [
                        24.68979049371767,
                        44.705178629100594
                    ],
                    [
                        24.692736022139965,
                        44.710940358865514
                    ],
                    [
                        24.698678818475837,
                        44.71605636748266
                    ],
                    [
                        24.707205434348708,
                        44.72013883926011
                    ],
                    [
                        24.72472373475713,
                        44.72574566400625
                    ],
                    [
                        24.729529653994902,
                        44.7283295564313
                    ],
                    [
                        24.730614844471326,
                        44.732153515534506
                    ],
                    [
                        24.72596397996171,
                        44.737424610850404
                    ],
                    [
                        24.717747408976667,
                        44.74155860002023
                    ],
                    [
                        24.700229107065073,
                        44.74264386318089
                    ],
                    [
                        24.68482956229162,
                        44.74000857813299
                    ],
                    [
                        24.66870651122062,
                        44.73980184792615
                    ],
                    [
                        24.653203548514103,
                        44.743574003826986
                    ],
                    [
                        24.633153105503833,
                        44.75713915530726
                    ],
                    [
                        24.621680943193695,
                        44.768482174053446
                    ],
                    [
                        24.57682578574378,
                        44.83467958614325
                    ],
                    [
                        24.569694433823017,
                        44.8479603940788
                    ],
                    [
                        24.56829919891942,
                        44.85956195202775
                    ],
                    [
                        24.57031456873542,
                        44.86909617892561
                    ],
                    [
                        24.57108973700186,
                        44.87788132152822
                    ],
                    [
                        24.568919303127927,
                        44.88594268478595
                    ],
                    [
                        24.563648320048642,
                        44.89142047257073
                    ],
                    [
                        24.55434654002854,
                        44.89219547014978
                    ],
                    [
                        24.545974953612046,
                        44.88834554629441
                    ],
                    [
                        24.53481287757748,
                        44.87731284730439
                    ],
                    [
                        24.525149361188586,
                        44.85909674695865
                    ],
                    [
                        24.52111859642912,
                        44.85297307372391
                    ],
                    [
                        24.514297304535088,
                        44.84708193691882
                    ],
                    [
                        24.473679657477042,
                        44.82269085965175
                    ],
                    [
                        24.465101359273735,
                        44.81984858351323
                    ],
                    [
                        24.456109649514023,
                        44.82201892493838
                    ],
                    [
                        24.449443393082387,
                        44.82625640844094
                    ],
                    [
                        24.43781620665845,
                        44.8500276471937
                    ],
                    [
                        24.462930950902663,
                        44.86377356400221
                    ],
                    [
                        24.502205047307182,
                        44.89687236966958
                    ],
                    [
                        24.508561250918813,
                        44.9056315467379
                    ],
                    [
                        24.51197189926985,
                        44.91410650046043
                    ],
                    [
                        24.51073163848281,
                        44.922994672978426
                    ],
                    [
                        24.504220405287008,
                        44.93472520182475
                    ],
                    [
                        24.49553878714438,
                        44.943406999831694
                    ],
                    [
                        24.489027544393352,
                        44.95188184221832
                    ],
                    [
                        24.488097348842285,
                        44.96025329067565
                    ],
                    [
                        24.495848838496865,
                        44.98113074198568
                    ],
                    [
                        24.506700880328946,
                        45.041798812136555
                    ],
                    [
                        24.537448357757214,
                        45.13610830278833
                    ],
                    [
                        24.535277948071883,
                        45.159414372219
                    ],
                    [
                        24.52949018581437,
                        45.1744780463929
                    ],
                    [
                        24.521738721952346,
                        45.186131093010424
                    ],
                    [
                        24.515072463282504,
                        45.193314117849454
                    ],
                    [
                        24.500189650576036,
                        45.20550975838459
                    ],
                    [
                        24.495073681878075,
                        45.21553497551941
                    ],
                    [
                        24.493213332042664,
                        45.22847992368043
                    ],
                    [
                        24.49770918004676,
                        45.2488662731309
                    ],
                    [
                        24.500499709327944,
                        45.27346426350917
                    ],
                    [
                        24.491197950977845,
                        45.297700507811825
                    ],
                    [
                        24.489957716216104,
                        45.30865590338033
                    ],
                    [
                        24.4919730981592,
                        45.31790599910468
                    ],
                    [
                        24.497864208159623,
                        45.32550241188667
                    ],
                    [
                        24.506080765658137,
                        45.332220381779074
                    ],
                    [
                        24.513677197182457,
                        45.340126847392376
                    ],
                    [
                        24.516622758252417,
                        45.349428629021304
                    ],
                    [
                        24.51429731660211,
                        45.36131419627928
                    ],
                    [
                        24.49383344649617,
                        45.42407520390411
                    ],
                    [
                        24.49367841770408,
                        45.435418180695784
                    ],
                    [
                        24.49615888833219,
                        45.44621857467262
                    ],
                    [
                        24.52545942412455,
                        45.485699352994295
                    ],
                    [
                        24.539463740597885,
                        45.529831054801036
                    ],
                    [
                        24.52721642308166,
                        45.56181874869918
                    ],
                    [
                        24.709065789988223,
                        45.598767410735555
                    ],
                    [
                        24.771904330586487,
                        45.60290151156968
                    ],
                    [
                        24.787407261254668,
                        45.60026601981719
                    ],
                    [
                        24.80042972197926,
                        45.595046698282374
                    ],
                    [
                        24.816294389901795,
                        45.58259269635515
                    ],
                    [
                        24.82389082180601,
                        45.57339427161059
                    ],
                    [
                        24.83102216931875,
                        45.566159570519766
                    ],
                    [
                        24.838773633235608,
                        45.56311065055291
                    ],
                    [
                        24.85086592283909,
                        45.56559114990348
                    ],
                    [
                        24.86869428683214,
                        45.5738593457842
                    ],
                    [
                        24.880373162516534,
                        45.57675323875291
                    ],
                    [
                        24.89246544987293,
                        45.57758007492832
                    ],
                    [
                        24.92212772211788,
                        45.57610730176798
                    ],
                    [
                        24.983881052929046,
                        45.58000883796124
                    ],
                    [
                        25.095140416507807,
                        45.5696219058512
                    ],
                    [
                        25.119169955779427,
                        45.55975169212979
                    ],
                    [
                        25.156583692526084,
                        45.536238914972905
                    ],
                    [
                        25.174102000917657,
                        45.52859078840956
                    ],
                    [
                        25.18991499159486,
                        45.52424998415343
                    ],
                    [
                        25.2062447446141,
                        45.5162401373008
                    ],
                    [
                        25.2208174970132,
                        45.503372703229054
                    ],
                    [
                        25.275904576092362,
                        45.41645295712769
                    ],
                    [
                        25.309235872560617,
                        45.38849599233826
                    ],
                    [
                        25.325100541201106,
                        45.368962323923675
                    ],
                    [
                        25.330526565869317,
                        45.3596605611189
                    ],
                    [
                        25.3339372107164,
                        45.349428629021304
                    ],
                    [
                        25.333782180706056,
                        45.33774975255634
                    ],
                    [
                        25.329131299936474,
                        45.321058247964764
                    ],
                    [
                        25.322930130611073,
                        45.31051627142916
                    ],
                    [
                        25.30722049337055,
                        45.29232616110991
                    ],
                    [
                        25.300244175229583,
                        45.2814741100777
                    ],
                    [
                        25.29435306199516,
                        45.26832245282431
                    ],
                    [
                        25.289702183035796,
                        45.2524577891967
                    ],
                    [
                        25.287686802086263,
                        45.22907420802231
                    ],
                    [
                        25.2796252783366,
                        45.20835195819899
                    ],
                    [
                        25.270943637351493,
                        45.192022195701306
                    ],
                    [
                        25.262572057543302,
                        45.181971144691566
                    ],
                    [
                        25.25352867957723,
                        45.17445221489591
                    ],
                    [
                        25.24484704002638,
                        45.16990469455144
                    ],
                    [
                        25.235545283443795,
                        45.16835440572198
                    ],
                    [
                        25.226708612355065,
                        45.170266426955514
                    ],
                    [
                        25.21973229346654,
                        45.17509817479231
                    ],
                    [
                        25.20841515631327,
                        45.18830150693672
                    ],
                    [
                        25.201697218116838,
                        45.19290069847135
                    ],
                    [
                        25.194875928563924,
                        45.193985903785475
                    ],
                    [
                        25.188829788100225,
                        45.19124706358952
                    ],
                    [
                        25.184023878097495,
                        45.186596169766666
                    ],
                    [
                        25.174412062291474,
                        45.16858694291977
                    ],
                    [
                        25.168986037798724,
                        45.162359938697016
                    ],
                    [
                        25.164025098570654,
                        45.148872377463796
                    ],
                    [
                        25.163094924234013,
                        45.1298554551477
                    ],
                    [
                        25.174102003865674,
                        45.09027130954243
                    ],
                    [
                        25.18774458275427,
                        45.07342479356036
                    ],
                    [
                        25.219112176657248,
                        45.047793283132194
                    ],
                    [
                        25.23042931502329,
                        45.0284146179296
                    ],
                    [
                        25.23523522298795,
                        45.01596059890502
                    ],
                    [
                        25.235700310945024,
                        45.006658841494165
                    ],
                    [
                        25.2310494346373,
                        44.99782218948324
                    ],
                    [
                        25.202834087866805,
                        44.97451601822307
                    ],
                    [
                        25.19642621127046,
                        44.96534346211158
                    ],
                    [
                        25.19441082060415,
                        44.94914282816706
                    ],
                    [
                        25.196891312062803,
                        44.92927339725337
                    ],
                    [
                        25.21322107577936,
                        44.875245758443924
                    ],
                    [
                        25.21585655152652,
                        44.85940678179347
                    ],
                    [
                        25.2074849698174,
                        44.77762883056895
                    ],
                    [
                        25.205004508419627,
                        44.766957700634435
                    ],
                    [
                        25.20014691835634,
                        44.75819850349654
                    ],
                    [
                        25.185419142522928,
                        44.738639030658966
                    ],
                    [
                        25.18231856380172,
                        44.72739945096405
                    ],
                    [
                        25.18464401412332,
                        44.7158240006603
                    ],
                    [
                        25.19859665283188,
                        44.7038867549212
                    ],
                    [
                        25.209655410136225,
                        44.6971688315131
                    ],
                    [
                        25.21864707173228,
                        44.690088904734736
                    ],
                    [
                        25.214771369472924,
                        44.685438228507145
                    ],
                    [
                        25.192240419303005,
                        44.675412832324305
                    ],
                    [
                        25.187744567073928,
                        44.66704122444533
                    ],
                    [
                        25.190690126326587,
                        44.65484560962021
                    ],
                    [
                        25.21616660525788,
                        44.61908550134293
                    ],
                    [
                        25.226708589765803,
                        44.60942195618269
                    ],
                    [
                        25.254303840808127,
                        44.58994018266552
                    ],
                    [
                        25.262727083144338,
                        44.58559925733585
                    ],
                    [
                        25.273114066711223,
                        44.58306725031384
                    ],
                    [
                        25.2963684281958,
                        44.580224827903365
                    ],
                    [
                        25.305515147692045,
                        44.57756343253686
                    ],
                    [
                        25.31300827687071,
                        44.573067884094236
                    ],
                    [
                        25.31714234943378,
                        44.56575539803062
                    ],
                    [
                        25.315902129368972,
                        44.55671211237586
                    ],
                    [
                        25.297763686409436,
                        44.53229489842155
                    ],
                    [
                        25.292492697452122,
                        44.5222955545753
                    ],
                    [
                        25.293732951268062,
                        44.50896317093451
                    ],
                    [
                        25.2968335101804,
                        44.49976458278964
                    ],
                    [
                        25.300709276635946,
                        44.49139322604442
                    ],
                    [
                        25.30318971132634,
                        44.48395158705438
                    ],
                    [
                        25.299779106302882,
                        44.46521915129393
                    ],
                    [
                        25.2785400775796,
                        44.43728793934651
                    ]
                ]
            ]
        },
        "type": "Feature",
        "properties": {
            "source": "https://simplemaps.com",
            "id": "ROAG",
            "name": "Arges"
        },
        "id": 25
    },
    {
        "geometry": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        23.48939863749904,
                        44.55030428376798
                    ],
                    [
                        23.472810478789512,
                        44.57461787815497
                    ],
                    [
                        23.462991978533136,
                        44.58523754108359
                    ],
                    [
                        23.406664649098843,
                        44.624744044725595
                    ],
                    [
                        23.342275811472646,
                        44.65644751105204
                    ],
                    [
                        23.31886640893267,
                        44.66419913039727
                    ],
                    [
                        23.14538860828713,
                        44.69964903357172
                    ],
                    [
                        23.12616498032826,
                        44.70657371129339
                    ],
                    [
                        23.10347902825037,
                        44.71768416036648
                    ],
                    [
                        23.02668784120279,
                        44.769308849055385
                    ],
                    [
                        22.937442654959337,
                        44.84163010876921
                    ],
                    [
                        22.93124147788327,
                        44.85271466459614
                    ],
                    [
                        22.927830855085908,
                        44.863902772121214
                    ],
                    [
                        22.924420192525403,
                        44.885374199074306
                    ],
                    [
                        22.92178471220165,
                        44.89470192711077
                    ],
                    [
                        22.915118429710116,
                        44.91172914500871
                    ],
                    [
                        22.912948025534604,
                        44.92116013839749
                    ],
                    [
                        22.91263796039619,
                        44.92991923895681
                    ],
                    [
                        22.917908972480973,
                        44.94676587423213
                    ],
                    [
                        22.922094754805368,
                        44.95529242232918
                    ],
                    [
                        22.922559855843208,
                        44.96423254037209
                    ],
                    [
                        22.9177539452372,
                        44.97299167446771
                    ],
                    [
                        22.90581667065609,
                        44.981750696581805
                    ],
                    [
                        22.88018517348468,
                        44.99275787854952
                    ],
                    [
                        22.86344201045394,
                        45.00402334220259
                    ],
                    [
                        22.85243492995894,
                        45.0134801292993
                    ],
                    [
                        22.845251906468427,
                        45.02200674238121
                    ],
                    [
                        22.835330030494074,
                        45.02836294080872
                    ],
                    [
                        22.823392775171918,
                        45.032548733150904
                    ],
                    [
                        22.804014112548828,
                        45.03458995134182
                    ],
                    [
                        22.756988560033776,
                        45.03084340966622
                    ],
                    [
                        22.741175570939436,
                        45.0330654958273
                    ],
                    [
                        22.723140496666492,
                        45.03988678656593
                    ],
                    [
                        22.680300734085666,
                        45.07941925527906
                    ],
                    [
                        22.641078322379133,
                        45.09239004323689
                    ],
                    [
                        22.646504347013803,
                        45.1135773810171
                    ],
                    [
                        22.641388380887573,
                        45.12169058160089
                    ],
                    [
                        22.634567092033908,
                        45.127530015328375
                    ],
                    [
                        22.62511030456421,
                        45.12964875052232
                    ],
                    [
                        22.58723147983952,
                        45.13106984703576
                    ],
                    [
                        22.574519077071525,
                        45.13429963111321
                    ],
                    [
                        22.566095818749112,
                        45.1388471551786
                    ],
                    [
                        22.562530144997222,
                        45.146856999582155
                    ],
                    [
                        22.564545526172807,
                        45.156933907481914
                    ],
                    [
                        22.572658726062212,
                        45.170757354137486
                    ],
                    [
                        22.601029086572833,
                        45.197706608992526
                    ],
                    [
                        22.669138625564017,
                        45.24046886080924
                    ],
                    [
                        22.881425408639124,
                        45.294935815835714
                    ],
                    [
                        22.892432490247153,
                        45.2964861172287
                    ],
                    [
                        22.905299919069755,
                        45.29170603507453
                    ],
                    [
                        22.912327915698853,
                        45.28503978664749
                    ],
                    [
                        22.921474643843354,
                        45.279872135016134
                    ],
                    [
                        22.93341190045082,
                        45.276719881678765
                    ],
                    [
                        22.976096633478104,
                        45.274807848609775
                    ],
                    [
                        22.985398390944862,
                        45.27206900704136
                    ],
                    [
                        22.99408003058657,
                        45.2672630860574
                    ],
                    [
                        23.00152143812666,
                        45.26183707110849
                    ],
                    [
                        23.01175337010073,
                        45.259149881780665
                    ],
                    [
                        23.026997916438106,
                        45.259666644558735
                    ],
                    [
                        23.090766637361845,
                        45.27935538324239
                    ],
                    [
                        23.116036411639094,
                        45.28044058379472
                    ],
                    [
                        23.130660842157315,
                        45.27886445154702
                    ],
                    [
                        23.16104658431243,
                        45.26912344405596
                    ],
                    [
                        23.173603958140216,
                        45.26878755231781
                    ],
                    [
                        23.189468620959257,
                        45.27175893162691
                    ],
                    [
                        23.244090608816546,
                        45.295168352999234
                    ],
                    [
                        23.26005862836019,
                        45.29927664117058
                    ],
                    [
                        23.304138624959144,
                        45.30560700343859
                    ],
                    [
                        23.33871015663119,
                        45.31744089723893
                    ],
                    [
                        23.35752038056538,
                        45.32149751286466
                    ],
                    [
                        23.382790153288727,
                        45.32131662328061
                    ],
                    [
                        23.398448114703545,
                        45.31824189574182
                    ],
                    [
                        23.412297398631644,
                        45.3128417060098
                    ],
                    [
                        23.430435824620353,
                        45.30379832053602
                    ],
                    [
                        23.439427524082134,
                        45.303023173341224
                    ],
                    [
                        23.449194371445294,
                        45.30545198078511
                    ],
                    [
                        23.466712681918068,
                        45.31547720801338
                    ],
                    [
                        23.52371178426972,
                        45.337853084251755
                    ],
                    [
                        23.585775179973353,
                        45.352580871221036
                    ],
                    [
                        23.61600589177522,
                        45.34586292427611
                    ],
                    [
                        23.664426712293082,
                        45.345397864736064
                    ],
                    [
                        23.675588819467865,
                        45.343227441483826
                    ],
                    [
                        23.694554073869952,
                        45.33568270402612
                    ],
                    [
                        23.710056997937993,
                        45.333512259714695
                    ],
                    [
                        23.72804040041068,
                        45.33294384664532
                    ],
                    [
                        23.789173616932796,
                        45.33787892673712
                    ],
                    [
                        23.798165314440045,
                        45.33759469772306
                    ],
                    [
                        23.806278514810668,
                        45.33521758046927
                    ],
                    [
                        23.824106883784818,
                        45.32550241188667
                    ],
                    [
                        23.831548292081298,
                        45.31744089723893
                    ],
                    [
                        23.83573408282962,
                        45.306640521257165
                    ],
                    [
                        23.823021682602022,
                        45.26772818426679
                    ],
                    [
                        23.821006299475528,
                        45.248349505766
                    ],
                    [
                        23.828757764148428,
                        45.22129689467371
                    ],
                    [
                        23.839144728373267,
                        45.202822579779045
                    ],
                    [
                        23.843330518879092,
                        45.18910248472894
                    ],
                    [
                        23.842090284483568,
                        45.176829331222436
                    ],
                    [
                        23.82596723831825,
                        45.143291328677215
                    ],
                    [
                        23.821936475254255,
                        45.128899437622316
                    ],
                    [
                        23.82534712161649,
                        45.09492218921717
                    ],
                    [
                        23.824727003233857,
                        45.08153798758259
                    ],
                    [
                        23.796821730423428,
                        45.003041490067
                    ],
                    [
                        23.785762972446694,
                        44.98082061227826
                    ],
                    [
                        23.78126712819335,
                        44.96733310750423
                    ],
                    [
                        23.778786633789135,
                        44.948238484118946
                    ],
                    [
                        23.793669453389906,
                        44.833335983041295
                    ],
                    [
                        23.78917363222279,
                        44.78016113926548
                    ],
                    [
                        23.775531055994442,
                        44.72254192909474
                    ],
                    [
                        23.765454147882952,
                        44.729905793904145
                    ],
                    [
                        23.752896760557995,
                        44.733858934207454
                    ],
                    [
                        23.745868754646228,
                        44.73458232704673
                    ],
                    [
                        23.740132702086633,
                        44.733083937325304
                    ],
                    [
                        23.73548181254267,
                        44.729156454360485
                    ],
                    [
                        23.732691264159406,
                        44.720733045401815
                    ],
                    [
                        23.732536251859663,
                        44.71417026114712
                    ],
                    [
                        23.73377650473944,
                        44.70683233178723
                    ],
                    [
                        23.736101901567842,
                        44.698202069078164
                    ],
                    [
                        23.73718711241745,
                        44.68884867846828
                    ],
                    [
                        23.736256971756735,
                        44.677686813187705
                    ],
                    [
                        23.732381220870224,
                        44.662519651172246
                    ],
                    [
                        23.73269126564402,
                        44.65660260304575
                    ],
                    [
                        23.734241553549506,
                        44.650608096423426
                    ],
                    [
                        23.736722019279764,
                        44.64417436600951
                    ],
                    [
                        23.737652207779746,
                        44.63688807734394
                    ],
                    [
                        23.736722024051847,
                        44.62939494040228
                    ],
                    [
                        23.73222617621567,
                        44.62389141173383
                    ],
                    [
                        23.723389512556388,
                        44.6198865333396
                    ],
                    [
                        23.675898874439547,
                        44.61831041891307
                    ],
                    [
                        23.581279312401865,
                        44.596812925751266
                    ],
                    [
                        23.48939863749904,
                        44.55030428376798
                    ]
                ]
            ]
        },
        "type": "Feature",
        "properties": {
            "source": "https://simplemaps.com",
            "id": "ROGJ",
            "name": "Gorj"
        },
        "id": 26
    },
    {
        "geometry": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        22.354945916317416,
                        45.949857082579264
                    ],
                    [
                        22.40150637968027,
                        45.99166330041811
                    ],
                    [
                        22.4125134638196,
                        46.00907828537351
                    ],
                    [
                        22.419644806304095,
                        46.02533048572343
                    ],
                    [
                        22.420109897045478,
                        46.037500305268566
                    ],
                    [
                        22.417784461178258,
                        46.04773226832143
                    ],
                    [
                        22.40724246491263,
                        46.07134837065385
                    ],
                    [
                        22.409567902085275,
                        46.08121855569388
                    ],
                    [
                        22.415303991866043,
                        46.09349174534349
                    ],
                    [
                        22.429566684198207,
                        46.114239809667666
                    ],
                    [
                        22.4345276257482,
                        46.12932935853291
                    ],
                    [
                        22.436543001927987,
                        46.143281962732935
                    ],
                    [
                        22.433597441731173,
                        46.17614814798788
                    ],
                    [
                        22.43809330059311,
                        46.187103619338416
                    ],
                    [
                        22.447084999010357,
                        46.19725802964653
                    ],
                    [
                        22.47023603302498,
                        46.21195991960709
                    ],
                    [
                        22.484188672749063,
                        46.217334288038856
                    ],
                    [
                        22.502017048049904,
                        46.2188587896511
                    ],
                    [
                        22.557879269879805,
                        46.209479505344156
                    ],
                    [
                        22.576534460148572,
                        46.20854931624948
                    ],
                    [
                        22.600719026646026,
                        46.21092641150782
                    ],
                    [
                        22.619322538482205,
                        46.21823859543536
                    ],
                    [
                        22.640303174409162,
                        46.23144195161518
                    ],
                    [
                        22.66309248584232,
                        46.25753858767561
                    ],
                    [
                        22.671929151907527,
                        46.27371328228213
                    ],
                    [
                        22.68965416228829,
                        46.30024908911714
                    ],
                    [
                        22.755283230862542,
                        46.33381293160235
                    ],
                    [
                        22.803704057938983,
                        46.312212252036005
                    ],
                    [
                        22.813005816395663,
                        46.31066196206936
                    ],
                    [
                        22.904266395497316,
                        46.31727654052023
                    ],
                    [
                        22.91418827402113,
                        46.31520950938731
                    ],
                    [
                        22.92364505398145,
                        46.306682850096955
                    ],
                    [
                        22.934342064297628,
                        46.29203250425085
                    ],
                    [
                        22.949689979513614,
                        46.26371391989847
                    ],
                    [
                        22.96679487550249,
                        46.219375516821586
                    ],
                    [
                        22.973461135341136,
                        46.213665272188166
                    ],
                    [
                        22.985553424118944,
                        46.210642226061026
                    ],
                    [
                        23.03087365545465,
                        46.205655453153064
                    ],
                    [
                        23.042655872614404,
                        46.2020897172767
                    ],
                    [
                        23.05366295975629,
                        46.196560393002216
                    ],
                    [
                        23.06653038576511,
                        46.184261357249774
                    ],
                    [
                        23.078519323054362,
                        46.16844840310181
                    ],
                    [
                        23.094952423816125,
                        46.13891528711216
                    ],
                    [
                        23.095727574181748,
                        46.128864255778275
                    ],
                    [
                        23.091541777441666,
                        46.12506599085014
                    ],
                    [
                        23.084255406950312,
                        46.12715893538565
                    ],
                    [
                        23.076813997053478,
                        46.12829578918239
                    ],
                    [
                        23.0705611540348,
                        46.12739148555161
                    ],
                    [
                        23.066375354845377,
                        46.12447170875374
                    ],
                    [
                        23.064825061778794,
                        46.12007921688249
                    ],
                    [
                        23.067667267472086,
                        46.113361286589665
                    ],
                    [
                        23.074488561153444,
                        46.10457633021352
                    ],
                    [
                        23.170968457735057,
                        46.01597706643548
                    ],
                    [
                        23.19473962085573,
                        46.00835482692023
                    ],
                    [
                        23.214428339270846,
                        46.005926024168936
                    ],
                    [
                        23.2255904435933,
                        45.99967313436508
                    ],
                    [
                        23.264399447768398,
                        45.929315701507576
                    ],
                    [
                        23.281142611450665,
                        45.9108930500153
                    ],
                    [
                        23.307084182302173,
                        45.88836213513629
                    ],
                    [
                        23.316075882025537,
                        45.87683829179844
                    ],
                    [
                        23.341190631070194,
                        45.800047131930675
                    ],
                    [
                        23.363566517347262,
                        45.7583958656197
                    ],
                    [
                        23.371783080139192,
                        45.73695021931546
                    ],
                    [
                        23.375503782062513,
                        45.72204156078335
                    ],
                    [
                        23.372868277768145,
                        45.703308805058846
                    ],
                    [
                        23.37472863564451,
                        45.69498895411723
                    ],
                    [
                        23.379999630617498,
                        45.68734083055633
                    ],
                    [
                        23.40108360822488,
                        45.66989998343615
                    ],
                    [
                        23.404390903665004,
                        45.6605982566644
                    ],
                    [
                        23.40216881493101,
                        45.653751112475895
                    ],
                    [
                        23.398448109289067,
                        45.646309687185855
                    ],
                    [
                        23.395502555532495,
                        45.6386357577887
                    ],
                    [
                        23.396432731228302,
                        45.63008330739713
                    ],
                    [
                        23.400308464404215,
                        45.61995473597779
                    ],
                    [
                        23.41090213301503,
                        45.60259145049114
                    ],
                    [
                        23.422994419864917,
                        45.58993073670448
                    ],
                    [
                        23.446558870574442,
                        45.57664987957906
                    ],
                    [
                        23.48536787376565,
                        45.56388581677342
                    ],
                    [
                        23.502421094422125,
                        45.55520416225985
                    ],
                    [
                        23.523866817912104,
                        45.537427494448224
                    ],
                    [
                        23.57378624948719,
                        45.50409619038172
                    ],
                    [
                        23.580349155762793,
                        45.497946689825504
                    ],
                    [
                        23.58375980250132,
                        45.48807649997308
                    ],
                    [
                        23.58562015282039,
                        45.48053173578865
                    ],
                    [
                        23.584224887527736,
                        45.44730377434553
                    ],
                    [
                        23.58081424414813,
                        45.432291785542155
                    ],
                    [
                        23.583294710614496,
                        45.423015842982714
                    ],
                    [
                        23.59709231860262,
                        45.39278514144285
                    ],
                    [
                        23.599882846050182,
                        45.38190724863358
                    ],
                    [
                        23.585775179973353,
                        45.352580871221036
                    ],
                    [
                        23.52371178426972,
                        45.337853084251755
                    ],
                    [
                        23.466712681918068,
                        45.31547720801338
                    ],
                    [
                        23.449194371445294,
                        45.30545198078511
                    ],
                    [
                        23.439427524082134,
                        45.303023173341224
                    ],
                    [
                        23.430435824620353,
                        45.30379832053602
                    ],
                    [
                        23.412297398631644,
                        45.3128417060098
                    ],
                    [
                        23.398448114703545,
                        45.31824189574182
                    ],
                    [
                        23.382790153288727,
                        45.32131662328061
                    ],
                    [
                        23.35752038056538,
                        45.32149751286466
                    ],
                    [
                        23.33871015663119,
                        45.31744089723893
                    ],
                    [
                        23.304138624959144,
                        45.30560700343859
                    ],
                    [
                        23.26005862836019,
                        45.29927664117058
                    ],
                    [
                        23.244090608816546,
                        45.295168352999234
                    ],
                    [
                        23.189468620959257,
                        45.27175893162691
                    ],
                    [
                        23.173603958140216,
                        45.26878755231781
                    ],
                    [
                        23.16104658431243,
                        45.26912344405596
                    ],
                    [
                        23.130660842157315,
                        45.27886445154702
                    ],
                    [
                        23.116036411639094,
                        45.28044058379472
                    ],
                    [
                        23.090766637361845,
                        45.27935538324239
                    ],
                    [
                        23.026997916438106,
                        45.259666644558735
                    ],
                    [
                        23.01175337010073,
                        45.259149881780665
                    ],
                    [
                        23.00152143812666,
                        45.26183707110849
                    ],
                    [
                        22.99408003058657,
                        45.2672630860574
                    ],
                    [
                        22.985398390944862,
                        45.27206900704136
                    ],
                    [
                        22.976096633478104,
                        45.274807848609775
                    ],
                    [
                        22.93341190045082,
                        45.276719881678765
                    ],
                    [
                        22.921474643843354,
                        45.279872135016134
                    ],
                    [
                        22.912327915698853,
                        45.28503978664749
                    ],
                    [
                        22.905299919069755,
                        45.29170603507453
                    ],
                    [
                        22.892432490247153,
                        45.2964861172287
                    ],
                    [
                        22.881425408639124,
                        45.294935815835714
                    ],
                    [
                        22.669138625564017,
                        45.24046886080924
                    ],
                    [
                        22.669913769651398,
                        45.259614970160676
                    ],
                    [
                        22.67223921108174,
                        45.2669013582593
                    ],
                    [
                        22.67709679540644,
                        45.27547964292571
                    ],
                    [
                        22.698645868065714,
                        45.29863068315038
                    ],
                    [
                        22.704226922713833,
                        45.306795563505624
                    ],
                    [
                        22.706397331275017,
                        45.314288640037255
                    ],
                    [
                        22.706862418961244,
                        45.32232432308917
                    ],
                    [
                        22.70407189355788,
                        45.33160024828567
                    ],
                    [
                        22.698180778135743,
                        45.342090548953
                    ],
                    [
                        22.684693229986646,
                        45.355526428255956
                    ],
                    [
                        22.67740685386777,
                        45.36508657127673
                    ],
                    [
                        22.675339794372324,
                        45.37394906462942
                    ],
                    [
                        22.67875044133423,
                        45.38043447955529
                    ],
                    [
                        22.691204459306004,
                        45.393611953911574
                    ],
                    [
                        22.696320430527177,
                        45.40368888807997
                    ],
                    [
                        22.698025751056683,
                        45.41301647132081
                    ],
                    [
                        22.694150017389603,
                        45.429656274581795
                    ],
                    [
                        22.694615107829957,
                        45.440482505708545
                    ],
                    [
                        22.693529899062717,
                        45.45143787881736
                    ],
                    [
                        22.690274285275603,
                        45.46322011573853
                    ],
                    [
                        22.678440382965373,
                        45.49254649348719
                    ],
                    [
                        22.66867353731534,
                        45.50652497112915
                    ],
                    [
                        22.653325635651225,
                        45.52021922248424
                    ],
                    [
                        22.620252718860307,
                        45.53843516037317
                    ],
                    [
                        22.601029084941906,
                        45.546780896319035
                    ],
                    [
                        22.588626744880692,
                        45.554454871523724
                    ],
                    [
                        22.582580602233428,
                        45.56233552420189
                    ],
                    [
                        22.57606936897652,
                        45.567089739566036
                    ],
                    [
                        22.565785758946163,
                        45.568614193634275
                    ],
                    [
                        22.55648400205031,
                        45.5672964526155
                    ],
                    [
                        22.547957391431982,
                        45.56734813089586
                    ],
                    [
                        22.54237633524597,
                        45.570035296633996
                    ],
                    [
                        22.541136102375432,
                        45.57804515435164
                    ],
                    [
                        22.542996452475943,
                        45.585538223563276
                    ],
                    [
                        22.542376337280185,
                        45.59243704599627
                    ],
                    [
                        22.537415397549754,
                        45.597320451930976
                    ],
                    [
                        22.522842647140312,
                        45.60036938558294
                    ],
                    [
                        22.51100874045389,
                        45.60140289180805
                    ],
                    [
                        22.49674604677366,
                        45.604916895790666
                    ],
                    [
                        22.48341352791986,
                        45.61153148989118
                    ],
                    [
                        22.4536479009976,
                        45.64005686217893
                    ],
                    [
                        22.44537967352561,
                        45.66289785870288
                    ],
                    [
                        22.453647897260176,
                        45.665584993031565
                    ],
                    [
                        22.457368602033167,
                        45.668375531868634
                    ],
                    [
                        22.461554396405184,
                        45.67382742103679
                    ],
                    [
                        22.463879837609134,
                        45.680674557007286
                    ],
                    [
                        22.46822065861659,
                        45.69938143408294
                    ],
                    [
                        22.47302655991892,
                        45.708941526273364
                    ],
                    [
                        22.481088093607962,
                        45.71909601153303
                    ],
                    [
                        22.492715284623312,
                        45.72811351139484
                    ],
                    [
                        22.53276452275231,
                        45.75369336641913
                    ],
                    [
                        22.54113609907391,
                        45.76128975917545
                    ],
                    [
                        22.543616567057516,
                        45.768679484114614
                    ],
                    [
                        22.540826042170348,
                        45.775294089442205
                    ],
                    [
                        22.52981896350532,
                        45.779893298723145
                    ],
                    [
                        22.522532588667467,
                        45.780358405169885
                    ],
                    [
                        22.514781119575666,
                        45.77885974798729
                    ],
                    [
                        22.50248212805685,
                        45.774028002417225
                    ],
                    [
                        22.49411055068699,
                        45.77741284314196
                    ],
                    [
                        22.48604902189163,
                        45.78599109368181
                    ],
                    [
                        22.467290482329098,
                        45.818366417702194
                    ],
                    [
                        22.45767866777025,
                        45.83069126053784
                    ],
                    [
                        22.449410439649203,
                        45.83715081672192
                    ],
                    [
                        22.4219702517624,
                        45.85244702785188
                    ],
                    [
                        22.412513459845417,
                        45.862704762859096
                    ],
                    [
                        22.406002230301624,
                        45.877484225506514
                    ],
                    [
                        22.401816444435216,
                        45.889757416594996
                    ],
                    [
                        22.398870881545147,
                        45.908205857713654
                    ],
                    [
                        22.38905236026148,
                        45.92466480633596
                    ],
                    [
                        22.354945916317416,
                        45.949857082579264
                    ]
                ]
            ]
        },
        "type": "Feature",
        "properties": {
            "source": "https://simplemaps.com",
            "id": "ROHD",
            "name": "Hunedoara"
        },
        "id": 27
    },
    {
        "geometry": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        23.958155540893358,
                        44.529659452605515
                    ],
                    [
                        23.929475126989264,
                        44.550665969044125
                    ],
                    [
                        23.91330042852403,
                        44.56826196320059
                    ],
                    [
                        23.90167322362139,
                        44.58335143259651
                    ],
                    [
                        23.88105431979913,
                        44.63277988568943
                    ],
                    [
                        23.872217640369037,
                        44.64171984262376
                    ],
                    [
                        23.862450816346485,
                        44.64755943456441
                    ],
                    [
                        23.829067807943307,
                        44.66270039101267
                    ],
                    [
                        23.81387494593652,
                        44.66740301354906
                    ],
                    [
                        23.796304968169046,
                        44.67494784022744
                    ],
                    [
                        23.788398490604507,
                        44.6818467535136
                    ],
                    [
                        23.784057666886262,
                        44.691174334832255
                    ],
                    [
                        23.78297244898858,
                        44.69913241260923
                    ],
                    [
                        23.775531055994442,
                        44.72254192909474
                    ],
                    [
                        23.78917363222279,
                        44.78016113926548
                    ],
                    [
                        23.793669453389906,
                        44.833335983041295
                    ],
                    [
                        23.778786633789135,
                        44.948238484118946
                    ],
                    [
                        23.78126712819335,
                        44.96733310750423
                    ],
                    [
                        23.785762972446694,
                        44.98082061227826
                    ],
                    [
                        23.796821730423428,
                        45.003041490067
                    ],
                    [
                        23.824727003233857,
                        45.08153798758259
                    ],
                    [
                        23.82534712161649,
                        45.09492218921717
                    ],
                    [
                        23.821936475254255,
                        45.128899437622316
                    ],
                    [
                        23.82596723831825,
                        45.143291328677215
                    ],
                    [
                        23.842090284483568,
                        45.176829331222436
                    ],
                    [
                        23.843330518879092,
                        45.18910248472894
                    ],
                    [
                        23.839144728373267,
                        45.202822579779045
                    ],
                    [
                        23.828757764148428,
                        45.22129689467371
                    ],
                    [
                        23.821006299475528,
                        45.248349505766
                    ],
                    [
                        23.823021682602022,
                        45.26772818426679
                    ],
                    [
                        23.83573408282962,
                        45.306640521257165
                    ],
                    [
                        23.831548292081298,
                        45.31744089723893
                    ],
                    [
                        23.824106883784818,
                        45.32550241188667
                    ],
                    [
                        23.806278514810668,
                        45.33521758046927
                    ],
                    [
                        23.798165314440045,
                        45.33759469772306
                    ],
                    [
                        23.789173616932796,
                        45.33787892673712
                    ],
                    [
                        23.72804040041068,
                        45.33294384664532
                    ],
                    [
                        23.710056997937993,
                        45.333512259714695
                    ],
                    [
                        23.694554073869952,
                        45.33568270402612
                    ],
                    [
                        23.675588819467865,
                        45.343227441483826
                    ],
                    [
                        23.664426712293082,
                        45.345397864736064
                    ],
                    [
                        23.61600589177522,
                        45.34586292427611
                    ],
                    [
                        23.585775179973353,
                        45.352580871221036
                    ],
                    [
                        23.599882846050182,
                        45.38190724863358
                    ],
                    [
                        23.59709231860262,
                        45.39278514144285
                    ],
                    [
                        23.583294710614496,
                        45.423015842982714
                    ],
                    [
                        23.58081424414813,
                        45.432291785542155
                    ],
                    [
                        23.584224887527736,
                        45.44730377434553
                    ],
                    [
                        23.626082795657084,
                        45.451928804352974
                    ],
                    [
                        23.64690840208231,
                        45.45050773002797
                    ],
                    [
                        23.658690629003917,
                        45.453866700734636
                    ],
                    [
                        23.67915449518987,
                        45.46285839233828
                    ],
                    [
                        23.709746943427756,
                        45.4797565897947
                    ],
                    [
                        23.722924431262864,
                        45.48337392599086
                    ],
                    [
                        23.740132685256018,
                        45.48381318835496
                    ],
                    [
                        23.752586703494963,
                        45.48606109842953
                    ],
                    [
                        23.761888463328432,
                        45.491228753691374
                    ],
                    [
                        23.770260043111087,
                        45.498437599770355
                    ],
                    [
                        23.77863162861058,
                        45.504354576258116
                    ],
                    [
                        23.793979526227638,
                        45.508023590843464
                    ],
                    [
                        23.96063602207905,
                        45.5122093856566
                    ],
                    [
                        23.998514844737322,
                        45.50900543784801
                    ],
                    [
                        24.034068233026716,
                        45.49815340276129
                    ],
                    [
                        24.049416133736912,
                        45.495879643240144
                    ],
                    [
                        24.068329707621213,
                        45.49639640381559
                    ],
                    [
                        24.168892045732733,
                        45.53703991958818
                    ],
                    [
                        24.182689650855526,
                        45.54052806960306
                    ],
                    [
                        24.321750929904187,
                        45.563033153145554
                    ],
                    [
                        24.52721642308166,
                        45.56181874869918
                    ],
                    [
                        24.539463740597885,
                        45.529831054801036
                    ],
                    [
                        24.52545942412455,
                        45.485699352994295
                    ],
                    [
                        24.49615888833219,
                        45.44621857467262
                    ],
                    [
                        24.49367841770408,
                        45.435418180695784
                    ],
                    [
                        24.49383344649617,
                        45.42407520390411
                    ],
                    [
                        24.51429731660211,
                        45.36131419627928
                    ],
                    [
                        24.516622758252417,
                        45.349428629021304
                    ],
                    [
                        24.513677197182457,
                        45.340126847392376
                    ],
                    [
                        24.506080765658137,
                        45.332220381779074
                    ],
                    [
                        24.497864208159623,
                        45.32550241188667
                    ],
                    [
                        24.4919730981592,
                        45.31790599910468
                    ],
                    [
                        24.489957716216104,
                        45.30865590338033
                    ],
                    [
                        24.491197950977845,
                        45.297700507811825
                    ],
                    [
                        24.500499709327944,
                        45.27346426350917
                    ],
                    [
                        24.49770918004676,
                        45.2488662731309
                    ],
                    [
                        24.493213332042664,
                        45.22847992368043
                    ],
                    [
                        24.495073681878075,
                        45.21553497551941
                    ],
                    [
                        24.500189650576036,
                        45.20550975838459
                    ],
                    [
                        24.515072463282504,
                        45.193314117849454
                    ],
                    [
                        24.521738721952346,
                        45.186131093010424
                    ],
                    [
                        24.52949018581437,
                        45.1744780463929
                    ],
                    [
                        24.535277948071883,
                        45.159414372219
                    ],
                    [
                        24.537448357757214,
                        45.13610830278833
                    ],
                    [
                        24.506700880328946,
                        45.041798812136555
                    ],
                    [
                        24.495848838496865,
                        44.98113074198568
                    ],
                    [
                        24.488097348842285,
                        44.96025329067565
                    ],
                    [
                        24.489027544393352,
                        44.95188184221832
                    ],
                    [
                        24.49553878714438,
                        44.943406999831694
                    ],
                    [
                        24.504220405287008,
                        44.93472520182475
                    ],
                    [
                        24.51073163848281,
                        44.922994672978426
                    ],
                    [
                        24.51197189926985,
                        44.91410650046043
                    ],
                    [
                        24.508561250918813,
                        44.9056315467379
                    ],
                    [
                        24.502205047307182,
                        44.89687236966958
                    ],
                    [
                        24.462930950902663,
                        44.86377356400221
                    ],
                    [
                        24.43781620665845,
                        44.8500276471937
                    ],
                    [
                        24.43983159184856,
                        44.89656230572315
                    ],
                    [
                        24.434560582856,
                        44.90382275310347
                    ],
                    [
                        24.426964128717696,
                        44.91209084916292
                    ],
                    [
                        24.416422174744,
                        44.91410650046043
                    ],
                    [
                        24.407533823340586,
                        44.91348634597319
                    ],
                    [
                        24.39699183727853,
                        44.909507298912935
                    ],
                    [
                        24.388775260778747,
                        44.90320261463333
                    ],
                    [
                        24.381333835800138,
                        44.89570940200375
                    ],
                    [
                        24.353376920159057,
                        44.860259607920106
                    ],
                    [
                        24.348260943074283,
                        44.84894239906475
                    ],
                    [
                        24.344695281727706,
                        44.836953550749215
                    ],
                    [
                        24.342524875411932,
                        44.823466029371254
                    ],
                    [
                        24.335703584698106,
                        44.80119347787036
                    ],
                    [
                        24.329967481554746,
                        44.790289617483914
                    ],
                    [
                        24.32082073577135,
                        44.77768044162161
                    ],
                    [
                        24.305007743584124,
                        44.75990372707933
                    ],
                    [
                        24.286352588571575,
                        44.74589967020562
                    ],
                    [
                        24.28619754183719,
                        44.737424610850404
                    ],
                    [
                        24.290538370989246,
                        44.71587560379326
                    ],
                    [
                        24.30449098608608,
                        44.672622277132135
                    ],
                    [
                        24.299840134961993,
                        44.65551757093278
                    ],
                    [
                        24.311984093779916,
                        44.6430893671493
                    ],
                    [
                        24.322991159494944,
                        44.62440824204478
                    ],
                    [
                        24.330897642213703,
                        44.60154134268865
                    ],
                    [
                        24.33322308883378,
                        44.583170422806006
                    ],
                    [
                        24.324851536565333,
                        44.578519750261705
                    ],
                    [
                        24.317875189731023,
                        44.57361028977417
                    ],
                    [
                        24.30903853936429,
                        44.57725361415729
                    ],
                    [
                        24.301390432196413,
                        44.58394574355345
                    ],
                    [
                        24.296274446740448,
                        44.59079274449272
                    ],
                    [
                        24.293638948039554,
                        44.59727813360619
                    ],
                    [
                        24.293483924263377,
                        44.60389275085527
                    ],
                    [
                        24.295189232771218,
                        44.613840368186956
                    ],
                    [
                        24.29332889827732,
                        44.6178970829242
                    ],
                    [
                        24.287437774163706,
                        44.619964072343855
                    ],
                    [
                        24.27798098381073,
                        44.6198865333396
                    ],
                    [
                        24.26557864868515,
                        44.61306529575792
                    ],
                    [
                        24.260307672440305,
                        44.60471970004435
                    ],
                    [
                        24.254261489829833,
                        44.58373878771352
                    ],
                    [
                        24.245993267474358,
                        44.57640077542033
                    ],
                    [
                        24.21669276387853,
                        44.564412078344525
                    ],
                    [
                        24.20692589759997,
                        44.562448232892834
                    ],
                    [
                        24.196693982699937,
                        44.562629233484806
                    ],
                    [
                        24.173232869034297,
                        44.567202501055334
                    ],
                    [
                        24.1605204529777,
                        44.567770843702085
                    ],
                    [
                        24.149668423447462,
                        44.56640157269755
                    ],
                    [
                        24.1373694078851,
                        44.561388785844144
                    ],
                    [
                        24.127137481882126,
                        44.55350818550235
                    ],
                    [
                        24.095666522843292,
                        44.520616050137896
                    ],
                    [
                        24.083522556814238,
                        44.517024503534316
                    ],
                    [
                        24.075616092723376,
                        44.51723142557123
                    ],
                    [
                        24.06817467592348,
                        44.52208893517675
                    ],
                    [
                        24.058872921364635,
                        44.53384534813335
                    ],
                    [
                        24.050656381450512,
                        44.5409509390478
                    ],
                    [
                        24.041664669676763,
                        44.54596347500194
                    ],
                    [
                        24.030967645501967,
                        44.549477444959955
                    ],
                    [
                        24.019908903262376,
                        44.550924490277474
                    ],
                    [
                        24.006731392272112,
                        44.549167342686125
                    ],
                    [
                        23.996344423364306,
                        44.5466868381875
                    ],
                    [
                        23.958155540893358,
                        44.529659452605515
                    ]
                ]
            ]
        },
        "type": "Feature",
        "properties": {
            "source": "https://simplemaps.com",
            "id": "ROVL",
            "name": "Valcea"
        },
        "id": 28
    },
    {
        "geometry": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        26.02893353312858,
                        44.73814801008947
                    ],
                    [
                        26.01715134012533,
                        44.74034447677504
                    ],
                    [
                        25.99699752619184,
                        44.74830260825216
                    ],
                    [
                        25.985008588217248,
                        44.75556311664951
                    ],
                    [
                        25.915813822477155,
                        44.81563682304377
                    ],
                    [
                        25.89922572094085,
                        44.822820054500816
                    ],
                    [
                        25.883567764569047,
                        44.826928350263245
                    ],
                    [
                        25.836077081673118,
                        44.83173398887437
                    ],
                    [
                        25.82522505425369,
                        44.83744438671227
                    ],
                    [
                        25.81747359105312,
                        44.84697869694816
                    ],
                    [
                        25.81370120847584,
                        44.865272136386345
                    ],
                    [
                        25.815716610277004,
                        44.87968999745821
                    ],
                    [
                        25.819127218181208,
                        44.89361655752418
                    ],
                    [
                        25.818507128238377,
                        44.908267005233995
                    ],
                    [
                        25.81385623564418,
                        44.921780304844596
                    ],
                    [
                        25.80005862221254,
                        44.93823920369954
                    ],
                    [
                        25.790291798428,
                        44.946300872825596
                    ],
                    [
                        25.78207522783977,
                        44.948987928550466
                    ],
                    [
                        25.77432375542658,
                        44.94777348098792
                    ],
                    [
                        25.765797175806348,
                        44.9451640352802
                    ],
                    [
                        25.754893436519257,
                        44.94345863230488
                    ],
                    [
                        25.7435762851258,
                        44.943561897271394
                    ],
                    [
                        25.731328955197526,
                        44.94655903713977
                    ],
                    [
                        25.721252069178906,
                        44.95043488274749
                    ],
                    [
                        25.711485221782667,
                        44.95673939950855
                    ],
                    [
                        25.702441827141417,
                        44.967539649889055
                    ],
                    [
                        25.695155471757502,
                        44.98058809154357
                    ],
                    [
                        25.68709394716726,
                        45.005263577607955
                    ],
                    [
                        25.681357863608167,
                        45.04799998752876
                    ],
                    [
                        25.677017042729208,
                        45.05880036102258
                    ],
                    [
                        25.668800490371535,
                        45.0694457068421
                    ],
                    [
                        25.62689090307647,
                        45.10236359325039
                    ],
                    [
                        25.572268915025347,
                        45.177552809286
                    ],
                    [
                        25.56079674870411,
                        45.18949006755035
                    ],
                    [
                        25.549944695513286,
                        45.19703481659531
                    ],
                    [
                        25.540901319088853,
                        45.20494130564444
                    ],
                    [
                        25.52570844983321,
                        45.22375153582647
                    ],
                    [
                        25.52446821372811,
                        45.2374974559102
                    ],
                    [
                        25.52694868227036,
                        45.256876122350484
                    ],
                    [
                        25.527103714544168,
                        45.26509268616186
                    ],
                    [
                        25.52431318550156,
                        45.27496287796281
                    ],
                    [
                        25.518267042841526,
                        45.28674510118597
                    ],
                    [
                        25.506484814980585,
                        45.30033600092534
                    ],
                    [
                        25.49594282518951,
                        45.30860424148494
                    ],
                    [
                        25.486175978097865,
                        45.31413361385955
                    ],
                    [
                        25.475737337989994,
                        45.31878448392399
                    ],
                    [
                        25.466280551407582,
                        45.32415883976257
                    ],
                    [
                        25.459304236296852,
                        45.33294384664532
                    ],
                    [
                        25.454808381303234,
                        45.34503610118124
                    ],
                    [
                        25.447987094457527,
                        45.3897879088166
                    ],
                    [
                        25.42979699261667,
                        45.45231640577406
                    ],
                    [
                        25.445971715684127,
                        45.459990353790886
                    ],
                    [
                        25.45883914405289,
                        45.46358183948731
                    ],
                    [
                        25.62782107730697,
                        45.48474334321728
                    ],
                    [
                        25.650972123369144,
                        45.48533764615195
                    ],
                    [
                        25.693295120030612,
                        45.47939485044718
                    ],
                    [
                        25.7358248211114,
                        45.46776763462484
                    ],
                    [
                        25.75024254749528,
                        45.465907296712494
                    ],
                    [
                        25.77804446714315,
                        45.472754419784586
                    ],
                    [
                        25.790446812410913,
                        45.47334870370808
                    ],
                    [
                        25.802849153146443,
                        45.46792266638732
                    ],
                    [
                        25.809825472566935,
                        45.461359762122164
                    ],
                    [
                        25.82305464311059,
                        45.44549512270992
                    ],
                    [
                        25.83173627791096,
                        45.43996570741534
                    ],
                    [
                        25.845533889569854,
                        45.43826041191731
                    ],
                    [
                        25.862742139392214,
                        45.44156768883657
                    ],
                    [
                        25.88217247700756,
                        45.45332407191491
                    ],
                    [
                        25.891319208777848,
                        45.46539053994232
                    ],
                    [
                        25.896435173219377,
                        45.47823211646337
                    ],
                    [
                        25.89891564053337,
                        45.48923918802736
                    ],
                    [
                        25.902791377497376,
                        45.50060803677689
                    ],
                    [
                        25.910852902066413,
                        45.508850427318514
                    ],
                    [
                        25.92403039102289,
                        45.51251944781447
                    ],
                    [
                        25.945786168262046,
                        45.510194007028666
                    ],
                    [
                        25.99885786573484,
                        45.48861910257991
                    ],
                    [
                        26.045986769127488,
                        45.48226288439285
                    ],
                    [
                        26.106086458067434,
                        45.43159413274873
                    ],
                    [
                        26.146859166136224,
                        45.41025178145199
                    ],
                    [
                        26.16070844757088,
                        45.40087249644343
                    ],
                    [
                        26.17404096706299,
                        45.38653228008834
                    ],
                    [
                        26.208354121508183,
                        45.333925696749404
                    ],
                    [
                        26.213625116077537,
                        45.31855195149807
                    ],
                    [
                        26.21207482196285,
                        45.30909515400652
                    ],
                    [
                        26.20597700243758,
                        45.30219634757715
                    ],
                    [
                        26.204116653291162,
                        45.294031488999394
                    ],
                    [
                        26.208664178394248,
                        45.28333446059122
                    ],
                    [
                        26.236879510460273,
                        45.262560536611055
                    ],
                    [
                        26.247731561857304,
                        45.25230276893199
                    ],
                    [
                        26.250522087505807,
                        45.24116648835772
                    ],
                    [
                        26.251607292400244,
                        45.23266571137984
                    ],
                    [
                        26.25470787937145,
                        45.225353506302596
                    ],
                    [
                        26.262149284689702,
                        45.21822214703977
                    ],
                    [
                        26.27615359873612,
                        45.21248606961108
                    ],
                    [
                        26.28979617615775,
                        45.21052236308317
                    ],
                    [
                        26.334031204354574,
                        45.21289949082973
                    ],
                    [
                        26.345348340499815,
                        45.21021229903645
                    ],
                    [
                        26.355115187402937,
                        45.204579579060514
                    ],
                    [
                        26.35992109522899,
                        45.19197053036929
                    ],
                    [
                        26.37077314561334,
                        45.185252586495444
                    ],
                    [
                        26.37888634559652,
                        45.183857324529235
                    ],
                    [
                        26.38632775116197,
                        45.18742299549778
                    ],
                    [
                        26.402915887663976,
                        45.198145866582415
                    ],
                    [
                        26.411132439086067,
                        45.200548808750746
                    ],
                    [
                        26.416093378481186,
                        45.19843008785176
                    ],
                    [
                        26.417178581510505,
                        45.19111786231717
                    ],
                    [
                        26.41469811282796,
                        45.18308217054932
                    ],
                    [
                        26.413302850063033,
                        45.1732119802608
                    ],
                    [
                        26.415938347236057,
                        45.16148142871329
                    ],
                    [
                        26.430201042719364,
                        45.15037099561712
                    ],
                    [
                        26.45366214436813,
                        45.13714183459541
                    ],
                    [
                        26.462963900608717,
                        45.12778839472283
                    ],
                    [
                        26.46916507231902,
                        45.117608137280705
                    ],
                    [
                        26.47366092354838,
                        45.10195018456826
                    ],
                    [
                        26.47629642001988,
                        45.08804921736566
                    ],
                    [
                        26.47815677289665,
                        45.05029959021907
                    ],
                    [
                        26.48265262205348,
                        45.03536509962562
                    ],
                    [
                        26.48947391152825,
                        45.02474559259566
                    ],
                    [
                        26.505958693204704,
                        45.01782095088949
                    ],
                    [
                        26.534018996170694,
                        45.012084866396236
                    ],
                    [
                        26.542545606886005,
                        45.009397691498386
                    ],
                    [
                        26.564921491653017,
                        44.99368799089211
                    ],
                    [
                        26.572828007099965,
                        44.986220875990114
                    ],
                    [
                        26.577943985105648,
                        44.97741011815032
                    ],
                    [
                        26.575928587812154,
                        44.96387078875009
                    ],
                    [
                        26.568022111008872,
                        44.9558093738745
                    ],
                    [
                        26.550142026768576,
                        44.942579964622695
                    ],
                    [
                        26.5436307957276,
                        44.93513855828351
                    ],
                    [
                        26.543010685515902,
                        44.92609522368084
                    ],
                    [
                        26.547351512030186,
                        44.916276743278814
                    ],
                    [
                        26.584920277617748,
                        44.88904325250119
                    ],
                    [
                        26.603885519827564,
                        44.8650653416157
                    ],
                    [
                        26.578098975460744,
                        44.84237935275136
                    ],
                    [
                        26.565541627838297,
                        44.82620479113847
                    ],
                    [
                        26.558720323360173,
                        44.82098536937932
                    ],
                    [
                        26.5479716476972,
                        44.81509439793685
                    ],
                    [
                        26.534794153952692,
                        44.81018511760104
                    ],
                    [
                        26.520221382645026,
                        44.80718778015343
                    ],
                    [
                        26.466064507577876,
                        44.810650265822275
                    ],
                    [
                        26.452731951956117,
                        44.80827291511963
                    ],
                    [
                        26.439244442926185,
                        44.80041835121692
                    ],
                    [
                        26.431286226199788,
                        44.79313168413655
                    ],
                    [
                        26.42198448466119,
                        44.78662055323414
                    ],
                    [
                        26.410822391660545,
                        44.783106663128926
                    ],
                    [
                        26.38834312238374,
                        44.78419173298779
                    ],
                    [
                        26.364882047400986,
                        44.7934419733109
                    ],
                    [
                        26.35387497026671,
                        44.79592246291242
                    ],
                    [
                        26.339612262224886,
                        44.79499220116441
                    ],
                    [
                        26.3054541136699,
                        44.78351986276057
                    ],
                    [
                        26.26964236560544,
                        44.75980050954383
                    ],
                    [
                        26.22757776692202,
                        44.76135091300612
                    ],
                    [
                        26.213521766077495,
                        44.76000725001878
                    ],
                    [
                        26.187166784195004,
                        44.76788789747002
                    ],
                    [
                        26.163809034948724,
                        44.76801707467938
                    ],
                    [
                        26.103295912736463,
                        44.753857606085475
                    ],
                    [
                        26.04226605010468,
                        44.75326335110313
                    ],
                    [
                        26.03451459054331,
                        44.742178793663165
                    ],
                    [
                        26.02893353312858,
                        44.73814801008947
                    ]
                ]
            ]
        },
        "type": "Feature",
        "properties": {
            "source": "https://simplemaps.com",
            "id": "ROPH",
            "name": "Prahova"
        },
        "id": 29
    },
    {
        "geometry": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        26.484823033573665,
                        46.02124808165302
                    ],
                    [
                        26.42089928842454,
                        45.95045137712194
                    ],
                    [
                        26.404776242903804,
                        45.91750766309255
                    ],
                    [
                        26.40322594289649,
                        45.90254729032339
                    ],
                    [
                        26.389118278423332,
                        45.85203358543604
                    ],
                    [
                        26.38043663702682,
                        45.80294097506188
                    ],
                    [
                        26.389273309366068,
                        45.78175365154007
                    ],
                    [
                        26.394699335540682,
                        45.772503575199636
                    ],
                    [
                        26.397334834466534,
                        45.76149650501174
                    ],
                    [
                        26.39500938688261,
                        45.749817577927715
                    ],
                    [
                        26.376819293879162,
                        45.72191236818565
                    ],
                    [
                        26.372478463856623,
                        45.709664995023445
                    ],
                    [
                        26.37108320010389,
                        45.69852872481428
                    ],
                    [
                        26.366742383503137,
                        45.68522206447499
                    ],
                    [
                        26.3582157696963,
                        45.67250964862026
                    ],
                    [
                        26.342712840118345,
                        45.655249715457764
                    ],
                    [
                        26.336201611924693,
                        45.64103871445544
                    ],
                    [
                        26.32860517998741,
                        45.618094402298446
                    ],
                    [
                        26.31940677322575,
                        45.608947658943976
                    ],
                    [
                        26.301733430802656,
                        45.602100517793936
                    ],
                    [
                        26.284680207790547,
                        45.60284982832927
                    ],
                    [
                        26.273518103431428,
                        45.60693229099998
                    ],
                    [
                        26.255017935737897,
                        45.6190245488374
                    ],
                    [
                        26.244941034990454,
                        45.62377880378935
                    ],
                    [
                        26.234554068525867,
                        45.625561617369314
                    ],
                    [
                        26.224477164472187,
                        45.62284860700867
                    ],
                    [
                        26.215640495803733,
                        45.61215158905383
                    ],
                    [
                        26.211454703928606,
                        45.602100517793936
                    ],
                    [
                        26.20752729497118,
                        45.58321278526687
                    ],
                    [
                        26.201016064100152,
                        45.577269996801604
                    ],
                    [
                        26.188923778591477,
                        45.574531137621236
                    ],
                    [
                        26.13957279047514,
                        45.57298087708496
                    ],
                    [
                        26.100453726037507,
                        45.56440255690124
                    ],
                    [
                        26.079059684768918,
                        45.580215558210874
                    ],
                    [
                        26.048208853978274,
                        45.61406361584686
                    ],
                    [
                        26.028933545378372,
                        45.625690814302004
                    ],
                    [
                        26.01001997118186,
                        45.633390604748755
                    ],
                    [
                        25.990486279949707,
                        45.63907501252041
                    ],
                    [
                        25.980357694401878,
                        45.645069451517315
                    ],
                    [
                        25.96500979647921,
                        45.66677356744786
                    ],
                    [
                        25.94950686735281,
                        45.684446911080066
                    ],
                    [
                        25.919534543628238,
                        45.70547925869691
                    ],
                    [
                        25.89472985256369,
                        45.71777822919997
                    ],
                    [
                        25.801763946964282,
                        45.74237618890605
                    ],
                    [
                        25.784400673442953,
                        45.74896498041809
                    ],
                    [
                        25.768587678480085,
                        45.76526885259823
                    ],
                    [
                        25.76279992451919,
                        45.75909356075766
                    ],
                    [
                        25.747296986092845,
                        45.75674222250157
                    ],
                    [
                        25.732879262378024,
                        45.75276314586035
                    ],
                    [
                        25.718926625829425,
                        45.75198800214946
                    ],
                    [
                        25.704508909191276,
                        45.75909356075766
                    ],
                    [
                        25.69670575997772,
                        45.754080901613726
                    ],
                    [
                        25.689109327716125,
                        45.75188467019069
                    ],
                    [
                        25.67097089584402,
                        45.751626263880105
                    ],
                    [
                        25.66900719718794,
                        45.7850092727966
                    ],
                    [
                        25.637691274088,
                        45.808082767192964
                    ],
                    [
                        25.567307981812743,
                        45.84102654473216
                    ],
                    [
                        25.557902867581905,
                        45.85430737147271
                    ],
                    [
                        25.554027136503517,
                        45.869732791425164
                    ],
                    [
                        25.552580197547233,
                        45.93492261756368
                    ],
                    [
                        25.554595572146923,
                        45.95709176706691
                    ],
                    [
                        25.56110680163057,
                        45.97073434091112
                    ],
                    [
                        25.561106807332376,
                        45.97817578443396
                    ],
                    [
                        25.558367954708665,
                        45.987968459266945
                    ],
                    [
                        25.570977002378267,
                        46.021428933568345
                    ],
                    [
                        25.567307980828797,
                        46.03902478912558
                    ],
                    [
                        25.55475059877047,
                        46.045665153301215
                    ],
                    [
                        25.533924999332523,
                        46.04956674346363
                    ],
                    [
                        25.51449466312405,
                        46.049101669750186
                    ],
                    [
                        25.505864698202238,
                        46.04271962725415
                    ],
                    [
                        25.49273888773872,
                        46.05532869838608
                    ],
                    [
                        25.4597693216698,
                        46.072691969443355
                    ],
                    [
                        25.451242706678528,
                        46.08333728694836
                    ],
                    [
                        25.448142127845017,
                        46.09201897058007
                    ],
                    [
                        25.45449832948185,
                        46.10586826231344
                    ],
                    [
                        25.47930301778745,
                        46.14049147393841
                    ],
                    [
                        25.484160595012444,
                        46.144212130620176
                    ],
                    [
                        25.493927446381434,
                        46.15028414420109
                    ],
                    [
                        25.492842240365,
                        46.15914664924699
                    ],
                    [
                        25.497493114253018,
                        46.165399465830426
                    ],
                    [
                        25.533304885051226,
                        46.19242625597684
                    ],
                    [
                        25.554285517868813,
                        46.20327831737728
                    ],
                    [
                        25.56916832788499,
                        46.21469878845292
                    ],
                    [
                        25.604876738868843,
                        46.25113065616737
                    ],
                    [
                        25.621309854468958,
                        46.26146600430833
                    ],
                    [
                        25.65469282287815,
                        46.27634877213876
                    ],
                    [
                        25.666475061467743,
                        46.28523719300657
                    ],
                    [
                        25.678102246946523,
                        46.29112823348371
                    ],
                    [
                        25.69096968102809,
                        46.292936930714774
                    ],
                    [
                        25.706782679540513,
                        46.28694252416924
                    ],
                    [
                        25.733034295005595,
                        46.27084524280184
                    ],
                    [
                        25.744041379472726,
                        46.26275790626728
                    ],
                    [
                        25.751327752062576,
                        46.25412791819085
                    ],
                    [
                        25.753963248852646,
                        46.244877827241076
                    ],
                    [
                        25.755358519475752,
                        46.23552443429078
                    ],
                    [
                        25.75830406626168,
                        46.22565417375645
                    ],
                    [
                        25.783470498532456,
                        46.19183201231105
                    ],
                    [
                        25.78920657954329,
                        46.18271110496928
                    ],
                    [
                        25.795872840240197,
                        46.17557975759751
                    ],
                    [
                        25.83576704079139,
                        46.153203830252274
                    ],
                    [
                        25.84491377009137,
                        46.14524567042974
                    ],
                    [
                        25.85297528968442,
                        46.13563382228398
                    ],
                    [
                        25.87080366251275,
                        46.12550526680323
                    ],
                    [
                        25.898450554896872,
                        46.115841782942354
                    ],
                    [
                        25.9917265186788,
                        46.110906705095644
                    ],
                    [
                        26.251607296415273,
                        46.15028414420109
                    ],
                    [
                        26.293206817161614,
                        46.16007678280694
                    ],
                    [
                        26.325039506509274,
                        46.179352133784725
                    ],
                    [
                        26.333721146332614,
                        46.18046317863562
                    ],
                    [
                        26.34178267239262,
                        46.17759514521474
                    ],
                    [
                        26.355115182138398,
                        46.16586454064547
                    ],
                    [
                        26.363331745093614,
                        46.16082614827053
                    ],
                    [
                        26.400125365309226,
                        46.14452223821771
                    ],
                    [
                        26.410047230653557,
                        46.13625394589655
                    ],
                    [
                        26.414853147488582,
                        46.127985772608994
                    ],
                    [
                        26.41283776789273,
                        46.121267843785205
                    ],
                    [
                        26.39873009679153,
                        46.11036408829662
                    ],
                    [
                        26.3960945977047,
                        46.10338775995149
                    ],
                    [
                        26.40214074312543,
                        46.09434439917706
                    ],
                    [
                        26.421209340511275,
                        46.08741972086916
                    ],
                    [
                        26.432061397106864,
                        46.08158032116016
                    ],
                    [
                        26.4406396784651,
                        46.07478483128907
                    ],
                    [
                        26.445910675224155,
                        46.06571562338881
                    ],
                    [
                        26.45521243443061,
                        46.04457996872836
                    ],
                    [
                        26.46141360367497,
                        46.035381543326174
                    ],
                    [
                        26.468079870169053,
                        46.02737174374013
                    ],
                    [
                        26.484823033573665,
                        46.02124808165302
                    ]
                ]
            ]
        },
        "type": "Feature",
        "properties": {
            "source": "https://simplemaps.com",
            "id": "ROCV",
            "name": "Covasna"
        },
        "id": 30
    },
    {
        "geometry": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        27.51985029470451,
                        46.16260895334737
                    ],
                    [
                        27.53318281659869,
                        46.11651359025432
                    ],
                    [
                        27.476080363538113,
                        46.11372308520417
                    ],
                    [
                        27.466778597157987,
                        46.10938221606411
                    ],
                    [
                        27.454531278461623,
                        46.101682410392485
                    ],
                    [
                        27.44486778952015,
                        46.09258737831524
                    ],
                    [
                        27.42858971906103,
                        46.081967905540836
                    ],
                    [
                        27.41215660768282,
                        46.07822132550849
                    ],
                    [
                        27.377378375659006,
                        46.07687778220294
                    ],
                    [
                        27.349008009889495,
                        46.07289866561869
                    ],
                    [
                        27.33024946664259,
                        46.06530223959909
                    ],
                    [
                        27.308648710298172,
                        46.05202135615265
                    ],
                    [
                        27.283999056672847,
                        46.03042063058909
                    ],
                    [
                        27.269529662581583,
                        46.020240414161236
                    ],
                    [
                        27.261003047455755,
                        46.0123339050077
                    ],
                    [
                        27.25402672071492,
                        46.002463655198056
                    ],
                    [
                        27.251081170357246,
                        45.99104320167031
                    ],
                    [
                        27.250306028291295,
                        45.96933912589067
                    ],
                    [
                        27.25914269243766,
                        45.94257069850246
                    ],
                    [
                        27.36590620599826,
                        45.754881921253705
                    ],
                    [
                        27.37164228710896,
                        45.74030915063161
                    ],
                    [
                        27.378308551218304,
                        45.72801018620794
                    ],
                    [
                        27.3848197825902,
                        45.71845005421378
                    ],
                    [
                        27.41045129365719,
                        45.69266351337448
                    ],
                    [
                        27.420063103866887,
                        45.68620392269395
                    ],
                    [
                        27.446728145488077,
                        45.676488769460406
                    ],
                    [
                        27.457166787091783,
                        45.67147617246066
                    ],
                    [
                        27.463057901757658,
                        45.66543003173938
                    ],
                    [
                        27.467708773966592,
                        45.65902211432754
                    ],
                    [
                        27.474375032560562,
                        45.65132232343253
                    ],
                    [
                        27.495459016719142,
                        45.63633615437946
                    ],
                    [
                        27.506207715733023,
                        45.62450225778905
                    ],
                    [
                        27.514114209250437,
                        45.610652970038934
                    ],
                    [
                        27.522020703023884,
                        45.58853545542732
                    ],
                    [
                        27.52326093950697,
                        45.57719249643689
                    ],
                    [
                        27.522485795356765,
                        45.567709879059805
                    ],
                    [
                        27.525431349189574,
                        45.560061755619536
                    ],
                    [
                        27.54356977541061,
                        45.5253351804796
                    ],
                    [
                        27.55349165315549,
                        45.51360464827143
                    ],
                    [
                        27.580053338214856,
                        45.49334748084529
                    ],
                    [
                        27.52093550079479,
                        45.47768952890144
                    ],
                    [
                        27.500781691438682,
                        45.46869782616043
                    ],
                    [
                        27.483211703590978,
                        45.45727732627175
                    ],
                    [
                        27.457786902282336,
                        45.43404879034603
                    ],
                    [
                        27.43277550500648,
                        45.40673777230299
                    ],
                    [
                        27.423473745859866,
                        45.38653228008834
                    ],
                    [
                        27.377688431395235,
                        45.38518872153631
                    ],
                    [
                        27.35567427179586,
                        45.38689404496829
                    ],
                    [
                        27.307563509991805,
                        45.396531677380004
                    ],
                    [
                        27.29779666213635,
                        45.3999164727523
                    ],
                    [
                        27.290975377356848,
                        45.407667966007125
                    ],
                    [
                        27.288494907977725,
                        45.415522780017426
                    ],
                    [
                        27.286944612843342,
                        45.42322255291474
                    ],
                    [
                        27.283068883872662,
                        45.42996634498437
                    ],
                    [
                        27.27609256585211,
                        45.434849767616505
                    ],
                    [
                        27.263793571184635,
                        45.436968482498884
                    ],
                    [
                        27.245965206471084,
                        45.436400067079454
                    ],
                    [
                        27.237748652845603,
                        45.43826041191731
                    ],
                    [
                        27.22782677581572,
                        45.44477163389923
                    ],
                    [
                        27.21707807455387,
                        45.44911243467913
                    ],
                    [
                        27.20064496958492,
                        45.45143787881736
                    ],
                    [
                        27.191033157197314,
                        45.44916413485289
                    ],
                    [
                        27.181421340799073,
                        45.44384146335798
                    ],
                    [
                        27.173514845230645,
                        45.43717520008518
                    ],
                    [
                        27.164781527881573,
                        45.43143911596476
                    ],
                    [
                        27.155634800939715,
                        45.42854523886471
                    ],
                    [
                        27.147108191728844,
                        45.43035392378695
                    ],
                    [
                        27.143387486320528,
                        45.43913890809962
                    ],
                    [
                        27.14586795549836,
                        45.4572256632225
                    ],
                    [
                        27.144162629477307,
                        45.46389189961832
                    ],
                    [
                        27.13780643377179,
                        45.46781933736634
                    ],
                    [
                        27.12447390818821,
                        45.46745757129208
                    ],
                    [
                        27.11238162849428,
                        45.464718753380595
                    ],
                    [
                        27.088455438515723,
                        45.455055247964445
                    ],
                    [
                        27.076518181256663,
                        45.45161875409591
                    ],
                    [
                        27.063805776625063,
                        45.450688566619064
                    ],
                    [
                        27.050163202862223,
                        45.45425426591391
                    ],
                    [
                        27.032438181664517,
                        45.462496631045376
                    ],
                    [
                        27.006238232012176,
                        45.48182362384659
                    ],
                    [
                        26.999210239751648,
                        45.49474274954019
                    ],
                    [
                        26.998590119054736,
                        45.5066799806938
                    ],
                    [
                        26.99921023800144,
                        45.515154929182785
                    ],
                    [
                        26.993009069641904,
                        45.52409496729245
                    ],
                    [
                        26.97580081808655,
                        45.53331921380295
                    ],
                    [
                        26.946345251769813,
                        45.54249178438304
                    ],
                    [
                        26.92241906227067,
                        45.545747389282546
                    ],
                    [
                        26.907071163955315,
                        45.54523063684096
                    ],
                    [
                        26.899939810867405,
                        45.54169076803804
                    ],
                    [
                        26.897769402074847,
                        45.53794423605657
                    ],
                    [
                        26.899164668070462,
                        45.53437858055959
                    ],
                    [
                        26.900714957563707,
                        45.53200144485955
                    ],
                    [
                        26.901490103354913,
                        45.52910755600913
                    ],
                    [
                        26.900869986753953,
                        45.52613616165683
                    ],
                    [
                        26.898699578788,
                        45.52192454676835
                    ],
                    [
                        26.894513785929654,
                        45.51866892053671
                    ],
                    [
                        26.888002558431584,
                        45.51804882450931
                    ],
                    [
                        26.87787397518439,
                        45.51903065963144
                    ],
                    [
                        26.863146192457798,
                        45.522854719982526
                    ],
                    [
                        26.843302446121267,
                        45.524973473518294
                    ],
                    [
                        26.831468539047705,
                        45.52838409686952
                    ],
                    [
                        26.78899051388433,
                        45.545695714006094
                    ],
                    [
                        26.754832389404942,
                        45.563317361386815
                    ],
                    [
                        26.732508174981362,
                        45.58305778206838
                    ],
                    [
                        26.66935956998288,
                        45.621194963640505
                    ],
                    [
                        26.646673617569675,
                        45.627861230067985
                    ],
                    [
                        26.633806189423897,
                        45.62796460355833
                    ],
                    [
                        26.623264195274245,
                        45.62447643378524
                    ],
                    [
                        26.61132694137628,
                        45.62238354775545
                    ],
                    [
                        26.5971675941595,
                        45.62202178439817
                    ],
                    [
                        26.568952264974733,
                        45.624760650957555
                    ],
                    [
                        26.551278926127534,
                        45.63444998987032
                    ],
                    [
                        26.5321586401729,
                        45.650392133615824
                    ],
                    [
                        26.46637454028893,
                        45.73085232835354
                    ],
                    [
                        26.42461998699433,
                        45.77317534811197
                    ],
                    [
                        26.38043663702682,
                        45.80294097506188
                    ],
                    [
                        26.389118278423332,
                        45.85203358543604
                    ],
                    [
                        26.40322594289649,
                        45.90254729032339
                    ],
                    [
                        26.404776242903804,
                        45.91750766309255
                    ],
                    [
                        26.42089928842454,
                        45.95045137712194
                    ],
                    [
                        26.484823033573665,
                        46.02124808165302
                    ],
                    [
                        26.60042321341554,
                        46.009233317848484
                    ],
                    [
                        26.63055056984814,
                        46.019542746857084
                    ],
                    [
                        26.63210086684265,
                        46.02912874564465
                    ],
                    [
                        26.63334109576349,
                        46.04840402202746
                    ],
                    [
                        26.636131629098102,
                        46.057344083387186
                    ],
                    [
                        26.64248783047306,
                        46.06594820944091
                    ],
                    [
                        26.654115026738367,
                        46.07346711903276
                    ],
                    [
                        26.67044477597933,
                        46.07682606925711
                    ],
                    [
                        26.767079710743197,
                        46.080960217685416
                    ],
                    [
                        26.796897007072268,
                        46.07711029902389
                    ],
                    [
                        26.840511919224117,
                        46.076102625095004
                    ],
                    [
                        26.865316605192323,
                        46.0710383278029
                    ],
                    [
                        26.881904736865778,
                        46.069901429743744
                    ],
                    [
                        26.901490102085603,
                        46.07292448349642
                    ],
                    [
                        26.918698353842828,
                        46.073415406588495
                    ],
                    [
                        26.93389122948004,
                        46.071916821562326
                    ],
                    [
                        26.972545194634932,
                        46.06065132237223
                    ],
                    [
                        26.981536903621386,
                        46.06189161203117
                    ],
                    [
                        26.98572269411521,
                        46.06594820944091
                    ],
                    [
                        26.98804813322078,
                        46.072381925408116
                    ],
                    [
                        26.993009062552797,
                        46.08023668840199
                    ],
                    [
                        27.001897410017154,
                        46.08721301615327
                    ],
                    [
                        27.01864057742397,
                        46.093104148243825
                    ],
                    [
                        27.033988473423626,
                        46.09408597489677
                    ],
                    [
                        27.04763106009345,
                        46.092122324337545
                    ],
                    [
                        27.09977258131574,
                        46.07935825046724
                    ],
                    [
                        27.112381623905907,
                        46.08090850413892
                    ],
                    [
                        27.12090824176397,
                        46.085714448908504
                    ],
                    [
                        27.132845487416215,
                        46.100493849940435
                    ],
                    [
                        27.142302276572412,
                        46.108607063784056
                    ],
                    [
                        27.16932905531898,
                        46.121190302862445
                    ],
                    [
                        27.18018110307595,
                        46.12816660280624
                    ],
                    [
                        27.197234331643827,
                        46.14467725380644
                    ],
                    [
                        27.20824140218567,
                        46.15351386921218
                    ],
                    [
                        27.233097778508366,
                        46.16297072633972
                    ],
                    [
                        27.306788358968493,
                        46.17382271144298
                    ],
                    [
                        27.332419878198632,
                        46.174339524865545
                    ],
                    [
                        27.352263627337475,
                        46.17175569532392
                    ],
                    [
                        27.394793326946584,
                        46.15361724113627
                    ],
                    [
                        27.413241812870446,
                        46.151834405409474
                    ],
                    [
                        27.424558951214376,
                        46.15403065251029
                    ],
                    [
                        27.4323104230623,
                        46.15940504497463
                    ],
                    [
                        27.43742638397027,
                        46.165528665988624
                    ],
                    [
                        27.445074499554273,
                        46.17144564013305
                    ],
                    [
                        27.45453128641607,
                        46.17266003731343
                    ],
                    [
                        27.489412877871487,
                        46.16534781643301
                    ],
                    [
                        27.51985029470451,
                        46.16260895334737
                    ]
                ]
            ]
        },
        "type": "Feature",
        "properties": {
            "source": "https://simplemaps.com",
            "id": "ROVN",
            "name": "Vrancea"
        },
        "id": 31
    },
    {
        "geometry": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        26.603885519827564,
                        44.8650653416157
                    ],
                    [
                        26.584920277617748,
                        44.88904325250119
                    ],
                    [
                        26.547351512030186,
                        44.916276743278814
                    ],
                    [
                        26.543010685515902,
                        44.92609522368084
                    ],
                    [
                        26.5436307957276,
                        44.93513855828351
                    ],
                    [
                        26.550142026768576,
                        44.942579964622695
                    ],
                    [
                        26.568022111008872,
                        44.9558093738745
                    ],
                    [
                        26.575928587812154,
                        44.96387078875009
                    ],
                    [
                        26.577943985105648,
                        44.97741011815032
                    ],
                    [
                        26.572828007099965,
                        44.986220875990114
                    ],
                    [
                        26.564921491653017,
                        44.99368799089211
                    ],
                    [
                        26.542545606886005,
                        45.009397691498386
                    ],
                    [
                        26.534018996170694,
                        45.012084866396236
                    ],
                    [
                        26.505958693204704,
                        45.01782095088949
                    ],
                    [
                        26.48947391152825,
                        45.02474559259566
                    ],
                    [
                        26.48265262205348,
                        45.03536509962562
                    ],
                    [
                        26.47815677289665,
                        45.05029959021907
                    ],
                    [
                        26.47629642001988,
                        45.08804921736566
                    ],
                    [
                        26.47366092354838,
                        45.10195018456826
                    ],
                    [
                        26.46916507231902,
                        45.117608137280705
                    ],
                    [
                        26.462963900608717,
                        45.12778839472283
                    ],
                    [
                        26.45366214436813,
                        45.13714183459541
                    ],
                    [
                        26.430201042719364,
                        45.15037099561712
                    ],
                    [
                        26.415938347236057,
                        45.16148142871329
                    ],
                    [
                        26.413302850063033,
                        45.1732119802608
                    ],
                    [
                        26.41469811282796,
                        45.18308217054932
                    ],
                    [
                        26.417178581510505,
                        45.19111786231717
                    ],
                    [
                        26.416093378481186,
                        45.19843008785176
                    ],
                    [
                        26.411132439086067,
                        45.200548808750746
                    ],
                    [
                        26.402915887663976,
                        45.198145866582415
                    ],
                    [
                        26.38632775116197,
                        45.18742299549778
                    ],
                    [
                        26.37888634559652,
                        45.183857324529235
                    ],
                    [
                        26.37077314561334,
                        45.185252586495444
                    ],
                    [
                        26.35992109522899,
                        45.19197053036929
                    ],
                    [
                        26.355115187402937,
                        45.204579579060514
                    ],
                    [
                        26.345348340499815,
                        45.21021229903645
                    ],
                    [
                        26.334031204354574,
                        45.21289949082973
                    ],
                    [
                        26.28979617615775,
                        45.21052236308317
                    ],
                    [
                        26.27615359873612,
                        45.21248606961108
                    ],
                    [
                        26.262149284689702,
                        45.21822214703977
                    ],
                    [
                        26.25470787937145,
                        45.225353506302596
                    ],
                    [
                        26.251607292400244,
                        45.23266571137984
                    ],
                    [
                        26.250522087505807,
                        45.24116648835772
                    ],
                    [
                        26.247731561857304,
                        45.25230276893199
                    ],
                    [
                        26.236879510460273,
                        45.262560536611055
                    ],
                    [
                        26.208664178394248,
                        45.28333446059122
                    ],
                    [
                        26.204116653291162,
                        45.294031488999394
                    ],
                    [
                        26.20597700243758,
                        45.30219634757715
                    ],
                    [
                        26.21207482196285,
                        45.30909515400652
                    ],
                    [
                        26.213625116077537,
                        45.31855195149807
                    ],
                    [
                        26.208354121508183,
                        45.333925696749404
                    ],
                    [
                        26.17404096706299,
                        45.38653228008834
                    ],
                    [
                        26.16070844757088,
                        45.40087249644343
                    ],
                    [
                        26.146859166136224,
                        45.41025178145199
                    ],
                    [
                        26.106086458067434,
                        45.43159413274873
                    ],
                    [
                        26.045986769127488,
                        45.48226288439285
                    ],
                    [
                        26.100453726037507,
                        45.56440255690124
                    ],
                    [
                        26.13957279047514,
                        45.57298087708496
                    ],
                    [
                        26.188923778591477,
                        45.574531137621236
                    ],
                    [
                        26.201016064100152,
                        45.577269996801604
                    ],
                    [
                        26.20752729497118,
                        45.58321278526687
                    ],
                    [
                        26.211454703928606,
                        45.602100517793936
                    ],
                    [
                        26.215640495803733,
                        45.61215158905383
                    ],
                    [
                        26.224477164472187,
                        45.62284860700867
                    ],
                    [
                        26.234554068525867,
                        45.625561617369314
                    ],
                    [
                        26.244941034990454,
                        45.62377880378935
                    ],
                    [
                        26.255017935737897,
                        45.6190245488374
                    ],
                    [
                        26.273518103431428,
                        45.60693229099998
                    ],
                    [
                        26.284680207790547,
                        45.60284982832927
                    ],
                    [
                        26.301733430802656,
                        45.602100517793936
                    ],
                    [
                        26.31940677322575,
                        45.608947658943976
                    ],
                    [
                        26.32860517998741,
                        45.618094402298446
                    ],
                    [
                        26.336201611924693,
                        45.64103871445544
                    ],
                    [
                        26.342712840118345,
                        45.655249715457764
                    ],
                    [
                        26.3582157696963,
                        45.67250964862026
                    ],
                    [
                        26.366742383503137,
                        45.68522206447499
                    ],
                    [
                        26.37108320010389,
                        45.69852872481428
                    ],
                    [
                        26.372478463856623,
                        45.709664995023445
                    ],
                    [
                        26.376819293879162,
                        45.72191236818565
                    ],
                    [
                        26.39500938688261,
                        45.749817577927715
                    ],
                    [
                        26.397334834466534,
                        45.76149650501174
                    ],
                    [
                        26.394699335540682,
                        45.772503575199636
                    ],
                    [
                        26.389273309366068,
                        45.78175365154007
                    ],
                    [
                        26.38043663702682,
                        45.80294097506188
                    ],
                    [
                        26.42461998699433,
                        45.77317534811197
                    ],
                    [
                        26.46637454028893,
                        45.73085232835354
                    ],
                    [
                        26.5321586401729,
                        45.650392133615824
                    ],
                    [
                        26.551278926127534,
                        45.63444998987032
                    ],
                    [
                        26.568952264974733,
                        45.624760650957555
                    ],
                    [
                        26.5971675941595,
                        45.62202178439817
                    ],
                    [
                        26.61132694137628,
                        45.62238354775545
                    ],
                    [
                        26.623264195274245,
                        45.62447643378524
                    ],
                    [
                        26.633806189423897,
                        45.62796460355833
                    ],
                    [
                        26.646673617569675,
                        45.627861230067985
                    ],
                    [
                        26.66935956998288,
                        45.621194963640505
                    ],
                    [
                        26.732508174981362,
                        45.58305778206838
                    ],
                    [
                        26.754832389404942,
                        45.563317361386815
                    ],
                    [
                        26.78899051388433,
                        45.545695714006094
                    ],
                    [
                        26.831468539047705,
                        45.52838409686952
                    ],
                    [
                        26.843302446121267,
                        45.524973473518294
                    ],
                    [
                        26.863146192457798,
                        45.522854719982526
                    ],
                    [
                        26.87787397518439,
                        45.51903065963144
                    ],
                    [
                        26.888002558431584,
                        45.51804882450931
                    ],
                    [
                        26.894513785929654,
                        45.51866892053671
                    ],
                    [
                        26.898699578788,
                        45.52192454676835
                    ],
                    [
                        26.900869986753953,
                        45.52613616165683
                    ],
                    [
                        26.901490103354913,
                        45.52910755600913
                    ],
                    [
                        26.900714957563707,
                        45.53200144485955
                    ],
                    [
                        26.899164668070462,
                        45.53437858055959
                    ],
                    [
                        26.897769402074847,
                        45.53794423605657
                    ],
                    [
                        26.899939810867405,
                        45.54169076803804
                    ],
                    [
                        26.907071163955315,
                        45.54523063684096
                    ],
                    [
                        26.92241906227067,
                        45.545747389282546
                    ],
                    [
                        26.946345251769813,
                        45.54249178438304
                    ],
                    [
                        26.97580081808655,
                        45.53331921380295
                    ],
                    [
                        26.993009069641904,
                        45.52409496729245
                    ],
                    [
                        26.99921023800144,
                        45.515154929182785
                    ],
                    [
                        26.998590119054736,
                        45.5066799806938
                    ],
                    [
                        26.999210239751648,
                        45.49474274954019
                    ],
                    [
                        27.006238232012176,
                        45.48182362384659
                    ],
                    [
                        27.032438181664517,
                        45.462496631045376
                    ],
                    [
                        27.050163202862223,
                        45.45425426591391
                    ],
                    [
                        27.063805776625063,
                        45.450688566619064
                    ],
                    [
                        27.076518181256663,
                        45.45161875409591
                    ],
                    [
                        27.088455438515723,
                        45.455055247964445
                    ],
                    [
                        27.11238162849428,
                        45.464718753380595
                    ],
                    [
                        27.12447390818821,
                        45.46745757129208
                    ],
                    [
                        27.13780643377179,
                        45.46781933736634
                    ],
                    [
                        27.144162629477307,
                        45.46389189961832
                    ],
                    [
                        27.14586795549836,
                        45.4572256632225
                    ],
                    [
                        27.143387486320528,
                        45.43913890809962
                    ],
                    [
                        27.147108191728844,
                        45.43035392378695
                    ],
                    [
                        27.155634800939715,
                        45.42854523886471
                    ],
                    [
                        27.164781527881573,
                        45.43143911596476
                    ],
                    [
                        27.173514845230645,
                        45.43717520008518
                    ],
                    [
                        27.181421340799073,
                        45.44384146335798
                    ],
                    [
                        27.191033157197314,
                        45.44916413485289
                    ],
                    [
                        27.20064496958492,
                        45.45143787881736
                    ],
                    [
                        27.21707807455387,
                        45.44911243467913
                    ],
                    [
                        27.22782677581572,
                        45.44477163389923
                    ],
                    [
                        27.237748652845603,
                        45.43826041191731
                    ],
                    [
                        27.245965206471084,
                        45.436400067079454
                    ],
                    [
                        27.263793571184635,
                        45.436968482498884
                    ],
                    [
                        27.27609256585211,
                        45.434849767616505
                    ],
                    [
                        27.283068883872662,
                        45.42996634498437
                    ],
                    [
                        27.286944612843342,
                        45.42322255291474
                    ],
                    [
                        27.288494907977725,
                        45.415522780017426
                    ],
                    [
                        27.290975377356848,
                        45.407667966007125
                    ],
                    [
                        27.29779666213635,
                        45.3999164727523
                    ],
                    [
                        27.307563509991805,
                        45.396531677380004
                    ],
                    [
                        27.35567427179586,
                        45.38689404496829
                    ],
                    [
                        27.377688431395235,
                        45.38518872153631
                    ],
                    [
                        27.423473745859866,
                        45.38653228008834
                    ],
                    [
                        27.420063101280526,
                        45.367256966472304
                    ],
                    [
                        27.40161461739295,
                        45.34470021914829
                    ],
                    [
                        27.394638297741068,
                        45.33103179984143
                    ],
                    [
                        27.387196891689804,
                        45.308449198502366
                    ],
                    [
                        27.37799848790216,
                        45.30036184086944
                    ],
                    [
                        27.365751173815198,
                        45.29834646426066
                    ],
                    [
                        27.350713332723014,
                        45.3004910406161
                    ],
                    [
                        27.335313754003252,
                        45.30005178076796
                    ],
                    [
                        27.316400181661592,
                        45.29431570468262
                    ],
                    [
                        27.309733921007645,
                        45.286124984192185
                    ],
                    [
                        27.309423862568664,
                        45.275944731987884
                    ],
                    [
                        27.314539829502376,
                        45.25305207234402
                    ],
                    [
                        27.31050906751946,
                        45.2384276381849
                    ],
                    [
                        27.304772983042287,
                        45.23444854830624
                    ],
                    [
                        27.297486605689908,
                        45.235740459571176
                    ],
                    [
                        27.289735141098998,
                        45.23951283775486
                    ],
                    [
                        27.27929650048818,
                        45.24188995317597
                    ],
                    [
                        27.265963982454384,
                        45.241631574092544
                    ],
                    [
                        27.226586541115964,
                        45.23297577436796
                    ],
                    [
                        27.214132521125272,
                        45.23294993896093
                    ],
                    [
                        27.167158644338766,
                        45.237962556321264
                    ],
                    [
                        27.08721520447015,
                        45.21817047820471
                    ],
                    [
                        27.072487418662117,
                        45.209643858484576
                    ],
                    [
                        27.06411583834731,
                        45.20140147848443
                    ],
                    [
                        27.062875603486333,
                        45.19424428918129
                    ],
                    [
                        27.06380577931263,
                        45.18690623398563
                    ],
                    [
                        27.07868859107556,
                        45.15951772287192
                    ],
                    [
                        27.084889764070635,
                        45.1552802635687
                    ],
                    [
                        27.094656610084304,
                        45.15378164559616
                    ],
                    [
                        27.106490513745907,
                        45.1552802635687
                    ],
                    [
                        27.115172154322316,
                        45.16189485279563
                    ],
                    [
                        27.118117709348862,
                        45.167992655994624
                    ],
                    [
                        27.119047885380176,
                        45.17432301922454
                    ],
                    [
                        27.119357943456517,
                        45.181376856359385
                    ],
                    [
                        27.125559115283245,
                        45.18582102941209
                    ],
                    [
                        27.134240756266202,
                        45.18809479031601
                    ],
                    [
                        27.143542516340055,
                        45.18778474425206
                    ],
                    [
                        27.15237918437424,
                        45.18427073425056
                    ],
                    [
                        27.15889041649501,
                        45.17868969246664
                    ],
                    [
                        27.162921177665794,
                        45.17145498957562
                    ],
                    [
                        27.164058058320922,
                        45.16323843156276
                    ],
                    [
                        27.163231235587876,
                        45.14308462647295
                    ],
                    [
                        27.164161410266633,
                        45.13228424270813
                    ],
                    [
                        27.169329053237536,
                        45.12564382228072
                    ],
                    [
                        27.178940870629397,
                        45.121948957126506
                    ],
                    [
                        27.191033156912447,
                        45.119365142708254
                    ],
                    [
                        27.199249709581498,
                        45.1145592362725
                    ],
                    [
                        27.205140821480335,
                        45.10680776180687
                    ],
                    [
                        27.20653608680296,
                        45.09709260081847
                    ],
                    [
                        27.205450880668497,
                        45.077197172116826
                    ],
                    [
                        27.205915969743067,
                        45.068670560619275
                    ],
                    [
                        27.20963667180504,
                        45.06164256514136
                    ],
                    [
                        27.217388137317652,
                        45.05794770236352
                    ],
                    [
                        27.230152214638498,
                        45.0567849794414
                    ],
                    [
                        27.25433678616664,
                        45.05714671689693
                    ],
                    [
                        27.263018426252493,
                        45.0547179228393
                    ],
                    [
                        27.26813439299895,
                        45.04846507162443
                    ],
                    [
                        27.27014977395283,
                        45.03916331507719
                    ],
                    [
                        27.26859948124042,
                        45.0230402694314
                    ],
                    [
                        27.26456871906207,
                        45.00177541824546
                    ],
                    [
                        27.253871708835884,
                        44.96459429232402
                    ],
                    [
                        27.24643028729499,
                        44.94754097962663
                    ],
                    [
                        27.23805871682849,
                        44.938135940116595
                    ],
                    [
                        27.20188520937943,
                        44.931521321959515
                    ],
                    [
                        27.190878147990997,
                        44.92759403043089
                    ],
                    [
                        27.17816573787109,
                        44.918498932662736
                    ],
                    [
                        27.174755094360968,
                        44.90924885316266
                    ],
                    [
                        27.177080510888786,
                        44.900050309918186
                    ],
                    [
                        27.18669235096983,
                        44.8939009588948
                    ],
                    [
                        27.197234328176343,
                        44.88501251917231
                    ],
                    [
                        27.203435495138997,
                        44.87297188142393
                    ],
                    [
                        27.19692427892401,
                        44.826463183145265
                    ],
                    [
                        27.200644987626866,
                        44.819409385538926
                    ],
                    [
                        27.178630793850765,
                        44.811373491442986
                    ],
                    [
                        27.1749101236717,
                        44.8070845504672
                    ],
                    [
                        27.174445002977723,
                        44.80114155838659
                    ],
                    [
                        27.18111126757667,
                        44.79620648941749
                    ],
                    [
                        27.19196333607267,
                        44.79101311180318
                    ],
                    [
                        27.19924971558641,
                        44.786310574728795
                    ],
                    [
                        27.203280459242993,
                        44.78078108702459
                    ],
                    [
                        27.198939665142394,
                        44.77654377843404
                    ],
                    [
                        27.18948284213762,
                        44.772874534332395
                    ],
                    [
                        27.16653854106805,
                        44.76889566403406
                    ],
                    [
                        27.138116509086117,
                        44.760627472081005
                    ],
                    [
                        27.131450232961118,
                        44.75954216044378
                    ],
                    [
                        27.12431889113814,
                        44.76021399059996
                    ],
                    [
                        27.120443163091696,
                        44.763004540774205
                    ],
                    [
                        27.118892871576612,
                        44.76770711052328
                    ],
                    [
                        27.11904786194358,
                        44.77313289199694
                    ],
                    [
                        27.12090821585485,
                        44.77925656696065
                    ],
                    [
                        27.121528335855206,
                        44.78594867894402
                    ],
                    [
                        27.119978052104326,
                        44.79282170060443
                    ],
                    [
                        27.114552033738203,
                        44.79979806772779
                    ],
                    [
                        27.10504358884225,
                        44.80656779160904
                    ],
                    [
                        27.09155602650115,
                        44.81282055743376
                    ],
                    [
                        27.075588028947568,
                        44.818453413865605
                    ],
                    [
                        27.052436987647116,
                        44.823466029371254
                    ],
                    [
                        27.036623962488367,
                        44.822070541701386
                    ],
                    [
                        27.02437667909241,
                        44.81638632380832
                    ],
                    [
                        27.01445480968418,
                        44.80858321600453
                    ],
                    [
                        27.000347127772066,
                        44.80253697320208
                    ],
                    [
                        26.98603272554401,
                        44.802691815985746
                    ],
                    [
                        26.972235118417476,
                        44.806774250741974
                    ],
                    [
                        26.94277959294126,
                        44.820184548908976
                    ],
                    [
                        26.919163463749285,
                        44.8261531738427
                    ],
                    [
                        26.89993983410941,
                        44.82666995795634
                    ],
                    [
                        26.864851491330555,
                        44.82186376926472
                    ],
                    [
                        26.850123737686783,
                        44.821967308182
                    ],
                    [
                        26.838186453991625,
                        44.8242408951646
                    ],
                    [
                        26.8276444703901,
                        44.82739321249281
                    ],
                    [
                        26.767699841671504,
                        44.83504152591778
                    ],
                    [
                        26.701915708694095,
                        44.8311655802828
                    ],
                    [
                        26.677886198289105,
                        44.83248351976088
                    ],
                    [
                        26.660212842405322,
                        44.83597157519396
                    ],
                    [
                        26.62636480285642,
                        44.85705571575517
                    ],
                    [
                        26.603885519827564,
                        44.8650653416157
                    ]
                ]
            ]
        },
        "type": "Feature",
        "properties": {
            "source": "https://simplemaps.com",
            "id": "ROBZ",
            "name": "Buzau"
        },
        "id": 32
    },
    {
        "geometry": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        25.42979699261667,
                        45.45231640577406
                    ],
                    [
                        25.409643179958955,
                        45.445340061962355
                    ],
                    [
                        25.40266686614367,
                        45.439164757500386
                    ],
                    [
                        25.3939852207464,
                        45.42668486552861
                    ],
                    [
                        25.388714224789503,
                        45.41588449616966
                    ],
                    [
                        25.370265741569863,
                        45.39939973003036
                    ],
                    [
                        25.309235872560617,
                        45.38849599233826
                    ],
                    [
                        25.275904576092362,
                        45.41645295712769
                    ],
                    [
                        25.2208174970132,
                        45.503372703229054
                    ],
                    [
                        25.2062447446141,
                        45.5162401373008
                    ],
                    [
                        25.18991499159486,
                        45.52424998415343
                    ],
                    [
                        25.174102000917657,
                        45.52859078840956
                    ],
                    [
                        25.156583692526084,
                        45.536238914972905
                    ],
                    [
                        25.119169955779427,
                        45.55975169212979
                    ],
                    [
                        25.095140416507807,
                        45.5696219058512
                    ],
                    [
                        24.983881052929046,
                        45.58000883796124
                    ],
                    [
                        24.92212772211788,
                        45.57610730176798
                    ],
                    [
                        24.89246544987293,
                        45.57758007492832
                    ],
                    [
                        24.880373162516534,
                        45.57675323875291
                    ],
                    [
                        24.86869428683214,
                        45.5738593457842
                    ],
                    [
                        24.85086592283909,
                        45.56559114990348
                    ],
                    [
                        24.838773633235608,
                        45.56311065055291
                    ],
                    [
                        24.83102216931875,
                        45.566159570519766
                    ],
                    [
                        24.82389082180601,
                        45.57339427161059
                    ],
                    [
                        24.816294389901795,
                        45.58259269635515
                    ],
                    [
                        24.80042972197926,
                        45.595046698282374
                    ],
                    [
                        24.787407261254668,
                        45.60026601981719
                    ],
                    [
                        24.771904330586487,
                        45.60290151156968
                    ],
                    [
                        24.709065789988223,
                        45.598767410735555
                    ],
                    [
                        24.70705040796409,
                        45.6192829381698
                    ],
                    [
                        24.70363976462198,
                        45.63432078986776
                    ],
                    [
                        24.699919064143288,
                        45.663207932263056
                    ],
                    [
                        24.691650831613316,
                        45.69638417973524
                    ],
                    [
                        24.687310017097733,
                        45.7082697952779
                    ],
                    [
                        24.681263866526848,
                        45.72033619156128
                    ],
                    [
                        24.649947946634683,
                        45.76653490908217
                    ],
                    [
                        24.649327836488137,
                        45.776844401414095
                    ],
                    [
                        24.654133736676073,
                        45.78542263850868
                    ],
                    [
                        24.669171583876498,
                        45.79358754999222
                    ],
                    [
                        24.705345081258127,
                        45.804542925687336
                    ],
                    [
                        24.723793577380025,
                        45.80779859870667
                    ],
                    [
                        24.741001820295043,
                        45.813017857085185
                    ],
                    [
                        24.75438601864057,
                        45.82022673860169
                    ],
                    [
                        24.75950199182404,
                        45.83084629220622
                    ],
                    [
                        24.756866484113413,
                        45.83740913094063
                    ],
                    [
                        24.750045201075967,
                        45.841414096857065
                    ],
                    [
                        24.743172234845918,
                        45.84366201458747
                    ],
                    [
                        24.736971058118243,
                        45.84841621423892
                    ],
                    [
                        24.734645621484066,
                        45.85497914332023
                    ],
                    [
                        24.734955676800997,
                        45.863609080740375
                    ],
                    [
                        24.736350943470317,
                        45.874461149376124
                    ],
                    [
                        24.732165160624803,
                        45.88210931632984
                    ],
                    [
                        24.71852258209901,
                        45.893529803368594
                    ],
                    [
                        24.71480187291855,
                        45.899162499600294
                    ],
                    [
                        24.715421986808437,
                        45.907172321696365
                    ],
                    [
                        24.72162315758613,
                        45.91345100139233
                    ],
                    [
                        24.766323278009413,
                        45.93001334483713
                    ],
                    [
                        24.781361115224104,
                        45.94112374755186
                    ],
                    [
                        24.798569364883498,
                        45.94753160837255
                    ],
                    [
                        24.810403272438425,
                        45.94918528586988
                    ],
                    [
                        24.818774854171153,
                        45.94750579963808
                    ],
                    [
                        24.826371286397464,
                        45.94425016147879
                    ],
                    [
                        24.832882523458473,
                        45.94381095778868
                    ],
                    [
                        24.841254104879766,
                        45.94688570131894
                    ],
                    [
                        24.84435469001161,
                        45.95652334741443
                    ],
                    [
                        24.843269484553296,
                        45.96414562261359
                    ],
                    [
                        24.83706831399849,
                        45.97745231242844
                    ],
                    [
                        24.839238727116122,
                        45.98349847287379
                    ],
                    [
                        24.845594923380997,
                        45.98820099415502
                    ],
                    [
                        24.901147089684603,
                        46.009155801602496
                    ],
                    [
                        24.960419959388798,
                        46.04339144801782
                    ],
                    [
                        24.98186567773602,
                        46.06359692168483
                    ],
                    [
                        24.975767851268248,
                        46.08447415184628
                    ],
                    [
                        24.97917850538836,
                        46.092845801492054
                    ],
                    [
                        24.985741407283093,
                        46.10338775995149
                    ],
                    [
                        24.995508253904724,
                        46.11150096416401
                    ],
                    [
                        25.01783247560719,
                        46.124135873920565
                    ],
                    [
                        25.031475049815747,
                        46.12987192811303
                    ],
                    [
                        25.04625451385153,
                        46.132662485341214
                    ],
                    [
                        25.138083534174022,
                        46.13553053230939
                    ],
                    [
                        25.18805463675145,
                        46.14343697777099
                    ],
                    [
                        25.241591426334214,
                        46.14948315434361
                    ],
                    [
                        25.296523467114085,
                        46.16689806800148
                    ],
                    [
                        25.313318313170306,
                        46.16741487114532
                    ],
                    [
                        25.330216506864144,
                        46.16462434251842
                    ],
                    [
                        25.350990426711114,
                        46.156976193999995
                    ],
                    [
                        25.367578569470645,
                        46.146124196999224
                    ],
                    [
                        25.38282310880512,
                        46.13829515877571
                    ],
                    [
                        25.42721316621322,
                        46.12721057913239
                    ],
                    [
                        25.45449832948185,
                        46.10586826231344
                    ],
                    [
                        25.448142127845017,
                        46.09201897058007
                    ],
                    [
                        25.451242706678528,
                        46.08333728694836
                    ],
                    [
                        25.4597693216698,
                        46.072691969443355
                    ],
                    [
                        25.49273888773872,
                        46.05532869838608
                    ],
                    [
                        25.505864698202238,
                        46.04271962725415
                    ],
                    [
                        25.51449466312405,
                        46.049101669750186
                    ],
                    [
                        25.533924999332523,
                        46.04956674346363
                    ],
                    [
                        25.55475059877047,
                        46.045665153301215
                    ],
                    [
                        25.567307980828797,
                        46.03902478912558
                    ],
                    [
                        25.570977002378267,
                        46.021428933568345
                    ],
                    [
                        25.558367954708665,
                        45.987968459266945
                    ],
                    [
                        25.561106807332376,
                        45.97817578443396
                    ],
                    [
                        25.56110680163057,
                        45.97073434091112
                    ],
                    [
                        25.554595572146923,
                        45.95709176706691
                    ],
                    [
                        25.552580197547233,
                        45.93492261756368
                    ],
                    [
                        25.554027136503517,
                        45.869732791425164
                    ],
                    [
                        25.557902867581905,
                        45.85430737147271
                    ],
                    [
                        25.567307981812743,
                        45.84102654473216
                    ],
                    [
                        25.637691274088,
                        45.808082767192964
                    ],
                    [
                        25.66900719718794,
                        45.7850092727966
                    ],
                    [
                        25.67097089584402,
                        45.751626263880105
                    ],
                    [
                        25.689109327716125,
                        45.75188467019069
                    ],
                    [
                        25.69670575997772,
                        45.754080901613726
                    ],
                    [
                        25.704508909191276,
                        45.75909356075766
                    ],
                    [
                        25.718926625829425,
                        45.75198800214946
                    ],
                    [
                        25.732879262378024,
                        45.75276314586035
                    ],
                    [
                        25.747296986092845,
                        45.75674222250157
                    ],
                    [
                        25.76279992451919,
                        45.75909356075766
                    ],
                    [
                        25.768587678480085,
                        45.76526885259823
                    ],
                    [
                        25.784400673442953,
                        45.74896498041809
                    ],
                    [
                        25.801763946964282,
                        45.74237618890605
                    ],
                    [
                        25.89472985256369,
                        45.71777822919997
                    ],
                    [
                        25.919534543628238,
                        45.70547925869691
                    ],
                    [
                        25.94950686735281,
                        45.684446911080066
                    ],
                    [
                        25.96500979647921,
                        45.66677356744786
                    ],
                    [
                        25.980357694401878,
                        45.645069451517315
                    ],
                    [
                        25.990486279949707,
                        45.63907501252041
                    ],
                    [
                        26.01001997118186,
                        45.633390604748755
                    ],
                    [
                        26.028933545378372,
                        45.625690814302004
                    ],
                    [
                        26.048208853978274,
                        45.61406361584686
                    ],
                    [
                        26.079059684768918,
                        45.580215558210874
                    ],
                    [
                        26.100453726037507,
                        45.56440255690124
                    ],
                    [
                        26.045986769127488,
                        45.48226288439285
                    ],
                    [
                        25.99885786573484,
                        45.48861910257991
                    ],
                    [
                        25.945786168262046,
                        45.510194007028666
                    ],
                    [
                        25.92403039102289,
                        45.51251944781447
                    ],
                    [
                        25.910852902066413,
                        45.508850427318514
                    ],
                    [
                        25.902791377497376,
                        45.50060803677689
                    ],
                    [
                        25.89891564053337,
                        45.48923918802736
                    ],
                    [
                        25.896435173219377,
                        45.47823211646337
                    ],
                    [
                        25.891319208777848,
                        45.46539053994232
                    ],
                    [
                        25.88217247700756,
                        45.45332407191491
                    ],
                    [
                        25.862742139392214,
                        45.44156768883657
                    ],
                    [
                        25.845533889569854,
                        45.43826041191731
                    ],
                    [
                        25.83173627791096,
                        45.43996570741534
                    ],
                    [
                        25.82305464311059,
                        45.44549512270992
                    ],
                    [
                        25.809825472566935,
                        45.461359762122164
                    ],
                    [
                        25.802849153146443,
                        45.46792266638732
                    ],
                    [
                        25.790446812410913,
                        45.47334870370808
                    ],
                    [
                        25.77804446714315,
                        45.472754419784586
                    ],
                    [
                        25.75024254749528,
                        45.465907296712494
                    ],
                    [
                        25.7358248211114,
                        45.46776763462484
                    ],
                    [
                        25.693295120030612,
                        45.47939485044718
                    ],
                    [
                        25.650972123369144,
                        45.48533764615195
                    ],
                    [
                        25.62782107730697,
                        45.48474334321728
                    ],
                    [
                        25.45883914405289,
                        45.46358183948731
                    ],
                    [
                        25.445971715684127,
                        45.459990353790886
                    ],
                    [
                        25.42979699261667,
                        45.45231640577406
                    ]
                ]
            ]
        },
        "type": "Feature",
        "properties": {
            "source": "https://simplemaps.com",
            "id": "ROBV",
            "name": "Brasov"
        },
        "id": 33
    },
    {
        "geometry": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        24.709065789988223,
                        45.598767410735555
                    ],
                    [
                        24.52721642308166,
                        45.56181874869918
                    ],
                    [
                        24.321750929904187,
                        45.563033153145554
                    ],
                    [
                        24.182689650855526,
                        45.54052806960306
                    ],
                    [
                        24.168892045732733,
                        45.53703991958818
                    ],
                    [
                        24.068329707621213,
                        45.49639640381559
                    ],
                    [
                        24.049416133736912,
                        45.495879643240144
                    ],
                    [
                        24.034068233026716,
                        45.49815340276129
                    ],
                    [
                        23.998514844737322,
                        45.50900543784801
                    ],
                    [
                        23.96063602207905,
                        45.5122093856566
                    ],
                    [
                        23.793979526227638,
                        45.508023590843464
                    ],
                    [
                        23.77863162861058,
                        45.504354576258116
                    ],
                    [
                        23.770260043111087,
                        45.498437599770355
                    ],
                    [
                        23.761888463328432,
                        45.491228753691374
                    ],
                    [
                        23.752586703494963,
                        45.48606109842953
                    ],
                    [
                        23.740132685256018,
                        45.48381318835496
                    ],
                    [
                        23.722924431262864,
                        45.48337392599086
                    ],
                    [
                        23.709746943427756,
                        45.4797565897947
                    ],
                    [
                        23.67915449518987,
                        45.46285839233828
                    ],
                    [
                        23.658690629003917,
                        45.453866700734636
                    ],
                    [
                        23.64690840208231,
                        45.45050773002797
                    ],
                    [
                        23.626082795657084,
                        45.451928804352974
                    ],
                    [
                        23.653419629920364,
                        45.48063506831275
                    ],
                    [
                        23.65264448525225,
                        45.490091874121596
                    ],
                    [
                        23.647993607626475,
                        45.50347608030528
                    ],
                    [
                        23.623602331344564,
                        45.53293164321775
                    ],
                    [
                        23.61352542352276,
                        45.55479074973571
                    ],
                    [
                        23.616470980756468,
                        45.57086211783347
                    ],
                    [
                        23.62406741455969,
                        45.58807036283656
                    ],
                    [
                        23.63197390940744,
                        45.61793934622227
                    ],
                    [
                        23.630320267112275,
                        45.636646243809786
                    ],
                    [
                        23.62391238794623,
                        45.653079329553705
                    ],
                    [
                        23.616160924970956,
                        45.66775545280779
                    ],
                    [
                        23.609494668720583,
                        45.693283634563635
                    ],
                    [
                        23.612440219810583,
                        45.71126699397153
                    ],
                    [
                        23.634971149195895,
                        45.76203912727912
                    ],
                    [
                        23.64163740563729,
                        45.772503575199636
                    ],
                    [
                        23.647683546749956,
                        45.77898896080523
                    ],
                    [
                        23.655900096666972,
                        45.785939422861006
                    ],
                    [
                        23.663651559444517,
                        45.789815137614184
                    ],
                    [
                        23.67016279517051,
                        45.79188222794878
                    ],
                    [
                        23.677449170890377,
                        45.79193389961697
                    ],
                    [
                        23.69284874737405,
                        45.789892682952086
                    ],
                    [
                        23.702615591393137,
                        45.79043527113131
                    ],
                    [
                        23.709281849663213,
                        45.793897581571414
                    ],
                    [
                        23.715793087191216,
                        45.80009880476397
                    ],
                    [
                        23.72912560248305,
                        45.81792713838763
                    ],
                    [
                        23.76343875275394,
                        45.85492746262863
                    ],
                    [
                        23.765144077552932,
                        45.86324738394123
                    ],
                    [
                        23.758632845613775,
                        45.868570044800066
                    ],
                    [
                        23.74669559109103,
                        45.87291087753998
                    ],
                    [
                        23.721219111329635,
                        45.877639277334154
                    ],
                    [
                        23.71145226588335,
                        45.880972410126944
                    ],
                    [
                        23.705096058567097,
                        45.88727689445397
                    ],
                    [
                        23.700600209780607,
                        45.920246462237024
                    ],
                    [
                        23.70540611907369,
                        45.92575000723923
                    ],
                    [
                        23.71300256039719,
                        45.928204682430874
                    ],
                    [
                        23.72292443249214,
                        45.928669750858596
                    ],
                    [
                        23.732226188106242,
                        45.927274470813124
                    ],
                    [
                        23.74173465865842,
                        45.92360549231202
                    ],
                    [
                        23.750416296444143,
                        45.918954594906126
                    ],
                    [
                        23.758942901044318,
                        45.91580228974444
                    ],
                    [
                        23.768864781668338,
                        45.91471711904819
                    ],
                    [
                        23.78483279595038,
                        45.917791841723265
                    ],
                    [
                        23.791654089440982,
                        45.91807609715733
                    ],
                    [
                        23.799302200668095,
                        45.91714591191001
                    ],
                    [
                        23.808914010495684,
                        45.91699084298215
                    ],
                    [
                        23.82085126994841,
                        45.91885121509035
                    ],
                    [
                        23.835734084976234,
                        45.92515575384872
                    ],
                    [
                        23.84953168581088,
                        45.93334642932734
                    ],
                    [
                        23.864466183764787,
                        45.946136407716594
                    ],
                    [
                        23.8671016728553,
                        45.958073598892874
                    ],
                    [
                        23.863846067787897,
                        45.96714288151173
                    ],
                    [
                        23.85655969091431,
                        45.97641880543084
                    ],
                    [
                        23.851857128989185,
                        45.98657317654639
                    ],
                    [
                        23.85283897756264,
                        46.00277371442498
                    ],
                    [
                        23.85997033543525,
                        46.01192050713679
                    ],
                    [
                        23.87206262172609,
                        46.01827671554494
                    ],
                    [
                        23.940947298888485,
                        46.02881866332037
                    ],
                    [
                        23.9525744995267,
                        46.02845695202014
                    ],
                    [
                        23.961411171441995,
                        46.025769790293914
                    ],
                    [
                        23.970557891874478,
                        46.02062793110315
                    ],
                    [
                        23.98812787805674,
                        46.00801887307915
                    ],
                    [
                        23.997274609492656,
                        46.00321299099292
                    ],
                    [
                        24.005801217069383,
                        46.00199856686644
                    ],
                    [
                        24.013707713566042,
                        46.00463407548532
                    ],
                    [
                        24.017583443776267,
                        46.01039598697731
                    ],
                    [
                        24.02244103771041,
                        46.02861199298953
                    ],
                    [
                        24.02910729054716,
                        46.04308135316655
                    ],
                    [
                        24.040424433940604,
                        46.055793780316364
                    ],
                    [
                        24.12403689798476,
                        46.118063854907376
                    ],
                    [
                        24.146257769711365,
                        46.13165480496307
                    ],
                    [
                        24.16129560367735,
                        46.14343697777099
                    ],
                    [
                        24.180829303278312,
                        46.151756934330926
                    ],
                    [
                        24.191836380471923,
                        46.159585891446014
                    ],
                    [
                        24.19638390827994,
                        46.1678282988862
                    ],
                    [
                        24.19746911440075,
                        46.17806023632271
                    ],
                    [
                        24.191836375681028,
                        46.2441543407645
                    ],
                    [
                        24.265888704808333,
                        46.24461944451473
                    ],
                    [
                        24.302630649030295,
                        46.24968373518682
                    ],
                    [
                        24.357614376122815,
                        46.233664071986695
                    ],
                    [
                        24.37621789339795,
                        46.23224297715004
                    ],
                    [
                        24.395596550935245,
                        46.2351626623273
                    ],
                    [
                        24.41249474237167,
                        46.23958098163905
                    ],
                    [
                        24.443707315899207,
                        46.24420607854363
                    ],
                    [
                        24.51367719937145,
                        46.24100210663082
                    ],
                    [
                        24.53341759835646,
                        46.24198396707102
                    ],
                    [
                        24.54581993968683,
                        46.2461697437712
                    ],
                    [
                        24.55279625927945,
                        46.25268098464991
                    ],
                    [
                        24.560392689036984,
                        46.25836535203446
                    ],
                    [
                        24.572640008724704,
                        46.26379141598805
                    ],
                    [
                        24.585507443654116,
                        46.264359874483254
                    ],
                    [
                        24.611914091817575,
                        46.25836535203446
                    ],
                    [
                        24.630982696850346,
                        46.25712512958755
                    ],
                    [
                        24.645452098594802,
                        46.25981230940743
                    ],
                    [
                        24.66467573362968,
                        46.26642690662492
                    ],
                    [
                        24.6738224615185,
                        46.265806780350644
                    ],
                    [
                        24.67754316026803,
                        46.26270616570777
                    ],
                    [
                        24.674907670811614,
                        46.2569701404208
                    ],
                    [
                        24.66793135334868,
                        46.25009718436257
                    ],
                    [
                        24.66297041417636,
                        46.24198396707102
                    ],
                    [
                        24.662195263116693,
                        46.23237212554162
                    ],
                    [
                        24.669016553687367,
                        46.20555206576325
                    ],
                    [
                        24.67366743822816,
                        46.14824293785794
                    ],
                    [
                        24.679558548015656,
                        46.12261140390561
                    ],
                    [
                        24.689945508999827,
                        46.10023549774703
                    ],
                    [
                        24.707360472331086,
                        46.08499098644787
                    ],
                    [
                        24.721313104208114,
                        46.08049510249114
                    ],
                    [
                        24.734025500516157,
                        46.0804433890131
                    ],
                    [
                        24.745342642640342,
                        46.083027233523794
                    ],
                    [
                        24.768648718764325,
                        46.08338900085233
                    ],
                    [
                        24.77640018431666,
                        46.08581780081024
                    ],
                    [
                        24.787252233253305,
                        46.092354851249375
                    ],
                    [
                        24.794848662684494,
                        46.094189329262946
                    ],
                    [
                        24.825906201497116,
                        46.09542958403149
                    ],
                    [
                        24.837068313386112,
                        46.097212438787764
                    ],
                    [
                        24.84559492847166,
                        46.09953790180539
                    ],
                    [
                        24.858772410161013,
                        46.10178576699685
                    ],
                    [
                        24.872311634439072,
                        46.10266426105523
                    ],
                    [
                        24.89448082601497,
                        46.100907275139384
                    ],
                    [
                        24.90781335048571,
                        46.09656648808709
                    ],
                    [
                        24.923678014875804,
                        46.08922843063044
                    ],
                    [
                        24.934220006759407,
                        46.08258801079395
                    ],
                    [
                        24.98186567773602,
                        46.06359692168483
                    ],
                    [
                        24.960419959388798,
                        46.04339144801782
                    ],
                    [
                        24.901147089684603,
                        46.009155801602496
                    ],
                    [
                        24.845594923380997,
                        45.98820099415502
                    ],
                    [
                        24.839238727116122,
                        45.98349847287379
                    ],
                    [
                        24.83706831399849,
                        45.97745231242844
                    ],
                    [
                        24.843269484553296,
                        45.96414562261359
                    ],
                    [
                        24.84435469001161,
                        45.95652334741443
                    ],
                    [
                        24.841254104879766,
                        45.94688570131894
                    ],
                    [
                        24.832882523458473,
                        45.94381095778868
                    ],
                    [
                        24.826371286397464,
                        45.94425016147879
                    ],
                    [
                        24.818774854171153,
                        45.94750579963808
                    ],
                    [
                        24.810403272438425,
                        45.94918528586988
                    ],
                    [
                        24.798569364883498,
                        45.94753160837255
                    ],
                    [
                        24.781361115224104,
                        45.94112374755186
                    ],
                    [
                        24.766323278009413,
                        45.93001334483713
                    ],
                    [
                        24.72162315758613,
                        45.91345100139233
                    ],
                    [
                        24.715421986808437,
                        45.907172321696365
                    ],
                    [
                        24.71480187291855,
                        45.899162499600294
                    ],
                    [
                        24.71852258209901,
                        45.893529803368594
                    ],
                    [
                        24.732165160624803,
                        45.88210931632984
                    ],
                    [
                        24.736350943470317,
                        45.874461149376124
                    ],
                    [
                        24.734955676800997,
                        45.863609080740375
                    ],
                    [
                        24.734645621484066,
                        45.85497914332023
                    ],
                    [
                        24.736971058118243,
                        45.84841621423892
                    ],
                    [
                        24.743172234845918,
                        45.84366201458747
                    ],
                    [
                        24.750045201075967,
                        45.841414096857065
                    ],
                    [
                        24.756866484113413,
                        45.83740913094063
                    ],
                    [
                        24.75950199182404,
                        45.83084629220622
                    ],
                    [
                        24.75438601864057,
                        45.82022673860169
                    ],
                    [
                        24.741001820295043,
                        45.813017857085185
                    ],
                    [
                        24.723793577380025,
                        45.80779859870667
                    ],
                    [
                        24.705345081258127,
                        45.804542925687336
                    ],
                    [
                        24.669171583876498,
                        45.79358754999222
                    ],
                    [
                        24.654133736676073,
                        45.78542263850868
                    ],
                    [
                        24.649327836488137,
                        45.776844401414095
                    ],
                    [
                        24.649947946634683,
                        45.76653490908217
                    ],
                    [
                        24.681263866526848,
                        45.72033619156128
                    ],
                    [
                        24.687310017097733,
                        45.7082697952779
                    ],
                    [
                        24.691650831613316,
                        45.69638417973524
                    ],
                    [
                        24.699919064143288,
                        45.663207932263056
                    ],
                    [
                        24.70363976462198,
                        45.63432078986776
                    ],
                    [
                        24.70705040796409,
                        45.6192829381698
                    ],
                    [
                        24.709065789988223,
                        45.598767410735555
                    ]
                ]
            ]
        },
        "type": "Feature",
        "properties": {
            "source": "https://simplemaps.com",
            "id": "ROSB",
            "name": "Sibiu"
        },
        "id": 34
    },
    {
        "geometry": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        25.06857873776609,
                        47.102965046086375
                    ],
                    [
                        25.158909137329328,
                        47.09144117438329
                    ],
                    [
                        25.20469444608031,
                        47.0764291069763
                    ],
                    [
                        25.211360714924712,
                        47.03831780114013
                    ],
                    [
                        25.216631710082105,
                        47.030023729621014
                    ],
                    [
                        25.225313360159795,
                        47.01909421869738
                    ],
                    [
                        25.247637567748882,
                        47.00348786378262
                    ],
                    [
                        25.257404425141253,
                        46.99434120591691
                    ],
                    [
                        25.264122355817378,
                        46.98245559567004
                    ],
                    [
                        25.267998069038608,
                        46.96669416632339
                    ],
                    [
                        25.270788600984073,
                        46.906026059262324
                    ],
                    [
                        25.25482058635599,
                        46.83832995402388
                    ],
                    [
                        25.260505005904406,
                        46.81608333022716
                    ],
                    [
                        25.28164065298535,
                        46.77469042091836
                    ],
                    [
                        25.286136509437252,
                        46.76771414091685
                    ],
                    [
                        25.28939211536556,
                        46.75848984021657
                    ],
                    [
                        25.288772016779973,
                        46.744382289480406
                    ],
                    [
                        25.282880892435433,
                        46.72267811834833
                    ],
                    [
                        25.279935341423602,
                        46.70391960957528
                    ],
                    [
                        25.282725864172807,
                        46.67694448394558
                    ],
                    [
                        25.28071047334345,
                        46.66738427994361
                    ],
                    [
                        25.272183867261397,
                        46.657384925696455
                    ],
                    [
                        25.229344119505214,
                        46.63286454593958
                    ],
                    [
                        25.214926381570113,
                        46.62154732612373
                    ],
                    [
                        25.178597856423043,
                        46.583668546505194
                    ],
                    [
                        25.16604048468861,
                        46.57410841493932
                    ],
                    [
                        25.149452348353023,
                        46.566460291744995
                    ],
                    [
                        25.10676761022888,
                        46.554187109613075
                    ],
                    [
                        25.093745146871356,
                        46.548218467452024
                    ],
                    [
                        25.034782331104772,
                        46.50594710230158
                    ],
                    [
                        25.02666913674971,
                        46.49646451042174
                    ],
                    [
                        25.02263837352255,
                        46.48548325667984
                    ],
                    [
                        25.01783247801262,
                        46.44794041354776
                    ],
                    [
                        25.012871528840932,
                        46.43967210808414
                    ],
                    [
                        25.00217451776512,
                        46.43300591937051
                    ],
                    [
                        24.939956092545383,
                        46.41525505664807
                    ],
                    [
                        24.93251469222719,
                        46.408718025664704
                    ],
                    [
                        24.932669714128018,
                        46.401819172610686
                    ],
                    [
                        24.96026493432847,
                        46.38817662796788
                    ],
                    [
                        24.967551314431432,
                        46.38166542147017
                    ],
                    [
                        24.96724124232871,
                        46.37120085420943
                    ],
                    [
                        24.961505149392508,
                        46.364353673492936
                    ],
                    [
                        24.950032985809163,
                        46.360038716702434
                    ],
                    [
                        24.92600345816349,
                        46.356085559955964
                    ],
                    [
                        24.9177352274062,
                        46.35223565034506
                    ],
                    [
                        24.910448853805054,
                        46.34781733982726
                    ],
                    [
                        24.90083703898143,
                        46.34347652380221
                    ],
                    [
                        24.878822860412203,
                        46.336991010565264
                    ],
                    [
                        24.87184655936929,
                        46.33138423428692
                    ],
                    [
                        24.870451297868787,
                        46.32523474971037
                    ],
                    [
                        24.876652451395227,
                        46.31634629063792
                    ],
                    [
                        24.95561404622795,
                        46.249425348865785
                    ],
                    [
                        24.973752472760417,
                        46.23787565468949
                    ],
                    [
                        24.993337843793462,
                        46.233509016697575
                    ],
                    [
                        25.039898303819328,
                        46.23454251554729
                    ],
                    [
                        25.056486442128534,
                        46.23030506725151
                    ],
                    [
                        25.109558141322015,
                        46.20162467064401
                    ],
                    [
                        25.18805463675145,
                        46.14343697777099
                    ],
                    [
                        25.138083534174022,
                        46.13553053230939
                    ],
                    [
                        25.04625451385153,
                        46.132662485341214
                    ],
                    [
                        25.031475049815747,
                        46.12987192811303
                    ],
                    [
                        25.01783247560719,
                        46.124135873920565
                    ],
                    [
                        24.995508253904724,
                        46.11150096416401
                    ],
                    [
                        24.985741407283093,
                        46.10338775995149
                    ],
                    [
                        24.97917850538836,
                        46.092845801492054
                    ],
                    [
                        24.975767851268248,
                        46.08447415184628
                    ],
                    [
                        24.98186567773602,
                        46.06359692168483
                    ],
                    [
                        24.934220006759407,
                        46.08258801079395
                    ],
                    [
                        24.923678014875804,
                        46.08922843063044
                    ],
                    [
                        24.90781335048571,
                        46.09656648808709
                    ],
                    [
                        24.89448082601497,
                        46.100907275139384
                    ],
                    [
                        24.872311634439072,
                        46.10266426105523
                    ],
                    [
                        24.858772410161013,
                        46.10178576699685
                    ],
                    [
                        24.84559492847166,
                        46.09953790180539
                    ],
                    [
                        24.837068313386112,
                        46.097212438787764
                    ],
                    [
                        24.825906201497116,
                        46.09542958403149
                    ],
                    [
                        24.794848662684494,
                        46.094189329262946
                    ],
                    [
                        24.787252233253305,
                        46.092354851249375
                    ],
                    [
                        24.77640018431666,
                        46.08581780081024
                    ],
                    [
                        24.768648718764325,
                        46.08338900085233
                    ],
                    [
                        24.745342642640342,
                        46.083027233523794
                    ],
                    [
                        24.734025500516157,
                        46.0804433890131
                    ],
                    [
                        24.721313104208114,
                        46.08049510249114
                    ],
                    [
                        24.707360472331086,
                        46.08499098644787
                    ],
                    [
                        24.689945508999827,
                        46.10023549774703
                    ],
                    [
                        24.679558548015656,
                        46.12261140390561
                    ],
                    [
                        24.67366743822816,
                        46.14824293785794
                    ],
                    [
                        24.669016553687367,
                        46.20555206576325
                    ],
                    [
                        24.662195263116693,
                        46.23237212554162
                    ],
                    [
                        24.66297041417636,
                        46.24198396707102
                    ],
                    [
                        24.66793135334868,
                        46.25009718436257
                    ],
                    [
                        24.674907670811614,
                        46.2569701404208
                    ],
                    [
                        24.67754316026803,
                        46.26270616570777
                    ],
                    [
                        24.6738224615185,
                        46.265806780350644
                    ],
                    [
                        24.66467573362968,
                        46.26642690662492
                    ],
                    [
                        24.645452098594802,
                        46.25981230940743
                    ],
                    [
                        24.630982696850346,
                        46.25712512958755
                    ],
                    [
                        24.611914091817575,
                        46.25836535203446
                    ],
                    [
                        24.585507443654116,
                        46.264359874483254
                    ],
                    [
                        24.572640008724704,
                        46.26379141598805
                    ],
                    [
                        24.560392689036984,
                        46.25836535203446
                    ],
                    [
                        24.55279625927945,
                        46.25268098464991
                    ],
                    [
                        24.54581993968683,
                        46.2461697437712
                    ],
                    [
                        24.53341759835646,
                        46.24198396707102
                    ],
                    [
                        24.51367719937145,
                        46.24100210663082
                    ],
                    [
                        24.443707315899207,
                        46.24420607854363
                    ],
                    [
                        24.41249474237167,
                        46.23958098163905
                    ],
                    [
                        24.395596550935245,
                        46.2351626623273
                    ],
                    [
                        24.37621789339795,
                        46.23224297715004
                    ],
                    [
                        24.357614376122815,
                        46.233664071986695
                    ],
                    [
                        24.302630649030295,
                        46.24968373518682
                    ],
                    [
                        24.265888704808333,
                        46.24461944451473
                    ],
                    [
                        24.191836375681028,
                        46.2441543407645
                    ],
                    [
                        24.1758683640638,
                        46.25180249498191
                    ],
                    [
                        24.16889204596942,
                        46.257280195475396
                    ],
                    [
                        24.161295602351018,
                        46.26622017219175
                    ],
                    [
                        24.153234082416503,
                        46.29776865361105
                    ],
                    [
                        24.143312215004762,
                        46.3128582210331
                    ],
                    [
                        24.122486598770422,
                        46.32461451733574
                    ],
                    [
                        24.067244501672594,
                        46.34071178945023
                    ],
                    [
                        24.05732262070789,
                        46.345414304620135
                    ],
                    [
                        24.02647180332024,
                        46.36900468078639
                    ],
                    [
                        24.02161421645649,
                        46.3765494183904
                    ],
                    [
                        24.02678185328325,
                        46.388357441211284
                    ],
                    [
                        24.034843367900702,
                        46.3953595424347
                    ],
                    [
                        24.047245715381916,
                        46.40336941622198
                    ],
                    [
                        24.05484216548875,
                        46.411534384413834
                    ],
                    [
                        24.059027937088175,
                        46.42024173240742
                    ],
                    [
                        24.057477664637428,
                        46.42724403044163
                    ],
                    [
                        24.053291857591134,
                        46.43241156570661
                    ],
                    [
                        24.04150962855218,
                        46.44098983896842
                    ],
                    [
                        24.026781863675268,
                        46.448276334502175
                    ],
                    [
                        23.99541426318385,
                        46.449671560445346
                    ],
                    [
                        23.972624942500076,
                        46.465277744996754
                    ],
                    [
                        23.967457319332677,
                        46.47649166459429
                    ],
                    [
                        23.971694776135447,
                        46.488713072245794
                    ],
                    [
                        23.991693561676232,
                        46.510029649703036
                    ],
                    [
                        24.00487105331656,
                        46.519279730845675
                    ],
                    [
                        24.02626508055346,
                        46.528865607577195
                    ],
                    [
                        24.032828000523747,
                        46.53447258244716
                    ],
                    [
                        24.034068240861806,
                        46.54566057625716
                    ],
                    [
                        24.030967638704304,
                        46.5540062075591
                    ],
                    [
                        24.02554162498994,
                        46.5619644559895
                    ],
                    [
                        24.02316451154883,
                        46.57116287784832
                    ],
                    [
                        24.025334917494636,
                        46.58258334686388
                    ],
                    [
                        24.03592858139919,
                        46.60351227125622
                    ],
                    [
                        24.045540390530473,
                        46.617723235854015
                    ],
                    [
                        24.06212853423051,
                        46.62898875917497
                    ],
                    [
                        24.075150998757632,
                        46.63309705774918
                    ],
                    [
                        24.11116947685439,
                        46.637515426946784
                    ],
                    [
                        24.120781285030816,
                        46.643768220414806
                    ],
                    [
                        24.127447543809073,
                        46.65474945508928
                    ],
                    [
                        24.126362349502028,
                        46.67182858544136
                    ],
                    [
                        24.119541050967044,
                        46.68175040004924
                    ],
                    [
                        24.110704382196538,
                        46.689579388478975
                    ],
                    [
                        24.10465823885549,
                        46.69663321967441
                    ],
                    [
                        24.10481326481562,
                        46.70531482875426
                    ],
                    [
                        24.10930912336328,
                        46.71652868166045
                    ],
                    [
                        24.146412805824752,
                        46.76624142890578
                    ],
                    [
                        24.157264854953162,
                        46.7759049171276
                    ],
                    [
                        24.166411577337726,
                        46.78215772461793
                    ],
                    [
                        24.196849001886843,
                        46.784534879143884
                    ],
                    [
                        24.279376264316177,
                        46.75683631038897
                    ],
                    [
                        24.345625441439793,
                        46.7453640825655
                    ],
                    [
                        24.36753624599498,
                        46.7445114039313
                    ],
                    [
                        24.38350425813634,
                        46.746604262604635
                    ],
                    [
                        24.42897952864396,
                        46.7594200887454
                    ],
                    [
                        24.464481227146525,
                        46.76283066433201
                    ],
                    [
                        24.48375654257417,
                        46.767274875309894
                    ],
                    [
                        24.49786421073428,
                        46.773579414168545
                    ],
                    [
                        24.50313519797739,
                        46.78156336191153
                    ],
                    [
                        24.506235784026778,
                        46.791872813552324
                    ],
                    [
                        24.507941124665205,
                        46.802311573721695
                    ],
                    [
                        24.51088666387393,
                        46.81311183337489
                    ],
                    [
                        24.517087840230975,
                        46.82166430777609
                    ],
                    [
                        24.536053090096413,
                        46.83781319485213
                    ],
                    [
                        24.542254262363823,
                        46.84504789788089
                    ],
                    [
                        24.55155601685631,
                        46.86365139073454
                    ],
                    [
                        24.561167831965548,
                        46.87584702007385
                    ],
                    [
                        24.58199344948329,
                        46.89452815375317
                    ],
                    [
                        24.606488068991045,
                        46.90791228498357
                    ],
                    [
                        24.624471460483374,
                        46.91362248567617
                    ],
                    [
                        24.636718780962166,
                        46.914811080276074
                    ],
                    [
                        24.648087592976992,
                        46.91336412283775
                    ],
                    [
                        24.66033491565746,
                        46.909695147043145
                    ],
                    [
                        24.68979048329091,
                        46.89687940282298
                    ],
                    [
                        24.706120242854755,
                        46.891970183717625
                    ],
                    [
                        24.724103638634997,
                        46.89013565825729
                    ],
                    [
                        24.735730818075407,
                        46.894037109181895
                    ],
                    [
                        24.74286216988246,
                        46.90209865924187
                    ],
                    [
                        24.75066530596146,
                        46.93026228623099
                    ],
                    [
                        24.756349724973667,
                        46.94413748122759
                    ],
                    [
                        24.764307902251254,
                        46.95666905100466
                    ],
                    [
                        24.789422640002726,
                        46.982507217844976
                    ],
                    [
                        24.794538609111463,
                        46.98974193264197
                    ],
                    [
                        24.808336210480796,
                        47.01464993322986
                    ],
                    [
                        24.815984332608707,
                        47.02178134807037
                    ],
                    [
                        24.866523889933895,
                        47.05211545450621
                    ],
                    [
                        24.89897668653111,
                        47.06694657262859
                    ],
                    [
                        24.925693394537575,
                        47.073147693681506
                    ],
                    [
                        24.991477491727764,
                        47.0819326810191
                    ],
                    [
                        25.06857873776609,
                        47.102965046086375
                    ]
                ]
            ]
        },
        "type": "Feature",
        "properties": {
            "source": "https://simplemaps.com",
            "id": "ROMS",
            "name": "Mures"
        },
        "id": 35
    },
    {
        "geometry": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        25.20469444608031,
                        47.0764291069763
                    ],
                    [
                        25.24190147109559,
                        47.06632632885188
                    ],
                    [
                        25.25482058384083,
                        47.06570623995981
                    ],
                    [
                        25.26985843258645,
                        47.06642975395674
                    ],
                    [
                        25.282570835079138,
                        47.07035716658503
                    ],
                    [
                        25.291872595128872,
                        47.07676505724848
                    ],
                    [
                        25.297298627550678,
                        47.084774948285606
                    ],
                    [
                        25.298848903121364,
                        47.093068907442564
                    ],
                    [
                        25.2993139921723,
                        47.10242234810998
                    ],
                    [
                        25.301639441421774,
                        47.11164664918211
                    ],
                    [
                        25.31176801600061,
                        47.12296375253056
                    ],
                    [
                        25.328356141749463,
                        47.13050845638475
                    ],
                    [
                        25.34804486568375,
                        47.136606294672795
                    ],
                    [
                        25.372539505486127,
                        47.14032706204993
                    ],
                    [
                        25.389799437323436,
                        47.139732806174024
                    ],
                    [
                        25.406852658369885,
                        47.13484937477129
                    ],
                    [
                        25.51888715352949,
                        47.08239773285303
                    ],
                    [
                        25.53004925893648,
                        47.074439538659924
                    ],
                    [
                        25.539867796825497,
                        47.065215394738196
                    ],
                    [
                        25.552115103322684,
                        47.055939422741105
                    ],
                    [
                        25.56792810625478,
                        47.04880816770713
                    ],
                    [
                        25.583586046165227,
                        47.04730943500089
                    ],
                    [
                        25.604411643187763,
                        47.049350620631195
                    ],
                    [
                        25.618674350105263,
                        47.0525804628235
                    ],
                    [
                        25.6712809699808,
                        47.057903212058896
                    ],
                    [
                        25.693760214327543,
                        47.05418248774431
                    ],
                    [
                        25.722027219724858,
                        47.04560417986064
                    ],
                    [
                        25.7370650655586,
                        47.038989621751796
                    ],
                    [
                        25.750552615711133,
                        47.02777584219266
                    ],
                    [
                        25.76269657295658,
                        47.012479594277686
                    ],
                    [
                        25.779439739898976,
                        46.98317907506293
                    ],
                    [
                        25.791842069221577,
                        46.96609992649493
                    ],
                    [
                        25.80936037741141,
                        46.94974432064987
                    ],
                    [
                        25.843053432428754,
                        46.932303649380955
                    ],
                    [
                        25.85716107538217,
                        46.922975912461304
                    ],
                    [
                        25.865842725711186,
                        46.912847397780155
                    ],
                    [
                        25.871268755175695,
                        46.89641431248375
                    ],
                    [
                        25.870493615268483,
                        46.88840451101054
                    ],
                    [
                        25.866772894369056,
                        46.88370184572687
                    ],
                    [
                        25.860261680522513,
                        46.88328853419636
                    ],
                    [
                        25.841968225021738,
                        46.885665658658674
                    ],
                    [
                        25.832046329895224,
                        46.88530379766256
                    ],
                    [
                        25.82444990947135,
                        46.88251336531032
                    ],
                    [
                        25.819437291356422,
                        46.87781078545199
                    ],
                    [
                        25.81695682977876,
                        46.8698009826887
                    ],
                    [
                        25.81654341409184,
                        46.85918144870729
                    ],
                    [
                        25.828170610332418,
                        46.693610152647814
                    ],
                    [
                        25.83282147843195,
                        46.68115606515249
                    ],
                    [
                        25.84088301068431,
                        46.67017487626467
                    ],
                    [
                        25.855765814194566,
                        46.65769496438234
                    ],
                    [
                        25.888993768653876,
                        46.634776519169826
                    ],
                    [
                        25.90093102291627,
                        46.63007395649705
                    ],
                    [
                        25.91116294997424,
                        46.629298771342235
                    ],
                    [
                        25.915038699047543,
                        46.63555171710189
                    ],
                    [
                        25.913643428898364,
                        46.64464673037239
                    ],
                    [
                        25.907287224260212,
                        46.66575653248343
                    ],
                    [
                        25.906977176842183,
                        46.674825820074986
                    ],
                    [
                        25.917519158358928,
                        46.679735007376074
                    ],
                    [
                        25.927130967589072,
                        46.68185370268546
                    ],
                    [
                        26.008779740790683,
                        46.66795280390239
                    ],
                    [
                        26.01203534294113,
                        46.59359033806644
                    ],
                    [
                        26.02893354780878,
                        46.548528558041916
                    ],
                    [
                        26.0416459581452,
                        46.532043827969275
                    ],
                    [
                        26.05627038123064,
                        46.51710929189402
                    ],
                    [
                        26.06913779878299,
                        46.49860904306974
                    ],
                    [
                        26.069912964302738,
                        46.48718867030564
                    ],
                    [
                        26.060301133605865,
                        46.48016058689179
                    ],
                    [
                        26.04629682541736,
                        46.476698296403654
                    ],
                    [
                        26.032499231711054,
                        46.46827512299223
                    ],
                    [
                        26.02428266274679,
                        46.45489082407007
                    ],
                    [
                        26.01885663712938,
                        46.426830520589064
                    ],
                    [
                        26.024902780438655,
                        46.41267117973559
                    ],
                    [
                        26.03870039632138,
                        46.40329196522088
                    ],
                    [
                        26.079834820517807,
                        46.3953078585263
                    ],
                    [
                        26.132596478891614,
                        46.39065710572397
                    ],
                    [
                        26.146859156251484,
                        46.38471420323362
                    ],
                    [
                        26.161948691070858,
                        46.37308711178543
                    ],
                    [
                        26.167374699897426,
                        46.36166651846841
                    ],
                    [
                        26.168149866437574,
                        46.35003944554506
                    ],
                    [
                        26.16024334896418,
                        46.326242303879226
                    ],
                    [
                        26.159468226608535,
                        46.312548192561344
                    ],
                    [
                        26.167839805579238,
                        46.3062178158607
                    ],
                    [
                        26.182257526569003,
                        46.30572687041011
                    ],
                    [
                        26.207837346139428,
                        46.311488700738934
                    ],
                    [
                        26.24711145398257,
                        46.32655249806618
                    ],
                    [
                        26.26199425119279,
                        46.3282577277739
                    ],
                    [
                        26.275843536888285,
                        46.3266816051709
                    ],
                    [
                        26.29274173135025,
                        46.319705291186736
                    ],
                    [
                        26.29894290200275,
                        46.31112700232595
                    ],
                    [
                        26.300183132871894,
                        46.30203192278051
                    ],
                    [
                        26.28685062338731,
                        46.27619377432957
                    ],
                    [
                        26.28452517673358,
                        46.26720202770955
                    ],
                    [
                        26.279874298850885,
                        46.226506844382406
                    ],
                    [
                        26.27553348763009,
                        46.2164041545095
                    ],
                    [
                        26.263389521361514,
                        46.19873078865958
                    ],
                    [
                        26.25904869712688,
                        46.188059577357144
                    ],
                    [
                        26.251607296415273,
                        46.15028414420109
                    ],
                    [
                        25.9917265186788,
                        46.110906705095644
                    ],
                    [
                        25.898450554896872,
                        46.115841782942354
                    ],
                    [
                        25.87080366251275,
                        46.12550526680323
                    ],
                    [
                        25.85297528968442,
                        46.13563382228398
                    ],
                    [
                        25.84491377009137,
                        46.14524567042974
                    ],
                    [
                        25.83576704079139,
                        46.153203830252274
                    ],
                    [
                        25.795872840240197,
                        46.17557975759751
                    ],
                    [
                        25.78920657954329,
                        46.18271110496928
                    ],
                    [
                        25.783470498532456,
                        46.19183201231105
                    ],
                    [
                        25.75830406626168,
                        46.22565417375645
                    ],
                    [
                        25.755358519475752,
                        46.23552443429078
                    ],
                    [
                        25.753963248852646,
                        46.244877827241076
                    ],
                    [
                        25.751327752062576,
                        46.25412791819085
                    ],
                    [
                        25.744041379472726,
                        46.26275790626728
                    ],
                    [
                        25.733034295005595,
                        46.27084524280184
                    ],
                    [
                        25.706782679540513,
                        46.28694252416924
                    ],
                    [
                        25.69096968102809,
                        46.292936930714774
                    ],
                    [
                        25.678102246946523,
                        46.29112823348371
                    ],
                    [
                        25.666475061467743,
                        46.28523719300657
                    ],
                    [
                        25.65469282287815,
                        46.27634877213876
                    ],
                    [
                        25.621309854468958,
                        46.26146600430833
                    ],
                    [
                        25.604876738868843,
                        46.25113065616737
                    ],
                    [
                        25.56916832788499,
                        46.21469878845292
                    ],
                    [
                        25.554285517868813,
                        46.20327831737728
                    ],
                    [
                        25.533304885051226,
                        46.19242625597684
                    ],
                    [
                        25.497493114253018,
                        46.165399465830426
                    ],
                    [
                        25.492842240365,
                        46.15914664924699
                    ],
                    [
                        25.493927446381434,
                        46.15028414420109
                    ],
                    [
                        25.484160595012444,
                        46.144212130620176
                    ],
                    [
                        25.47930301778745,
                        46.14049147393841
                    ],
                    [
                        25.45449832948185,
                        46.10586826231344
                    ],
                    [
                        25.42721316621322,
                        46.12721057913239
                    ],
                    [
                        25.38282310880512,
                        46.13829515877571
                    ],
                    [
                        25.367578569470645,
                        46.146124196999224
                    ],
                    [
                        25.350990426711114,
                        46.156976193999995
                    ],
                    [
                        25.330216506864144,
                        46.16462434251842
                    ],
                    [
                        25.313318313170306,
                        46.16741487114532
                    ],
                    [
                        25.296523467114085,
                        46.16689806800148
                    ],
                    [
                        25.241591426334214,
                        46.14948315434361
                    ],
                    [
                        25.18805463675145,
                        46.14343697777099
                    ],
                    [
                        25.109558141322015,
                        46.20162467064401
                    ],
                    [
                        25.056486442128534,
                        46.23030506725151
                    ],
                    [
                        25.039898303819328,
                        46.23454251554729
                    ],
                    [
                        24.993337843793462,
                        46.233509016697575
                    ],
                    [
                        24.973752472760417,
                        46.23787565468949
                    ],
                    [
                        24.95561404622795,
                        46.249425348865785
                    ],
                    [
                        24.876652451395227,
                        46.31634629063792
                    ],
                    [
                        24.870451297868787,
                        46.32523474971037
                    ],
                    [
                        24.87184655936929,
                        46.33138423428692
                    ],
                    [
                        24.878822860412203,
                        46.336991010565264
                    ],
                    [
                        24.90083703898143,
                        46.34347652380221
                    ],
                    [
                        24.910448853805054,
                        46.34781733982726
                    ],
                    [
                        24.9177352274062,
                        46.35223565034506
                    ],
                    [
                        24.92600345816349,
                        46.356085559955964
                    ],
                    [
                        24.950032985809163,
                        46.360038716702434
                    ],
                    [
                        24.961505149392508,
                        46.364353673492936
                    ],
                    [
                        24.96724124232871,
                        46.37120085420943
                    ],
                    [
                        24.967551314431432,
                        46.38166542147017
                    ],
                    [
                        24.96026493432847,
                        46.38817662796788
                    ],
                    [
                        24.932669714128018,
                        46.401819172610686
                    ],
                    [
                        24.93251469222719,
                        46.408718025664704
                    ],
                    [
                        24.939956092545383,
                        46.41525505664807
                    ],
                    [
                        25.00217451776512,
                        46.43300591937051
                    ],
                    [
                        25.012871528840932,
                        46.43967210808414
                    ],
                    [
                        25.01783247801262,
                        46.44794041354776
                    ],
                    [
                        25.02263837352255,
                        46.48548325667984
                    ],
                    [
                        25.02666913674971,
                        46.49646451042174
                    ],
                    [
                        25.034782331104772,
                        46.50594710230158
                    ],
                    [
                        25.093745146871356,
                        46.548218467452024
                    ],
                    [
                        25.10676761022888,
                        46.554187109613075
                    ],
                    [
                        25.149452348353023,
                        46.566460291744995
                    ],
                    [
                        25.16604048468861,
                        46.57410841493932
                    ],
                    [
                        25.178597856423043,
                        46.583668546505194
                    ],
                    [
                        25.214926381570113,
                        46.62154732612373
                    ],
                    [
                        25.229344119505214,
                        46.63286454593958
                    ],
                    [
                        25.272183867261397,
                        46.657384925696455
                    ],
                    [
                        25.28071047334345,
                        46.66738427994361
                    ],
                    [
                        25.282725864172807,
                        46.67694448394558
                    ],
                    [
                        25.279935341423602,
                        46.70391960957528
                    ],
                    [
                        25.282880892435433,
                        46.72267811834833
                    ],
                    [
                        25.288772016779973,
                        46.744382289480406
                    ],
                    [
                        25.28939211536556,
                        46.75848984021657
                    ],
                    [
                        25.286136509437252,
                        46.76771414091685
                    ],
                    [
                        25.28164065298535,
                        46.77469042091836
                    ],
                    [
                        25.260505005904406,
                        46.81608333022716
                    ],
                    [
                        25.25482058635599,
                        46.83832995402388
                    ],
                    [
                        25.270788600984073,
                        46.906026059262324
                    ],
                    [
                        25.267998069038608,
                        46.96669416632339
                    ],
                    [
                        25.264122355817378,
                        46.98245559567004
                    ],
                    [
                        25.257404425141253,
                        46.99434120591691
                    ],
                    [
                        25.247637567748882,
                        47.00348786378262
                    ],
                    [
                        25.225313360159795,
                        47.01909421869738
                    ],
                    [
                        25.216631710082105,
                        47.030023729621014
                    ],
                    [
                        25.211360714924712,
                        47.03831780114013
                    ],
                    [
                        25.20469444608031,
                        47.0764291069763
                    ]
                ]
            ]
        },
        "type": "Feature",
        "properties": {
            "source": "https://simplemaps.com",
            "id": "ROHR",
            "name": "Harghita"
        },
        "id": 36
    },
    {
        "geometry": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        26.48234256992957,
                        47.25360183042539
                    ],
                    [
                        26.551588992207872,
                        47.20729976226501
                    ],
                    [
                        26.60264529154074,
                        47.15637254648328
                    ],
                    [
                        26.63241091919565,
                        47.10583301511097
                    ],
                    [
                        26.63954226164367,
                        47.090045827562506
                    ],
                    [
                        26.648378944813444,
                        47.07635165097116
                    ],
                    [
                        26.661246380434555,
                        47.071287390794026
                    ],
                    [
                        26.67866132693002,
                        47.07097726452921
                    ],
                    [
                        26.69726483444633,
                        47.07263086494908
                    ],
                    [
                        26.72057092063689,
                        47.07211419073586
                    ],
                    [
                        26.749096318873367,
                        47.06653317909517
                    ],
                    [
                        26.787595260643876,
                        47.05211545450621
                    ],
                    [
                        26.846558061790187,
                        47.02079948608289
                    ],
                    [
                        26.872447941533117,
                        47.01129094620016
                    ],
                    [
                        26.913117310179597,
                        47.00501235773472
                    ],
                    [
                        26.927690060632706,
                        47.005503264153745
                    ],
                    [
                        26.936526723541007,
                        47.0088621905023
                    ],
                    [
                        26.94226279950958,
                        47.01516666813371
                    ],
                    [
                        26.95037602171628,
                        47.03185828422642
                    ],
                    [
                        26.959522741685127,
                        47.03780102883578
                    ],
                    [
                        26.973785429028283,
                        47.039971385931956
                    ],
                    [
                        27.02112105718796,
                        47.03237504692216
                    ],
                    [
                        27.038794382166554,
                        47.03144478247467
                    ],
                    [
                        27.050886662140964,
                        47.034752043152075
                    ],
                    [
                        27.061480344126036,
                        47.04131503552277
                    ],
                    [
                        27.09605187732024,
                        47.06854851605616
                    ],
                    [
                        27.109281051041098,
                        47.07387122457982
                    ],
                    [
                        27.12540407647076,
                        47.07666162878749
                    ],
                    [
                        27.148038351659025,
                        47.075059644553015
                    ],
                    [
                        27.16044071412425,
                        47.07051222937784
                    ],
                    [
                        27.16819217519078,
                        47.0627349013786
                    ],
                    [
                        27.172739701549666,
                        47.05384656127666
                    ],
                    [
                        27.175995326582346,
                        47.044467348160175
                    ],
                    [
                        27.18529706398708,
                        47.03439032185375
                    ],
                    [
                        27.197544390550394,
                        47.024623540511705
                    ],
                    [
                        27.220488712019936,
                        47.01113591215225
                    ],
                    [
                        27.23371789728624,
                        47.00064570523856
                    ],
                    [
                        27.239453970886743,
                        46.99170562298284
                    ],
                    [
                        27.236198370638803,
                        46.984626038737545
                    ],
                    [
                        27.227206646305664,
                        46.98023339181358
                    ],
                    [
                        27.19769941762943,
                        46.97496247913586
                    ],
                    [
                        27.179716017962754,
                        46.97013073147452
                    ],
                    [
                        27.16323122941431,
                        46.963593623017594
                    ],
                    [
                        27.14943362007367,
                        46.95457606950798
                    ],
                    [
                        27.14292238982331,
                        46.944576678592256
                    ],
                    [
                        27.144317664295574,
                        46.93413810683463
                    ],
                    [
                        27.15501469346853,
                        46.92225256826416
                    ],
                    [
                        27.176460392985092,
                        46.90246038539864
                    ],
                    [
                        27.19382368923216,
                        46.88160902954984
                    ],
                    [
                        27.199559756946375,
                        46.87274642675807
                    ],
                    [
                        27.204830751240383,
                        46.85956892827793
                    ],
                    [
                        27.21056685892058,
                        46.828098121397545
                    ],
                    [
                        27.232942737094646,
                        46.78598172437725
                    ],
                    [
                        27.23635338399907,
                        46.77006539646605
                    ],
                    [
                        27.236663433889994,
                        46.75885156057238
                    ],
                    [
                        27.225501346410336,
                        46.74283199888023
                    ],
                    [
                        27.18607221888237,
                        46.72918935755727
                    ],
                    [
                        27.157495140744643,
                        46.734537807336935
                    ],
                    [
                        27.146953166297106,
                        46.738646189364374
                    ],
                    [
                        27.065976198170198,
                        46.75141027314205
                    ],
                    [
                        27.04189497888228,
                        46.751151885341216
                    ],
                    [
                        26.971149931520767,
                        46.743658727509086
                    ],
                    [
                        26.95115116315802,
                        46.75342564355297
                    ],
                    [
                        26.93761193994465,
                        46.76401932289153
                    ],
                    [
                        26.931410749201504,
                        46.77388940862498
                    ],
                    [
                        26.930480577522474,
                        46.780814076440734
                    ],
                    [
                        26.932651001932545,
                        46.78714451782136
                    ],
                    [
                        26.931410756078026,
                        46.79476672884792
                    ],
                    [
                        26.92567467871572,
                        46.8027249360143
                    ],
                    [
                        26.905520868889155,
                        46.813370270066656
                    ],
                    [
                        26.894668812102697,
                        46.81378364635305
                    ],
                    [
                        26.88924278562313,
                        46.81037300052915
                    ],
                    [
                        26.890638065398523,
                        46.80298336448884
                    ],
                    [
                        26.891258167519585,
                        46.79533516579396
                    ],
                    [
                        26.88877770662549,
                        46.78706697765725
                    ],
                    [
                        26.88273155479498,
                        46.779987254196435
                    ],
                    [
                        26.855859810231138,
                        46.764691035103134
                    ],
                    [
                        26.850898874233923,
                        46.75838651354975
                    ],
                    [
                        26.850123728772836,
                        46.750402515809895
                    ],
                    [
                        26.85244917267205,
                        46.7420051188066
                    ],
                    [
                        26.851829064175558,
                        46.73404700334863
                    ],
                    [
                        26.84624799792929,
                        46.72634714144203
                    ],
                    [
                        26.83493085416656,
                        46.71962917589772
                    ],
                    [
                        26.818911176699938,
                        46.714797532617084
                    ],
                    [
                        26.80294314503938,
                        46.71492663546426
                    ],
                    [
                        26.790540805664918,
                        46.719525861439585
                    ],
                    [
                        26.75994836966905,
                        46.73471880780391
                    ],
                    [
                        26.733438342641644,
                        46.74125577013143
                    ],
                    [
                        26.71436975425223,
                        46.74009313931442
                    ],
                    [
                        26.702380822435263,
                        46.73497718268885
                    ],
                    [
                        26.693544138384578,
                        46.72102446155224
                    ],
                    [
                        26.685482611205796,
                        46.71378973388913
                    ],
                    [
                        26.62388429975861,
                        46.6959613393315
                    ],
                    [
                        26.609776647731334,
                        46.68942435416599
                    ],
                    [
                        26.590346315688006,
                        46.672448690139476
                    ],
                    [
                        26.581819687198195,
                        46.66699672029894
                    ],
                    [
                        26.5691072901774,
                        46.66606657900197
                    ],
                    [
                        26.52797284815689,
                        46.67157010649931
                    ],
                    [
                        26.492471142642316,
                        46.66583404408587
                    ],
                    [
                        26.454437287028906,
                        46.666144090676966
                    ],
                    [
                        26.443585230096655,
                        46.66327601729457
                    ],
                    [
                        26.434696886884353,
                        46.65746243534072
                    ],
                    [
                        26.426790387208264,
                        46.6486774080687
                    ],
                    [
                        26.417643658910873,
                        46.64071923795789
                    ],
                    [
                        26.407721789001148,
                        46.63508653673596
                    ],
                    [
                        26.390358506085104,
                        46.63327784922248
                    ],
                    [
                        26.3111902240441,
                        46.63309705774918
                    ],
                    [
                        26.299718040499258,
                        46.63495731155691
                    ],
                    [
                        26.29723758963084,
                        46.638910673250926
                    ],
                    [
                        26.29816775891498,
                        46.64428498166837
                    ],
                    [
                        26.300648224279026,
                        46.65110624423513
                    ],
                    [
                        26.301113318289108,
                        46.65834098156576
                    ],
                    [
                        26.298632856357624,
                        46.66542070024522
                    ],
                    [
                        26.293051800656922,
                        46.672448690139476
                    ],
                    [
                        26.28638552261205,
                        46.67952824996468
                    ],
                    [
                        26.275378441926183,
                        46.69523788368451
                    ],
                    [
                        26.26850548594939,
                        46.70056060790592
                    ],
                    [
                        26.253777697843,
                        46.70443631124819
                    ],
                    [
                        26.241995486109204,
                        46.70293778652224
                    ],
                    [
                        26.230833373226854,
                        46.698777811929546
                    ],
                    [
                        26.169235047205717,
                        46.667694327985856
                    ],
                    [
                        26.14344852972705,
                        46.66020137688173
                    ],
                    [
                        26.124069865676102,
                        46.65787592273941
                    ],
                    [
                        26.110737333546812,
                        46.65994290701266
                    ],
                    [
                        26.082160267517498,
                        46.67141508062733
                    ],
                    [
                        26.05937095815084,
                        46.675419990107
                    ],
                    [
                        26.045366662099138,
                        46.67513587508648
                    ],
                    [
                        26.008779740790683,
                        46.66795280390239
                    ],
                    [
                        25.927130967589072,
                        46.68185370268546
                    ],
                    [
                        25.917519158358928,
                        46.679735007376074
                    ],
                    [
                        25.906977176842183,
                        46.674825820074986
                    ],
                    [
                        25.907287224260212,
                        46.66575653248343
                    ],
                    [
                        25.913643428898364,
                        46.64464673037239
                    ],
                    [
                        25.915038699047543,
                        46.63555171710189
                    ],
                    [
                        25.91116294997424,
                        46.629298771342235
                    ],
                    [
                        25.90093102291627,
                        46.63007395649705
                    ],
                    [
                        25.888993768653876,
                        46.634776519169826
                    ],
                    [
                        25.855765814194566,
                        46.65769496438234
                    ],
                    [
                        25.84088301068431,
                        46.67017487626467
                    ],
                    [
                        25.83282147843195,
                        46.68115606515249
                    ],
                    [
                        25.828170610332418,
                        46.693610152647814
                    ],
                    [
                        25.81654341409184,
                        46.85918144870729
                    ],
                    [
                        25.81695682977876,
                        46.8698009826887
                    ],
                    [
                        25.819437291356422,
                        46.87781078545199
                    ],
                    [
                        25.82444990947135,
                        46.88251336531032
                    ],
                    [
                        25.832046329895224,
                        46.88530379766256
                    ],
                    [
                        25.841968225021738,
                        46.885665658658674
                    ],
                    [
                        25.860261680522513,
                        46.88328853419636
                    ],
                    [
                        25.866772894369056,
                        46.88370184572687
                    ],
                    [
                        25.870493615268483,
                        46.88840451101054
                    ],
                    [
                        25.871268755175695,
                        46.89641431248375
                    ],
                    [
                        25.865842725711186,
                        46.912847397780155
                    ],
                    [
                        25.85716107538217,
                        46.922975912461304
                    ],
                    [
                        25.843053432428754,
                        46.932303649380955
                    ],
                    [
                        25.80936037741141,
                        46.94974432064987
                    ],
                    [
                        25.791842069221577,
                        46.96609992649493
                    ],
                    [
                        25.779439739898976,
                        46.98317907506293
                    ],
                    [
                        25.76269657295658,
                        47.012479594277686
                    ],
                    [
                        25.750552615711133,
                        47.02777584219266
                    ],
                    [
                        25.7370650655586,
                        47.038989621751796
                    ],
                    [
                        25.722027219724858,
                        47.04560417986064
                    ],
                    [
                        25.693760214327543,
                        47.05418248774431
                    ],
                    [
                        25.6712809699808,
                        47.057903212058896
                    ],
                    [
                        25.672056098005093,
                        47.07991725934682
                    ],
                    [
                        25.683528272311488,
                        47.10580719405241
                    ],
                    [
                        25.69624066717099,
                        47.12301539744293
                    ],
                    [
                        25.740785760317465,
                        47.159679877811605
                    ],
                    [
                        25.755978634348057,
                        47.16926587721358
                    ],
                    [
                        25.79509768956294,
                        47.18660328994317
                    ],
                    [
                        25.812150900238777,
                        47.196964347116584
                    ],
                    [
                        25.819643999320633,
                        47.206937997781615
                    ],
                    [
                        25.8216077019359,
                        47.21631725705525
                    ],
                    [
                        25.81943728555548,
                        47.224611286829415
                    ],
                    [
                        25.81199587700803,
                        47.23189764916748
                    ],
                    [
                        25.791842087046735,
                        47.24463600524722
                    ],
                    [
                        25.774323758604112,
                        47.26161159801136
                    ],
                    [
                        25.771533225884507,
                        47.268536216507954
                    ],
                    [
                        25.77571903895502,
                        47.274220758466015
                    ],
                    [
                        25.783470485249982,
                        47.27763128722552
                    ],
                    [
                        25.79416752646174,
                        47.277941462961415
                    ],
                    [
                        25.806569864122547,
                        47.274530777036894
                    ],
                    [
                        25.820264102492917,
                        47.268536216507954
                    ],
                    [
                        25.865687703154897,
                        47.23949416460685
                    ],
                    [
                        25.878451785443488,
                        47.23326717636789
                    ],
                    [
                        25.891319202459293,
                        47.23184598641942
                    ],
                    [
                        25.908992550526367,
                        47.23401644420063
                    ],
                    [
                        25.98206303503173,
                        47.25747759802837
                    ],
                    [
                        25.99668744150015,
                        47.25825260353688
                    ],
                    [
                        26.010795127710324,
                        47.255100465126375
                    ],
                    [
                        26.02319746183168,
                        47.24926096616214
                    ],
                    [
                        26.039630577729678,
                        47.24538530025151
                    ],
                    [
                        26.058750849541227,
                        47.244920162058264
                    ],
                    [
                        26.110427271601605,
                        47.25406682774271
                    ],
                    [
                        26.222926875651023,
                        47.25370516310289
                    ],
                    [
                        26.259358749310277,
                        47.259880428895876
                    ],
                    [
                        26.353099811644526,
                        47.29318597283403
                    ],
                    [
                        26.375734074855927,
                        47.29700994281132
                    ],
                    [
                        26.395784533417903,
                        47.29675157537567
                    ],
                    [
                        26.415473257128216,
                        47.2939093939224
                    ],
                    [
                        26.43273319866856,
                        47.288793501807405
                    ],
                    [
                        26.447305947372048,
                        47.2809903361426
                    ],
                    [
                        26.48234256992957,
                        47.25360183042539
                    ]
                ]
            ]
        },
        "type": "Feature",
        "properties": {
            "source": "https://simplemaps.com",
            "id": "RONT",
            "name": "Neamt"
        },
        "id": 37
    },
    {
        "geometry": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        27.225501346410336,
                        46.74283199888023
                    ],
                    [
                        27.23960900391071,
                        46.73027457661121
                    ],
                    [
                        27.245810167852344,
                        46.72360826556549
                    ],
                    [
                        27.259297726248814,
                        46.713428063078545
                    ],
                    [
                        27.304928011771825,
                        46.68707306050094
                    ],
                    [
                        27.323841578897046,
                        46.67250026325582
                    ],
                    [
                        27.33583051836913,
                        46.65474945508928
                    ],
                    [
                        27.33645063641505,
                        46.63007395649705
                    ],
                    [
                        27.33303999517883,
                        46.60733635178835
                    ],
                    [
                        27.337690860356126,
                        46.58485702216062
                    ],
                    [
                        27.44176720110953,
                        46.45912829462388
                    ],
                    [
                        27.479025903709683,
                        46.39747828270681
                    ],
                    [
                        27.501711875602066,
                        46.33557002565126
                    ],
                    [
                        27.513029010220617,
                        46.289061206386776
                    ],
                    [
                        27.51985029470451,
                        46.16260895334737
                    ],
                    [
                        27.489412877871487,
                        46.16534781643301
                    ],
                    [
                        27.45453128641607,
                        46.17266003731343
                    ],
                    [
                        27.445074499554273,
                        46.17144564013305
                    ],
                    [
                        27.43742638397027,
                        46.165528665988624
                    ],
                    [
                        27.4323104230623,
                        46.15940504497463
                    ],
                    [
                        27.424558951214376,
                        46.15403065251029
                    ],
                    [
                        27.413241812870446,
                        46.151834405409474
                    ],
                    [
                        27.394793326946584,
                        46.15361724113627
                    ],
                    [
                        27.352263627337475,
                        46.17175569532392
                    ],
                    [
                        27.332419878198632,
                        46.174339524865545
                    ],
                    [
                        27.306788358968493,
                        46.17382271144298
                    ],
                    [
                        27.233097778508366,
                        46.16297072633972
                    ],
                    [
                        27.20824140218567,
                        46.15351386921218
                    ],
                    [
                        27.197234331643827,
                        46.14467725380644
                    ],
                    [
                        27.18018110307595,
                        46.12816660280624
                    ],
                    [
                        27.16932905531898,
                        46.121190302862445
                    ],
                    [
                        27.142302276572412,
                        46.108607063784056
                    ],
                    [
                        27.132845487416215,
                        46.100493849940435
                    ],
                    [
                        27.12090824176397,
                        46.085714448908504
                    ],
                    [
                        27.112381623905907,
                        46.08090850413892
                    ],
                    [
                        27.09977258131574,
                        46.07935825046724
                    ],
                    [
                        27.04763106009345,
                        46.092122324337545
                    ],
                    [
                        27.033988473423626,
                        46.09408597489677
                    ],
                    [
                        27.01864057742397,
                        46.093104148243825
                    ],
                    [
                        27.001897410017154,
                        46.08721301615327
                    ],
                    [
                        26.993009062552797,
                        46.08023668840199
                    ],
                    [
                        26.98804813322078,
                        46.072381925408116
                    ],
                    [
                        26.98572269411521,
                        46.06594820944091
                    ],
                    [
                        26.981536903621386,
                        46.06189161203117
                    ],
                    [
                        26.972545194634932,
                        46.06065132237223
                    ],
                    [
                        26.93389122948004,
                        46.071916821562326
                    ],
                    [
                        26.918698353842828,
                        46.073415406588495
                    ],
                    [
                        26.901490102085603,
                        46.07292448349642
                    ],
                    [
                        26.881904736865778,
                        46.069901429743744
                    ],
                    [
                        26.865316605192323,
                        46.0710383278029
                    ],
                    [
                        26.840511919224117,
                        46.076102625095004
                    ],
                    [
                        26.796897007072268,
                        46.07711029902389
                    ],
                    [
                        26.767079710743197,
                        46.080960217685416
                    ],
                    [
                        26.67044477597933,
                        46.07682606925711
                    ],
                    [
                        26.654115026738367,
                        46.07346711903276
                    ],
                    [
                        26.64248783047306,
                        46.06594820944091
                    ],
                    [
                        26.636131629098102,
                        46.057344083387186
                    ],
                    [
                        26.63334109576349,
                        46.04840402202746
                    ],
                    [
                        26.63210086684265,
                        46.02912874564465
                    ],
                    [
                        26.63055056984814,
                        46.019542746857084
                    ],
                    [
                        26.60042321341554,
                        46.009233317848484
                    ],
                    [
                        26.484823033573665,
                        46.02124808165302
                    ],
                    [
                        26.468079870169053,
                        46.02737174374013
                    ],
                    [
                        26.46141360367497,
                        46.035381543326174
                    ],
                    [
                        26.45521243443061,
                        46.04457996872836
                    ],
                    [
                        26.445910675224155,
                        46.06571562338881
                    ],
                    [
                        26.4406396784651,
                        46.07478483128907
                    ],
                    [
                        26.432061397106864,
                        46.08158032116016
                    ],
                    [
                        26.421209340511275,
                        46.08741972086916
                    ],
                    [
                        26.40214074312543,
                        46.09434439917706
                    ],
                    [
                        26.3960945977047,
                        46.10338775995149
                    ],
                    [
                        26.39873009679153,
                        46.11036408829662
                    ],
                    [
                        26.41283776789273,
                        46.121267843785205
                    ],
                    [
                        26.414853147488582,
                        46.127985772608994
                    ],
                    [
                        26.410047230653557,
                        46.13625394589655
                    ],
                    [
                        26.400125365309226,
                        46.14452223821771
                    ],
                    [
                        26.363331745093614,
                        46.16082614827053
                    ],
                    [
                        26.355115182138398,
                        46.16586454064547
                    ],
                    [
                        26.34178267239262,
                        46.17759514521474
                    ],
                    [
                        26.333721146332614,
                        46.18046317863562
                    ],
                    [
                        26.325039506509274,
                        46.179352133784725
                    ],
                    [
                        26.293206817161614,
                        46.16007678280694
                    ],
                    [
                        26.251607296415273,
                        46.15028414420109
                    ],
                    [
                        26.25904869712688,
                        46.188059577357144
                    ],
                    [
                        26.263389521361514,
                        46.19873078865958
                    ],
                    [
                        26.27553348763009,
                        46.2164041545095
                    ],
                    [
                        26.279874298850885,
                        46.226506844382406
                    ],
                    [
                        26.28452517673358,
                        46.26720202770955
                    ],
                    [
                        26.28685062338731,
                        46.27619377432957
                    ],
                    [
                        26.300183132871894,
                        46.30203192278051
                    ],
                    [
                        26.29894290200275,
                        46.31112700232595
                    ],
                    [
                        26.29274173135025,
                        46.319705291186736
                    ],
                    [
                        26.275843536888285,
                        46.3266816051709
                    ],
                    [
                        26.26199425119279,
                        46.3282577277739
                    ],
                    [
                        26.24711145398257,
                        46.32655249806618
                    ],
                    [
                        26.207837346139428,
                        46.311488700738934
                    ],
                    [
                        26.182257526569003,
                        46.30572687041011
                    ],
                    [
                        26.167839805579238,
                        46.3062178158607
                    ],
                    [
                        26.159468226608535,
                        46.312548192561344
                    ],
                    [
                        26.16024334896418,
                        46.326242303879226
                    ],
                    [
                        26.168149866437574,
                        46.35003944554506
                    ],
                    [
                        26.167374699897426,
                        46.36166651846841
                    ],
                    [
                        26.161948691070858,
                        46.37308711178543
                    ],
                    [
                        26.146859156251484,
                        46.38471420323362
                    ],
                    [
                        26.132596478891614,
                        46.39065710572397
                    ],
                    [
                        26.079834820517807,
                        46.3953078585263
                    ],
                    [
                        26.03870039632138,
                        46.40329196522088
                    ],
                    [
                        26.024902780438655,
                        46.41267117973559
                    ],
                    [
                        26.01885663712938,
                        46.426830520589064
                    ],
                    [
                        26.02428266274679,
                        46.45489082407007
                    ],
                    [
                        26.032499231711054,
                        46.46827512299223
                    ],
                    [
                        26.04629682541736,
                        46.476698296403654
                    ],
                    [
                        26.060301133605865,
                        46.48016058689179
                    ],
                    [
                        26.069912964302738,
                        46.48718867030564
                    ],
                    [
                        26.06913779878299,
                        46.49860904306974
                    ],
                    [
                        26.05627038123064,
                        46.51710929189402
                    ],
                    [
                        26.0416459581452,
                        46.532043827969275
                    ],
                    [
                        26.02893354780878,
                        46.548528558041916
                    ],
                    [
                        26.01203534294113,
                        46.59359033806644
                    ],
                    [
                        26.008779740790683,
                        46.66795280390239
                    ],
                    [
                        26.045366662099138,
                        46.67513587508648
                    ],
                    [
                        26.05937095815084,
                        46.675419990107
                    ],
                    [
                        26.082160267517498,
                        46.67141508062733
                    ],
                    [
                        26.110737333546812,
                        46.65994290701266
                    ],
                    [
                        26.124069865676102,
                        46.65787592273941
                    ],
                    [
                        26.14344852972705,
                        46.66020137688173
                    ],
                    [
                        26.169235047205717,
                        46.667694327985856
                    ],
                    [
                        26.230833373226854,
                        46.698777811929546
                    ],
                    [
                        26.241995486109204,
                        46.70293778652224
                    ],
                    [
                        26.253777697843,
                        46.70443631124819
                    ],
                    [
                        26.26850548594939,
                        46.70056060790592
                    ],
                    [
                        26.275378441926183,
                        46.69523788368451
                    ],
                    [
                        26.28638552261205,
                        46.67952824996468
                    ],
                    [
                        26.293051800656922,
                        46.672448690139476
                    ],
                    [
                        26.298632856357624,
                        46.66542070024522
                    ],
                    [
                        26.301113318289108,
                        46.65834098156576
                    ],
                    [
                        26.300648224279026,
                        46.65110624423513
                    ],
                    [
                        26.29816775891498,
                        46.64428498166837
                    ],
                    [
                        26.29723758963084,
                        46.638910673250926
                    ],
                    [
                        26.299718040499258,
                        46.63495731155691
                    ],
                    [
                        26.3111902240441,
                        46.63309705774918
                    ],
                    [
                        26.390358506085104,
                        46.63327784922248
                    ],
                    [
                        26.407721789001148,
                        46.63508653673596
                    ],
                    [
                        26.417643658910873,
                        46.64071923795789
                    ],
                    [
                        26.426790387208264,
                        46.6486774080687
                    ],
                    [
                        26.434696886884353,
                        46.65746243534072
                    ],
                    [
                        26.443585230096655,
                        46.66327601729457
                    ],
                    [
                        26.454437287028906,
                        46.666144090676966
                    ],
                    [
                        26.492471142642316,
                        46.66583404408587
                    ],
                    [
                        26.52797284815689,
                        46.67157010649931
                    ],
                    [
                        26.5691072901774,
                        46.66606657900197
                    ],
                    [
                        26.581819687198195,
                        46.66699672029894
                    ],
                    [
                        26.590346315688006,
                        46.672448690139476
                    ],
                    [
                        26.609776647731334,
                        46.68942435416599
                    ],
                    [
                        26.62388429975861,
                        46.6959613393315
                    ],
                    [
                        26.685482611205796,
                        46.71378973388913
                    ],
                    [
                        26.693544138384578,
                        46.72102446155224
                    ],
                    [
                        26.702380822435263,
                        46.73497718268885
                    ],
                    [
                        26.71436975425223,
                        46.74009313931442
                    ],
                    [
                        26.733438342641644,
                        46.74125577013143
                    ],
                    [
                        26.75994836966905,
                        46.73471880780391
                    ],
                    [
                        26.790540805664918,
                        46.719525861439585
                    ],
                    [
                        26.80294314503938,
                        46.71492663546426
                    ],
                    [
                        26.818911176699938,
                        46.714797532617084
                    ],
                    [
                        26.83493085416656,
                        46.71962917589772
                    ],
                    [
                        26.84624799792929,
                        46.72634714144203
                    ],
                    [
                        26.851829064175558,
                        46.73404700334863
                    ],
                    [
                        26.85244917267205,
                        46.7420051188066
                    ],
                    [
                        26.850123728772836,
                        46.750402515809895
                    ],
                    [
                        26.850898874233923,
                        46.75838651354975
                    ],
                    [
                        26.855859810231138,
                        46.764691035103134
                    ],
                    [
                        26.88273155479498,
                        46.779987254196435
                    ],
                    [
                        26.88877770662549,
                        46.78706697765725
                    ],
                    [
                        26.891258167519585,
                        46.79533516579396
                    ],
                    [
                        26.890638065398523,
                        46.80298336448884
                    ],
                    [
                        26.88924278562313,
                        46.81037300052915
                    ],
                    [
                        26.894668812102697,
                        46.81378364635305
                    ],
                    [
                        26.905520868889155,
                        46.813370270066656
                    ],
                    [
                        26.92567467871572,
                        46.8027249360143
                    ],
                    [
                        26.931410756078026,
                        46.79476672884792
                    ],
                    [
                        26.932651001932545,
                        46.78714451782136
                    ],
                    [
                        26.930480577522474,
                        46.780814076440734
                    ],
                    [
                        26.931410749201504,
                        46.77388940862498
                    ],
                    [
                        26.93761193994465,
                        46.76401932289153
                    ],
                    [
                        26.95115116315802,
                        46.75342564355297
                    ],
                    [
                        26.971149931520767,
                        46.743658727509086
                    ],
                    [
                        27.04189497888228,
                        46.751151885341216
                    ],
                    [
                        27.065976198170198,
                        46.75141027314205
                    ],
                    [
                        27.146953166297106,
                        46.738646189364374
                    ],
                    [
                        27.157495140744643,
                        46.734537807336935
                    ],
                    [
                        27.18607221888237,
                        46.72918935755727
                    ],
                    [
                        27.225501346410336,
                        46.74283199888023
                    ]
                ]
            ]
        },
        "type": "Feature",
        "properties": {
            "source": "https://simplemaps.com",
            "id": "ROBC",
            "name": "Bacau"
        },
        "id": 38
    },
    {
        "geometry": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        22.755283230862542,
                        46.33381293160235
                    ],
                    [
                        22.70670739617802,
                        46.36874628130972
                    ],
                    [
                        22.68810388538675,
                        46.421973044588654
                    ],
                    [
                        22.686863643632794,
                        46.48300285173421
                    ],
                    [
                        22.691979611344657,
                        46.50646395733593
                    ],
                    [
                        22.702521594406992,
                        46.53214708419802
                    ],
                    [
                        22.71554406818011,
                        46.55038895417215
                    ],
                    [
                        22.72810143083039,
                        46.560672489788615
                    ],
                    [
                        22.739780302396515,
                        46.56542670449778
                    ],
                    [
                        22.753112833579415,
                        46.56697708656621
                    ],
                    [
                        22.765050089982303,
                        46.56697708656621
                    ],
                    [
                        22.778072552778703,
                        46.56558183444654
                    ],
                    [
                        22.787581008636536,
                        46.563359693023955
                    ],
                    [
                        22.802773887451266,
                        46.5569001918347
                    ],
                    [
                        22.833004586686403,
                        46.53819322905228
                    ],
                    [
                        22.97392621867208,
                        46.53576444764414
                    ],
                    [
                        22.996715522662505,
                        46.53101019344482
                    ],
                    [
                        23.01066815990745,
                        46.52501572827919
                    ],
                    [
                        23.01971154535512,
                        46.5112698727039
                    ],
                    [
                        23.025292586326074,
                        46.50496524867904
                    ],
                    [
                        23.034129266301004,
                        46.49894501444067
                    ],
                    [
                        23.046531603517426,
                        46.492588769045845
                    ],
                    [
                        23.05505821447101,
                        46.487162744640386
                    ],
                    [
                        23.05970909358854,
                        46.481710882309265
                    ],
                    [
                        23.061569457029293,
                        46.46987705909717
                    ],
                    [
                        23.063274772747313,
                        46.4632624297458
                    ],
                    [
                        23.070251086078866,
                        46.4562860772897
                    ],
                    [
                        23.07727907951532,
                        46.45530421478788
                    ],
                    [
                        23.085030555371276,
                        46.45835319785201
                    ],
                    [
                        23.09557254168584,
                        46.46930856495879
                    ],
                    [
                        23.103168977211656,
                        46.47468291300531
                    ],
                    [
                        23.144303425205365,
                        46.491891220105046
                    ],
                    [
                        23.153915241747345,
                        46.4943716904507
                    ],
                    [
                        23.17236371848394,
                        46.494578333216374
                    ],
                    [
                        23.21799400102375,
                        46.48447553723758
                    ],
                    [
                        23.234892199219036,
                        46.48284775991638
                    ],
                    [
                        23.247966335858756,
                        46.4841655057238
                    ],
                    [
                        23.25726809062111,
                        46.48801537791911
                    ],
                    [
                        23.267034949397548,
                        46.49468173135162
                    ],
                    [
                        23.303208453472976,
                        46.51393121278063
                    ],
                    [
                        23.403719107371497,
                        46.527082810178634
                    ],
                    [
                        23.420513954395503,
                        46.52429233700259
                    ],
                    [
                        23.4350867041964,
                        46.51904714478954
                    ],
                    [
                        23.490793887127325,
                        46.490547518176534
                    ],
                    [
                        23.54014489163552,
                        46.47674999272613
                    ],
                    [
                        23.56169395377933,
                        46.473752692910374
                    ],
                    [
                        23.580194130761956,
                        46.47318434564741
                    ],
                    [
                        23.61275028795494,
                        46.47530311229289
                    ],
                    [
                        23.623912378913055,
                        46.47251245457053
                    ],
                    [
                        23.630010217382996,
                        46.46698320993217
                    ],
                    [
                        23.63011355339166,
                        46.45907660099801
                    ],
                    [
                        23.62267215383447,
                        46.44910310028034
                    ],
                    [
                        23.61445560850661,
                        46.44083491981145
                    ],
                    [
                        23.609184603864726,
                        46.43285085048185
                    ],
                    [
                        23.610734894322125,
                        46.424246708941475
                    ],
                    [
                        23.618176312666634,
                        46.414299079714986
                    ],
                    [
                        23.63869184989149,
                        46.40460970822143
                    ],
                    [
                        23.654969926087198,
                        46.40088899916271
                    ],
                    [
                        23.669387638264137,
                        46.40037215203145
                    ],
                    [
                        23.675898881430268,
                        46.40367952713979
                    ],
                    [
                        23.677914269635515,
                        46.40915727977587
                    ],
                    [
                        23.67605390902544,
                        46.41592683412304
                    ],
                    [
                        23.673573441329218,
                        46.42238639514417
                    ],
                    [
                        23.67403852587676,
                        46.42884592574237
                    ],
                    [
                        23.680084674380673,
                        46.43329013582635
                    ],
                    [
                        23.691091750544476,
                        46.43556387605213
                    ],
                    [
                        23.73796227293284,
                        46.43579640458202
                    ],
                    [
                        23.74979616872548,
                        46.4376308700824
                    ],
                    [
                        23.769174829473826,
                        46.443677007382114
                    ],
                    [
                        23.778941687226045,
                        46.445537438030584
                    ],
                    [
                        23.823951849080892,
                        46.444762219004716
                    ],
                    [
                        23.83914472564238,
                        46.44595081732263
                    ],
                    [
                        23.87562829459121,
                        46.45220372002276
                    ],
                    [
                        23.895937120743945,
                        46.450446637324795
                    ],
                    [
                        23.958000520650597,
                        46.43664906168435
                    ],
                    [
                        23.97107465573422,
                        46.43659737149132
                    ],
                    [
                        23.987817821635854,
                        46.44223011509035
                    ],
                    [
                        23.99541426318385,
                        46.449671560445346
                    ],
                    [
                        24.026781863675268,
                        46.448276334502175
                    ],
                    [
                        24.04150962855218,
                        46.44098983896842
                    ],
                    [
                        24.053291857591134,
                        46.43241156570661
                    ],
                    [
                        24.057477664637428,
                        46.42724403044163
                    ],
                    [
                        24.059027937088175,
                        46.42024173240742
                    ],
                    [
                        24.05484216548875,
                        46.411534384413834
                    ],
                    [
                        24.047245715381916,
                        46.40336941622198
                    ],
                    [
                        24.034843367900702,
                        46.3953595424347
                    ],
                    [
                        24.02678185328325,
                        46.388357441211284
                    ],
                    [
                        24.02161421645649,
                        46.3765494183904
                    ],
                    [
                        24.02647180332024,
                        46.36900468078639
                    ],
                    [
                        24.05732262070789,
                        46.345414304620135
                    ],
                    [
                        24.067244501672594,
                        46.34071178945023
                    ],
                    [
                        24.122486598770422,
                        46.32461451733574
                    ],
                    [
                        24.143312215004762,
                        46.3128582210331
                    ],
                    [
                        24.153234082416503,
                        46.29776865361105
                    ],
                    [
                        24.161295602351018,
                        46.26622017219175
                    ],
                    [
                        24.16889204596942,
                        46.257280195475396
                    ],
                    [
                        24.1758683640638,
                        46.25180249498191
                    ],
                    [
                        24.191836375681028,
                        46.2441543407645
                    ],
                    [
                        24.19746911440075,
                        46.17806023632271
                    ],
                    [
                        24.19638390827994,
                        46.1678282988862
                    ],
                    [
                        24.191836380471923,
                        46.159585891446014
                    ],
                    [
                        24.180829303278312,
                        46.151756934330926
                    ],
                    [
                        24.16129560367735,
                        46.14343697777099
                    ],
                    [
                        24.146257769711365,
                        46.13165480496307
                    ],
                    [
                        24.12403689798476,
                        46.118063854907376
                    ],
                    [
                        24.040424433940604,
                        46.055793780316364
                    ],
                    [
                        24.02910729054716,
                        46.04308135316655
                    ],
                    [
                        24.02244103771041,
                        46.02861199298953
                    ],
                    [
                        24.017583443776267,
                        46.01039598697731
                    ],
                    [
                        24.013707713566042,
                        46.00463407548532
                    ],
                    [
                        24.005801217069383,
                        46.00199856686644
                    ],
                    [
                        23.997274609492656,
                        46.00321299099292
                    ],
                    [
                        23.98812787805674,
                        46.00801887307915
                    ],
                    [
                        23.970557891874478,
                        46.02062793110315
                    ],
                    [
                        23.961411171441995,
                        46.025769790293914
                    ],
                    [
                        23.9525744995267,
                        46.02845695202014
                    ],
                    [
                        23.940947298888485,
                        46.02881866332037
                    ],
                    [
                        23.87206262172609,
                        46.01827671554494
                    ],
                    [
                        23.85997033543525,
                        46.01192050713679
                    ],
                    [
                        23.85283897756264,
                        46.00277371442498
                    ],
                    [
                        23.851857128989185,
                        45.98657317654639
                    ],
                    [
                        23.85655969091431,
                        45.97641880543084
                    ],
                    [
                        23.863846067787897,
                        45.96714288151173
                    ],
                    [
                        23.8671016728553,
                        45.958073598892874
                    ],
                    [
                        23.864466183764787,
                        45.946136407716594
                    ],
                    [
                        23.84953168581088,
                        45.93334642932734
                    ],
                    [
                        23.835734084976234,
                        45.92515575384872
                    ],
                    [
                        23.82085126994841,
                        45.91885121509035
                    ],
                    [
                        23.808914010495684,
                        45.91699084298215
                    ],
                    [
                        23.799302200668095,
                        45.91714591191001
                    ],
                    [
                        23.791654089440982,
                        45.91807609715733
                    ],
                    [
                        23.78483279595038,
                        45.917791841723265
                    ],
                    [
                        23.768864781668338,
                        45.91471711904819
                    ],
                    [
                        23.758942901044318,
                        45.91580228974444
                    ],
                    [
                        23.750416296444143,
                        45.918954594906126
                    ],
                    [
                        23.74173465865842,
                        45.92360549231202
                    ],
                    [
                        23.732226188106242,
                        45.927274470813124
                    ],
                    [
                        23.72292443249214,
                        45.928669750858596
                    ],
                    [
                        23.71300256039719,
                        45.928204682430874
                    ],
                    [
                        23.70540611907369,
                        45.92575000723923
                    ],
                    [
                        23.700600209780607,
                        45.920246462237024
                    ],
                    [
                        23.705096058567097,
                        45.88727689445397
                    ],
                    [
                        23.71145226588335,
                        45.880972410126944
                    ],
                    [
                        23.721219111329635,
                        45.877639277334154
                    ],
                    [
                        23.74669559109103,
                        45.87291087753998
                    ],
                    [
                        23.758632845613775,
                        45.868570044800066
                    ],
                    [
                        23.765144077552932,
                        45.86324738394123
                    ],
                    [
                        23.76343875275394,
                        45.85492746262863
                    ],
                    [
                        23.72912560248305,
                        45.81792713838763
                    ],
                    [
                        23.715793087191216,
                        45.80009880476397
                    ],
                    [
                        23.709281849663213,
                        45.793897581571414
                    ],
                    [
                        23.702615591393137,
                        45.79043527113131
                    ],
                    [
                        23.69284874737405,
                        45.789892682952086
                    ],
                    [
                        23.677449170890377,
                        45.79193389961697
                    ],
                    [
                        23.67016279517051,
                        45.79188222794878
                    ],
                    [
                        23.663651559444517,
                        45.789815137614184
                    ],
                    [
                        23.655900096666972,
                        45.785939422861006
                    ],
                    [
                        23.647683546749956,
                        45.77898896080523
                    ],
                    [
                        23.64163740563729,
                        45.772503575199636
                    ],
                    [
                        23.634971149195895,
                        45.76203912727912
                    ],
                    [
                        23.612440219810583,
                        45.71126699397153
                    ],
                    [
                        23.609494668720583,
                        45.693283634563635
                    ],
                    [
                        23.616160924970956,
                        45.66775545280779
                    ],
                    [
                        23.62391238794623,
                        45.653079329553705
                    ],
                    [
                        23.630320267112275,
                        45.636646243809786
                    ],
                    [
                        23.63197390940744,
                        45.61793934622227
                    ],
                    [
                        23.62406741455969,
                        45.58807036283656
                    ],
                    [
                        23.616470980756468,
                        45.57086211783347
                    ],
                    [
                        23.61352542352276,
                        45.55479074973571
                    ],
                    [
                        23.623602331344564,
                        45.53293164321775
                    ],
                    [
                        23.647993607626475,
                        45.50347608030528
                    ],
                    [
                        23.65264448525225,
                        45.490091874121596
                    ],
                    [
                        23.653419629920364,
                        45.48063506831275
                    ],
                    [
                        23.626082795657084,
                        45.451928804352974
                    ],
                    [
                        23.584224887527736,
                        45.44730377434553
                    ],
                    [
                        23.58562015282039,
                        45.48053173578865
                    ],
                    [
                        23.58375980250132,
                        45.48807649997308
                    ],
                    [
                        23.580349155762793,
                        45.497946689825504
                    ],
                    [
                        23.57378624948719,
                        45.50409619038172
                    ],
                    [
                        23.523866817912104,
                        45.537427494448224
                    ],
                    [
                        23.502421094422125,
                        45.55520416225985
                    ],
                    [
                        23.48536787376565,
                        45.56388581677342
                    ],
                    [
                        23.446558870574442,
                        45.57664987957906
                    ],
                    [
                        23.422994419864917,
                        45.58993073670448
                    ],
                    [
                        23.41090213301503,
                        45.60259145049114
                    ],
                    [
                        23.400308464404215,
                        45.61995473597779
                    ],
                    [
                        23.396432731228302,
                        45.63008330739713
                    ],
                    [
                        23.395502555532495,
                        45.6386357577887
                    ],
                    [
                        23.398448109289067,
                        45.646309687185855
                    ],
                    [
                        23.40216881493101,
                        45.653751112475895
                    ],
                    [
                        23.404390903665004,
                        45.6605982566644
                    ],
                    [
                        23.40108360822488,
                        45.66989998343615
                    ],
                    [
                        23.379999630617498,
                        45.68734083055633
                    ],
                    [
                        23.37472863564451,
                        45.69498895411723
                    ],
                    [
                        23.372868277768145,
                        45.703308805058846
                    ],
                    [
                        23.375503782062513,
                        45.72204156078335
                    ],
                    [
                        23.371783080139192,
                        45.73695021931546
                    ],
                    [
                        23.363566517347262,
                        45.7583958656197
                    ],
                    [
                        23.341190631070194,
                        45.800047131930675
                    ],
                    [
                        23.316075882025537,
                        45.87683829179844
                    ],
                    [
                        23.307084182302173,
                        45.88836213513629
                    ],
                    [
                        23.281142611450665,
                        45.9108930500153
                    ],
                    [
                        23.264399447768398,
                        45.929315701507576
                    ],
                    [
                        23.2255904435933,
                        45.99967313436508
                    ],
                    [
                        23.214428339270846,
                        46.005926024168936
                    ],
                    [
                        23.19473962085573,
                        46.00835482692023
                    ],
                    [
                        23.170968457735057,
                        46.01597706643548
                    ],
                    [
                        23.074488561153444,
                        46.10457633021352
                    ],
                    [
                        23.067667267472086,
                        46.113361286589665
                    ],
                    [
                        23.064825061778794,
                        46.12007921688249
                    ],
                    [
                        23.066375354845377,
                        46.12447170875374
                    ],
                    [
                        23.0705611540348,
                        46.12739148555161
                    ],
                    [
                        23.076813997053478,
                        46.12829578918239
                    ],
                    [
                        23.084255406950312,
                        46.12715893538565
                    ],
                    [
                        23.091541777441666,
                        46.12506599085014
                    ],
                    [
                        23.095727574181748,
                        46.128864255778275
                    ],
                    [
                        23.094952423816125,
                        46.13891528711216
                    ],
                    [
                        23.078519323054362,
                        46.16844840310181
                    ],
                    [
                        23.06653038576511,
                        46.184261357249774
                    ],
                    [
                        23.05366295975629,
                        46.196560393002216
                    ],
                    [
                        23.042655872614404,
                        46.2020897172767
                    ],
                    [
                        23.03087365545465,
                        46.205655453153064
                    ],
                    [
                        22.985553424118944,
                        46.210642226061026
                    ],
                    [
                        22.973461135341136,
                        46.213665272188166
                    ],
                    [
                        22.96679487550249,
                        46.219375516821586
                    ],
                    [
                        22.949689979513614,
                        46.26371391989847
                    ],
                    [
                        22.934342064297628,
                        46.29203250425085
                    ],
                    [
                        22.92364505398145,
                        46.306682850096955
                    ],
                    [
                        22.91418827402113,
                        46.31520950938731
                    ],
                    [
                        22.904266395497316,
                        46.31727654052023
                    ],
                    [
                        22.813005816395663,
                        46.31066196206936
                    ],
                    [
                        22.803704057938983,
                        46.312212252036005
                    ],
                    [
                        22.755283230862542,
                        46.33381293160235
                    ]
                ]
            ]
        },
        "type": "Feature",
        "properties": {
            "source": "https://simplemaps.com",
            "id": "ROAB",
            "name": "Alba"
        },
        "id": 39
    },
    {
        "geometry": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        28.054804741122442,
                        44.777008887673226
                    ],
                    [
                        28.03470257839921,
                        44.763236934805846
                    ],
                    [
                        28.014083670781268,
                        44.75791419847667
                    ],
                    [
                        27.99506678763677,
                        44.761092562910555
                    ],
                    [
                        27.965094449359196,
                        44.77522602274425
                    ],
                    [
                        27.94576742869576,
                        44.778403913229205
                    ],
                    [
                        27.926647167464594,
                        44.77783558021037
                    ],
                    [
                        27.91088588117275,
                        44.775303591557424
                    ],
                    [
                        27.880293430264953,
                        44.795664090588865
                    ],
                    [
                        27.872386909304744,
                        44.803363718303395
                    ],
                    [
                        27.854868606947907,
                        44.81152864305522
                    ],
                    [
                        27.83342286942062,
                        44.814215707471774
                    ],
                    [
                        27.787224176909785,
                        44.810650265822275
                    ],
                    [
                        27.765003278899368,
                        44.80517236277086
                    ],
                    [
                        27.74732993467393,
                        44.79835104872212
                    ],
                    [
                        27.724850691736524,
                        44.79282170060443
                    ],
                    [
                        27.685886691803653,
                        44.78698244962436
                    ],
                    [
                        27.41262170860591,
                        44.792718474614354
                    ],
                    [
                        27.384819781179644,
                        44.80052157918756
                    ],
                    [
                        27.37257245173924,
                        44.80517236277086
                    ],
                    [
                        27.359084919196793,
                        44.8068777857614
                    ],
                    [
                        27.341876677482954,
                        44.80274373567015
                    ],
                    [
                        27.318880657567966,
                        44.79447545788132
                    ],
                    [
                        27.29903689100854,
                        44.79406194157249
                    ],
                    [
                        27.283223932788637,
                        44.79540571843163
                    ],
                    [
                        27.200644987626866,
                        44.819409385538926
                    ],
                    [
                        27.19692427892401,
                        44.826463183145265
                    ],
                    [
                        27.203435495138997,
                        44.87297188142393
                    ],
                    [
                        27.197234328176343,
                        44.88501251917231
                    ],
                    [
                        27.18669235096983,
                        44.8939009588948
                    ],
                    [
                        27.177080510888786,
                        44.900050309918186
                    ],
                    [
                        27.174755094360968,
                        44.90924885316266
                    ],
                    [
                        27.17816573787109,
                        44.918498932662736
                    ],
                    [
                        27.190878147990997,
                        44.92759403043089
                    ],
                    [
                        27.20188520937943,
                        44.931521321959515
                    ],
                    [
                        27.23805871682849,
                        44.938135940116595
                    ],
                    [
                        27.24643028729499,
                        44.94754097962663
                    ],
                    [
                        27.253871708835884,
                        44.96459429232402
                    ],
                    [
                        27.26456871906207,
                        45.00177541824546
                    ],
                    [
                        27.26859948124042,
                        45.0230402694314
                    ],
                    [
                        27.27014977395283,
                        45.03916331507719
                    ],
                    [
                        27.26813439299895,
                        45.04846507162443
                    ],
                    [
                        27.263018426252493,
                        45.0547179228393
                    ],
                    [
                        27.25433678616664,
                        45.05714671689693
                    ],
                    [
                        27.230152214638498,
                        45.0567849794414
                    ],
                    [
                        27.217388137317652,
                        45.05794770236352
                    ],
                    [
                        27.20963667180504,
                        45.06164256514136
                    ],
                    [
                        27.205915969743067,
                        45.068670560619275
                    ],
                    [
                        27.205450880668497,
                        45.077197172116826
                    ],
                    [
                        27.20653608680296,
                        45.09709260081847
                    ],
                    [
                        27.205140821480335,
                        45.10680776180687
                    ],
                    [
                        27.199249709581498,
                        45.1145592362725
                    ],
                    [
                        27.191033156912447,
                        45.119365142708254
                    ],
                    [
                        27.178940870629397,
                        45.121948957126506
                    ],
                    [
                        27.169329053237536,
                        45.12564382228072
                    ],
                    [
                        27.164161410266633,
                        45.13228424270813
                    ],
                    [
                        27.163231235587876,
                        45.14308462647295
                    ],
                    [
                        27.164058058320922,
                        45.16323843156276
                    ],
                    [
                        27.162921177665794,
                        45.17145498957562
                    ],
                    [
                        27.15889041649501,
                        45.17868969246664
                    ],
                    [
                        27.15237918437424,
                        45.18427073425056
                    ],
                    [
                        27.143542516340055,
                        45.18778474425206
                    ],
                    [
                        27.134240756266202,
                        45.18809479031601
                    ],
                    [
                        27.125559115283245,
                        45.18582102941209
                    ],
                    [
                        27.119357943456517,
                        45.181376856359385
                    ],
                    [
                        27.119047885380176,
                        45.17432301922454
                    ],
                    [
                        27.118117709348862,
                        45.167992655994624
                    ],
                    [
                        27.115172154322316,
                        45.16189485279563
                    ],
                    [
                        27.106490513745907,
                        45.1552802635687
                    ],
                    [
                        27.094656610084304,
                        45.15378164559616
                    ],
                    [
                        27.084889764070635,
                        45.1552802635687
                    ],
                    [
                        27.07868859107556,
                        45.15951772287192
                    ],
                    [
                        27.06380577931263,
                        45.18690623398563
                    ],
                    [
                        27.062875603486333,
                        45.19424428918129
                    ],
                    [
                        27.06411583834731,
                        45.20140147848443
                    ],
                    [
                        27.072487418662117,
                        45.209643858484576
                    ],
                    [
                        27.08721520447015,
                        45.21817047820471
                    ],
                    [
                        27.167158644338766,
                        45.237962556321264
                    ],
                    [
                        27.214132521125272,
                        45.23294993896093
                    ],
                    [
                        27.226586541115964,
                        45.23297577436796
                    ],
                    [
                        27.265963982454384,
                        45.241631574092544
                    ],
                    [
                        27.27929650048818,
                        45.24188995317597
                    ],
                    [
                        27.289735141098998,
                        45.23951283775486
                    ],
                    [
                        27.297486605689908,
                        45.235740459571176
                    ],
                    [
                        27.304772983042287,
                        45.23444854830624
                    ],
                    [
                        27.31050906751946,
                        45.2384276381849
                    ],
                    [
                        27.314539829502376,
                        45.25305207234402
                    ],
                    [
                        27.309423862568664,
                        45.275944731987884
                    ],
                    [
                        27.309733921007645,
                        45.286124984192185
                    ],
                    [
                        27.316400181661592,
                        45.29431570468262
                    ],
                    [
                        27.335313754003252,
                        45.30005178076796
                    ],
                    [
                        27.350713332723014,
                        45.3004910406161
                    ],
                    [
                        27.365751173815198,
                        45.29834646426066
                    ],
                    [
                        27.37799848790216,
                        45.30036184086944
                    ],
                    [
                        27.387196891689804,
                        45.308449198502366
                    ],
                    [
                        27.394638297741068,
                        45.33103179984143
                    ],
                    [
                        27.40161461739295,
                        45.34470021914829
                    ],
                    [
                        27.420063101280526,
                        45.367256966472304
                    ],
                    [
                        27.423473745859866,
                        45.38653228008834
                    ],
                    [
                        27.43277550500648,
                        45.40673777230299
                    ],
                    [
                        27.457786902282336,
                        45.43404879034603
                    ],
                    [
                        27.483211703590978,
                        45.45727732627175
                    ],
                    [
                        27.500781691438682,
                        45.46869782616043
                    ],
                    [
                        27.52093550079479,
                        45.47768952890144
                    ],
                    [
                        27.580053338214856,
                        45.49334748084529
                    ],
                    [
                        27.6373108244353,
                        45.47551911002252
                    ],
                    [
                        27.67234744526584,
                        45.47681101904488
                    ],
                    [
                        27.69069257974852,
                        45.47916229571328
                    ],
                    [
                        27.702629834664997,
                        45.47701772031248
                    ],
                    [
                        27.711311479008447,
                        45.47154004137492
                    ],
                    [
                        27.731361933362678,
                        45.4543317789977
                    ],
                    [
                        27.765158316127202,
                        45.43314441881136
                    ],
                    [
                        27.820245396222585,
                        45.412370511072815
                    ],
                    [
                        27.85548872134782,
                        45.40740957014056
                    ],
                    [
                        27.921272820440528,
                        45.40947662731538
                    ],
                    [
                        27.94483727296381,
                        45.40663442183675
                    ],
                    [
                        27.969693639924838,
                        45.401156734636444
                    ],
                    [
                        28.030206737056787,
                        45.39542062443479
                    ],
                    [
                        28.026020949105636,
                        45.38632559022646
                    ],
                    [
                        28.024005571421352,
                        45.37769564361235
                    ],
                    [
                        28.02168012781982,
                        45.34813669705518
                    ],
                    [
                        28.020904980725394,
                        45.34446767090336
                    ],
                    [
                        28.019199661468917,
                        45.341108716020514
                    ],
                    [
                        28.010828078799296,
                        45.330308338606265
                    ],
                    [
                        28.00938113643671,
                        45.32806039944651
                    ],
                    [
                        28.004316847972856,
                        45.3128417060098
                    ],
                    [
                        27.9997693210005,
                        45.30674388274917
                    ],
                    [
                        27.986746860465242,
                        45.29232616110991
                    ],
                    [
                        28.041317173816566,
                        45.25842642270356
                    ],
                    [
                        28.075526971073675,
                        45.24822032358817
                    ],
                    [
                        28.110253532581993,
                        45.25821970671018
                    ],
                    [
                        28.116971470803044,
                        45.2540856013015
                    ],
                    [
                        28.122397493449263,
                        45.24977060813573
                    ],
                    [
                        28.126893346007236,
                        45.244525464134156
                    ],
                    [
                        28.130769075420186,
                        45.237704160764885
                    ],
                    [
                        28.117901646723386,
                        45.22447500615633
                    ],
                    [
                        28.10296715737605,
                        45.203546049104084
                    ],
                    [
                        28.097696161758797,
                        45.18416738655552
                    ],
                    [
                        28.113664177909335,
                        45.17564077123743
                    ],
                    [
                        28.132060988776,
                        45.17153250257886
                    ],
                    [
                        28.1525765333731,
                        45.16124889577177
                    ],
                    [
                        28.16962975388777,
                        45.14789053127488
                    ],
                    [
                        28.177949659090686,
                        45.134661359045126
                    ],
                    [
                        28.17428063343817,
                        45.1216389065163
                    ],
                    [
                        28.162705111162207,
                        45.10830638062668
                    ],
                    [
                        28.147770623036976,
                        45.09791941790156
                    ],
                    [
                        28.13417972301203,
                        45.09370779511432
                    ],
                    [
                        28.131440871510797,
                        45.08903107538006
                    ],
                    [
                        28.137590366580294,
                        45.05647492312318
                    ],
                    [
                        28.138675571290168,
                        45.053839425642145
                    ],
                    [
                        28.141001010719133,
                        45.051824040844565
                    ],
                    [
                        28.14332644991138,
                        45.04872345615955
                    ],
                    [
                        28.14441165472465,
                        45.04283234333808
                    ],
                    [
                        28.142396274854192,
                        45.03645030405513
                    ],
                    [
                        28.133094516943427,
                        45.02562409173961
                    ],
                    [
                        28.130769076852538,
                        45.01859609605846
                    ],
                    [
                        28.1410010176733,
                        44.98237095769579
                    ],
                    [
                        28.141362738974944,
                        44.95978827346804
                    ],
                    [
                        28.127358431824174,
                        44.949711404989806
                    ],
                    [
                        28.124102835969605,
                        44.94485393369287
                    ],
                    [
                        28.125188041742863,
                        44.900515562742086
                    ],
                    [
                        28.12663498229601,
                        44.895761333768284
                    ],
                    [
                        28.125033001693765,
                        44.891601315387
                    ],
                    [
                        28.11707480732977,
                        44.881446751680556
                    ],
                    [
                        28.09020307313595,
                        44.85607369083772
                    ],
                    [
                        28.080074519776915,
                        44.84077762782023
                    ],
                    [
                        28.076147106792774,
                        44.816903095323006
                    ],
                    [
                        28.070100964454515,
                        44.79592246291242
                    ],
                    [
                        28.054804741122442,
                        44.777008887673226
                    ]
                ]
            ]
        },
        "type": "Feature",
        "properties": {
            "source": "https://simplemaps.com",
            "id": "ROBR",
            "name": "Braila"
        },
        "id": 40
    },
    {
        "geometry": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        28.02276531643026,
                        44.35470886599204
                    ],
                    [
                        27.871456764201053,
                        44.390004122887724
                    ],
                    [
                        27.780247841013413,
                        44.41775424421624
                    ],
                    [
                        27.739268439080238,
                        44.43770139802556
                    ],
                    [
                        27.717822709666002,
                        44.45483207326362
                    ],
                    [
                        27.702474817664932,
                        44.46457313628907
                    ],
                    [
                        27.68960739389712,
                        44.46883648789959
                    ],
                    [
                        27.634210244215502,
                        44.4775180426227
                    ],
                    [
                        27.605168085702697,
                        44.48780163038262
                    ],
                    [
                        27.46584839895175,
                        44.50645666413783
                    ],
                    [
                        27.43541098666643,
                        44.50769694514109
                    ],
                    [
                        27.410296275276615,
                        44.50498414050869
                    ],
                    [
                        27.38140912022766,
                        44.49684491881761
                    ],
                    [
                        27.363735792003858,
                        44.4935377004422
                    ],
                    [
                        27.18560713296491,
                        44.4959406725539
                    ],
                    [
                        27.127574497715813,
                        44.488421742197765
                    ],
                    [
                        27.09729210893313,
                        44.48803417220347
                    ],
                    [
                        27.07341759459429,
                        44.49214243277435
                    ],
                    [
                        27.000037076692895,
                        44.514027502867116
                    ],
                    [
                        26.976731007605604,
                        44.517696542744
                    ],
                    [
                        26.956887236171806,
                        44.51872993488925
                    ],
                    [
                        26.899474748733514,
                        44.511133678435044
                    ],
                    [
                        26.880974577693525,
                        44.51418254065278
                    ],
                    [
                        26.85120894583021,
                        44.526584838148295
                    ],
                    [
                        26.839426734166246,
                        44.52880701846778
                    ],
                    [
                        26.82433717782083,
                        44.52844504733042
                    ],
                    [
                        26.808834251991282,
                        44.52632633230789
                    ],
                    [
                        26.783719521136337,
                        44.526274753240024
                    ],
                    [
                        26.76506430699128,
                        44.53040872933506
                    ],
                    [
                        26.748166131958428,
                        44.537462680044364
                    ],
                    [
                        26.71592006160194,
                        44.560923924178404
                    ],
                    [
                        26.707031681437954,
                        44.56324915348998
                    ],
                    [
                        26.698040001213332,
                        44.5615697859662
                    ],
                    [
                        26.69059860748071,
                        44.55712569150772
                    ],
                    [
                        26.675560736812297,
                        44.54301784345839
                    ],
                    [
                        26.66703415092474,
                        44.53748862288796
                    ],
                    [
                        26.65742231376008,
                        44.53345773515431
                    ],
                    [
                        26.633496132000523,
                        44.5274116306519
                    ],
                    [
                        26.616597918174477,
                        44.5258612053275
                    ],
                    [
                        26.60233523955026,
                        44.527179066478666
                    ],
                    [
                        26.58988121752613,
                        44.53043467173114
                    ],
                    [
                        26.557945169870464,
                        44.54735862092586
                    ],
                    [
                        26.543940886235777,
                        44.55293986271674
                    ],
                    [
                        26.52967816228966,
                        44.555058410484264
                    ],
                    [
                        26.51355514968865,
                        44.55317244154843
                    ],
                    [
                        26.434076758070177,
                        44.52327737964208
                    ],
                    [
                        26.410512320542747,
                        44.536325774691434
                    ],
                    [
                        26.378989683335742,
                        44.548030404768966
                    ],
                    [
                        26.370308066126086,
                        44.55658300251866
                    ],
                    [
                        26.367517529426955,
                        44.56467030305326
                    ],
                    [
                        26.369377885167868,
                        44.57340364441879
                    ],
                    [
                        26.37247845930919,
                        44.581775154421344
                    ],
                    [
                        26.37774948268971,
                        44.590017715962375
                    ],
                    [
                        26.38384726888443,
                        44.5973297216491
                    ],
                    [
                        26.392218863360057,
                        44.603737678990726
                    ],
                    [
                        26.431751324057817,
                        44.62332299073344
                    ],
                    [
                        26.438107545888208,
                        44.62864578695233
                    ],
                    [
                        26.44250004307634,
                        44.63719824643338
                    ],
                    [
                        26.43970951455476,
                        44.6438644968775
                    ],
                    [
                        26.430976201765702,
                        44.65086668115446
                    ],
                    [
                        26.369687929875454,
                        44.67520613518052
                    ],
                    [
                        26.359611029994277,
                        44.684507916486496
                    ],
                    [
                        26.35728557910757,
                        44.69298278081676
                    ],
                    [
                        26.357130583521624,
                        44.70127706565344
                    ],
                    [
                        26.354184988654207,
                        44.70895076657667
                    ],
                    [
                        26.346898652535227,
                        44.719286310702294
                    ],
                    [
                        26.34457319206757,
                        44.72745105557755
                    ],
                    [
                        26.343798063770375,
                        44.743755085299064
                    ],
                    [
                        26.33821697564664,
                        44.74845743014294
                    ],
                    [
                        26.32845012824485,
                        44.75132546299529
                    ],
                    [
                        26.288245893484845,
                        44.75556311664951
                    ],
                    [
                        26.26964236560544,
                        44.75980050954383
                    ],
                    [
                        26.3054541136699,
                        44.78351986276057
                    ],
                    [
                        26.339612262224886,
                        44.79499220116441
                    ],
                    [
                        26.35387497026671,
                        44.79592246291242
                    ],
                    [
                        26.364882047400986,
                        44.7934419733109
                    ],
                    [
                        26.38834312238374,
                        44.78419173298779
                    ],
                    [
                        26.410822391660545,
                        44.783106663128926
                    ],
                    [
                        26.42198448466119,
                        44.78662055323414
                    ],
                    [
                        26.431286226199788,
                        44.79313168413655
                    ],
                    [
                        26.439244442926185,
                        44.80041835121692
                    ],
                    [
                        26.452731951956117,
                        44.80827291511963
                    ],
                    [
                        26.466064507577876,
                        44.810650265822275
                    ],
                    [
                        26.520221382645026,
                        44.80718778015343
                    ],
                    [
                        26.534794153952692,
                        44.81018511760104
                    ],
                    [
                        26.5479716476972,
                        44.81509439793685
                    ],
                    [
                        26.558720323360173,
                        44.82098536937932
                    ],
                    [
                        26.565541627838297,
                        44.82620479113847
                    ],
                    [
                        26.578098975460744,
                        44.84237935275136
                    ],
                    [
                        26.603885519827564,
                        44.8650653416157
                    ],
                    [
                        26.62636480285642,
                        44.85705571575517
                    ],
                    [
                        26.660212842405322,
                        44.83597157519396
                    ],
                    [
                        26.677886198289105,
                        44.83248351976088
                    ],
                    [
                        26.701915708694095,
                        44.8311655802828
                    ],
                    [
                        26.767699841671504,
                        44.83504152591778
                    ],
                    [
                        26.8276444703901,
                        44.82739321249281
                    ],
                    [
                        26.838186453991625,
                        44.8242408951646
                    ],
                    [
                        26.850123737686783,
                        44.821967308182
                    ],
                    [
                        26.864851491330555,
                        44.82186376926472
                    ],
                    [
                        26.89993983410941,
                        44.82666995795634
                    ],
                    [
                        26.919163463749285,
                        44.8261531738427
                    ],
                    [
                        26.94277959294126,
                        44.820184548908976
                    ],
                    [
                        26.972235118417476,
                        44.806774250741974
                    ],
                    [
                        26.98603272554401,
                        44.802691815985746
                    ],
                    [
                        27.000347127772066,
                        44.80253697320208
                    ],
                    [
                        27.01445480968418,
                        44.80858321600453
                    ],
                    [
                        27.02437667909241,
                        44.81638632380832
                    ],
                    [
                        27.036623962488367,
                        44.822070541701386
                    ],
                    [
                        27.052436987647116,
                        44.823466029371254
                    ],
                    [
                        27.075588028947568,
                        44.818453413865605
                    ],
                    [
                        27.09155602650115,
                        44.81282055743376
                    ],
                    [
                        27.10504358884225,
                        44.80656779160904
                    ],
                    [
                        27.114552033738203,
                        44.79979806772779
                    ],
                    [
                        27.119978052104326,
                        44.79282170060443
                    ],
                    [
                        27.121528335855206,
                        44.78594867894402
                    ],
                    [
                        27.12090821585485,
                        44.77925656696065
                    ],
                    [
                        27.11904786194358,
                        44.77313289199694
                    ],
                    [
                        27.118892871576612,
                        44.76770711052328
                    ],
                    [
                        27.120443163091696,
                        44.763004540774205
                    ],
                    [
                        27.12431889113814,
                        44.76021399059996
                    ],
                    [
                        27.131450232961118,
                        44.75954216044378
                    ],
                    [
                        27.138116509086117,
                        44.760627472081005
                    ],
                    [
                        27.16653854106805,
                        44.76889566403406
                    ],
                    [
                        27.18948284213762,
                        44.772874534332395
                    ],
                    [
                        27.198939665142394,
                        44.77654377843404
                    ],
                    [
                        27.203280459242993,
                        44.78078108702459
                    ],
                    [
                        27.19924971558641,
                        44.786310574728795
                    ],
                    [
                        27.19196333607267,
                        44.79101311180318
                    ],
                    [
                        27.18111126757667,
                        44.79620648941749
                    ],
                    [
                        27.174445002977723,
                        44.80114155838659
                    ],
                    [
                        27.1749101236717,
                        44.8070845504672
                    ],
                    [
                        27.178630793850765,
                        44.811373491442986
                    ],
                    [
                        27.200644987626866,
                        44.819409385538926
                    ],
                    [
                        27.283223932788637,
                        44.79540571843163
                    ],
                    [
                        27.29903689100854,
                        44.79406194157249
                    ],
                    [
                        27.318880657567966,
                        44.79447545788132
                    ],
                    [
                        27.341876677482954,
                        44.80274373567015
                    ],
                    [
                        27.359084919196793,
                        44.8068777857614
                    ],
                    [
                        27.37257245173924,
                        44.80517236277086
                    ],
                    [
                        27.384819781179644,
                        44.80052157918756
                    ],
                    [
                        27.41262170860591,
                        44.792718474614354
                    ],
                    [
                        27.685886691803653,
                        44.78698244962436
                    ],
                    [
                        27.724850691736524,
                        44.79282170060443
                    ],
                    [
                        27.74732993467393,
                        44.79835104872212
                    ],
                    [
                        27.765003278899368,
                        44.80517236277086
                    ],
                    [
                        27.787224176909785,
                        44.810650265822275
                    ],
                    [
                        27.83342286942062,
                        44.814215707471774
                    ],
                    [
                        27.854868606947907,
                        44.81152864305522
                    ],
                    [
                        27.872386909304744,
                        44.803363718303395
                    ],
                    [
                        27.880293430264953,
                        44.795664090588865
                    ],
                    [
                        27.91088588117275,
                        44.775303591557424
                    ],
                    [
                        27.894762834218536,
                        44.76897323162579
                    ],
                    [
                        27.883704031877407,
                        44.75791419847667
                    ],
                    [
                        27.876882746837758,
                        44.74424580733658
                    ],
                    [
                        27.88447917661252,
                        44.72600399143348
                    ],
                    [
                        27.89853521127047,
                        44.70812421538796
                    ],
                    [
                        27.916363561193712,
                        44.69445567948853
                    ],
                    [
                        27.935225452502813,
                        44.689003782874515
                    ],
                    [
                        27.960288551797497,
                        44.686420142038614
                    ],
                    [
                        27.97796184308432,
                        44.67928849964407
                    ],
                    [
                        28.030775199702738,
                        44.637069111045506
                    ],
                    [
                        28.03454754633972,
                        44.63097109783322
                    ],
                    [
                        28.033617376890806,
                        44.62182440233757
                    ],
                    [
                        28.028036317198087,
                        44.598208245655755
                    ],
                    [
                        28.021370092042737,
                        44.58797651948186
                    ],
                    [
                        28.021525103306146,
                        44.55247470545077
                    ],
                    [
                        28.015220573696585,
                        44.543327941064476
                    ],
                    [
                        28.003903416516657,
                        44.539917185550685
                    ],
                    [
                        28.007210751667614,
                        44.531985114390416
                    ],
                    [
                        28.02033652678708,
                        44.5222955545753
                    ],
                    [
                        28.042609061024237,
                        44.513510507210746
                    ],
                    [
                        28.067000339489635,
                        44.507154321740174
                    ],
                    [
                        28.0860689791465,
                        44.50467407195884
                    ],
                    [
                        28.093355360443024,
                        44.496819283728975
                    ],
                    [
                        28.102192009478863,
                        44.478525699548825
                    ],
                    [
                        28.10901327624721,
                        44.45780331409292
                    ],
                    [
                        28.110253511776094,
                        44.44261045058992
                    ],
                    [
                        28.098781380285963,
                        44.430389190795395
                    ],
                    [
                        28.05728520682015,
                        44.40586873442115
                    ],
                    [
                        28.04819014285752,
                        44.39822055906973
                    ],
                    [
                        28.02276531643026,
                        44.35470886599204
                    ]
                ]
            ]
        },
        "type": "Feature",
        "properties": {
            "source": "https://simplemaps.com",
            "id": "ROIL",
            "name": "Ialomita"
        },
        "id": 41
    },
    {
        "geometry": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        26.19570523465072,
                        43.402671171499456
                    ],
                    [
                        26.210662587483178,
                        43.43408158901151
                    ],
                    [
                        26.167286223454976,
                        43.461004661687305
                    ],
                    [
                        26.191218003668077,
                        43.51185972674804
                    ],
                    [
                        26.113439736777025,
                        43.52532130465967
                    ],
                    [
                        26.104465326465643,
                        43.59262943674203
                    ],
                    [
                        26.037157240492732,
                        43.57468075712466
                    ],
                    [
                        25.98929367927777,
                        43.51485121807422
                    ],
                    [
                        26.04164445542864,
                        43.49839828610652
                    ],
                    [
                        26.041644456193264,
                        43.46698783998979
                    ],
                    [
                        25.975832065737407,
                        43.4625005243855
                    ],
                    [
                        25.97583206597274,
                        43.4310900756731
                    ],
                    [
                        26.041644465681983,
                        43.380235227807326
                    ],
                    [
                        26.096986671644427,
                        43.37126070317126
                    ],
                    [
                        26.14485020466062,
                        43.326388556806705
                    ],
                    [
                        26.17177344760228,
                        43.34284164186438
                    ],
                    [
                        26.140363009077326,
                        43.39818394629195
                    ],
                    [
                        26.14784166319959,
                        43.413141146547375
                    ],
                    [
                        26.19570523465072,
                        43.402671171499456
                    ]
                ]
            ]
        },
        "type": "Feature",
        "properties": {
            "source": "https://simplemaps.com",
            "id": "ROB",
            "name": "Bucuresti"
        },
        "id": 42
    },
    {
        "geometry": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        26.434076758070177,
                        44.52327737964208
                    ],
                    [
                        26.41640343854303,
                        44.51454419398339
                    ],
                    [
                        26.412682753683246,
                        44.50852400468818
                    ],
                    [
                        26.411597529610347,
                        44.4957856416701
                    ],
                    [
                        26.421209345278033,
                        44.48818920015726
                    ],
                    [
                        26.435316993681518,
                        44.482246300395126
                    ],
                    [
                        26.453817192397253,
                        44.477699005661925
                    ],
                    [
                        26.459708299014157,
                        44.473616523305296
                    ],
                    [
                        26.46048341062084,
                        44.46806108009601
                    ],
                    [
                        26.45645268274893,
                        44.46023232018516
                    ],
                    [
                        26.449631398271894,
                        44.451679902239675
                    ],
                    [
                        26.438314264180264,
                        44.44292077742408
                    ],
                    [
                        26.377956193667533,
                        44.42289617433659
                    ],
                    [
                        26.359766063060366,
                        44.41359424632185
                    ],
                    [
                        26.342402789505808,
                        44.40142449480443
                    ],
                    [
                        26.316461230758776,
                        44.37703328691278
                    ],
                    [
                        26.29072634683135,
                        44.34793932041419
                    ],
                    [
                        26.280029341912666,
                        44.32145525990102
                    ],
                    [
                        26.225872407914576,
                        44.28091488003952
                    ],
                    [
                        26.201326131497396,
                        44.26629063813733
                    ],
                    [
                        26.188768749608798,
                        44.26122629120922
                    ],
                    [
                        26.175591238770373,
                        44.25874568647585
                    ],
                    [
                        26.16225874634253,
                        44.25843580254874
                    ],
                    [
                        26.147324243929738,
                        44.26003768532977
                    ],
                    [
                        26.131356248321072,
                        44.26324177435563
                    ],
                    [
                        26.11569828239638,
                        44.26835769262072
                    ],
                    [
                        26.09921351104568,
                        44.27590251322958
                    ],
                    [
                        26.022887412128856,
                        44.32473669505071
                    ],
                    [
                        26.011260201836066,
                        44.32902575323511
                    ],
                    [
                        26.000408160508233,
                        44.329645931532205
                    ],
                    [
                        25.989349395601344,
                        44.32902575323511
                    ],
                    [
                        25.980202652684824,
                        44.33080850141262
                    ],
                    [
                        25.972296190833934,
                        44.33636392820059
                    ],
                    [
                        25.964854758533228,
                        44.34835268967543
                    ],
                    [
                        25.95074712478107,
                        44.355535923509635
                    ],
                    [
                        25.931781875806642,
                        44.360186818101006
                    ],
                    [
                        25.905116797252415,
                        44.369281611161945
                    ],
                    [
                        25.894729864448692,
                        44.38194253296359
                    ],
                    [
                        25.888838752791102,
                        44.40070108232497
                    ],
                    [
                        25.8978304374829,
                        44.44591786927505
                    ],
                    [
                        25.907752331513457,
                        44.46537417063369
                    ],
                    [
                        25.923100229767524,
                        44.48798259795622
                    ],
                    [
                        25.928371201402726,
                        44.498860330086124
                    ],
                    [
                        25.931058389711634,
                        44.514854270004705
                    ],
                    [
                        25.93198856256121,
                        44.52733410924615
                    ],
                    [
                        25.907132181845068,
                        44.56591045543884
                    ],
                    [
                        25.929921498335936,
                        44.57913969442215
                    ],
                    [
                        25.977877217076752,
                        44.61908550134293
                    ],
                    [
                        25.98717898761246,
                        44.628774919661154
                    ],
                    [
                        25.99203659133426,
                        44.63735333106697
                    ],
                    [
                        25.988005798214264,
                        44.645388811056705
                    ],
                    [
                        25.954002707103218,
                        44.65407045890349
                    ],
                    [
                        25.94966191147672,
                        44.65972918481306
                    ],
                    [
                        25.94997197643654,
                        44.66590456761693
                    ],
                    [
                        25.95400270690567,
                        44.672208885799634
                    ],
                    [
                        25.975396753812415,
                        44.68339685744439
                    ],
                    [
                        25.981597941496133,
                        44.6899857050628
                    ],
                    [
                        25.984905221055552,
                        44.70042427158625
                    ],
                    [
                        25.99157147131085,
                        44.71019105454148
                    ],
                    [
                        26.003663765146094,
                        44.717012401111944
                    ],
                    [
                        26.02893353312858,
                        44.73814801008947
                    ],
                    [
                        26.03451459054331,
                        44.742178793663165
                    ],
                    [
                        26.04226605010468,
                        44.75326335110313
                    ],
                    [
                        26.103295912736463,
                        44.753857606085475
                    ],
                    [
                        26.163809034948724,
                        44.76801707467938
                    ],
                    [
                        26.187166784195004,
                        44.76788789747002
                    ],
                    [
                        26.213521766077495,
                        44.76000725001878
                    ],
                    [
                        26.22757776692202,
                        44.76135091300612
                    ],
                    [
                        26.26964236560544,
                        44.75980050954383
                    ],
                    [
                        26.288245893484845,
                        44.75556311664951
                    ],
                    [
                        26.32845012824485,
                        44.75132546299529
                    ],
                    [
                        26.33821697564664,
                        44.74845743014294
                    ],
                    [
                        26.343798063770375,
                        44.743755085299064
                    ],
                    [
                        26.34457319206757,
                        44.72745105557755
                    ],
                    [
                        26.346898652535227,
                        44.719286310702294
                    ],
                    [
                        26.354184988654207,
                        44.70895076657667
                    ],
                    [
                        26.357130583521624,
                        44.70127706565344
                    ],
                    [
                        26.35728557910757,
                        44.69298278081676
                    ],
                    [
                        26.359611029994277,
                        44.684507916486496
                    ],
                    [
                        26.369687929875454,
                        44.67520613518052
                    ],
                    [
                        26.430976201765702,
                        44.65086668115446
                    ],
                    [
                        26.43970951455476,
                        44.6438644968775
                    ],
                    [
                        26.44250004307634,
                        44.63719824643338
                    ],
                    [
                        26.438107545888208,
                        44.62864578695233
                    ],
                    [
                        26.431751324057817,
                        44.62332299073344
                    ],
                    [
                        26.392218863360057,
                        44.603737678990726
                    ],
                    [
                        26.38384726888443,
                        44.5973297216491
                    ],
                    [
                        26.37774948268971,
                        44.590017715962375
                    ],
                    [
                        26.37247845930919,
                        44.581775154421344
                    ],
                    [
                        26.369377885167868,
                        44.57340364441879
                    ],
                    [
                        26.367517529426955,
                        44.56467030305326
                    ],
                    [
                        26.370308066126086,
                        44.55658300251866
                    ],
                    [
                        26.378989683335742,
                        44.548030404768966
                    ],
                    [
                        26.410512320542747,
                        44.536325774691434
                    ],
                    [
                        26.434076758070177,
                        44.52327737964208
                    ]
                ]
            ]
        },
        "type": "Feature",
        "properties": {
            "source": "https://simplemaps.com",
            "id": "ROIF",
            "name": "Ilfov"
        },
        "id": 24
    }
    ]
};
